import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type AdminDashboardRowDto = {
  __typename?: 'AdminDashboardRowDTO';
  branch?: Maybe<Scalars['String']['output']>;
  controlUser?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<DateObject>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fictiveSubsidyUtilization: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  regulation?: Maybe<RegulationRowDto>;
  responsibleUser?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subsidyBudget: Scalars['String']['output'];
  subsidyUtilization: Scalars['String']['output'];
  tenants: Array<Tenant>;
};

export type AdvancedReport = {
  __typename?: 'AdvancedReport';
  tenants: Array<AdvancedReportTenant>;
  total: Scalars['Int']['output'];
  users: Array<AdvancedReportUser>;
};

export type AdvancedReportCategory = {
  __typename?: 'AdvancedReportCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parentCategory?: Maybe<AdvancedReportParentCategory>;
  total: Scalars['Int']['output'];
  users: Array<AdvancedReportUser>;
};

export type AdvancedReportParentCategory = {
  __typename?: 'AdvancedReportParentCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type AdvancedReportProject = {
  __typename?: 'AdvancedReportProject';
  categories: Array<AdvancedReportCategory>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  users: Array<AdvancedReportUser>;
};

export type AdvancedReportTenant = {
  __typename?: 'AdvancedReportTenant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projects: Array<AdvancedReportProject>;
  total: Scalars['Int']['output'];
  users: Array<AdvancedReportUser>;
};

export type AdvancedReportUser = {
  __typename?: 'AdvancedReportUser';
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type Availability = {
  __typename?: 'Availability';
  availability: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  month: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type AvailabilityFilterArgs = {
  availability?: InputMaybe<NumberFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  month?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type AvailabilitySortArgs = {
  direction: SortDirection;
  field: AvailabilitySortFields;
};

export enum AvailabilitySortFields {
  Availability = 'availability',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Month = 'month',
  UpdatedAt = 'updatedAt'
}

export type BooleanFieldComparison = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Budget = {
  __typename?: 'Budget';
  budgetLines: PaginatedBudgetLine;
  completionDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BudgetFilterArgs = {
  budgetLines?: InputMaybe<BudgetLineFilterArgs>;
  completionDate?: InputMaybe<DateFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  total?: InputMaybe<NumberFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type BudgetFilterArgsWithCategory = {
  budgetLines?: InputMaybe<BudgetLineFilterArgs>;
  category?: InputMaybe<StringFieldComparison>;
  completionDate?: InputMaybe<DateFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  total?: InputMaybe<NumberFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type BudgetLine = {
  __typename?: 'BudgetLine';
  budget?: Maybe<Budget>;
  budgetId: Scalars['ID']['output'];
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  hourCosts: Scalars['Float']['output'];
  hourlyRate: Scalars['Float']['output'];
  hours: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoiceCosts: Scalars['Float']['output'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BudgetLineFilterArgs = {
  budget?: InputMaybe<BudgetFilterArgs>;
  budgetId?: InputMaybe<StringFieldComparison>;
  category?: InputMaybe<CategoryFilterArgs>;
  categoryId?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  hourCosts?: InputMaybe<NumberFieldComparison>;
  hourlyRate?: InputMaybe<NumberFieldComparison>;
  hours?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  invoiceCosts?: InputMaybe<NumberFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type BudgetLineSortArgs = {
  direction: SortDirection;
  field: BudgetLineSortFields;
};

export enum BudgetLineSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  HourCosts = 'hourCosts',
  HourlyRate = 'hourlyRate',
  Hours = 'hours',
  Id = 'id',
  InvoiceCosts = 'invoiceCosts',
  UpdatedAt = 'updatedAt'
}

export type BudgetSortArgs = {
  direction: SortDirection;
  field: BudgetSortFields;
};

export enum BudgetSortFields {
  CompletionDate = 'completionDate',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EndDate = 'endDate',
  Id = 'id',
  Note = 'note',
  StartDate = 'startDate',
  Total = 'total',
  UpdatedAt = 'updatedAt'
}

export type Categories = {
  __typename?: 'Categories';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  budgetLines: PaginatedBudgetLine;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  hasHours: Scalars['Boolean']['output'];
  hasInvoices: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoices: PaginatedInvoice;
  loggedHours: PaginatedLoggedHour;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parentCategory?: Maybe<Category>;
  parentCategoryId?: Maybe<Scalars['ID']['output']>;
  projects: PaginatedProject;
  subCategories: PaginatedCategory;
  subsidyPercentage?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: PaginatedUser;
};

export type CategoryFilterArgs = {
  budgetLines?: InputMaybe<BudgetLineFilterArgs>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  hasHours?: InputMaybe<BooleanFieldComparison>;
  hasInvoices?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  invoices?: InputMaybe<InvoiceFilterArgs>;
  loggedHours?: InputMaybe<LoggedHourFilterArgs>;
  name?: InputMaybe<StringFieldComparison>;
  order?: InputMaybe<NumberFieldComparison>;
  parentCategory?: InputMaybe<CategoryFilterArgs>;
  parentCategoryId?: InputMaybe<StringFieldComparison>;
  projects?: InputMaybe<ProjectFilterArgs>;
  subCategories?: InputMaybe<CategoryFilterArgs>;
  subsidyPercentage?: InputMaybe<NumberFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  users?: InputMaybe<UserFilterArgs>;
};

export type CategoryHo = {
  __typename?: 'CategoryHO';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ParentCategoryHo>;
};

export type CategoryHoInputData = {
  __typename?: 'CategoryHOInputData';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ParentCategory>;
  projects?: Maybe<Array<ProjectsHoInputData>>;
};

export type CategorySortArgs = {
  direction: SortDirection;
  field: CategorySortFields;
};

export enum CategorySortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  HasHours = 'hasHours',
  HasInvoices = 'hasInvoices',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  SubsidyPercentage = 'subsidyPercentage',
  UpdatedAt = 'updatedAt'
}

export type Content = {
  __typename?: 'Content';
  contentFills: PaginatedContentFill;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ContentFill = {
  __typename?: 'ContentFill';
  content: Content;
  contentId: Scalars['ID']['output'];
  fill: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
};

export type ContentFillFilterArgs = {
  content?: InputMaybe<ContentFilterArgs>;
  contentId?: InputMaybe<StringFieldComparison>;
  fill?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  language?: InputMaybe<StringFieldComparison>;
};

export type ContentFillSortArgs = {
  direction: SortDirection;
  field: ContentFillSortFields;
};

export enum ContentFillSortFields {
  Fill = 'fill',
  Id = 'id',
  Language = 'language'
}

export type ContentFilterArgs = {
  contentFills?: InputMaybe<ContentFillFilterArgs>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
};

export type ContentSortArgs = {
  direction: SortDirection;
  field: ContentSortFields;
};

export enum ContentSortFields {
  Id = 'id',
  Name = 'name'
}

export type Contract = {
  __typename?: 'Contract';
  costPerHour: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customCostPerHour?: Maybe<Scalars['Float']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  hourlyRateInputs?: Maybe<Scalars['String']['output']>;
  hoursPerWeek?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['ID']['output']>;
  salarySlip?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type ContractFilterArgs = {
  costPerHour?: InputMaybe<NumberFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  customCostPerHour?: InputMaybe<NumberFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  hourlyRateInputs?: InputMaybe<StringFieldComparison>;
  hoursPerWeek?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
  salarySlip?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type ContractSortArgs = {
  direction: SortDirection;
  field: ContractSortFields;
};

export enum ContractSortFields {
  CostPerHour = 'costPerHour',
  CreatedAt = 'createdAt',
  CustomCostPerHour = 'customCostPerHour',
  DeletedAt = 'deletedAt',
  EndDate = 'endDate',
  HourlyRateInputs = 'hourlyRateInputs',
  HoursPerWeek = 'hoursPerWeek',
  Id = 'id',
  SalarySlip = 'salarySlip',
  StartDate = 'startDate',
  UpdatedAt = 'updatedAt'
}

export type Customer = {
  __typename?: 'Customer';
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projects: PaginatedProject;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerFilterArgs = {
  active?: InputMaybe<BooleanFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  projects?: InputMaybe<ProjectFilterArgs>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type CustomerSortArgs = {
  direction: SortDirection;
  field: CustomerSortFields;
};

export enum CustomerSortFields {
  Active = 'active',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type DashboardRowDto = {
  __typename?: 'DashboardRowDTO';
  fictiveSubsidyRealization: Scalars['Float']['output'];
  fictiveTotalRealization: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  regulation?: Maybe<RegulationRowDto>;
  status?: Maybe<Scalars['String']['output']>;
  subRows: Array<DashboardRowDto>;
  subsidyBudget: Scalars['Float']['output'];
  subsidyRealization: Scalars['Float']['output'];
  totalBudget: Scalars['Float']['output'];
  totalRealization: Scalars['Float']['output'];
};

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type DateObject = {
  __typename?: 'DateObject';
  date: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type DaysOff = {
  __typename?: 'DaysOff';
  approved?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type DaysOffFilterArgs = {
  approved?: InputMaybe<BooleanFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type DaysOffSortArgs = {
  direction: SortDirection;
  field: DaysOffSortFields;
};

export enum DaysOffSortFields {
  Approved = 'approved',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EndDate = 'endDate',
  Id = 'id',
  Note = 'note',
  StartDate = 'startDate',
  UpdatedAt = 'updatedAt'
}

export type DefaultHoInputData = {
  __typename?: 'DefaultHOInputData';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ParentCategory>;
};

export type EmployeeHoInputData = {
  __typename?: 'EmployeeHOInputData';
  active: Scalars['Boolean']['output'];
  categories: Array<DefaultHoInputData>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ParentCategory>;
  userTenantRoles: Array<EmployeeTenantRolesHoiInputData>;
};

export type EmployeeTenantRolesHoiInputData = {
  __typename?: 'EmployeeTenantRolesHOIInputData';
  projectId: Scalars['String']['output'];
};

export type ErrorLog = {
  __typename?: 'ErrorLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  domain: Scalars['String']['output'];
  error: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stack?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ErrorLogFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  domain?: InputMaybe<StringFieldComparison>;
  error?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  stack?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ErrorLogSortArgs = {
  direction: SortDirection;
  field: ErrorLogSortFields;
};

export enum ErrorLogSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Domain = 'domain',
  Error = 'error',
  Id = 'id',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type EventLog = {
  __typename?: 'EventLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  log: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventLogFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  log?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type EventLogSortArgs = {
  direction: SortDirection;
  field: EventLogSortFields;
};

export enum EventLogSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Log = 'log',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type HoursOverviewDataType = {
  __typename?: 'HoursOverviewDataType';
  advancedReport: AdvancedReport;
  allIds: Array<Scalars['String']['output']>;
  data: Array<LoggedHourHo>;
  totalCount: Scalars['Float']['output'];
};

export type HoursOverviewFilterArgs = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  projects?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  tenants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HoursOverviewInputDataType = {
  __typename?: 'HoursOverviewInputDataType';
  categories: Array<CategoryHoInputData>;
  employees: Array<EmployeeHoInputData>;
  projects: Array<ProjectsHoInputData>;
  tenants: Array<DefaultHoInputData>;
};

export type HoursOverviewPagingArgs = {
  page: Scalars['Float']['input'];
  rows?: InputMaybe<Scalars['Float']['input']>;
};

export type HoursOverviewSortingArgs = {
  direction: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

export type HoursRequired = {
  __typename?: 'HoursRequired';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  month: Scalars['DateTime']['output'];
  perMonth: Scalars['Int']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HoursRequiredFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  month?: InputMaybe<DateFieldComparison>;
  perMonth?: InputMaybe<NumberFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type HoursRequiredSortArgs = {
  direction: SortDirection;
  field: HoursRequiredSortFields;
};

export enum HoursRequiredSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Month = 'month',
  PerMonth = 'perMonth',
  UpdatedAt = 'updatedAt'
}

export type Invoice = {
  __typename?: 'Invoice';
  attachment?: Maybe<Scalars['String']['output']>;
  attachmentProof?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  categoryId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paidOn?: Maybe<Scalars['DateTime']['output']>;
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  subsidyPercentage?: Maybe<Scalars['Int']['output']>;
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vat: Scalars['Float']['output'];
  vatSubsidyEligible: Scalars['Boolean']['output'];
};

export type InvoiceFilterArgs = {
  attachment?: InputMaybe<StringFieldComparison>;
  attachmentProof?: InputMaybe<StringFieldComparison>;
  category?: InputMaybe<CategoryFilterArgs>;
  categoryId?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  invoiceNumber?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  paidOn?: InputMaybe<DateFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  subsidyPercentage?: InputMaybe<NumberFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  total?: InputMaybe<NumberFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  vat?: InputMaybe<NumberFieldComparison>;
  vatSubsidyEligible?: InputMaybe<BooleanFieldComparison>;
};

export type InvoiceSortArgs = {
  direction: SortDirection;
  field: InvoiceSortFields;
};

export enum InvoiceSortFields {
  Attachment = 'attachment',
  AttachmentProof = 'attachmentProof',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  InvoiceNumber = 'invoiceNumber',
  Name = 'name',
  PaidOn = 'paidOn',
  Status = 'status',
  SubsidyPercentage = 'subsidyPercentage',
  Total = 'total',
  UpdatedAt = 'updatedAt',
  Vat = 'vat',
  VatSubsidyEligible = 'vatSubsidyEligible'
}

export type Job = {
  __typename?: 'Job';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  log?: Maybe<Scalars['String']['output']>;
  queue: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JobFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  log?: InputMaybe<StringFieldComparison>;
  queue?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type JobSortArgs = {
  direction: SortDirection;
  field: JobSortFields;
};

export enum JobSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Log = 'log',
  Queue = 'queue',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type LoggedHour = {
  __typename?: 'LoggedHour';
  addendum?: Maybe<Scalars['Boolean']['output']>;
  approvedBy?: Maybe<User>;
  approvedById?: Maybe<Scalars['ID']['output']>;
  break: Scalars['Int']['output'];
  category?: Maybe<Category>;
  categoryId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  declarable?: Maybe<Scalars['Boolean']['output']>;
  declarableTime?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  endDatetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
  startDatetime: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type LoggedHourFilterArgs = {
  addendum?: InputMaybe<BooleanFieldComparison>;
  approvedBy?: InputMaybe<UserFilterArgs>;
  approvedById?: InputMaybe<StringFieldComparison>;
  break?: InputMaybe<NumberFieldComparison>;
  category?: InputMaybe<CategoryFilterArgs>;
  categoryId?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  declarable?: InputMaybe<BooleanFieldComparison>;
  declarableTime?: InputMaybe<NumberFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  endDatetime?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
  startDatetime?: InputMaybe<DateFieldComparison>;
  status?: InputMaybe<BooleanFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type LoggedHourHo = {
  __typename?: 'LoggedHourHO';
  addendum?: Maybe<Scalars['Boolean']['output']>;
  break: Scalars['Int']['output'];
  category: CategoryHo;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  declarable?: Maybe<Scalars['Boolean']['output']>;
  declarableTime?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  endDatetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  project: ProjectHo;
  startDatetime: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  tenant: TenantHo;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: UserHo;
};

export type LoggedHourSortArgs = {
  direction: SortDirection;
  field: LoggedHourSortFields;
};

export enum LoggedHourSortFields {
  Addendum = 'addendum',
  Break = 'break',
  CreatedAt = 'createdAt',
  Declarable = 'declarable',
  DeclarableTime = 'declarableTime',
  DeletedAt = 'deletedAt',
  Description = 'description',
  EndDatetime = 'endDatetime',
  Id = 'id',
  StartDatetime = 'startDatetime',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type MailLog = {
  __typename?: 'MailLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  emailTemplate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sentBy: Scalars['String']['output'];
  sentTo: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MailLogFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  emailTemplate?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  message?: InputMaybe<StringFieldComparison>;
  reason?: InputMaybe<StringFieldComparison>;
  sentBy?: InputMaybe<StringFieldComparison>;
  sentTo?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MailLogSortArgs = {
  direction: SortDirection;
  field: MailLogSortFields;
};

export enum MailLogSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EmailTemplate = 'emailTemplate',
  Id = 'id',
  Message = 'message',
  Reason = 'reason',
  SentBy = 'sentBy',
  SentTo = 'sentTo',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type MailTemplate = {
  __typename?: 'MailTemplate';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mailTemplateFills: PaginatedMailTemplateFill;
};

export type MailTemplateFill = {
  __typename?: 'MailTemplateFill';
  disclaimer?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  mailTemplate: MailTemplate;
  mailTemplateId: Scalars['ID']['output'];
  plainText: Scalars['String']['output'];
  preHeader?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  urlText?: Maybe<Scalars['String']['output']>;
};

export type MailTemplateFillFilterArgs = {
  disclaimer?: InputMaybe<StringFieldComparison>;
  heading?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  language?: InputMaybe<StringFieldComparison>;
  mailTemplate?: InputMaybe<MailTemplateFilterArgs>;
  mailTemplateId?: InputMaybe<StringFieldComparison>;
  plainText?: InputMaybe<StringFieldComparison>;
  preHeader?: InputMaybe<StringFieldComparison>;
  subject?: InputMaybe<StringFieldComparison>;
  text?: InputMaybe<StringFieldComparison>;
  title?: InputMaybe<StringFieldComparison>;
  urlText?: InputMaybe<StringFieldComparison>;
};

export type MailTemplateFillSortArgs = {
  direction: SortDirection;
  field: MailTemplateFillSortFields;
};

export enum MailTemplateFillSortFields {
  Disclaimer = 'disclaimer',
  Heading = 'heading',
  Id = 'id',
  Language = 'language',
  PlainText = 'plainText',
  PreHeader = 'preHeader',
  Subject = 'subject',
  Text = 'text',
  Title = 'title',
  UrlText = 'urlText'
}

export type MailTemplateFilterArgs = {
  active?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  mailTemplateFills?: InputMaybe<MailTemplateFillFilterArgs>;
};

export type MailTemplateSortArgs = {
  direction: SortDirection;
  field: MailTemplateSortFields;
};

export enum MailTemplateSortFields {
  Active = 'active',
  Id = 'id'
}

export type Mutation = {
  __typename?: 'Mutation';
  createAvailability: Availability;
  createBudget: Budget;
  createBudgetLine: BudgetLine;
  createCategory: Category;
  createContent: Content;
  createContentFill: ContentFill;
  createContentWithFill: Scalars['Boolean']['output'];
  createContract: Contract;
  createCustomer: Customer;
  createDaysOff: DaysOff;
  createErrorLog: ErrorLog;
  createEventLog: EventLog;
  createHoursRequired: HoursRequired;
  createInvoice: Invoice;
  createJob: Job;
  createLoggedHour: LoggedHour;
  createMailLog: MailLog;
  createMailTemplate: MailTemplate;
  createMailTemplateFill: MailTemplateFill;
  createPermission: Permission;
  createPlannedHour: PlannedHour;
  createProductivity: Productivity;
  createProject: Project;
  createProjectDate: ProjectDate;
  createProjectDateReminder: ProjectDateReminder;
  createProjectDocument: ProjectDocument;
  createRegulation: Regulation;
  createResetPassword: ResetPassword;
  createRole: Role;
  createSimpleProject: Project;
  createTenant: Tenant;
  createUser: User;
  createUserTenantRole: UserTenantRole;
  deleteAvailability: Availability;
  deleteBudget: Budget;
  deleteBudgetLine: BudgetLine;
  deleteCategory: Category;
  deleteCategoryAndChildren: Category;
  deleteContent: Content;
  deleteContentFill: ContentFill;
  deleteContract: Contract;
  deleteCustomer: Customer;
  deleteDaysOff: DaysOff;
  deleteErrorLog: ErrorLog;
  deleteEventLog: EventLog;
  deleteHoursRequired: HoursRequired;
  deleteInvoice: Invoice;
  deleteJob: Job;
  deleteLoggedHour: LoggedHour;
  deleteMailLog: MailLog;
  deleteMailTemplate: MailTemplate;
  deleteMailTemplateFill: MailTemplateFill;
  deletePermission: Permission;
  deletePlannedHour: PlannedHour;
  deleteProductivity: Productivity;
  deleteProject: Project;
  deleteProjectDate: ProjectDate;
  deleteProjectDateReminder: ProjectDateReminder;
  deleteProjectDocument: ProjectDocument;
  deleteRegulation: Regulation;
  deleteResetPassword: ResetPassword;
  deleteRole: Role;
  deleteTenant: Tenant;
  deleteUser: User;
  deleteUserTenantRole: UserTenantRole;
  restoreAvailability: Availability;
  restoreBudget: Budget;
  restoreBudgetLine: BudgetLine;
  restoreCategory: Category;
  restoreContract: Contract;
  restoreCustomer: Customer;
  restoreDaysOff: DaysOff;
  restoreErrorLog: ErrorLog;
  restoreEventLog: EventLog;
  restoreHoursRequired: HoursRequired;
  restoreInvoice: Invoice;
  restoreJob: Job;
  restoreLoggedHour: LoggedHour;
  restoreMailLog: MailLog;
  restorePlannedHour: PlannedHour;
  restoreProductivity: Productivity;
  restoreProject: Project;
  restoreProjectDateReminder: ProjectDateReminder;
  restoreUser: User;
  updateAvailability: Availability;
  updateBudget: Budget;
  updateBudgetLine: BudgetLine;
  updateCategory: Category;
  updateContent: Content;
  updateContentFill: ContentFill;
  updateContentWithFill: Scalars['Boolean']['output'];
  updateContract: Contract;
  updateCustomer: Customer;
  updateDaysOff: DaysOff;
  updateErrorLog: ErrorLog;
  updateEventLog: EventLog;
  updateHoursRequired: HoursRequired;
  updateInvoice: Invoice;
  updateJob: Job;
  updateLoggedHour: LoggedHour;
  updateLoggedHourStatus: Scalars['Boolean']['output'];
  updateMailLog: MailLog;
  updateMailTemplate: MailTemplate;
  updateMailTemplateFill: MailTemplateFill;
  updatePermission: Permission;
  updatePlannedHour: PlannedHour;
  updateProductivity: Productivity;
  updateProject: Project;
  updateProjectDate: ProjectDate;
  updateProjectDateReminder: ProjectDateReminder;
  updateProjectDocument: ProjectDocument;
  updateRegulation: Regulation;
  updateResetPassword: ResetPassword;
  updateRole: Role;
  updateTenant: Tenant;
  updateUser: User;
  updateUserTenantRole: UserTenantRole;
};


export type MutationCreateAvailabilityArgs = {
  availability: Scalars['Int']['input'];
  month: Scalars['DateTime']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateBudgetArgs = {
  budgetLineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  completionDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  note: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateBudgetLineArgs = {
  budgetId: Scalars['ID']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  hourCosts?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  invoiceCosts?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCategoryArgs = {
  budgetLineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasHours: Scalars['Boolean']['input'];
  hasInvoices: Scalars['Boolean']['input'];
  invoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  loggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subCategoriesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subsidyPercentage?: InputMaybe<Scalars['Float']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateContentArgs = {
  contentFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
};


export type MutationCreateContentFillArgs = {
  contentId: Scalars['ID']['input'];
  fill: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type MutationCreateContentWithFillArgs = {
  fill: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateContractArgs = {
  costPerHour: Scalars['Float']['input'];
  customCostPerHour?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  hourlyRateInputs?: InputMaybe<Scalars['String']['input']>;
  hoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  salarySlip?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tenantId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateCustomerArgs = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateDaysOffArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['DateTime']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateErrorLogArgs = {
  domain: Scalars['String']['input'];
  error: Scalars['String']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateEventLogArgs = {
  log: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateHoursRequiredArgs = {
  month: Scalars['DateTime']['input'];
  perMonth: Scalars['Int']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationCreateInvoiceArgs = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  attachmentProof?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  paidOn?: InputMaybe<Scalars['DateTime']['input']>;
  projectId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  subsidyPercentage?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  total: Scalars['Float']['input'];
  vat?: InputMaybe<Scalars['Float']['input']>;
  vatSubsidyEligible: Scalars['Boolean']['input'];
};


export type MutationCreateJobArgs = {
  log?: InputMaybe<Scalars['String']['input']>;
  queue: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationCreateLoggedHourArgs = {
  addendum?: InputMaybe<Scalars['Boolean']['input']>;
  approvedById?: InputMaybe<Scalars['ID']['input']>;
  break: Scalars['Int']['input'];
  categoryId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  declarable?: InputMaybe<Scalars['Boolean']['input']>;
  declarableTime?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  endDatetime: Scalars['DateTime']['input'];
  projectId: Scalars['ID']['input'];
  startDatetime: Scalars['DateTime']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationCreateMailLogArgs = {
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sentBy: Scalars['String']['input'];
  sentTo: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMailTemplateArgs = {
  active: Scalars['Boolean']['input'];
  mailTemplateFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateMailTemplateFillArgs = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  mailTemplateId: Scalars['ID']['input'];
  plainText: Scalars['String']['input'];
  preHeader?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePermissionArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreatePlannedHourArgs = {
  hours: Scalars['Float']['input'];
  month: Scalars['DateTime']['input'];
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateProductivityArgs = {
  factor: Scalars['Float']['input'];
  startDate: Scalars['DateTime']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateProjectArgs = {
  active: Scalars['Boolean']['input'];
  addendum: Scalars['Boolean']['input'];
  branch?: InputMaybe<Scalars['String']['input']>;
  budgetIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  controlUserId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  decisionDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filingDate?: InputMaybe<Scalars['DateTime']['input']>;
  hourSubsidyType: Scalars['String']['input'];
  hoursRequiredIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceVatSubsidyEligible: Scalars['Boolean']['input'];
  loggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  maxHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  plannedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectDateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleUserId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: Scalars['String']['input'];
  subsidyPercentage?: InputMaybe<Scalars['Float']['input']>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateProjectDateArgs = {
  dateTime: Scalars['DateTime']['input'];
  doneAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  projectDateReminderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateProjectDateReminderArgs = {
  advanceHours: Scalars['Int']['input'];
  mailText: Scalars['String']['input'];
  projectDateId: Scalars['ID']['input'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCreateProjectDocumentArgs = {
  attachment: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationCreateRegulationArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateResetPasswordArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateRoleArgs = {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  permissionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectDateReminderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateSimpleProjectArgs = {
  addendum: Scalars['Boolean']['input'];
  branch?: InputMaybe<Scalars['String']['input']>;
  budget: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  hourSubsidyType: Scalars['String']['input'];
  invoiceVatSubsidyEligible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  realization: Scalars['Float']['input'];
  regulationId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  subsidyPercentage: Scalars['Float']['input'];
  tenantId: Scalars['String']['input'];
  vatSubsidyEligible: Scalars['Boolean']['input'];
};


export type MutationCreateTenantArgs = {
  budgetLineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  contractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  invoiceDetails?: InputMaybe<Scalars['String']['input']>;
  invoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceVatSubsidyEligible: Scalars['Boolean']['input'];
  kvk?: InputMaybe<Scalars['String']['input']>;
  loggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mfaRequired: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  timeZone: Scalars['String']['input'];
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateUserArgs = {
  active: Scalars['Boolean']['input'];
  approvedLoggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  availabilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  controllerForProjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  daysOffIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email: Scalars['String']['input'];
  function?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  loggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  plannedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productivityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  responsibleForProjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone: Scalars['String']['input'];
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateUserTenantRoleArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteAvailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBudgetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBudgetLineArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCategoryAndChildrenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentFillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDaysOffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteErrorLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHoursRequiredArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLoggedHourArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailTemplateFillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlannedHourArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectDateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectDateReminderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRegulationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResetPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserTenantRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreAvailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreBudgetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreBudgetLineArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreDaysOffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreErrorLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreHoursRequiredArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreLoggedHourArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreMailLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestorePlannedHourArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreProductivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreProjectDateReminderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAvailabilityArgs = {
  availability?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  month?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateBudgetArgs = {
  budgetLineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  completionDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateBudgetLineArgs = {
  budgetId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  hourCosts?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  invoiceCosts?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateCategoryArgs = {
  budgetLineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasHours?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  invoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  loggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subCategoriesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subsidyPercentage?: InputMaybe<Scalars['Float']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateContentArgs = {
  contentFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContentFillArgs = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  fill?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContentWithFillArgs = {
  fill: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateContractArgs = {
  costPerHour?: InputMaybe<Scalars['Float']['input']>;
  customCostPerHour?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  hourlyRateInputs?: InputMaybe<Scalars['String']['input']>;
  hoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  salarySlip?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateCustomerArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateDaysOffArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateErrorLogArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEventLogArgs = {
  id: Scalars['ID']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateHoursRequiredArgs = {
  id: Scalars['ID']['input'];
  month?: InputMaybe<Scalars['DateTime']['input']>;
  perMonth?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateInvoiceArgs = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  attachmentProof?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paidOn?: InputMaybe<Scalars['DateTime']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subsidyPercentage?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
  vatSubsidyEligible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateJobArgs = {
  id: Scalars['ID']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLoggedHourArgs = {
  addendum?: InputMaybe<Scalars['Boolean']['input']>;
  approvedById?: InputMaybe<Scalars['ID']['input']>;
  break?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  declarable?: InputMaybe<Scalars['Boolean']['input']>;
  declarableTime?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateLoggedHourStatusArgs = {
  data: Array<UpdateLoggedHoursStatusType>;
};


export type MutationUpdateMailLogArgs = {
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMailTemplateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  mailTemplateFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateMailTemplateFillArgs = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  plainText?: InputMaybe<Scalars['String']['input']>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePermissionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdatePlannedHourArgs = {
  hours?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  month?: InputMaybe<Scalars['DateTime']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateProductivityArgs = {
  factor?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateProjectArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addendum?: InputMaybe<Scalars['Boolean']['input']>;
  branch?: InputMaybe<Scalars['String']['input']>;
  budgetIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  controlUserId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  decisionDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filingDate?: InputMaybe<Scalars['DateTime']['input']>;
  hourSubsidyType?: InputMaybe<Scalars['String']['input']>;
  hoursRequiredIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  invoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceVatSubsidyEligible?: InputMaybe<Scalars['Boolean']['input']>;
  loggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  maxHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  plannedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectDateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleUserId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subsidyPercentage?: InputMaybe<Scalars['Float']['input']>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateProjectDateArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  doneAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  projectDateReminderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectDateReminderArgs = {
  advanceHours?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  mailText?: InputMaybe<Scalars['String']['input']>;
  projectDateId?: InputMaybe<Scalars['ID']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateProjectDocumentArgs = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateRegulationArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRoleArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  permissionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectDateReminderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateTenantArgs = {
  budgetLineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  contractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invoiceDetails?: InputMaybe<Scalars['String']['input']>;
  invoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceVatSubsidyEligible?: InputMaybe<Scalars['Boolean']['input']>;
  kvk?: InputMaybe<Scalars['String']['input']>;
  loggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mfaRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateUserArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  approvedLoggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  availabilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  controllerForProjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  daysOffIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  loggedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  plannedHourIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productivityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  responsibleForProjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateUserTenantRoleArgs = {
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type PageArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PaginatedAvailability = {
  __typename?: 'PaginatedAvailability';
  items?: Maybe<Array<Availability>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedBudget = {
  __typename?: 'PaginatedBudget';
  items?: Maybe<Array<Budget>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedBudgetLine = {
  __typename?: 'PaginatedBudgetLine';
  items?: Maybe<Array<BudgetLine>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCategory = {
  __typename?: 'PaginatedCategory';
  items?: Maybe<Array<Category>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedContent = {
  __typename?: 'PaginatedContent';
  items?: Maybe<Array<Content>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedContentFill = {
  __typename?: 'PaginatedContentFill';
  items?: Maybe<Array<ContentFill>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedContract = {
  __typename?: 'PaginatedContract';
  items?: Maybe<Array<Contract>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCustomer = {
  __typename?: 'PaginatedCustomer';
  items?: Maybe<Array<Customer>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedDaysOff = {
  __typename?: 'PaginatedDaysOff';
  items?: Maybe<Array<DaysOff>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedErrorLog = {
  __typename?: 'PaginatedErrorLog';
  items?: Maybe<Array<ErrorLog>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedEventLog = {
  __typename?: 'PaginatedEventLog';
  items?: Maybe<Array<EventLog>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedHoursRequired = {
  __typename?: 'PaginatedHoursRequired';
  items?: Maybe<Array<HoursRequired>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedInvoice = {
  __typename?: 'PaginatedInvoice';
  items?: Maybe<Array<Invoice>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedJob = {
  __typename?: 'PaginatedJob';
  items?: Maybe<Array<Job>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedLoggedHour = {
  __typename?: 'PaginatedLoggedHour';
  items?: Maybe<Array<LoggedHour>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailLog = {
  __typename?: 'PaginatedMailLog';
  items?: Maybe<Array<MailLog>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailTemplate = {
  __typename?: 'PaginatedMailTemplate';
  items?: Maybe<Array<MailTemplate>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailTemplateFill = {
  __typename?: 'PaginatedMailTemplateFill';
  items?: Maybe<Array<MailTemplateFill>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPermission = {
  __typename?: 'PaginatedPermission';
  items?: Maybe<Array<Permission>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPlannedHour = {
  __typename?: 'PaginatedPlannedHour';
  items?: Maybe<Array<PlannedHour>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedProductivity = {
  __typename?: 'PaginatedProductivity';
  items?: Maybe<Array<Productivity>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedProject = {
  __typename?: 'PaginatedProject';
  items?: Maybe<Array<Project>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedProjectDate = {
  __typename?: 'PaginatedProjectDate';
  items?: Maybe<Array<ProjectDate>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedProjectDateReminder = {
  __typename?: 'PaginatedProjectDateReminder';
  items?: Maybe<Array<ProjectDateReminder>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedProjectDocument = {
  __typename?: 'PaginatedProjectDocument';
  items?: Maybe<Array<ProjectDocument>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedRegulation = {
  __typename?: 'PaginatedRegulation';
  items?: Maybe<Array<Regulation>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResetPassword = {
  __typename?: 'PaginatedResetPassword';
  items?: Maybe<Array<ResetPassword>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedRole = {
  __typename?: 'PaginatedRole';
  items?: Maybe<Array<Role>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedTenant = {
  __typename?: 'PaginatedTenant';
  items?: Maybe<Array<Tenant>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  items?: Maybe<Array<User>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedUserTenantRole = {
  __typename?: 'PaginatedUserTenantRole';
  items?: Maybe<Array<UserTenantRole>>;
  totalCount: Scalars['Int']['output'];
};

export type ParentCategory = {
  __typename?: 'ParentCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ParentCategoryHo = {
  __typename?: 'ParentCategoryHO';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roles: PaginatedRole;
};

export type PermissionFilterArgs = {
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  roles?: InputMaybe<RoleFilterArgs>;
};

export type PermissionSortArgs = {
  direction: SortDirection;
  field: PermissionSortFields;
};

export enum PermissionSortFields {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type PlannedHour = {
  __typename?: 'PlannedHour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  hours: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  month: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type PlannedHourFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  hours?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  month?: InputMaybe<DateFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type PlannedHourSortArgs = {
  direction: SortDirection;
  field: PlannedHourSortFields;
};

export enum PlannedHourSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Hours = 'hours',
  Id = 'id',
  Month = 'month',
  UpdatedAt = 'updatedAt'
}

export type Productivity = {
  __typename?: 'Productivity';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  factor: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  startDate: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type ProductivityFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  factor?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type ProductivitySortArgs = {
  direction: SortDirection;
  field: ProductivitySortFields;
};

export enum ProductivitySortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Factor = 'factor',
  Id = 'id',
  StartDate = 'startDate',
  UpdatedAt = 'updatedAt'
}

export type Project = {
  __typename?: 'Project';
  active: Scalars['Boolean']['output'];
  addendum: Scalars['Boolean']['output'];
  branch?: Maybe<Scalars['String']['output']>;
  budgets: PaginatedBudget;
  categories: PaginatedCategory;
  contracts: PaginatedContract;
  controlUser?: Maybe<User>;
  controlUserId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']['output']>;
  decisionDate?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  filingDate?: Maybe<Scalars['DateTime']['output']>;
  hourSubsidyType: Scalars['String']['output'];
  hoursRequireds: PaginatedHoursRequired;
  id: Scalars['ID']['output'];
  invoiceVatSubsidyEligible: Scalars['Boolean']['output'];
  invoices: PaginatedInvoice;
  isSimple: Scalars['Boolean']['output'];
  loggedHours: PaginatedLoggedHour;
  maxHourlyRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  plannedHours: PaginatedPlannedHour;
  projectDates: PaginatedProjectDate;
  projectDocuments: PaginatedProjectDocument;
  reference?: Maybe<Scalars['String']['output']>;
  regulation?: Maybe<Regulation>;
  regulationId?: Maybe<Scalars['ID']['output']>;
  responsibleUser?: Maybe<User>;
  responsibleUserId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  subsidyPercentage: Scalars['Float']['output'];
  tenants: PaginatedTenant;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userTenantRoles: PaginatedUserTenantRole;
};

export type ProjectDate = {
  __typename?: 'ProjectDate';
  dateTime: Scalars['DateTime']['output'];
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectDateReminders: PaginatedProjectDateReminder;
  projectId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type ProjectDateFilterArgs = {
  dateTime?: InputMaybe<DateFieldComparison>;
  doneAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectDateReminders?: InputMaybe<ProjectDateReminderFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<StringFieldComparison>;
};

export type ProjectDateReminder = {
  __typename?: 'ProjectDateReminder';
  advanceHours: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  mailText: Scalars['String']['output'];
  projectDate: ProjectDate;
  projectDateId: Scalars['ID']['output'];
  roles: PaginatedRole;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectDateReminderFilterArgs = {
  advanceHours?: InputMaybe<NumberFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  mailText?: InputMaybe<StringFieldComparison>;
  projectDate?: InputMaybe<ProjectDateFilterArgs>;
  projectDateId?: InputMaybe<StringFieldComparison>;
  roles?: InputMaybe<RoleFilterArgs>;
  sentAt?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ProjectDateReminderSortArgs = {
  direction: SortDirection;
  field: ProjectDateReminderSortFields;
};

export enum ProjectDateReminderSortFields {
  AdvanceHours = 'advanceHours',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  MailText = 'mailText',
  SentAt = 'sentAt',
  UpdatedAt = 'updatedAt'
}

export type ProjectDateSortArgs = {
  direction: SortDirection;
  field: ProjectDateSortFields;
};

export enum ProjectDateSortFields {
  DateTime = 'dateTime',
  DoneAt = 'doneAt',
  Id = 'id',
  Name = 'name',
  Type = 'type'
}

export type ProjectDocument = {
  __typename?: 'ProjectDocument';
  attachment: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
};

export type ProjectDocumentFilterArgs = {
  attachment?: InputMaybe<StringFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
};

export type ProjectDocumentSortArgs = {
  direction: SortDirection;
  field: ProjectDocumentSortFields;
};

export enum ProjectDocumentSortFields {
  Attachment = 'attachment',
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type ProjectFilterArgs = {
  active?: InputMaybe<BooleanFieldComparison>;
  addendum?: InputMaybe<BooleanFieldComparison>;
  branch?: InputMaybe<StringFieldComparison>;
  budgets?: InputMaybe<BudgetFilterArgs>;
  categories?: InputMaybe<CategoryFilterArgs>;
  contracts?: InputMaybe<ContractFilterArgs>;
  controlUser?: InputMaybe<UserFilterArgs>;
  controlUserId?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  customer?: InputMaybe<CustomerFilterArgs>;
  customerId?: InputMaybe<StringFieldComparison>;
  decisionDate?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  filingDate?: InputMaybe<DateFieldComparison>;
  hourSubsidyType?: InputMaybe<StringFieldComparison>;
  hoursRequireds?: InputMaybe<HoursRequiredFilterArgs>;
  id?: InputMaybe<StringFieldComparison>;
  invoiceVatSubsidyEligible?: InputMaybe<BooleanFieldComparison>;
  invoices?: InputMaybe<InvoiceFilterArgs>;
  isSimple?: InputMaybe<BooleanFieldComparison>;
  loggedHours?: InputMaybe<LoggedHourFilterArgs>;
  maxHourlyRate?: InputMaybe<NumberFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  plannedHours?: InputMaybe<PlannedHourFilterArgs>;
  projectDates?: InputMaybe<ProjectDateFilterArgs>;
  projectDocuments?: InputMaybe<ProjectDocumentFilterArgs>;
  reference?: InputMaybe<StringFieldComparison>;
  regulation?: InputMaybe<RegulationFilterArgs>;
  regulationId?: InputMaybe<StringFieldComparison>;
  responsibleUser?: InputMaybe<UserFilterArgs>;
  responsibleUserId?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  subsidyPercentage?: InputMaybe<NumberFieldComparison>;
  tenants?: InputMaybe<TenantFilterArgs>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type ProjectHo = {
  __typename?: 'ProjectHO';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tenants: Array<TenantHo>;
};

export type ProjectRowsDto = {
  __typename?: 'ProjectRowsDTO';
  hourRows: Array<DashboardRowDto>;
  invoiceRows: Array<DashboardRowDto>;
  totalRows: Array<DashboardRowDto>;
};

export type ProjectSortArgs = {
  direction: SortDirection;
  field: ProjectSortFields;
};

export enum ProjectSortFields {
  Active = 'active',
  Addendum = 'addendum',
  Branch = 'branch',
  CreatedAt = 'createdAt',
  DecisionDate = 'decisionDate',
  DeletedAt = 'deletedAt',
  Description = 'description',
  EndDate = 'endDate',
  FilingDate = 'filingDate',
  HourSubsidyType = 'hourSubsidyType',
  Id = 'id',
  InvoiceVatSubsidyEligible = 'invoiceVatSubsidyEligible',
  IsSimple = 'isSimple',
  MaxHourlyRate = 'maxHourlyRate',
  Name = 'name',
  Reference = 'reference',
  StartDate = 'startDate',
  Status = 'status',
  SubsidyPercentage = 'subsidyPercentage',
  UpdatedAt = 'updatedAt'
}

export type ProjectUser = {
  __typename?: 'ProjectUser';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProjectWithUsers = {
  __typename?: 'ProjectWithUsers';
  active: Scalars['Boolean']['output'];
  addendum: Scalars['Boolean']['output'];
  branch?: Maybe<Scalars['String']['output']>;
  budgets: PaginatedBudget;
  categories: PaginatedCategory;
  contracts: PaginatedContract;
  controlUser?: Maybe<User>;
  controlUserId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']['output']>;
  decisionDate?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  filingDate?: Maybe<Scalars['DateTime']['output']>;
  hourSubsidyType: Scalars['String']['output'];
  hoursRequireds: PaginatedHoursRequired;
  id: Scalars['ID']['output'];
  invoiceVatSubsidyEligible: Scalars['Boolean']['output'];
  invoices: PaginatedInvoice;
  isSimple: Scalars['Boolean']['output'];
  loggedHours: PaginatedLoggedHour;
  maxHourlyRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  plannedHours: PaginatedPlannedHour;
  projectDates: PaginatedProjectDate;
  projectDocuments: PaginatedProjectDocument;
  reference?: Maybe<Scalars['String']['output']>;
  regulation?: Maybe<Regulation>;
  regulationId?: Maybe<Scalars['ID']['output']>;
  responsibleUser?: Maybe<User>;
  responsibleUserId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  subsidyPercentage: Scalars['Float']['output'];
  tenants: PaginatedTenant;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userTenantRoles: PaginatedUserTenantRole;
  users: Array<ProjectUser>;
};

export type ProjectsHoInputData = {
  __typename?: 'ProjectsHOInputData';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ParentCategory>;
  tenants: Array<DefaultHoInputData>;
};

export type Query = {
  __typename?: 'Query';
  adminDashboardRows: Array<AdminDashboardRowDto>;
  availabilities: PaginatedAvailability;
  availability?: Maybe<Availability>;
  budget?: Maybe<Budget>;
  budgetLine?: Maybe<BudgetLine>;
  budgetLines: PaginatedBudgetLine;
  budgets: PaginatedBudget;
  budgetsWithCategories: PaginatedBudget;
  categories: PaginatedCategory;
  category?: Maybe<Category>;
  content?: Maybe<Content>;
  contentFill?: Maybe<ContentFill>;
  contentFills: PaginatedContentFill;
  contents: PaginatedContent;
  contract?: Maybe<Contract>;
  contracts: PaginatedContract;
  customer?: Maybe<Customer>;
  customers: PaginatedCustomer;
  dashboardRows: Array<DashboardRowDto>;
  daysOff?: Maybe<DaysOff>;
  daysOffs: PaginatedDaysOff;
  errorLog?: Maybe<ErrorLog>;
  errorLogs: PaginatedErrorLog;
  eventLog?: Maybe<EventLog>;
  eventLogs: PaginatedEventLog;
  getHoursOverviewData: HoursOverviewDataType;
  getHoursOverviewInputData: HoursOverviewInputDataType;
  getOrganizedLoggedHours: Array<LoggedHour>;
  hoursRequired?: Maybe<HoursRequired>;
  hoursRequireds: PaginatedHoursRequired;
  invoice?: Maybe<Invoice>;
  invoices: PaginatedInvoice;
  job?: Maybe<Job>;
  jobs: PaginatedJob;
  loggedHour?: Maybe<LoggedHour>;
  loggedHours: PaginatedLoggedHour;
  mailLog?: Maybe<MailLog>;
  mailLogs: PaginatedMailLog;
  mailTemplate?: Maybe<MailTemplate>;
  mailTemplateFill?: Maybe<MailTemplateFill>;
  mailTemplateFills: PaginatedMailTemplateFill;
  mailTemplates: PaginatedMailTemplate;
  permission?: Maybe<Permission>;
  permissions: PaginatedPermission;
  plannedHour?: Maybe<PlannedHour>;
  plannedHours: PaginatedPlannedHour;
  productivities: PaginatedProductivity;
  productivity?: Maybe<Productivity>;
  project?: Maybe<Project>;
  projectDashboardRows: ProjectRowsDto;
  projectDate?: Maybe<ProjectDate>;
  projectDateReminder?: Maybe<ProjectDateReminder>;
  projectDateReminders: PaginatedProjectDateReminder;
  projectDates: PaginatedProjectDate;
  projectDocument?: Maybe<ProjectDocument>;
  projectDocuments: PaginatedProjectDocument;
  projectWithCategories: PaginatedProject;
  projectWithUsers?: Maybe<ProjectWithUsers>;
  projects: PaginatedProject;
  projectsWhereAdmin: PaginatedProject;
  regulation?: Maybe<Regulation>;
  regulations: PaginatedRegulation;
  resetPassword?: Maybe<ResetPassword>;
  resetPasswords: PaginatedResetPassword;
  role?: Maybe<Role>;
  roles: PaginatedRole;
  tenant?: Maybe<Tenant>;
  tenants: PaginatedTenant;
  user?: Maybe<User>;
  userTenantRole?: Maybe<UserTenantRole>;
  userTenantRoles: PaginatedUserTenantRole;
  users: PaginatedUser;
};


export type QueryAvailabilitiesArgs = {
  filter?: InputMaybe<AvailabilityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AvailabilitySortArgs>>;
};


export type QueryAvailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBudgetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBudgetLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBudgetLinesArgs = {
  filter?: InputMaybe<BudgetLineFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetLineSortArgs>>;
};


export type QueryBudgetsArgs = {
  filter?: InputMaybe<BudgetFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetSortArgs>>;
};


export type QueryBudgetsWithCategoriesArgs = {
  filter?: InputMaybe<BudgetFilterArgsWithCategory>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetSortArgs>>;
};


export type QueryCategoriesArgs = {
  filter?: InputMaybe<CategoryFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CategorySortArgs>>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentFillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentFillsArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type QueryContentsArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type QueryContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractsArgs = {
  filter?: InputMaybe<ContractFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContractSortArgs>>;
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomerFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CustomerSortArgs>>;
};


export type QueryDaysOffArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDaysOffsArgs = {
  filter?: InputMaybe<DaysOffFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<DaysOffSortArgs>>;
};


export type QueryErrorLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryErrorLogsArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type QueryEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventLogsArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type QueryGetHoursOverviewDataArgs = {
  filters?: InputMaybe<HoursOverviewFilterArgs>;
  pagination?: InputMaybe<HoursOverviewPagingArgs>;
  sorting?: InputMaybe<HoursOverviewSortingArgs>;
};


export type QueryGetHoursOverviewInputDataArgs = {
  filters?: InputMaybe<HoursOverviewFilterArgs>;
};


export type QueryGetOrganizedLoggedHoursArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryHoursRequiredArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHoursRequiredsArgs = {
  filter?: InputMaybe<HoursRequiredFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<HoursRequiredSortArgs>>;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoicesArgs = {
  filter?: InputMaybe<InvoiceFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<InvoiceSortArgs>>;
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobsArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type QueryLoggedHourArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLoggedHoursArgs = {
  filter?: InputMaybe<LoggedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<LoggedHourSortArgs>>;
};


export type QueryMailLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailLogsArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type QueryMailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailTemplateFillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailTemplateFillsArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type QueryMailTemplatesArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type QueryPermissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionsArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type QueryPlannedHourArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlannedHoursArgs = {
  filter?: InputMaybe<PlannedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PlannedHourSortArgs>>;
};


export type QueryProductivitiesArgs = {
  filter?: InputMaybe<ProductivityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProductivitySortArgs>>;
};


export type QueryProductivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectDashboardRowsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryProjectDateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectDateReminderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectDateRemindersArgs = {
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateReminderSortArgs>>;
};


export type QueryProjectDatesArgs = {
  filter?: InputMaybe<ProjectDateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateSortArgs>>;
};


export type QueryProjectDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectDocumentsArgs = {
  filter?: InputMaybe<ProjectDocumentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDocumentSortArgs>>;
};


export type QueryProjectWithCategoriesArgs = {
  filter?: InputMaybe<ProjectFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectSortArgs>>;
};


export type QueryProjectWithUsersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  filter?: InputMaybe<ProjectFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectSortArgs>>;
};


export type QueryProjectsWhereAdminArgs = {
  filter?: InputMaybe<ProjectFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectSortArgs>>;
};


export type QueryRegulationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRegulationsArgs = {
  filter?: InputMaybe<RegulationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegulationSortArgs>>;
};


export type QueryResetPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResetPasswordsArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantsArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserTenantRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserTenantRolesArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};

export type Regulation = {
  __typename?: 'Regulation';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projects: PaginatedProject;
};

export type RegulationFilterArgs = {
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  projects?: InputMaybe<ProjectFilterArgs>;
};

export type RegulationRowDto = {
  __typename?: 'RegulationRowDTO';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RegulationSortArgs = {
  direction: SortDirection;
  field: RegulationSortFields;
};

export enum RegulationSortFields {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type ResetPassword = {
  __typename?: 'ResetPassword';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResetPasswordFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  token?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ResetPasswordSortArgs = {
  direction: SortDirection;
  field: ResetPasswordSortFields;
};

export enum ResetPasswordSortFields {
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  Token = 'token',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type Role = {
  __typename?: 'Role';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  machineName: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  permissions: PaginatedPermission;
  projectDateReminders: PaginatedProjectDateReminder;
  userTenantRoles: PaginatedUserTenantRole;
};

export type RoleFilterArgs = {
  description?: InputMaybe<StringFieldComparison>;
  displayName?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  order?: InputMaybe<NumberFieldComparison>;
  permissions?: InputMaybe<PermissionFilterArgs>;
  projectDateReminders?: InputMaybe<ProjectDateReminderFilterArgs>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type RoleSortArgs = {
  direction: SortDirection;
  field: RoleSortFields;
};

export enum RoleSortFields {
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  MachineName = 'machineName',
  Order = 'order'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  createdAvailability: Availability;
  createdBudget: Budget;
  createdBudgetLine: BudgetLine;
  createdCategory: Category;
  createdContent: Content;
  createdContentFill: ContentFill;
  createdContract: Contract;
  createdCustomer: Customer;
  createdDaysOff: DaysOff;
  createdErrorLog: ErrorLog;
  createdEventLog: EventLog;
  createdHoursRequired: HoursRequired;
  createdInvoice: Invoice;
  createdJob: Job;
  createdLoggedHour: LoggedHour;
  createdMailLog: MailLog;
  createdMailTemplate: MailTemplate;
  createdMailTemplateFill: MailTemplateFill;
  createdPermission: Permission;
  createdPlannedHour: PlannedHour;
  createdProductivity: Productivity;
  createdProject: Project;
  createdProjectDate: ProjectDate;
  createdProjectDateReminder: ProjectDateReminder;
  createdProjectDocument: ProjectDocument;
  createdRegulation: Regulation;
  createdResetPassword: ResetPassword;
  createdRole: Role;
  createdTenant: Tenant;
  createdUser: User;
  createdUserTenantRole: UserTenantRole;
  deletedAvailability: Availability;
  deletedBudget: Budget;
  deletedBudgetLine: BudgetLine;
  deletedCategory: Category;
  deletedContent: Content;
  deletedContentFill: ContentFill;
  deletedContract: Contract;
  deletedCustomer: Customer;
  deletedDaysOff: DaysOff;
  deletedErrorLog: ErrorLog;
  deletedEventLog: EventLog;
  deletedHoursRequired: HoursRequired;
  deletedInvoice: Invoice;
  deletedJob: Job;
  deletedLoggedHour: LoggedHour;
  deletedMailLog: MailLog;
  deletedMailTemplate: MailTemplate;
  deletedMailTemplateFill: MailTemplateFill;
  deletedPermission: Permission;
  deletedPlannedHour: PlannedHour;
  deletedProductivity: Productivity;
  deletedProject: Project;
  deletedProjectDate: ProjectDate;
  deletedProjectDateReminder: ProjectDateReminder;
  deletedProjectDocument: ProjectDocument;
  deletedRegulation: Regulation;
  deletedResetPassword: ResetPassword;
  deletedRole: Role;
  deletedTenant: Tenant;
  deletedUser: User;
  deletedUserTenantRole: UserTenantRole;
  restoredAvailability: Availability;
  restoredBudget: Budget;
  restoredBudgetLine: BudgetLine;
  restoredCategory: Category;
  restoredContract: Contract;
  restoredCustomer: Customer;
  restoredDaysOff: DaysOff;
  restoredErrorLog: ErrorLog;
  restoredEventLog: EventLog;
  restoredHoursRequired: HoursRequired;
  restoredInvoice: Invoice;
  restoredJob: Job;
  restoredLoggedHour: LoggedHour;
  restoredMailLog: MailLog;
  restoredPlannedHour: PlannedHour;
  restoredProductivity: Productivity;
  restoredProject: Project;
  restoredProjectDateReminder: ProjectDateReminder;
  restoredUser: User;
  updatedAvailability: Availability;
  updatedBudget: Budget;
  updatedBudgetLine: BudgetLine;
  updatedCategory: Category;
  updatedContent: Content;
  updatedContentFill: ContentFill;
  updatedContract: Contract;
  updatedCustomer: Customer;
  updatedDaysOff: DaysOff;
  updatedErrorLog: ErrorLog;
  updatedEventLog: EventLog;
  updatedHoursRequired: HoursRequired;
  updatedInvoice: Invoice;
  updatedJob: Job;
  updatedLoggedHour: LoggedHour;
  updatedMailLog: MailLog;
  updatedMailTemplate: MailTemplate;
  updatedMailTemplateFill: MailTemplateFill;
  updatedPermission: Permission;
  updatedPlannedHour: PlannedHour;
  updatedProductivity: Productivity;
  updatedProject: Project;
  updatedProjectDate: ProjectDate;
  updatedProjectDateReminder: ProjectDateReminder;
  updatedProjectDocument: ProjectDocument;
  updatedRegulation: Regulation;
  updatedResetPassword: ResetPassword;
  updatedRole: Role;
  updatedTenant: Tenant;
  updatedUser: User;
  updatedUserTenantRole: UserTenantRole;
};


export type SubscriptionCreatedAvailabilityArgs = {
  filter?: InputMaybe<AvailabilityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AvailabilitySortArgs>>;
};


export type SubscriptionCreatedBudgetArgs = {
  filter?: InputMaybe<BudgetFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetSortArgs>>;
};


export type SubscriptionCreatedBudgetLineArgs = {
  filter?: InputMaybe<BudgetLineFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetLineSortArgs>>;
};


export type SubscriptionCreatedCategoryArgs = {
  filter?: InputMaybe<CategoryFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CategorySortArgs>>;
};


export type SubscriptionCreatedContentArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type SubscriptionCreatedContentFillArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type SubscriptionCreatedContractArgs = {
  filter?: InputMaybe<ContractFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContractSortArgs>>;
};


export type SubscriptionCreatedCustomerArgs = {
  filter?: InputMaybe<CustomerFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CustomerSortArgs>>;
};


export type SubscriptionCreatedDaysOffArgs = {
  filter?: InputMaybe<DaysOffFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<DaysOffSortArgs>>;
};


export type SubscriptionCreatedErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionCreatedEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionCreatedHoursRequiredArgs = {
  filter?: InputMaybe<HoursRequiredFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<HoursRequiredSortArgs>>;
};


export type SubscriptionCreatedInvoiceArgs = {
  filter?: InputMaybe<InvoiceFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<InvoiceSortArgs>>;
};


export type SubscriptionCreatedJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionCreatedLoggedHourArgs = {
  filter?: InputMaybe<LoggedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<LoggedHourSortArgs>>;
};


export type SubscriptionCreatedMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionCreatedMailTemplateArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type SubscriptionCreatedMailTemplateFillArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type SubscriptionCreatedPermissionArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type SubscriptionCreatedPlannedHourArgs = {
  filter?: InputMaybe<PlannedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PlannedHourSortArgs>>;
};


export type SubscriptionCreatedProductivityArgs = {
  filter?: InputMaybe<ProductivityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProductivitySortArgs>>;
};


export type SubscriptionCreatedProjectArgs = {
  filter?: InputMaybe<ProjectFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectSortArgs>>;
};


export type SubscriptionCreatedProjectDateArgs = {
  filter?: InputMaybe<ProjectDateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateSortArgs>>;
};


export type SubscriptionCreatedProjectDateReminderArgs = {
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateReminderSortArgs>>;
};


export type SubscriptionCreatedProjectDocumentArgs = {
  filter?: InputMaybe<ProjectDocumentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDocumentSortArgs>>;
};


export type SubscriptionCreatedRegulationArgs = {
  filter?: InputMaybe<RegulationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegulationSortArgs>>;
};


export type SubscriptionCreatedResetPasswordArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type SubscriptionCreatedRoleArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type SubscriptionCreatedTenantArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type SubscriptionCreatedUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionCreatedUserTenantRoleArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};


export type SubscriptionDeletedAvailabilityArgs = {
  filter?: InputMaybe<AvailabilityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AvailabilitySortArgs>>;
};


export type SubscriptionDeletedBudgetArgs = {
  filter?: InputMaybe<BudgetFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetSortArgs>>;
};


export type SubscriptionDeletedBudgetLineArgs = {
  filter?: InputMaybe<BudgetLineFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetLineSortArgs>>;
};


export type SubscriptionDeletedCategoryArgs = {
  filter?: InputMaybe<CategoryFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CategorySortArgs>>;
};


export type SubscriptionDeletedContentArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type SubscriptionDeletedContentFillArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type SubscriptionDeletedContractArgs = {
  filter?: InputMaybe<ContractFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContractSortArgs>>;
};


export type SubscriptionDeletedCustomerArgs = {
  filter?: InputMaybe<CustomerFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CustomerSortArgs>>;
};


export type SubscriptionDeletedDaysOffArgs = {
  filter?: InputMaybe<DaysOffFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<DaysOffSortArgs>>;
};


export type SubscriptionDeletedErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionDeletedEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionDeletedHoursRequiredArgs = {
  filter?: InputMaybe<HoursRequiredFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<HoursRequiredSortArgs>>;
};


export type SubscriptionDeletedInvoiceArgs = {
  filter?: InputMaybe<InvoiceFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<InvoiceSortArgs>>;
};


export type SubscriptionDeletedJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionDeletedLoggedHourArgs = {
  filter?: InputMaybe<LoggedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<LoggedHourSortArgs>>;
};


export type SubscriptionDeletedMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionDeletedMailTemplateArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type SubscriptionDeletedMailTemplateFillArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type SubscriptionDeletedPermissionArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type SubscriptionDeletedPlannedHourArgs = {
  filter?: InputMaybe<PlannedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PlannedHourSortArgs>>;
};


export type SubscriptionDeletedProductivityArgs = {
  filter?: InputMaybe<ProductivityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProductivitySortArgs>>;
};


export type SubscriptionDeletedProjectArgs = {
  filter?: InputMaybe<ProjectFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectSortArgs>>;
};


export type SubscriptionDeletedProjectDateArgs = {
  filter?: InputMaybe<ProjectDateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateSortArgs>>;
};


export type SubscriptionDeletedProjectDateReminderArgs = {
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateReminderSortArgs>>;
};


export type SubscriptionDeletedProjectDocumentArgs = {
  filter?: InputMaybe<ProjectDocumentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDocumentSortArgs>>;
};


export type SubscriptionDeletedRegulationArgs = {
  filter?: InputMaybe<RegulationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegulationSortArgs>>;
};


export type SubscriptionDeletedResetPasswordArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type SubscriptionDeletedRoleArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type SubscriptionDeletedTenantArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type SubscriptionDeletedUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionDeletedUserTenantRoleArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};


export type SubscriptionRestoredAvailabilityArgs = {
  filter?: InputMaybe<AvailabilityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AvailabilitySortArgs>>;
};


export type SubscriptionRestoredBudgetArgs = {
  filter?: InputMaybe<BudgetFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetSortArgs>>;
};


export type SubscriptionRestoredBudgetLineArgs = {
  filter?: InputMaybe<BudgetLineFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetLineSortArgs>>;
};


export type SubscriptionRestoredCategoryArgs = {
  filter?: InputMaybe<CategoryFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CategorySortArgs>>;
};


export type SubscriptionRestoredContractArgs = {
  filter?: InputMaybe<ContractFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContractSortArgs>>;
};


export type SubscriptionRestoredCustomerArgs = {
  filter?: InputMaybe<CustomerFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CustomerSortArgs>>;
};


export type SubscriptionRestoredDaysOffArgs = {
  filter?: InputMaybe<DaysOffFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<DaysOffSortArgs>>;
};


export type SubscriptionRestoredErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionRestoredEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionRestoredHoursRequiredArgs = {
  filter?: InputMaybe<HoursRequiredFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<HoursRequiredSortArgs>>;
};


export type SubscriptionRestoredInvoiceArgs = {
  filter?: InputMaybe<InvoiceFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<InvoiceSortArgs>>;
};


export type SubscriptionRestoredJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionRestoredLoggedHourArgs = {
  filter?: InputMaybe<LoggedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<LoggedHourSortArgs>>;
};


export type SubscriptionRestoredMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionRestoredPlannedHourArgs = {
  filter?: InputMaybe<PlannedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PlannedHourSortArgs>>;
};


export type SubscriptionRestoredProductivityArgs = {
  filter?: InputMaybe<ProductivityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProductivitySortArgs>>;
};


export type SubscriptionRestoredProjectArgs = {
  filter?: InputMaybe<ProjectFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectSortArgs>>;
};


export type SubscriptionRestoredProjectDateReminderArgs = {
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateReminderSortArgs>>;
};


export type SubscriptionRestoredUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionUpdatedAvailabilityArgs = {
  filter?: InputMaybe<AvailabilityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AvailabilitySortArgs>>;
};


export type SubscriptionUpdatedBudgetArgs = {
  filter?: InputMaybe<BudgetFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetSortArgs>>;
};


export type SubscriptionUpdatedBudgetLineArgs = {
  filter?: InputMaybe<BudgetLineFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetLineSortArgs>>;
};


export type SubscriptionUpdatedCategoryArgs = {
  filter?: InputMaybe<CategoryFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CategorySortArgs>>;
};


export type SubscriptionUpdatedContentArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type SubscriptionUpdatedContentFillArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type SubscriptionUpdatedContractArgs = {
  filter?: InputMaybe<ContractFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContractSortArgs>>;
};


export type SubscriptionUpdatedCustomerArgs = {
  filter?: InputMaybe<CustomerFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CustomerSortArgs>>;
};


export type SubscriptionUpdatedDaysOffArgs = {
  filter?: InputMaybe<DaysOffFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<DaysOffSortArgs>>;
};


export type SubscriptionUpdatedErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionUpdatedEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionUpdatedHoursRequiredArgs = {
  filter?: InputMaybe<HoursRequiredFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<HoursRequiredSortArgs>>;
};


export type SubscriptionUpdatedInvoiceArgs = {
  filter?: InputMaybe<InvoiceFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<InvoiceSortArgs>>;
};


export type SubscriptionUpdatedJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionUpdatedLoggedHourArgs = {
  filter?: InputMaybe<LoggedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<LoggedHourSortArgs>>;
};


export type SubscriptionUpdatedMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionUpdatedMailTemplateArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type SubscriptionUpdatedMailTemplateFillArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type SubscriptionUpdatedPermissionArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type SubscriptionUpdatedPlannedHourArgs = {
  filter?: InputMaybe<PlannedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PlannedHourSortArgs>>;
};


export type SubscriptionUpdatedProductivityArgs = {
  filter?: InputMaybe<ProductivityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProductivitySortArgs>>;
};


export type SubscriptionUpdatedProjectArgs = {
  filter?: InputMaybe<ProjectFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectSortArgs>>;
};


export type SubscriptionUpdatedProjectDateArgs = {
  filter?: InputMaybe<ProjectDateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateSortArgs>>;
};


export type SubscriptionUpdatedProjectDateReminderArgs = {
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateReminderSortArgs>>;
};


export type SubscriptionUpdatedProjectDocumentArgs = {
  filter?: InputMaybe<ProjectDocumentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDocumentSortArgs>>;
};


export type SubscriptionUpdatedRegulationArgs = {
  filter?: InputMaybe<RegulationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegulationSortArgs>>;
};


export type SubscriptionUpdatedResetPasswordArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type SubscriptionUpdatedRoleArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type SubscriptionUpdatedTenantArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type SubscriptionUpdatedUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionUpdatedUserTenantRoleArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};

export type Tenant = {
  __typename?: 'Tenant';
  budgetLines: PaginatedBudgetLine;
  contactPerson?: Maybe<Scalars['String']['output']>;
  contracts: PaginatedContract;
  description?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceDetails?: Maybe<Scalars['String']['output']>;
  invoiceVatSubsidyEligible: Scalars['Boolean']['output'];
  invoices: PaginatedInvoice;
  kvk?: Maybe<Scalars['String']['output']>;
  loggedHours: PaginatedLoggedHour;
  mfaRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  projects: PaginatedProject;
  timeZone: Scalars['String']['output'];
  userTenantRoles: PaginatedUserTenantRole;
};

export type TenantFilterArgs = {
  budgetLines?: InputMaybe<BudgetLineFilterArgs>;
  contactPerson?: InputMaybe<StringFieldComparison>;
  contracts?: InputMaybe<ContractFilterArgs>;
  description?: InputMaybe<StringFieldComparison>;
  iban?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  invoiceDetails?: InputMaybe<StringFieldComparison>;
  invoiceVatSubsidyEligible?: InputMaybe<BooleanFieldComparison>;
  invoices?: InputMaybe<InvoiceFilterArgs>;
  kvk?: InputMaybe<StringFieldComparison>;
  loggedHours?: InputMaybe<LoggedHourFilterArgs>;
  mfaRequired?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  projects?: InputMaybe<ProjectFilterArgs>;
  timeZone?: InputMaybe<StringFieldComparison>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type TenantHo = {
  __typename?: 'TenantHO';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TenantSortArgs = {
  direction: SortDirection;
  field: TenantSortFields;
};

export enum TenantSortFields {
  ContactPerson = 'contactPerson',
  Description = 'description',
  Iban = 'iban',
  Id = 'id',
  InvoiceDetails = 'invoiceDetails',
  InvoiceVatSubsidyEligible = 'invoiceVatSubsidyEligible',
  Kvk = 'kvk',
  MfaRequired = 'mfaRequired',
  Name = 'name',
  TimeZone = 'timeZone'
}

export type UpdateLoggedHoursStatusType = {
  approvedById?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  approvedLoggedHours: PaginatedLoggedHour;
  availabilities: PaginatedAvailability;
  avatar?: Maybe<Scalars['String']['output']>;
  categories: PaginatedCategory;
  contracts: PaginatedContract;
  controllerForProjects: PaginatedProject;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  daysOffs: PaginatedDaysOff;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fullName: Scalars['String']['output'];
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  loggedHours: PaginatedLoggedHour;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  plannedHours: PaginatedPlannedHour;
  productivities: PaginatedProductivity;
  responsibleForProjects: PaginatedProject;
  termsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  timeZone: Scalars['String']['output'];
  totpVerified?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userTenantRoles: PaginatedUserTenantRole;
};

export type UserFilterArgs = {
  active?: InputMaybe<BooleanFieldComparison>;
  approvedLoggedHours?: InputMaybe<LoggedHourFilterArgs>;
  availabilities?: InputMaybe<AvailabilityFilterArgs>;
  avatar?: InputMaybe<StringFieldComparison>;
  categories?: InputMaybe<CategoryFilterArgs>;
  contracts?: InputMaybe<ContractFilterArgs>;
  controllerForProjects?: InputMaybe<ProjectFilterArgs>;
  createdAt?: InputMaybe<DateFieldComparison>;
  daysOffs?: InputMaybe<DaysOffFilterArgs>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  emailVerifiedAt?: InputMaybe<DateFieldComparison>;
  fullName?: InputMaybe<StringFieldComparison>;
  function?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  loggedHours?: InputMaybe<LoggedHourFilterArgs>;
  name?: InputMaybe<StringFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  phoneNumber?: InputMaybe<StringFieldComparison>;
  plannedHours?: InputMaybe<PlannedHourFilterArgs>;
  productivities?: InputMaybe<ProductivityFilterArgs>;
  responsibleForProjects?: InputMaybe<ProjectFilterArgs>;
  termsAndConditions?: InputMaybe<BooleanFieldComparison>;
  timeZone?: InputMaybe<StringFieldComparison>;
  totpVerified?: InputMaybe<BooleanFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type UserHo = {
  __typename?: 'UserHO';
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserSortArgs = {
  direction: SortDirection;
  field: UserSortFields;
};

export enum UserSortFields {
  Active = 'active',
  Avatar = 'avatar',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Email = 'email',
  EmailVerifiedAt = 'emailVerifiedAt',
  Function = 'function',
  Id = 'id',
  LastName = 'lastName',
  Locale = 'locale',
  Name = 'name',
  Note = 'note',
  PhoneNumber = 'phoneNumber',
  TermsAndConditions = 'termsAndConditions',
  TimeZone = 'timeZone',
  TotpVerified = 'totpVerified',
  UpdatedAt = 'updatedAt'
}

export type UserTenantRole = {
  __typename?: 'UserTenantRole';
  id: Scalars['ID']['output'];
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['ID']['output']>;
  role: Role;
  roleId: Scalars['ID']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type UserTenantRoleFilterArgs = {
  id?: InputMaybe<StringFieldComparison>;
  project?: InputMaybe<ProjectFilterArgs>;
  projectId?: InputMaybe<StringFieldComparison>;
  role?: InputMaybe<RoleFilterArgs>;
  roleId?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type UserTenantRoleSortArgs = {
  direction: SortDirection;
  field: UserTenantRoleSortFields;
};

export enum UserTenantRoleSortFields {
  Id = 'id'
}

export type AvailabilityFieldsFragment = { __typename?: 'Availability', id: string, month: any, availability: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null };

export type GetAvailabilitiesQueryVariables = Exact<{
  filter?: InputMaybe<AvailabilityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AvailabilitySortArgs> | AvailabilitySortArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAvailabilitiesQuery = { __typename?: 'Query', availabilities: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null }> | null } };

export type GetAvailabilityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAvailabilityQuery = { __typename?: 'Query', availability?: { __typename?: 'Availability', id: string, month: any, availability: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } | null };

export type GetAllRelatedDataForAvailabilityQueryVariables = Exact<{
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForAvailabilityQuery = { __typename?: 'Query', users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null } };

export type CreateAvailabilityMutationVariables = Exact<{
  month: Scalars['DateTime']['input'];
  availability: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAvailabilityMutation = { __typename?: 'Mutation', createAvailability: { __typename?: 'Availability', id: string, month: any, availability: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdateAvailabilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  month?: InputMaybe<Scalars['DateTime']['input']>;
  availability?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAvailabilityMutation = { __typename?: 'Mutation', updateAvailability: { __typename?: 'Availability', id: string, month: any, availability: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeleteAvailabilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteAvailabilityMutation = { __typename?: 'Mutation', deleteAvailability: { __typename?: 'Availability', id: string, month: any, availability: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type CreatedAvailabilitySubscriptionVariables = Exact<{
  filter?: InputMaybe<AvailabilityFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedAvailabilitySubscription = { __typename?: 'Subscription', createdAvailability: { __typename?: 'Availability', id: string, month: any, availability: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdatedAvailabilitySubscriptionVariables = Exact<{
  filter?: InputMaybe<AvailabilityFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedAvailabilitySubscription = { __typename?: 'Subscription', updatedAvailability: { __typename?: 'Availability', id: string, month: any, availability: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeletedAvailabilitySubscriptionVariables = Exact<{
  filter?: InputMaybe<AvailabilityFilterArgs>;
}>;


export type DeletedAvailabilitySubscription = { __typename?: 'Subscription', deletedAvailability: { __typename?: 'Availability', id: string } };

export type RestoredAvailabilitySubscriptionVariables = Exact<{
  filter?: InputMaybe<AvailabilityFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredAvailabilitySubscription = { __typename?: 'Subscription', restoredAvailability: { __typename?: 'Availability', id: string, month: any, availability: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type BudgetFieldsFragment = { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } };

export type GetBudgetsQueryVariables = Exact<{
  filter?: InputMaybe<BudgetFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetSortArgs> | BudgetSortArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBudgetsQuery = { __typename?: 'Query', budgets: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetBudgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBudgetQuery = { __typename?: 'Query', budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForBudgetQueryVariables = Exact<{
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForBudgetQuery = { __typename?: 'Query', projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', items?: Array<{ __typename?: 'BudgetLine', id: string, displayField: string }> | null } };

export type CreateBudgetMutationVariables = Exact<{
  total?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  completionDate?: InputMaybe<Scalars['DateTime']['input']>;
  note: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  budgetLines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateBudgetMutation = { __typename?: 'Mutation', createBudget: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdateBudgetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  total?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  completionDate?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  budgetLines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateBudgetMutation = { __typename?: 'Mutation', updateBudget: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeleteBudgetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteBudgetMutation = { __typename?: 'Mutation', deleteBudget: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type CreatedBudgetSubscriptionVariables = Exact<{
  filter?: InputMaybe<BudgetFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedBudgetSubscription = { __typename?: 'Subscription', createdBudget: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdatedBudgetSubscriptionVariables = Exact<{
  filter?: InputMaybe<BudgetFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedBudgetSubscription = { __typename?: 'Subscription', updatedBudget: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeletedBudgetSubscriptionVariables = Exact<{
  filter?: InputMaybe<BudgetFilterArgs>;
}>;


export type DeletedBudgetSubscription = { __typename?: 'Subscription', deletedBudget: { __typename?: 'Budget', id: string } };

export type RestoredBudgetSubscriptionVariables = Exact<{
  filter?: InputMaybe<BudgetFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredBudgetSubscription = { __typename?: 'Subscription', restoredBudget: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type BudgetLineFieldsFragment = { __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetBudgetLinesQueryVariables = Exact<{
  filter?: InputMaybe<BudgetLineFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetLineSortArgs> | BudgetLineSortArgs>;
  withBudget?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBudgetLinesQuery = { __typename?: 'Query', budgetLines: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetBudgetLineQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withBudget?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBudgetLineQuery = { __typename?: 'Query', budgetLine?: { __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForBudgetLineQueryVariables = Exact<{
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForBudgetLineQuery = { __typename?: 'Query', budgets?: { __typename?: 'PaginatedBudget', items?: Array<{ __typename?: 'Budget', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, displayField: string }> | null } };

export type CreateBudgetLineMutationVariables = Exact<{
  hours?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  hourCosts?: InputMaybe<Scalars['Float']['input']>;
  invoiceCosts?: InputMaybe<Scalars['Float']['input']>;
  budgetId: Scalars['ID']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  withBudget?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateBudgetLineMutation = { __typename?: 'Mutation', createBudgetLine: { __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdateBudgetLineMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  hours?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  hourCosts?: InputMaybe<Scalars['Float']['input']>;
  invoiceCosts?: InputMaybe<Scalars['Float']['input']>;
  budgetId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  withBudget?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateBudgetLineMutation = { __typename?: 'Mutation', updateBudgetLine: { __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeleteBudgetLineMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withBudget?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteBudgetLineMutation = { __typename?: 'Mutation', deleteBudgetLine: { __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedBudgetLineSubscriptionVariables = Exact<{
  filter?: InputMaybe<BudgetLineFilterArgs>;
  withBudget?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedBudgetLineSubscription = { __typename?: 'Subscription', createdBudgetLine: { __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedBudgetLineSubscriptionVariables = Exact<{
  filter?: InputMaybe<BudgetLineFilterArgs>;
  withBudget?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedBudgetLineSubscription = { __typename?: 'Subscription', updatedBudgetLine: { __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedBudgetLineSubscriptionVariables = Exact<{
  filter?: InputMaybe<BudgetLineFilterArgs>;
}>;


export type DeletedBudgetLineSubscription = { __typename?: 'Subscription', deletedBudgetLine: { __typename?: 'BudgetLine', id: string } };

export type RestoredBudgetLineSubscriptionVariables = Exact<{
  filter?: InputMaybe<BudgetLineFilterArgs>;
  withBudget?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredBudgetLineSubscription = { __typename?: 'Subscription', restoredBudgetLine: { __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, budget?: { __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CategoryFieldsFragment = { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, parentCategory?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, subCategories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string }> | null } };

export type GetCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<CategoryFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CategorySortArgs> | CategorySortArgs>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withSubCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', categories: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, parentCategory?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, subCategories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string }> | null } }> | null } };

export type GetCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withSubCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCategoryQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, parentCategory?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, subCategories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForCategoryQueryVariables = Exact<{
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withParentCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withSubCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForCategoryQuery = { __typename?: 'Query', loggedHours?: { __typename?: 'PaginatedLoggedHour', items?: Array<{ __typename?: 'LoggedHour', id: string, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', items?: Array<{ __typename?: 'BudgetLine', id: string, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', items?: Array<{ __typename?: 'Invoice', id: string, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null } };

export type CreateCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
  subsidyPercentage?: InputMaybe<Scalars['Float']['input']>;
  hasHours: Scalars['Boolean']['input'];
  hasInvoices: Scalars['Boolean']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  loggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  budgetLines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  subCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withSubCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, parentCategory?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, subCategories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string }> | null } } };

export type UpdateCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subsidyPercentage?: InputMaybe<Scalars['Float']['input']>;
  hasHours?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  loggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  budgetLines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  subCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withSubCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, parentCategory?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, subCategories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string }> | null } } };

export type DeleteCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withSubCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, parentCategory?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, subCategories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string }> | null } } };

export type CreatedCategorySubscriptionVariables = Exact<{
  filter?: InputMaybe<CategoryFilterArgs>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withSubCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedCategorySubscription = { __typename?: 'Subscription', createdCategory: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, parentCategory?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, subCategories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string }> | null } } };

export type UpdatedCategorySubscriptionVariables = Exact<{
  filter?: InputMaybe<CategoryFilterArgs>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withSubCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedCategorySubscription = { __typename?: 'Subscription', updatedCategory: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, parentCategory?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, subCategories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string }> | null } } };

export type DeletedCategorySubscriptionVariables = Exact<{
  filter?: InputMaybe<CategoryFilterArgs>;
}>;


export type DeletedCategorySubscription = { __typename?: 'Subscription', deletedCategory: { __typename?: 'Category', id: string } };

export type RestoredCategorySubscriptionVariables = Exact<{
  filter?: InputMaybe<CategoryFilterArgs>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withSubCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredCategorySubscription = { __typename?: 'Subscription', restoredCategory: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, parentCategory?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, subCategories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string }> | null } } };

export type ContentFieldsFragment = { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } };

export type GetContentsQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs> | ContentSortArgs>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentsQuery = { __typename?: 'Query', contents: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } }> | null } };

export type GetContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentQuery = { __typename?: 'Query', content?: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } | null };

export type GetAllRelatedDataForContentQueryVariables = Exact<{
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForContentQuery = { __typename?: 'Query', contentFills?: { __typename?: 'PaginatedContentFill', items?: Array<{ __typename?: 'ContentFill', id: string, displayField: string }> | null } };

export type CreateContentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  contentFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateContentMutation = { __typename?: 'Mutation', createContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type UpdateContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  contentFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateContentMutation = { __typename?: 'Mutation', updateContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type DeleteContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteContentMutation = { __typename?: 'Mutation', deleteContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type CreatedContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedContentSubscription = { __typename?: 'Subscription', createdContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type UpdatedContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedContentSubscription = { __typename?: 'Subscription', updatedContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type DeletedContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
}>;


export type DeletedContentSubscription = { __typename?: 'Subscription', deletedContent: { __typename?: 'Content', id: string } };

export type ContentFillFieldsFragment = { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } };

export type GetContentFillsQueryVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs> | ContentFillSortArgs>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentFillsQuery = { __typename?: 'Query', contentFills: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } }> | null } };

export type GetContentFillQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentFillQuery = { __typename?: 'Query', contentFill?: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } | null };

export type GetAllRelatedDataForContentFillQueryVariables = Exact<{
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForContentFillQuery = { __typename?: 'Query', contents?: { __typename?: 'PaginatedContent', items?: Array<{ __typename?: 'Content', id: string, displayField: string }> | null } };

export type CreateContentFillMutationVariables = Exact<{
  fill: Scalars['String']['input'];
  language: Scalars['String']['input'];
  contentId: Scalars['ID']['input'];
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateContentFillMutation = { __typename?: 'Mutation', createContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type UpdateContentFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fill?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['ID']['input']>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateContentFillMutation = { __typename?: 'Mutation', updateContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type DeleteContentFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteContentFillMutation = { __typename?: 'Mutation', deleteContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type CreatedContentFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedContentFillSubscription = { __typename?: 'Subscription', createdContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type UpdatedContentFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedContentFillSubscription = { __typename?: 'Subscription', updatedContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type DeletedContentFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
}>;


export type DeletedContentFillSubscription = { __typename?: 'Subscription', deletedContentFill: { __typename?: 'ContentFill', id: string } };

export type ContractFieldsFragment = { __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetContractsQueryVariables = Exact<{
  filter?: InputMaybe<ContractFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContractSortArgs> | ContractSortArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContractsQuery = { __typename?: 'Query', contracts: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetContractQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContractQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForContractQueryVariables = Exact<{
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForContractQuery = { __typename?: 'Query', users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null } };

export type CreateContractMutationVariables = Exact<{
  hoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  costPerHour: Scalars['Float']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  customCostPerHour?: InputMaybe<Scalars['Float']['input']>;
  salarySlip?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdateContractMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  hoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  costPerHour?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  customCostPerHour?: InputMaybe<Scalars['Float']['input']>;
  salarySlip?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: { __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeleteContractMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteContractMutation = { __typename?: 'Mutation', deleteContract: { __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedContractSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContractFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedContractSubscription = { __typename?: 'Subscription', createdContract: { __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedContractSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContractFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedContractSubscription = { __typename?: 'Subscription', updatedContract: { __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedContractSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContractFilterArgs>;
}>;


export type DeletedContractSubscription = { __typename?: 'Subscription', deletedContract: { __typename?: 'Contract', id: string } };

export type RestoredContractSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContractFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredContractSubscription = { __typename?: 'Subscription', restoredContract: { __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CustomerFieldsFragment = { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } };

export type GetCustomersQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<CustomerSortArgs> | CustomerSortArgs>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomersQuery = { __typename?: 'Query', customers: { __typename?: 'PaginatedCustomer', totalCount: number, items?: Array<{ __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetCustomerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForCustomerQueryVariables = Exact<{
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForCustomerQuery = { __typename?: 'Query', projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null } };

export type CreateCustomerMutationVariables = Exact<{
  name: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdateCustomerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type CreatedCustomerSubscriptionVariables = Exact<{
  filter?: InputMaybe<CustomerFilterArgs>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedCustomerSubscription = { __typename?: 'Subscription', createdCustomer: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdatedCustomerSubscriptionVariables = Exact<{
  filter?: InputMaybe<CustomerFilterArgs>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedCustomerSubscription = { __typename?: 'Subscription', updatedCustomer: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeletedCustomerSubscriptionVariables = Exact<{
  filter?: InputMaybe<CustomerFilterArgs>;
}>;


export type DeletedCustomerSubscription = { __typename?: 'Subscription', deletedCustomer: { __typename?: 'Customer', id: string } };

export type RestoredCustomerSubscriptionVariables = Exact<{
  filter?: InputMaybe<CustomerFilterArgs>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredCustomerSubscription = { __typename?: 'Subscription', restoredCustomer: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DaysOffFieldsFragment = { __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null };

export type GetDaysOffsQueryVariables = Exact<{
  filter?: InputMaybe<DaysOffFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<DaysOffSortArgs> | DaysOffSortArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDaysOffsQuery = { __typename?: 'Query', daysOffs: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null }> | null } };

export type GetDaysOffQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDaysOffQuery = { __typename?: 'Query', daysOff?: { __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } | null };

export type GetAllRelatedDataForDaysOffQueryVariables = Exact<{
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForDaysOffQuery = { __typename?: 'Query', users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null } };

export type CreateDaysOffMutationVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateDaysOffMutation = { __typename?: 'Mutation', createDaysOff: { __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdateDaysOffMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateDaysOffMutation = { __typename?: 'Mutation', updateDaysOff: { __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeleteDaysOffMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDaysOffMutation = { __typename?: 'Mutation', deleteDaysOff: { __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type CreatedDaysOffSubscriptionVariables = Exact<{
  filter?: InputMaybe<DaysOffFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedDaysOffSubscription = { __typename?: 'Subscription', createdDaysOff: { __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdatedDaysOffSubscriptionVariables = Exact<{
  filter?: InputMaybe<DaysOffFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedDaysOffSubscription = { __typename?: 'Subscription', updatedDaysOff: { __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeletedDaysOffSubscriptionVariables = Exact<{
  filter?: InputMaybe<DaysOffFilterArgs>;
}>;


export type DeletedDaysOffSubscription = { __typename?: 'Subscription', deletedDaysOff: { __typename?: 'DaysOff', id: string } };

export type RestoredDaysOffSubscriptionVariables = Exact<{
  filter?: InputMaybe<DaysOffFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredDaysOffSubscription = { __typename?: 'Subscription', restoredDaysOff: { __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type ErrorLogFieldsFragment = { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetErrorLogsQueryVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs> | ErrorLogSortArgs>;
}>;


export type GetErrorLogsQuery = { __typename?: 'Query', errorLogs: { __typename?: 'PaginatedErrorLog', totalCount: number, items?: Array<{ __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetErrorLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetErrorLogQuery = { __typename?: 'Query', errorLog?: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateErrorLogMutationVariables = Exact<{
  error: Scalars['String']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
}>;


export type CreateErrorLogMutation = { __typename?: 'Mutation', createErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateErrorLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  stack?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateErrorLogMutation = { __typename?: 'Mutation', updateErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteErrorLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteErrorLogMutation = { __typename?: 'Mutation', deleteErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type CreatedErrorLogSubscription = { __typename?: 'Subscription', createdErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type UpdatedErrorLogSubscription = { __typename?: 'Subscription', updatedErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type DeletedErrorLogSubscription = { __typename?: 'Subscription', deletedErrorLog: { __typename?: 'ErrorLog', id: string } };

export type RestoredErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type RestoredErrorLogSubscription = { __typename?: 'Subscription', restoredErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type EventLogFieldsFragment = { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetEventLogsQueryVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs> | EventLogSortArgs>;
}>;


export type GetEventLogsQuery = { __typename?: 'Query', eventLogs: { __typename?: 'PaginatedEventLog', totalCount: number, items?: Array<{ __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetEventLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEventLogQuery = { __typename?: 'Query', eventLog?: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateEventLogMutationVariables = Exact<{
  log: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type CreateEventLogMutation = { __typename?: 'Mutation', createEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateEventLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEventLogMutation = { __typename?: 'Mutation', updateEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteEventLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEventLogMutation = { __typename?: 'Mutation', deleteEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type CreatedEventLogSubscription = { __typename?: 'Subscription', createdEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type UpdatedEventLogSubscription = { __typename?: 'Subscription', updatedEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type DeletedEventLogSubscription = { __typename?: 'Subscription', deletedEventLog: { __typename?: 'EventLog', id: string } };

export type RestoredEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type RestoredEventLogSubscription = { __typename?: 'Subscription', restoredEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type HoursRequiredFieldsFragment = { __typename?: 'HoursRequired', id: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetHoursRequiredsQueryVariables = Exact<{
  filter?: InputMaybe<HoursRequiredFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<HoursRequiredSortArgs> | HoursRequiredSortArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetHoursRequiredsQuery = { __typename?: 'Query', hoursRequireds: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetHoursRequiredQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetHoursRequiredQuery = { __typename?: 'Query', hoursRequired?: { __typename?: 'HoursRequired', id: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForHoursRequiredQueryVariables = Exact<{
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForHoursRequiredQuery = { __typename?: 'Query', projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null } };

export type CreateHoursRequiredMutationVariables = Exact<{
  month: Scalars['DateTime']['input'];
  perMonth: Scalars['Int']['input'];
  projectId: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateHoursRequiredMutation = { __typename?: 'Mutation', createHoursRequired: { __typename?: 'HoursRequired', id: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdateHoursRequiredMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  month?: InputMaybe<Scalars['DateTime']['input']>;
  perMonth?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateHoursRequiredMutation = { __typename?: 'Mutation', updateHoursRequired: { __typename?: 'HoursRequired', id: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeleteHoursRequiredMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteHoursRequiredMutation = { __typename?: 'Mutation', deleteHoursRequired: { __typename?: 'HoursRequired', id: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedHoursRequiredSubscriptionVariables = Exact<{
  filter?: InputMaybe<HoursRequiredFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedHoursRequiredSubscription = { __typename?: 'Subscription', createdHoursRequired: { __typename?: 'HoursRequired', id: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedHoursRequiredSubscriptionVariables = Exact<{
  filter?: InputMaybe<HoursRequiredFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedHoursRequiredSubscription = { __typename?: 'Subscription', updatedHoursRequired: { __typename?: 'HoursRequired', id: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedHoursRequiredSubscriptionVariables = Exact<{
  filter?: InputMaybe<HoursRequiredFilterArgs>;
}>;


export type DeletedHoursRequiredSubscription = { __typename?: 'Subscription', deletedHoursRequired: { __typename?: 'HoursRequired', id: string } };

export type RestoredHoursRequiredSubscriptionVariables = Exact<{
  filter?: InputMaybe<HoursRequiredFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredHoursRequiredSubscription = { __typename?: 'Subscription', restoredHoursRequired: { __typename?: 'HoursRequired', id: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type InvoiceFieldsFragment = { __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetInvoicesQueryVariables = Exact<{
  filter?: InputMaybe<InvoiceFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<InvoiceSortArgs> | InvoiceSortArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetInvoiceQuery = { __typename?: 'Query', invoice?: { __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForInvoiceQueryVariables = Exact<{
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForInvoiceQuery = { __typename?: 'Query', tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, displayField: string }> | null } };

export type CreateInvoiceMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  status: Scalars['String']['input'];
  total: Scalars['Float']['input'];
  vat?: InputMaybe<Scalars['Float']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  attachmentProof?: InputMaybe<Scalars['String']['input']>;
  subsidyPercentage?: InputMaybe<Scalars['Int']['input']>;
  vatSubsidyEligible: Scalars['Boolean']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  paidOn?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdateInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  attachmentProof?: InputMaybe<Scalars['String']['input']>;
  subsidyPercentage?: InputMaybe<Scalars['Int']['input']>;
  vatSubsidyEligible?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  paidOn?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice: { __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeleteInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteInvoiceMutation = { __typename?: 'Mutation', deleteInvoice: { __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedInvoiceSubscriptionVariables = Exact<{
  filter?: InputMaybe<InvoiceFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedInvoiceSubscription = { __typename?: 'Subscription', createdInvoice: { __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedInvoiceSubscriptionVariables = Exact<{
  filter?: InputMaybe<InvoiceFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedInvoiceSubscription = { __typename?: 'Subscription', updatedInvoice: { __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedInvoiceSubscriptionVariables = Exact<{
  filter?: InputMaybe<InvoiceFilterArgs>;
}>;


export type DeletedInvoiceSubscription = { __typename?: 'Subscription', deletedInvoice: { __typename?: 'Invoice', id: string } };

export type RestoredInvoiceSubscriptionVariables = Exact<{
  filter?: InputMaybe<InvoiceFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredInvoiceSubscription = { __typename?: 'Subscription', restoredInvoice: { __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type JobFieldsFragment = { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetJobsQueryVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs> | JobSortArgs>;
}>;


export type GetJobsQuery = { __typename?: 'Query', jobs: { __typename?: 'PaginatedJob', totalCount: number, items?: Array<{ __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetJobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJobQuery = { __typename?: 'Query', job?: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateJobMutationVariables = Exact<{
  queue: Scalars['String']['input'];
  status: Scalars['String']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  queue?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type CreatedJobSubscription = { __typename?: 'Subscription', createdJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type UpdatedJobSubscription = { __typename?: 'Subscription', updatedJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type DeletedJobSubscription = { __typename?: 'Subscription', deletedJob: { __typename?: 'Job', id: string } };

export type RestoredJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type RestoredJobSubscription = { __typename?: 'Subscription', restoredJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type LoggedHourFieldsFragment = { __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, approvedBy?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null };

export type GetLoggedHoursQueryVariables = Exact<{
  filter?: InputMaybe<LoggedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<LoggedHourSortArgs> | LoggedHourSortArgs>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLoggedHoursQuery = { __typename?: 'Query', loggedHours: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, approvedBy?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null }> | null } };

export type GetLoggedHourQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLoggedHourQuery = { __typename?: 'Query', loggedHour?: { __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, approvedBy?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null } | null };

export type GetAllRelatedDataForLoggedHourQueryVariables = Exact<{
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedBies?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForLoggedHourQuery = { __typename?: 'Query', categories?: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null } };

export type CreateLoggedHourMutationVariables = Exact<{
  description: Scalars['String']['input'];
  startDatetime: Scalars['DateTime']['input'];
  endDatetime: Scalars['DateTime']['input'];
  break: Scalars['Int']['input'];
  declarableTime?: InputMaybe<Scalars['Int']['input']>;
  addendum?: InputMaybe<Scalars['Boolean']['input']>;
  declarable?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  categoryId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  approvedById?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateLoggedHourMutation = { __typename?: 'Mutation', createLoggedHour: { __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, approvedBy?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null } };

export type UpdateLoggedHourMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  break?: InputMaybe<Scalars['Int']['input']>;
  declarableTime?: InputMaybe<Scalars['Int']['input']>;
  addendum?: InputMaybe<Scalars['Boolean']['input']>;
  declarable?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  approvedById?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateLoggedHourMutation = { __typename?: 'Mutation', updateLoggedHour: { __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, approvedBy?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null } };

export type DeleteLoggedHourMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteLoggedHourMutation = { __typename?: 'Mutation', deleteLoggedHour: { __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, approvedBy?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null } };

export type CreatedLoggedHourSubscriptionVariables = Exact<{
  filter?: InputMaybe<LoggedHourFilterArgs>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedLoggedHourSubscription = { __typename?: 'Subscription', createdLoggedHour: { __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, approvedBy?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null } };

export type UpdatedLoggedHourSubscriptionVariables = Exact<{
  filter?: InputMaybe<LoggedHourFilterArgs>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedLoggedHourSubscription = { __typename?: 'Subscription', updatedLoggedHour: { __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, approvedBy?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null } };

export type DeletedLoggedHourSubscriptionVariables = Exact<{
  filter?: InputMaybe<LoggedHourFilterArgs>;
}>;


export type DeletedLoggedHourSubscription = { __typename?: 'Subscription', deletedLoggedHour: { __typename?: 'LoggedHour', id: string } };

export type RestoredLoggedHourSubscriptionVariables = Exact<{
  filter?: InputMaybe<LoggedHourFilterArgs>;
  withCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredLoggedHourSubscription = { __typename?: 'Subscription', restoredLoggedHour: { __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, category?: { __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, approvedBy?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string } | null } };

export type MailLogFieldsFragment = { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetMailLogsQueryVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs> | MailLogSortArgs>;
}>;


export type GetMailLogsQuery = { __typename?: 'Query', mailLogs: { __typename?: 'PaginatedMailLog', totalCount: number, items?: Array<{ __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetMailLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMailLogQuery = { __typename?: 'Query', mailLog?: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateMailLogMutationVariables = Exact<{
  sentTo: Scalars['String']['input'];
  sentBy: Scalars['String']['input'];
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMailLogMutation = { __typename?: 'Mutation', createMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateMailLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sentTo?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMailLogMutation = { __typename?: 'Mutation', updateMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteMailLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMailLogMutation = { __typename?: 'Mutation', deleteMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type CreatedMailLogSubscription = { __typename?: 'Subscription', createdMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type UpdatedMailLogSubscription = { __typename?: 'Subscription', updatedMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type DeletedMailLogSubscription = { __typename?: 'Subscription', deletedMailLog: { __typename?: 'MailLog', id: string } };

export type RestoredMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type RestoredMailLogSubscription = { __typename?: 'Subscription', restoredMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type MailTemplateFieldsFragment = { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null } };

export type GetMailTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs> | MailTemplateSortArgs>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplatesQuery = { __typename?: 'Query', mailTemplates: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null } }> | null } };

export type GetMailTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateQuery = { __typename?: 'Query', mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null } } | null };

export type GetAllRelatedDataForMailTemplateQueryVariables = Exact<{
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMailTemplateQuery = { __typename?: 'Query', mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', items?: Array<{ __typename?: 'MailTemplateFill', id: string, displayField?: string | null }> | null } };

export type CreateMailTemplateMutationVariables = Exact<{
  active: Scalars['Boolean']['input'];
  mailTemplateFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMailTemplateMutation = { __typename?: 'Mutation', createMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null } } };

export type UpdateMailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  mailTemplateFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMailTemplateMutation = { __typename?: 'Mutation', updateMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null } } };

export type DeleteMailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMailTemplateMutation = { __typename?: 'Mutation', deleteMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null } } };

export type CreatedMailTemplateSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMailTemplateSubscription = { __typename?: 'Subscription', createdMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null } } };

export type UpdatedMailTemplateSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMailTemplateSubscription = { __typename?: 'Subscription', updatedMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null } } };

export type DeletedMailTemplateSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
}>;


export type DeletedMailTemplateSubscription = { __typename?: 'Subscription', deletedMailTemplate: { __typename?: 'MailTemplate', id: string } };

export type MailTemplateFillFieldsFragment = { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } };

export type GetMailTemplateFillsQueryVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs> | MailTemplateFillSortArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateFillsQuery = { __typename?: 'Query', mailTemplateFills: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } }> | null } };

export type GetMailTemplateFillQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateFillQuery = { __typename?: 'Query', mailTemplateFill?: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } | null };

export type GetAllRelatedDataForMailTemplateFillQueryVariables = Exact<{
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMailTemplateFillQuery = { __typename?: 'Query', mailTemplates?: { __typename?: 'PaginatedMailTemplate', items?: Array<{ __typename?: 'MailTemplate', id: string, displayField: string }> | null } };

export type CreateMailTemplateFillMutationVariables = Exact<{
  subject: Scalars['String']['input'];
  urlText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  plainText: Scalars['String']['input'];
  language: Scalars['String']['input'];
  mailTemplateId: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMailTemplateFillMutation = { __typename?: 'Mutation', createMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type UpdateMailTemplateFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  plainText?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMailTemplateFillMutation = { __typename?: 'Mutation', updateMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type DeleteMailTemplateFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMailTemplateFillMutation = { __typename?: 'Mutation', deleteMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type CreatedMailTemplateFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMailTemplateFillSubscription = { __typename?: 'Subscription', createdMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type UpdatedMailTemplateFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMailTemplateFillSubscription = { __typename?: 'Subscription', updatedMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type DeletedMailTemplateFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
}>;


export type DeletedMailTemplateFillSubscription = { __typename?: 'Subscription', deletedMailTemplateFill: { __typename?: 'MailTemplateFill', id: string } };

export type PermissionFieldsFragment = { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } };

export type GetPermissionsQueryVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs> | PermissionSortArgs>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPermissionsQuery = { __typename?: 'Query', permissions: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } }> | null } };

export type GetPermissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPermissionQuery = { __typename?: 'Query', permission?: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } | null };

export type GetAllRelatedDataForPermissionQueryVariables = Exact<{
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForPermissionQuery = { __typename?: 'Query', roles?: { __typename?: 'PaginatedRole', items?: Array<{ __typename?: 'Role', id: string, displayField: string }> | null } };

export type CreatePermissionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePermissionMutation = { __typename?: 'Mutation', createPermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type UpdatePermissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePermissionMutation = { __typename?: 'Mutation', updatePermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type DeletePermissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeletePermissionMutation = { __typename?: 'Mutation', deletePermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type CreatedPermissionSubscriptionVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedPermissionSubscription = { __typename?: 'Subscription', createdPermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type UpdatedPermissionSubscriptionVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedPermissionSubscription = { __typename?: 'Subscription', updatedPermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type DeletedPermissionSubscriptionVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
}>;


export type DeletedPermissionSubscription = { __typename?: 'Subscription', deletedPermission: { __typename?: 'Permission', id: string } };

export type PlannedHourFieldsFragment = { __typename?: 'PlannedHour', id: string, month: any, hours: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null };

export type GetPlannedHoursQueryVariables = Exact<{
  filter?: InputMaybe<PlannedHourFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PlannedHourSortArgs> | PlannedHourSortArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPlannedHoursQuery = { __typename?: 'Query', plannedHours: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null }> | null } };

export type GetPlannedHourQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPlannedHourQuery = { __typename?: 'Query', plannedHour?: { __typename?: 'PlannedHour', id: string, month: any, hours: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } | null };

export type GetAllRelatedDataForPlannedHourQueryVariables = Exact<{
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForPlannedHourQuery = { __typename?: 'Query', projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null } };

export type CreatePlannedHourMutationVariables = Exact<{
  month: Scalars['DateTime']['input'];
  hours: Scalars['Float']['input'];
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePlannedHourMutation = { __typename?: 'Mutation', createPlannedHour: { __typename?: 'PlannedHour', id: string, month: any, hours: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdatePlannedHourMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  month?: InputMaybe<Scalars['DateTime']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePlannedHourMutation = { __typename?: 'Mutation', updatePlannedHour: { __typename?: 'PlannedHour', id: string, month: any, hours: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeletePlannedHourMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeletePlannedHourMutation = { __typename?: 'Mutation', deletePlannedHour: { __typename?: 'PlannedHour', id: string, month: any, hours: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type CreatedPlannedHourSubscriptionVariables = Exact<{
  filter?: InputMaybe<PlannedHourFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedPlannedHourSubscription = { __typename?: 'Subscription', createdPlannedHour: { __typename?: 'PlannedHour', id: string, month: any, hours: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdatedPlannedHourSubscriptionVariables = Exact<{
  filter?: InputMaybe<PlannedHourFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedPlannedHourSubscription = { __typename?: 'Subscription', updatedPlannedHour: { __typename?: 'PlannedHour', id: string, month: any, hours: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeletedPlannedHourSubscriptionVariables = Exact<{
  filter?: InputMaybe<PlannedHourFilterArgs>;
}>;


export type DeletedPlannedHourSubscription = { __typename?: 'Subscription', deletedPlannedHour: { __typename?: 'PlannedHour', id: string } };

export type RestoredPlannedHourSubscriptionVariables = Exact<{
  filter?: InputMaybe<PlannedHourFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredPlannedHourSubscription = { __typename?: 'Subscription', restoredPlannedHour: { __typename?: 'PlannedHour', id: string, month: any, hours: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type ProductivityFieldsFragment = { __typename?: 'Productivity', id: string, startDate: any, factor: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null };

export type GetProductivitiesQueryVariables = Exact<{
  filter?: InputMaybe<ProductivityFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProductivitySortArgs> | ProductivitySortArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProductivitiesQuery = { __typename?: 'Query', productivities: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null }> | null } };

export type GetProductivityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProductivityQuery = { __typename?: 'Query', productivity?: { __typename?: 'Productivity', id: string, startDate: any, factor: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } | null };

export type GetAllRelatedDataForProductivityQueryVariables = Exact<{
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForProductivityQuery = { __typename?: 'Query', users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null } };

export type CreateProductivityMutationVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  factor: Scalars['Float']['input'];
  userId: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateProductivityMutation = { __typename?: 'Mutation', createProductivity: { __typename?: 'Productivity', id: string, startDate: any, factor: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdateProductivityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  factor?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProductivityMutation = { __typename?: 'Mutation', updateProductivity: { __typename?: 'Productivity', id: string, startDate: any, factor: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeleteProductivityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteProductivityMutation = { __typename?: 'Mutation', deleteProductivity: { __typename?: 'Productivity', id: string, startDate: any, factor: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type CreatedProductivitySubscriptionVariables = Exact<{
  filter?: InputMaybe<ProductivityFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedProductivitySubscription = { __typename?: 'Subscription', createdProductivity: { __typename?: 'Productivity', id: string, startDate: any, factor: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdatedProductivitySubscriptionVariables = Exact<{
  filter?: InputMaybe<ProductivityFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedProductivitySubscription = { __typename?: 'Subscription', updatedProductivity: { __typename?: 'Productivity', id: string, startDate: any, factor: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeletedProductivitySubscriptionVariables = Exact<{
  filter?: InputMaybe<ProductivityFilterArgs>;
}>;


export type DeletedProductivitySubscription = { __typename?: 'Subscription', deletedProductivity: { __typename?: 'Productivity', id: string } };

export type RestoredProductivitySubscriptionVariables = Exact<{
  filter?: InputMaybe<ProductivityFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredProductivitySubscription = { __typename?: 'Subscription', restoredProductivity: { __typename?: 'Productivity', id: string, startDate: any, factor: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type ProjectFieldsFragment = { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, projectId: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, projectId: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, displayField: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, controlUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null };

export type GetProjectsQueryVariables = Exact<{
  filter?: InputMaybe<ProjectFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectSortArgs> | ProjectSortArgs>;
  withCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withHoursRequireds?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleUser?: InputMaybe<Scalars['Boolean']['input']>;
  withControlUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectsQuery = { __typename?: 'Query', projects: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, projectId: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, projectId: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, displayField: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, controlUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null }> | null } };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withHoursRequireds?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleUser?: InputMaybe<Scalars['Boolean']['input']>;
  withControlUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, projectId: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, projectId: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, displayField: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, controlUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } | null };

export type GetAllRelatedDataForProjectQueryVariables = Exact<{
  withCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withHoursRequireds?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withRegulations?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleUsers?: InputMaybe<Scalars['Boolean']['input']>;
  withControlUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForProjectQuery = { __typename?: 'Query', customers?: { __typename?: 'PaginatedCustomer', items?: Array<{ __typename?: 'Customer', id: string, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', items?: Array<{ __typename?: 'LoggedHour', id: string, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', items?: Array<{ __typename?: 'Budget', id: string, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', items?: Array<{ __typename?: 'PlannedHour', id: string, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', items?: Array<{ __typename?: 'HoursRequired', id: string, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', items?: Array<{ __typename?: 'Invoice', id: string, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', items?: Array<{ __typename?: 'ProjectDate', id: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', items?: Array<{ __typename?: 'Contract', id: string, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', items?: Array<{ __typename?: 'ProjectDocument', id: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null }, regulations?: { __typename?: 'PaginatedRegulation', items?: Array<{ __typename?: 'Regulation', id: string, displayField: string }> | null }, users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null } };

export type CreateProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  branch?: InputMaybe<Scalars['String']['input']>;
  subsidyPercentage?: InputMaybe<Scalars['Float']['input']>;
  invoiceVatSubsidyEligible: Scalars['Boolean']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  hourSubsidyType: Scalars['String']['input'];
  maxHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  addendum: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filingDate?: InputMaybe<Scalars['DateTime']['input']>;
  decisionDate?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenants?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  loggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  budgets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  plannedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  hoursRequireds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projectDates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  contracts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projectDocuments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  regulationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleUserId?: InputMaybe<Scalars['ID']['input']>;
  controlUserId?: InputMaybe<Scalars['ID']['input']>;
  withCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withHoursRequireds?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleUser?: InputMaybe<Scalars['Boolean']['input']>;
  withControlUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, projectId: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, projectId: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, displayField: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, controlUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  branch?: InputMaybe<Scalars['String']['input']>;
  subsidyPercentage?: InputMaybe<Scalars['Float']['input']>;
  invoiceVatSubsidyEligible?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  hourSubsidyType?: InputMaybe<Scalars['String']['input']>;
  maxHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  addendum?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filingDate?: InputMaybe<Scalars['DateTime']['input']>;
  decisionDate?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenants?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  loggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  budgets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  plannedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  hoursRequireds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projectDates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  contracts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projectDocuments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  regulationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleUserId?: InputMaybe<Scalars['ID']['input']>;
  controlUserId?: InputMaybe<Scalars['ID']['input']>;
  withCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withHoursRequireds?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleUser?: InputMaybe<Scalars['Boolean']['input']>;
  withControlUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, projectId: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, projectId: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, displayField: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, controlUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withHoursRequireds?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleUser?: InputMaybe<Scalars['Boolean']['input']>;
  withControlUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, projectId: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, projectId: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, displayField: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, controlUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type CreatedProjectSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectFilterArgs>;
  withCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withHoursRequireds?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleUser?: InputMaybe<Scalars['Boolean']['input']>;
  withControlUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedProjectSubscription = { __typename?: 'Subscription', createdProject: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, projectId: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, projectId: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, displayField: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, controlUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type UpdatedProjectSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectFilterArgs>;
  withCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withHoursRequireds?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleUser?: InputMaybe<Scalars['Boolean']['input']>;
  withControlUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedProjectSubscription = { __typename?: 'Subscription', updatedProject: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, projectId: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, projectId: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, displayField: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, controlUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type DeletedProjectSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectFilterArgs>;
}>;


export type DeletedProjectSubscription = { __typename?: 'Subscription', deletedProject: { __typename?: 'Project', id: string } };

export type RestoredProjectSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectFilterArgs>;
  withCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withHoursRequireds?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleUser?: InputMaybe<Scalars['Boolean']['input']>;
  withControlUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredProjectSubscription = { __typename?: 'Subscription', restoredProject: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, customer?: { __typename?: 'Customer', id: string, name: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgets?: { __typename?: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename?: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, projectId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, hoursRequireds?: { __typename?: 'PaginatedHoursRequired', totalCount: number, items?: Array<{ __typename?: 'HoursRequired', id: string, projectId: string, month: any, perMonth: number, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDates?: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, projectDocuments?: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, projectId: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, displayField: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, controlUser?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null } };

export type ProjectDateFieldsFragment = { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetProjectDatesQueryVariables = Exact<{
  filter?: InputMaybe<ProjectDateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateSortArgs> | ProjectDateSortArgs>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectDatesQuery = { __typename?: 'Query', projectDates: { __typename?: 'PaginatedProjectDate', totalCount: number, items?: Array<{ __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetProjectDateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectDateQuery = { __typename?: 'Query', projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForProjectDateQueryVariables = Exact<{
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForProjectDateQuery = { __typename?: 'Query', projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', items?: Array<{ __typename?: 'ProjectDateReminder', id: string, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null } };

export type CreateProjectDateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  dateTime: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
  doneAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectDateReminders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projectId: Scalars['ID']['input'];
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateProjectDateMutation = { __typename?: 'Mutation', createProjectDate: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdateProjectDateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  doneAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectDateReminders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProjectDateMutation = { __typename?: 'Mutation', updateProjectDate: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeleteProjectDateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteProjectDateMutation = { __typename?: 'Mutation', deleteProjectDate: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedProjectDateSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDateFilterArgs>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedProjectDateSubscription = { __typename?: 'Subscription', createdProjectDate: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedProjectDateSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDateFilterArgs>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedProjectDateSubscription = { __typename?: 'Subscription', updatedProjectDate: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedProjectDateSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDateFilterArgs>;
}>;


export type DeletedProjectDateSubscription = { __typename?: 'Subscription', deletedProjectDate: { __typename?: 'ProjectDate', id: string } };

export type ProjectDateReminderFieldsFragment = { __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } };

export type GetProjectDateRemindersQueryVariables = Exact<{
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDateReminderSortArgs> | ProjectDateReminderSortArgs>;
  withProjectDate?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectDateRemindersQuery = { __typename?: 'Query', projectDateReminders: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } }> | null } };

export type GetProjectDateReminderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withProjectDate?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectDateReminderQuery = { __typename?: 'Query', projectDateReminder?: { __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } | null };

export type GetAllRelatedDataForProjectDateReminderQueryVariables = Exact<{
  withProjectDates?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForProjectDateReminderQuery = { __typename?: 'Query', projectDates?: { __typename?: 'PaginatedProjectDate', items?: Array<{ __typename?: 'ProjectDate', id: string, displayField: string }> | null }, roles?: { __typename?: 'PaginatedRole', items?: Array<{ __typename?: 'Role', id: string, displayField: string }> | null } };

export type CreateProjectDateReminderMutationVariables = Exact<{
  advanceHours: Scalars['Int']['input'];
  mailText: Scalars['String']['input'];
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectDateId: Scalars['ID']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withProjectDate?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateProjectDateReminderMutation = { __typename?: 'Mutation', createProjectDateReminder: { __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type UpdateProjectDateReminderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  advanceHours?: InputMaybe<Scalars['Int']['input']>;
  mailText?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectDateId?: InputMaybe<Scalars['ID']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withProjectDate?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProjectDateReminderMutation = { __typename?: 'Mutation', updateProjectDateReminder: { __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type DeleteProjectDateReminderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withProjectDate?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteProjectDateReminderMutation = { __typename?: 'Mutation', deleteProjectDateReminder: { __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type CreatedProjectDateReminderSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
  withProjectDate?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedProjectDateReminderSubscription = { __typename?: 'Subscription', createdProjectDateReminder: { __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type UpdatedProjectDateReminderSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
  withProjectDate?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedProjectDateReminderSubscription = { __typename?: 'Subscription', updatedProjectDateReminder: { __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type DeletedProjectDateReminderSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
}>;


export type DeletedProjectDateReminderSubscription = { __typename?: 'Subscription', deletedProjectDateReminder: { __typename?: 'ProjectDateReminder', id: string } };

export type RestoredProjectDateReminderSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDateReminderFilterArgs>;
  withProjectDate?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredProjectDateReminderSubscription = { __typename?: 'Subscription', restoredProjectDateReminder: { __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, projectDate?: { __typename?: 'ProjectDate', id: string, name: string, dateTime: any, type: string, doneAt?: any | null, projectId: string, displayField: string }, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }> | null } } };

export type ProjectDocumentFieldsFragment = { __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetProjectDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<ProjectDocumentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ProjectDocumentSortArgs> | ProjectDocumentSortArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectDocumentsQuery = { __typename?: 'Query', projectDocuments: { __typename?: 'PaginatedProjectDocument', totalCount: number, items?: Array<{ __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetProjectDocumentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectDocumentQuery = { __typename?: 'Query', projectDocument?: { __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForProjectDocumentQueryVariables = Exact<{
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForProjectDocumentQuery = { __typename?: 'Query', projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null } };

export type CreateProjectDocumentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  attachment: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateProjectDocumentMutation = { __typename?: 'Mutation', createProjectDocument: { __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdateProjectDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProjectDocumentMutation = { __typename?: 'Mutation', updateProjectDocument: { __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeleteProjectDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteProjectDocumentMutation = { __typename?: 'Mutation', deleteProjectDocument: { __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedProjectDocumentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDocumentFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedProjectDocumentSubscription = { __typename?: 'Subscription', createdProjectDocument: { __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedProjectDocumentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDocumentFilterArgs>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedProjectDocumentSubscription = { __typename?: 'Subscription', updatedProjectDocument: { __typename?: 'ProjectDocument', id: string, name: string, description?: string | null, attachment: string, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedProjectDocumentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ProjectDocumentFilterArgs>;
}>;


export type DeletedProjectDocumentSubscription = { __typename?: 'Subscription', deletedProjectDocument: { __typename?: 'ProjectDocument', id: string } };

export type RegulationFieldsFragment = { __typename?: 'Regulation', id: string, name: string, description?: string | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } };

export type GetRegulationsQueryVariables = Exact<{
  filter?: InputMaybe<RegulationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegulationSortArgs> | RegulationSortArgs>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRegulationsQuery = { __typename?: 'Query', regulations: { __typename?: 'PaginatedRegulation', totalCount: number, items?: Array<{ __typename?: 'Regulation', id: string, name: string, description?: string | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetRegulationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRegulationQuery = { __typename?: 'Query', regulation?: { __typename?: 'Regulation', id: string, name: string, description?: string | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForRegulationQueryVariables = Exact<{
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForRegulationQuery = { __typename?: 'Query', projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null } };

export type CreateRegulationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateRegulationMutation = { __typename?: 'Mutation', createRegulation: { __typename?: 'Regulation', id: string, name: string, description?: string | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdateRegulationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRegulationMutation = { __typename?: 'Mutation', updateRegulation: { __typename?: 'Regulation', id: string, name: string, description?: string | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeleteRegulationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteRegulationMutation = { __typename?: 'Mutation', deleteRegulation: { __typename?: 'Regulation', id: string, name: string, description?: string | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type CreatedRegulationSubscriptionVariables = Exact<{
  filter?: InputMaybe<RegulationFilterArgs>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedRegulationSubscription = { __typename?: 'Subscription', createdRegulation: { __typename?: 'Regulation', id: string, name: string, description?: string | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdatedRegulationSubscriptionVariables = Exact<{
  filter?: InputMaybe<RegulationFilterArgs>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedRegulationSubscription = { __typename?: 'Subscription', updatedRegulation: { __typename?: 'Regulation', id: string, name: string, description?: string | null, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeletedRegulationSubscriptionVariables = Exact<{
  filter?: InputMaybe<RegulationFilterArgs>;
}>;


export type DeletedRegulationSubscription = { __typename?: 'Subscription', deletedRegulation: { __typename?: 'Regulation', id: string } };

export type ResetPasswordFieldsFragment = { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null };

export type GetResetPasswordsQueryVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs> | ResetPasswordSortArgs>;
}>;


export type GetResetPasswordsQuery = { __typename?: 'Query', resetPasswords: { __typename?: 'PaginatedResetPassword', totalCount: number, items?: Array<{ __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null }> | null } };

export type GetResetPasswordQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResetPasswordQuery = { __typename?: 'Query', resetPassword?: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type CreateResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type CreateResetPasswordMutation = { __typename?: 'Mutation', createResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type UpdateResetPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateResetPasswordMutation = { __typename?: 'Mutation', updateResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type DeleteResetPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteResetPasswordMutation = { __typename?: 'Mutation', deleteResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type CreatedResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
}>;


export type CreatedResetPasswordSubscription = { __typename?: 'Subscription', createdResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type UpdatedResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
}>;


export type UpdatedResetPasswordSubscription = { __typename?: 'Subscription', updatedResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type DeletedResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
}>;


export type DeletedResetPasswordSubscription = { __typename?: 'Subscription', deletedResetPassword: { __typename?: 'ResetPassword', id: string } };

export type RoleFieldsFragment = { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } };

export type GetRolesQueryVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs> | RoleSortArgs>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRolesQuery = { __typename?: 'Query', roles: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRoleQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForRoleQueryVariables = Exact<{
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForRoleQuery = { __typename?: 'Query', permissions?: { __typename?: 'PaginatedPermission', items?: Array<{ __typename?: 'Permission', id: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null }, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', items?: Array<{ __typename?: 'ProjectDateReminder', id: string, displayField: string }> | null } };

export type CreateRoleMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projectDateReminders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projectDateReminders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type CreatedRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedRoleSubscription = { __typename?: 'Subscription', createdRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdatedRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjectDateReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedRoleSubscription = { __typename?: 'Subscription', updatedRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projectDateReminders?: { __typename?: 'PaginatedProjectDateReminder', totalCount: number, items?: Array<{ __typename?: 'ProjectDateReminder', id: string, advanceHours: number, mailText: string, projectDateId: string, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeletedRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
}>;


export type DeletedRoleSubscription = { __typename?: 'Subscription', deletedRole: { __typename?: 'Role', id: string } };

export type TenantFieldsFragment = { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } };

export type GetTenantsQueryVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs> | TenantSortArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantsQuery = { __typename?: 'Query', tenants: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetTenantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantQuery = { __typename?: 'Query', tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForTenantQueryVariables = Exact<{
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForTenantQuery = { __typename?: 'Query', userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', items?: Array<{ __typename?: 'BudgetLine', id: string, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', items?: Array<{ __typename?: 'LoggedHour', id: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', items?: Array<{ __typename?: 'Contract', id: string, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', items?: Array<{ __typename?: 'Invoice', id: string, displayField: string }> | null } };

export type CreateTenantMutationVariables = Exact<{
  name: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  kvk?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  invoiceDetails?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  invoiceVatSubsidyEligible: Scalars['Boolean']['input'];
  mfaRequired: Scalars['Boolean']['input'];
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  budgetLines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  loggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  contracts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdateTenantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  kvk?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  invoiceDetails?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  invoiceVatSubsidyEligible?: InputMaybe<Scalars['Boolean']['input']>;
  mfaRequired?: InputMaybe<Scalars['Boolean']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  budgetLines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  loggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  contracts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeleteTenantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteTenantMutation = { __typename?: 'Mutation', deleteTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type CreatedTenantSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedTenantSubscription = { __typename?: 'Subscription', createdTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdatedTenantSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withBudgetLines?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withInvoices?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedTenantSubscription = { __typename?: 'Subscription', updatedTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, budgetLines?: { __typename?: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename?: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, invoices?: { __typename?: 'PaginatedInvoice', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: string, name: string, description: string, status: string, total: number, vat: number, attachment?: string | null, attachmentProof?: string | null, subsidyPercentage?: number | null, vatSubsidyEligible: boolean, invoiceNumber?: string | null, paidOn?: any | null, tenantId: string, projectId: string, categoryId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeletedTenantSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
}>;


export type DeletedTenantSubscription = { __typename?: 'Subscription', deletedTenant: { __typename?: 'Tenant', id: string } };

export type UserFieldsFragment = { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } };

export type GetUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs> | UserSortArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForUserQueryVariables = Exact<{
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForUserQuery = { __typename?: 'Query', userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', items?: Array<{ __typename?: 'Contract', id: string, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', items?: Array<{ __typename?: 'Availability', id: string, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', items?: Array<{ __typename?: 'DaysOff', id: string, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', items?: Array<{ __typename?: 'LoggedHour', id: string, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', items?: Array<{ __typename?: 'PlannedHour', id: string, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', items?: Array<{ __typename?: 'Productivity', id: string, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, displayField: string }> | null } };

export type CreateUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  function?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  contracts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  availabilities?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  daysOffs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  loggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  approvedLoggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  plannedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  productivities?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  responsibleForProjects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  controllerForProjects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  contracts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  availabilities?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  daysOffs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  loggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  approvedLoggedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  plannedHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  productivities?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  responsibleForProjects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  controllerForProjects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type CreatedUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedUserSubscription = { __typename?: 'Subscription', createdUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdatedUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedUserSubscription = { __typename?: 'Subscription', updatedUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeletedUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
}>;


export type DeletedUserSubscription = { __typename?: 'Subscription', deletedUser: { __typename?: 'User', id: string } };

export type RestoredUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredUserSubscription = { __typename?: 'Subscription', restoredUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UserTenantRoleFieldsFragment = { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetUserTenantRolesQueryVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs> | UserTenantRoleSortArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserTenantRolesQuery = { __typename?: 'Query', userTenantRoles: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetUserTenantRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserTenantRoleQuery = { __typename?: 'Query', userTenantRole?: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForUserTenantRoleQueryVariables = Exact<{
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForUserTenantRoleQuery = { __typename?: 'Query', users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null }, roles?: { __typename?: 'PaginatedRole', items?: Array<{ __typename?: 'Role', id: string, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, displayField: string }> | null } };

export type CreateUserTenantRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserTenantRoleMutation = { __typename?: 'Mutation', createUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdateUserTenantRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserTenantRoleMutation = { __typename?: 'Mutation', updateUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeleteUserTenantRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUserTenantRoleMutation = { __typename?: 'Mutation', deleteUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedUserTenantRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedUserTenantRoleSubscription = { __typename?: 'Subscription', createdUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedUserTenantRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
  withProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedUserTenantRoleSubscription = { __typename?: 'Subscription', updatedUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, description?: string | null, kvk?: string | null, iban?: string | null, invoiceDetails?: string | null, contactPerson?: string | null, invoiceVatSubsidyEligible: boolean, mfaRequired: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, order: number, displayField: string }, project?: { __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedUserTenantRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
}>;


export type DeletedUserTenantRoleSubscription = { __typename?: 'Subscription', deletedUserTenantRole: { __typename?: 'UserTenantRole', id: string } };

export type GetFullUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFullUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, lastName: string, fullName: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string, role: { __typename?: 'Role', id: string, machineName: string, displayField: string }, tenant: { __typename?: 'Tenant', id: string, name: string, displayField: string } }> | null } } | null };

export type CreateUserWithUserTenantMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  function?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContracts?: InputMaybe<Scalars['Boolean']['input']>;
  withAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  withDaysOffs?: InputMaybe<Scalars['Boolean']['input']>;
  withLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withApprovedLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withPlannedHours?: InputMaybe<Scalars['Boolean']['input']>;
  withProductivities?: InputMaybe<Scalars['Boolean']['input']>;
  withResponsibleForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withControllerForProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserWithUserTenantMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, lastName: string, function?: string | null, phoneNumber?: string | null, note?: string | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, projectId?: string | null, displayField: string }> | null }, contracts?: { __typename?: 'PaginatedContract', totalCount: number, items?: Array<{ __typename?: 'Contract', id: string, hoursPerWeek?: number | null, costPerHour: number, startDate: any, endDate?: any | null, hourlyRateInputs?: string | null, customCostPerHour?: number | null, salarySlip?: string | null, userId: string, tenantId: string, projectId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, availabilities?: { __typename?: 'PaginatedAvailability', totalCount: number, items?: Array<{ __typename?: 'Availability', id: string, month: any, availability: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, daysOffs?: { __typename?: 'PaginatedDaysOff', totalCount: number, items?: Array<{ __typename?: 'DaysOff', id: string, startDate: any, endDate: any, approved?: boolean | null, note?: string | null, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, loggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, approvedLoggedHours?: { __typename?: 'PaginatedLoggedHour', totalCount: number, items?: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, break: number, declarableTime?: number | null, addendum?: boolean | null, declarable?: boolean | null, status?: boolean | null, categoryId: string, projectId: string, userId: string, approvedById?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, plannedHours?: { __typename?: 'PaginatedPlannedHour', totalCount: number, items?: Array<{ __typename?: 'PlannedHour', id: string, month: any, hours: number, projectId: string, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, productivities?: { __typename?: 'PaginatedProductivity', totalCount: number, items?: Array<{ __typename?: 'Productivity', id: string, startDate: any, factor: number, userId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, responsibleForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, controllerForProjects?: { __typename?: 'PaginatedProject', totalCount: number, items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, description?: string | null, branch?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, addendum: boolean, startDate?: any | null, endDate?: any | null, filingDate?: any | null, decisionDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, categories?: { __typename?: 'PaginatedCategory', totalCount: number, items?: Array<{ __typename?: 'Category', id: string, name: string, subsidyPercentage?: number | null, hasHours: boolean, hasInvoices: boolean, order: number, parentCategoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type GetBudgetsWithCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<BudgetFilterArgsWithCategory>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<BudgetSortArgs> | BudgetSortArgs>;
}>;


export type GetBudgetsWithCategoriesQuery = { __typename?: 'Query', budgetsWithCategories: { __typename: 'PaginatedBudget', totalCount: number, items?: Array<{ __typename: 'Budget', id: string, total?: number | null, startDate?: any | null, endDate?: any | null, completionDate?: any | null, note: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, project?: { __typename: 'Project', id: string, name: string, active: boolean, description?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, isSimple: boolean, startDate?: any | null, endDate?: any | null, customerId?: string | null, regulationId?: string | null, responsibleUserId?: string | null, controlUserId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, budgetLines: { __typename: 'PaginatedBudgetLine', totalCount: number, items?: Array<{ __typename: 'BudgetLine', id: string, hours: number, hourlyRate: number, hourCosts: number, invoiceCosts: number, budgetId: string, tenantId?: string | null, categoryId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string, category?: { __typename?: 'Category', name: string } | null }> | null } }> | null } };

export type DeleteCategoryAndChildrenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCategoryAndChildrenMutation = { __typename?: 'Mutation', deleteCategoryAndChildren: { __typename?: 'Category', id: string } };

export type CreateContentWithFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  fill: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type CreateContentWithFillMutation = { __typename?: 'Mutation', createContentWithFill: boolean };

export type UpdateContentWithFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  fill: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type UpdateContentWithFillMutation = { __typename?: 'Mutation', updateContentWithFill: boolean };

export type RowFieldsFragment = { __typename?: 'DashboardRowDTO', id: string, name: string, order: number, status?: string | null, totalBudget: number, subsidyBudget: number, totalRealization: number, subsidyRealization: number, fictiveTotalRealization: number, fictiveSubsidyRealization: number, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null };

export type GetDashboardRowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardRowsQuery = { __typename?: 'Query', dashboardRows: Array<{ __typename?: 'DashboardRowDTO', id: string, name: string, order: number, status?: string | null, totalBudget: number, subsidyBudget: number, totalRealization: number, subsidyRealization: number, fictiveTotalRealization: number, fictiveSubsidyRealization: number, subRows: Array<{ __typename?: 'DashboardRowDTO', id: string, name: string, order: number, status?: string | null, totalBudget: number, subsidyBudget: number, totalRealization: number, subsidyRealization: number, fictiveTotalRealization: number, fictiveSubsidyRealization: number, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null }>, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null }> };

export type GetProjectDashboardRowsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetProjectDashboardRowsQuery = { __typename?: 'Query', projectDashboardRows: { __typename?: 'ProjectRowsDTO', hourRows: Array<{ __typename?: 'DashboardRowDTO', id: string, name: string, order: number, status?: string | null, totalBudget: number, subsidyBudget: number, totalRealization: number, subsidyRealization: number, fictiveTotalRealization: number, fictiveSubsidyRealization: number, subRows: Array<{ __typename?: 'DashboardRowDTO', id: string, name: string, order: number, status?: string | null, totalBudget: number, subsidyBudget: number, totalRealization: number, subsidyRealization: number, fictiveTotalRealization: number, fictiveSubsidyRealization: number, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null }>, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null }>, invoiceRows: Array<{ __typename?: 'DashboardRowDTO', id: string, name: string, order: number, status?: string | null, totalBudget: number, subsidyBudget: number, totalRealization: number, subsidyRealization: number, fictiveTotalRealization: number, fictiveSubsidyRealization: number, subRows: Array<{ __typename?: 'DashboardRowDTO', id: string, name: string, order: number, status?: string | null, totalBudget: number, subsidyBudget: number, totalRealization: number, subsidyRealization: number, fictiveTotalRealization: number, fictiveSubsidyRealization: number, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null }>, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null }>, totalRows: Array<{ __typename?: 'DashboardRowDTO', id: string, name: string, order: number, status?: string | null, totalBudget: number, subsidyBudget: number, totalRealization: number, subsidyRealization: number, fictiveTotalRealization: number, fictiveSubsidyRealization: number, subRows: Array<{ __typename?: 'DashboardRowDTO', id: string, name: string, order: number, status?: string | null, totalBudget: number, subsidyBudget: number, totalRealization: number, subsidyRealization: number, fictiveTotalRealization: number, fictiveSubsidyRealization: number, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null }>, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null }> } };

export type GetAdminDashboardRowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminDashboardRowsQuery = { __typename?: 'Query', adminDashboardRows: Array<{ __typename?: 'AdminDashboardRowDTO', id: string, name: string, branch?: string | null, status?: string | null, startDate?: any | null, endDate?: any | null, responsibleUser?: string | null, controlUser?: string | null, subsidyBudget: string, subsidyUtilization: string, fictiveSubsidyUtilization: string, regulation?: { __typename?: 'RegulationRowDTO', id: string, name: string } | null, tenants: Array<{ __typename?: 'Tenant', id: string, name: string }>, deadline?: { __typename?: 'DateObject', name: string, date: any } | null }> };

export type GetHoursOverviewInputDataQueryVariables = Exact<{
  filters?: InputMaybe<HoursOverviewFilterArgs>;
}>;


export type GetHoursOverviewInputDataQuery = { __typename?: 'Query', getHoursOverviewInputData: { __typename?: 'HoursOverviewInputDataType', tenants: Array<{ __typename?: 'DefaultHOInputData', id: string, name: string }>, employees: Array<{ __typename?: 'EmployeeHOInputData', id: string, name: string, lastName: string, active: boolean, categories: Array<{ __typename?: 'DefaultHOInputData', id: string }>, userTenantRoles: Array<{ __typename?: 'EmployeeTenantRolesHOIInputData', projectId: string }> }>, projects: Array<{ __typename?: 'ProjectsHOInputData', id: string, name: string, active: boolean, tenants: Array<{ __typename?: 'DefaultHOInputData', id: string, name: string }> }>, categories: Array<{ __typename?: 'CategoryHOInputData', id: string, name: string, projects?: Array<{ __typename?: 'ProjectsHOInputData', id: string, name: string }> | null, parentCategory?: { __typename?: 'ParentCategory', id: string, name: string } | null }> } };

export type GetHoursOverviewDataQueryVariables = Exact<{
  filters?: InputMaybe<HoursOverviewFilterArgs>;
  sorting?: InputMaybe<HoursOverviewSortingArgs>;
  pagination?: InputMaybe<HoursOverviewPagingArgs>;
}>;


export type GetHoursOverviewDataQuery = { __typename?: 'Query', getHoursOverviewData: { __typename?: 'HoursOverviewDataType', allIds: Array<string>, totalCount: number, advancedReport: { __typename?: 'AdvancedReport', total: number, users: Array<{ __typename?: 'AdvancedReportUser', id: string, name: string, lastName: string, total: number }>, tenants: Array<{ __typename?: 'AdvancedReportTenant', id: string, name: string, total: number, users: Array<{ __typename?: 'AdvancedReportUser', id: string, name: string, total: number }>, projects: Array<{ __typename?: 'AdvancedReportProject', id: string, name: string, total: number, users: Array<{ __typename?: 'AdvancedReportUser', id: string, name: string, total: number }>, categories: Array<{ __typename?: 'AdvancedReportCategory', id: string, name: string, order: number, total: number, users: Array<{ __typename?: 'AdvancedReportUser', id: string, name: string, total: number }>, parentCategory?: { __typename?: 'AdvancedReportParentCategory', id: string, name: string, order: number } | null }> }> }> }, data: Array<{ __typename?: 'LoggedHourHO', id: string, description: string, startDatetime: any, endDatetime: any, declarableTime?: number | null, addendum?: boolean | null, break: number, status?: boolean | null, createdAt?: any | null, updatedAt?: any | null, project: { __typename?: 'ProjectHO', id: string, name: string, tenants: Array<{ __typename?: 'TenantHO', id: string, name: string }> }, category: { __typename?: 'CategoryHO', id: string, name: string, parentCategory?: { __typename?: 'ParentCategoryHO', id: string, name: string } | null }, user: { __typename?: 'UserHO', id: string, name: string, lastName: string }, tenant: { __typename?: 'TenantHO', id: string, name: string } }> } };

export type UpdateLoggedHourStatusMutationVariables = Exact<{
  data: Array<UpdateLoggedHoursStatusType> | UpdateLoggedHoursStatusType;
}>;


export type UpdateLoggedHourStatusMutation = { __typename?: 'Mutation', updateLoggedHourStatus: boolean };

export type GetAllRelatedDataForInvoiceExtendedQueryVariables = Exact<{
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withProjects?: InputMaybe<Scalars['Boolean']['input']>;
  withCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForInvoiceExtendedQuery = { __typename?: 'Query', tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, invoiceVatSubsidyEligible: boolean, displayField: string }> | null }, projects?: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, invoiceVatSubsidyEligible: boolean, displayField: string, tenants: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string }> | null }, categories: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, hasInvoices: boolean, order: number, displayField: string, parentCategory?: { __typename?: 'Category', id: string, name: string, hasHours: boolean, hasInvoices: boolean, order: number } | null }> | null } }> | null }, categories?: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, hasInvoices: boolean, displayField: string, parentCategory?: { __typename?: 'Category', id: string, name: string, hasHours: boolean, hasInvoices: boolean } | null }> | null } };

export type GetOrganizedLoggedHoursQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetOrganizedLoggedHoursQuery = { __typename?: 'Query', getOrganizedLoggedHours: Array<{ __typename?: 'LoggedHour', id: string, description: string, startDatetime: any, endDatetime: any, declarableTime?: number | null, break: number, userId: string, project?: { __typename?: 'Project', id: string, name: string, active: boolean, customer?: { __typename?: 'Customer', id: string, name: string } | null } | null, category?: { __typename?: 'Category', id: string, name: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string } | null }> };

export type GetProjectsWithCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsWithCategoriesQuery = { __typename?: 'Query', projectWithCategories: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, name: string, active: boolean, subsidyPercentage: number, hourSubsidyType: string, categories: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, name: string, order: number, hasHours: boolean, hasInvoices: boolean, subsidyPercentage?: number | null, parentCategory?: { __typename?: 'Category', id: string, name: string, hasHours: boolean, hasInvoices: boolean, order: number } | null, subCategories: { __typename?: 'PaginatedCategory', items?: Array<{ __typename?: 'Category', id: string, order: number }> | null } }> | null }, customer?: { __typename?: 'Customer', name: string } | null, tenants: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, name: string }> | null } }> | null } };

export type CreateSimpleProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  status: Scalars['String']['input'];
  regulationId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  budget: Scalars['Float']['input'];
  realization: Scalars['Float']['input'];
  branch?: InputMaybe<Scalars['String']['input']>;
  subsidyPercentage: Scalars['Float']['input'];
  invoiceVatSubsidyEligible: Scalars['Boolean']['input'];
  vatSubsidyEligible: Scalars['Boolean']['input'];
  hourSubsidyType: Scalars['String']['input'];
  addendum: Scalars['Boolean']['input'];
}>;


export type CreateSimpleProjectMutation = { __typename?: 'Mutation', createSimpleProject: { __typename?: 'Project', id: string, name: string } };

export type ProjectsWhereAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsWhereAdminQuery = { __typename?: 'Query', projectsWhereAdmin: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, name: string, hourSubsidyType: string, tenants: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string }> | null } }> | null } };

export type ProjectsWhereAdminWithContractsQueryVariables = Exact<{
  filter?: InputMaybe<ProjectFilterArgs>;
}>;


export type ProjectsWhereAdminWithContractsQuery = { __typename?: 'Query', projectsWhereAdmin: { __typename?: 'PaginatedProject', items?: Array<{ __typename?: 'Project', id: string, name: string, hourSubsidyType: string, contracts: { __typename?: 'PaginatedContract', items?: Array<{ __typename?: 'Contract', id: string, costPerHour: number, customCostPerHour?: number | null, tenantId: string }> | null }, tenants: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, name: string }> | null } }> | null } };

export type GetSalaryProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSalaryProjectQuery = { __typename?: 'Query', projectWithUsers?: { __typename?: 'ProjectWithUsers', id: string, name: string, active: boolean, description?: string | null, subsidyPercentage: number, invoiceVatSubsidyEligible: boolean, reference?: string | null, status: string, hourSubsidyType: string, maxHourlyRate?: number | null, users: Array<{ __typename?: 'ProjectUser', id: string, name: string, lastName: string, avatar?: string | null }> } | null };

export const AvailabilityFieldsFragmentDoc = gql`
    fragment availabilityFields on Availability {
  id
  month
  availability
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const BudgetFieldsFragmentDoc = gql`
    fragment budgetFields on Budget {
  id
  total
  startDate
  endDate
  completionDate
  note
  project @include(if: $withProject) {
    id
    name
    active
    description
    branch
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    isSimple
    addendum
    startDate
    endDate
    filingDate
    decisionDate
    customerId
    regulationId
    responsibleUserId
    controlUserId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  budgetLines @include(if: $withBudgetLines) {
    items {
      id
      hours
      hourlyRate
      hourCosts
      invoiceCosts
      budgetId
      tenantId
      categoryId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const BudgetLineFieldsFragmentDoc = gql`
    fragment budgetLineFields on BudgetLine {
  id
  hours
  hourlyRate
  hourCosts
  invoiceCosts
  budget @include(if: $withBudget) {
    id
    total
    startDate
    endDate
    completionDate
    note
    projectId
    createdAt
    updatedAt
    deletedAt
    displayField: id
  }
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    description
    kvk
    iban
    invoiceDetails
    contactPerson
    invoiceVatSubsidyEligible
    mfaRequired
    displayField: name
  }
  category @include(if: $withCategory) {
    id
    name
    subsidyPercentage
    hasHours
    hasInvoices
    order
    parentCategoryId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const CategoryFieldsFragmentDoc = gql`
    fragment categoryFields on Category {
  id
  name
  subsidyPercentage
  hasHours
  hasInvoices
  order
  loggedHours @include(if: $withLoggedHours) {
    items {
      id
      description
      startDatetime
      endDatetime
      break
      declarableTime
      addendum
      declarable
      status
      categoryId
      projectId
      userId
      approvedById
      tenantId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  budgetLines @include(if: $withBudgetLines) {
    items {
      id
      hours
      hourlyRate
      hourCosts
      invoiceCosts
      budgetId
      tenantId
      categoryId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  invoices @include(if: $withInvoices) {
    items {
      id
      name
      description
      status
      total
      vat
      attachment
      attachmentProof
      subsidyPercentage
      vatSubsidyEligible
      invoiceNumber
      paidOn
      tenantId
      projectId
      categoryId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  projects @include(if: $withProjects) {
    items {
      id
      name
      active
      description
      branch
      subsidyPercentage
      invoiceVatSubsidyEligible
      reference
      status
      hourSubsidyType
      maxHourlyRate
      isSimple
      addendum
      startDate
      endDate
      filingDate
      decisionDate
      customerId
      regulationId
      responsibleUserId
      controlUserId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  parentCategory @include(if: $withParentCategory) {
    id
    name
    subsidyPercentage
    hasHours
    hasInvoices
    order
    parentCategoryId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  subCategories @include(if: $withSubCategories) {
    items {
      id
      name
      subsidyPercentage
      hasHours
      hasInvoices
      order
      parentCategoryId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  users @include(if: $withUsers) {
    items {
      id
      name
      email
      emailVerifiedAt
      active
      avatar
      totpVerified
      termsAndConditions
      locale
      timeZone
      createdAt
      updatedAt
      deletedAt
      lastName
      function
      phoneNumber
      note
      displayField: fullName
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ContentFieldsFragmentDoc = gql`
    fragment contentFields on Content {
  id
  name
  contentFills @include(if: $withContentFills) {
    items {
      id
      fill
      language
      contentId
      displayField: id
    }
    totalCount
  }
}
    `;
export const ContentFillFieldsFragmentDoc = gql`
    fragment contentFillFields on ContentFill {
  id
  fill
  language
  content @include(if: $withContent) {
    id
    name
    displayField: name
  }
}
    `;
export const ContractFieldsFragmentDoc = gql`
    fragment contractFields on Contract {
  id
  hoursPerWeek
  costPerHour
  startDate
  endDate
  hourlyRateInputs
  customCostPerHour
  salarySlip
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    description
    kvk
    iban
    invoiceDetails
    contactPerson
    invoiceVatSubsidyEligible
    mfaRequired
    displayField: name
  }
  project @include(if: $withProject) {
    id
    name
    active
    description
    branch
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    isSimple
    addendum
    startDate
    endDate
    filingDate
    decisionDate
    customerId
    regulationId
    responsibleUserId
    controlUserId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const CustomerFieldsFragmentDoc = gql`
    fragment customerFields on Customer {
  id
  name
  active
  projects @include(if: $withProjects) {
    items {
      id
      name
      active
      description
      branch
      subsidyPercentage
      invoiceVatSubsidyEligible
      reference
      status
      hourSubsidyType
      maxHourlyRate
      isSimple
      addendum
      startDate
      endDate
      filingDate
      decisionDate
      customerId
      regulationId
      responsibleUserId
      controlUserId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const DaysOffFieldsFragmentDoc = gql`
    fragment daysOffFields on DaysOff {
  id
  startDate
  endDate
  approved
  note
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ErrorLogFieldsFragmentDoc = gql`
    fragment errorLogFields on ErrorLog {
  id
  error
  stack
  domain
  createdAt
  updatedAt
  deletedAt
}
    `;
export const EventLogFieldsFragmentDoc = gql`
    fragment eventLogFields on EventLog {
  id
  log
  type
  createdAt
  updatedAt
  deletedAt
}
    `;
export const HoursRequiredFieldsFragmentDoc = gql`
    fragment hoursRequiredFields on HoursRequired {
  id
  project @include(if: $withProject) {
    id
    name
    active
    description
    branch
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    isSimple
    addendum
    startDate
    endDate
    filingDate
    decisionDate
    customerId
    regulationId
    responsibleUserId
    controlUserId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  month
  perMonth
  createdAt
  updatedAt
  deletedAt
}
    `;
export const InvoiceFieldsFragmentDoc = gql`
    fragment invoiceFields on Invoice {
  id
  name
  description
  status
  total
  vat
  attachment
  attachmentProof
  subsidyPercentage
  vatSubsidyEligible
  invoiceNumber
  paidOn
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    description
    kvk
    iban
    invoiceDetails
    contactPerson
    invoiceVatSubsidyEligible
    mfaRequired
    displayField: name
  }
  project @include(if: $withProject) {
    id
    name
    active
    description
    branch
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    isSimple
    addendum
    startDate
    endDate
    filingDate
    decisionDate
    customerId
    regulationId
    responsibleUserId
    controlUserId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  category @include(if: $withCategory) {
    id
    name
    subsidyPercentage
    hasHours
    hasInvoices
    order
    parentCategoryId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const JobFieldsFragmentDoc = gql`
    fragment jobFields on Job {
  id
  queue
  status
  log
  createdAt
  updatedAt
  deletedAt
}
    `;
export const LoggedHourFieldsFragmentDoc = gql`
    fragment loggedHourFields on LoggedHour {
  id
  description
  startDatetime
  endDatetime
  break
  declarableTime
  addendum
  declarable
  status
  category @include(if: $withCategory) {
    id
    name
    subsidyPercentage
    hasHours
    hasInvoices
    order
    parentCategoryId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  project @include(if: $withProject) {
    id
    name
    active
    description
    branch
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    isSimple
    addendum
    startDate
    endDate
    filingDate
    decisionDate
    customerId
    regulationId
    responsibleUserId
    controlUserId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  approvedBy @include(if: $withApprovedBy) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    description
    kvk
    iban
    invoiceDetails
    contactPerson
    invoiceVatSubsidyEligible
    mfaRequired
    displayField: name
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const MailLogFieldsFragmentDoc = gql`
    fragment mailLogFields on MailLog {
  id
  sentTo
  sentBy
  emailTemplate
  status
  message
  reason
  createdAt
  updatedAt
  deletedAt
}
    `;
export const MailTemplateFieldsFragmentDoc = gql`
    fragment mailTemplateFields on MailTemplate {
  id
  active
  mailTemplateFills @include(if: $withMailTemplateFills) {
    items {
      id
      subject
      urlText
      title
      heading
      preHeader
      disclaimer
      text
      plainText
      language
      mailTemplateId
      displayField: title
    }
    totalCount
  }
}
    `;
export const MailTemplateFillFieldsFragmentDoc = gql`
    fragment mailTemplateFillFields on MailTemplateFill {
  id
  subject
  urlText
  title
  heading
  preHeader
  disclaimer
  text
  plainText
  language
  mailTemplate @include(if: $withMailTemplate) {
    id
    active
    displayField: id
  }
}
    `;
export const PermissionFieldsFragmentDoc = gql`
    fragment permissionFields on Permission {
  id
  name
  description
  roles @include(if: $withRoles) {
    items {
      id
      machineName
      displayName
      description
      order
      displayField: displayName
    }
    totalCount
  }
}
    `;
export const PlannedHourFieldsFragmentDoc = gql`
    fragment plannedHourFields on PlannedHour {
  id
  month
  hours
  project @include(if: $withProject) {
    id
    name
    active
    description
    branch
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    isSimple
    addendum
    startDate
    endDate
    filingDate
    decisionDate
    customerId
    regulationId
    responsibleUserId
    controlUserId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ProductivityFieldsFragmentDoc = gql`
    fragment productivityFields on Productivity {
  id
  startDate
  factor
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ProjectFieldsFragmentDoc = gql`
    fragment projectFields on Project {
  id
  name
  active
  description
  branch
  subsidyPercentage
  invoiceVatSubsidyEligible
  reference
  status
  hourSubsidyType
  maxHourlyRate
  isSimple
  addendum
  startDate
  endDate
  filingDate
  decisionDate
  customer @include(if: $withCustomer) {
    id
    name
    active
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  categories @include(if: $withCategories) {
    items {
      id
      name
      subsidyPercentage
      hasHours
      hasInvoices
      order
      parentCategoryId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  tenants @include(if: $withTenants) {
    items {
      id
      name
      timeZone
      description
      kvk
      iban
      invoiceDetails
      contactPerson
      invoiceVatSubsidyEligible
      mfaRequired
      displayField: name
    }
    totalCount
  }
  loggedHours @include(if: $withLoggedHours) {
    items {
      id
      description
      startDatetime
      endDatetime
      break
      declarableTime
      addendum
      declarable
      status
      categoryId
      projectId
      userId
      approvedById
      tenantId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  budgets @include(if: $withBudgets) {
    items {
      id
      total
      startDate
      endDate
      completionDate
      note
      projectId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  plannedHours @include(if: $withPlannedHours) {
    items {
      id
      month
      hours
      projectId
      userId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  hoursRequireds @include(if: $withHoursRequireds) {
    items {
      id
      projectId
      month
      perMonth
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  invoices @include(if: $withInvoices) {
    items {
      id
      name
      description
      status
      total
      vat
      attachment
      attachmentProof
      subsidyPercentage
      vatSubsidyEligible
      invoiceNumber
      paidOn
      tenantId
      projectId
      categoryId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  projectDates @include(if: $withProjectDates) {
    items {
      id
      name
      dateTime
      type
      doneAt
      projectId
      displayField: name
    }
    totalCount
  }
  contracts @include(if: $withContracts) {
    items {
      id
      hoursPerWeek
      costPerHour
      startDate
      endDate
      hourlyRateInputs
      customCostPerHour
      salarySlip
      userId
      tenantId
      projectId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  projectDocuments @include(if: $withProjectDocuments) {
    items {
      id
      name
      description
      attachment
      projectId
      displayField: name
    }
    totalCount
  }
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      projectId
      displayField: id
    }
    totalCount
  }
  regulation @include(if: $withRegulation) {
    id
    name
    description
    displayField: name
  }
  responsibleUser @include(if: $withResponsibleUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  controlUser @include(if: $withControlUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ProjectDateFieldsFragmentDoc = gql`
    fragment projectDateFields on ProjectDate {
  id
  name
  dateTime
  type
  doneAt
  projectDateReminders @include(if: $withProjectDateReminders) {
    items {
      id
      advanceHours
      mailText
      projectDateId
      sentAt
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  project @include(if: $withProject) {
    id
    name
    active
    description
    branch
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    isSimple
    addendum
    startDate
    endDate
    filingDate
    decisionDate
    customerId
    regulationId
    responsibleUserId
    controlUserId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
}
    `;
export const ProjectDateReminderFieldsFragmentDoc = gql`
    fragment projectDateReminderFields on ProjectDateReminder {
  id
  advanceHours
  mailText
  projectDate @include(if: $withProjectDate) {
    id
    name
    dateTime
    type
    doneAt
    projectId
    displayField: name
  }
  roles @include(if: $withRoles) {
    items {
      id
      machineName
      displayName
      description
      order
      displayField: displayName
    }
    totalCount
  }
  sentAt
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ProjectDocumentFieldsFragmentDoc = gql`
    fragment projectDocumentFields on ProjectDocument {
  id
  name
  description
  attachment
  project @include(if: $withProject) {
    id
    name
    active
    description
    branch
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    isSimple
    addendum
    startDate
    endDate
    filingDate
    decisionDate
    customerId
    regulationId
    responsibleUserId
    controlUserId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
}
    `;
export const RegulationFieldsFragmentDoc = gql`
    fragment regulationFields on Regulation {
  id
  name
  description
  projects @include(if: $withProjects) {
    items {
      id
      name
      active
      description
      branch
      subsidyPercentage
      invoiceVatSubsidyEligible
      reference
      status
      hourSubsidyType
      maxHourlyRate
      isSimple
      addendum
      startDate
      endDate
      filingDate
      decisionDate
      customerId
      regulationId
      responsibleUserId
      controlUserId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
}
    `;
export const ResetPasswordFieldsFragmentDoc = gql`
    fragment resetPasswordFields on ResetPassword {
  id
  email
  token
  type
  createdAt
  updatedAt
}
    `;
export const RoleFieldsFragmentDoc = gql`
    fragment roleFields on Role {
  id
  machineName
  displayName
  description
  permissions @include(if: $withPermissions) {
    items {
      id
      name
      description
      displayField: name
    }
    totalCount
  }
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      projectId
      displayField: id
    }
    totalCount
  }
  projectDateReminders @include(if: $withProjectDateReminders) {
    items {
      id
      advanceHours
      mailText
      projectDateId
      sentAt
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  order
}
    `;
export const TenantFieldsFragmentDoc = gql`
    fragment tenantFields on Tenant {
  id
  name
  timeZone
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      projectId
      displayField: id
    }
    totalCount
  }
  description
  kvk
  iban
  invoiceDetails
  contactPerson
  invoiceVatSubsidyEligible
  mfaRequired
  projects @include(if: $withProjects) {
    items {
      id
      name
      active
      description
      branch
      subsidyPercentage
      invoiceVatSubsidyEligible
      reference
      status
      hourSubsidyType
      maxHourlyRate
      isSimple
      addendum
      startDate
      endDate
      filingDate
      decisionDate
      customerId
      regulationId
      responsibleUserId
      controlUserId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  budgetLines @include(if: $withBudgetLines) {
    items {
      id
      hours
      hourlyRate
      hourCosts
      invoiceCosts
      budgetId
      tenantId
      categoryId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  loggedHours @include(if: $withLoggedHours) {
    items {
      id
      description
      startDatetime
      endDatetime
      break
      declarableTime
      addendum
      declarable
      status
      categoryId
      projectId
      userId
      approvedById
      tenantId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  contracts @include(if: $withContracts) {
    items {
      id
      hoursPerWeek
      costPerHour
      startDate
      endDate
      hourlyRateInputs
      customCostPerHour
      salarySlip
      userId
      tenantId
      projectId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  invoices @include(if: $withInvoices) {
    items {
      id
      name
      description
      status
      total
      vat
      attachment
      attachmentProof
      subsidyPercentage
      vatSubsidyEligible
      invoiceNumber
      paidOn
      tenantId
      projectId
      categoryId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  name
  email
  emailVerifiedAt
  active
  avatar
  totpVerified
  termsAndConditions
  locale
  timeZone
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      projectId
      displayField: id
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
  lastName
  function
  phoneNumber
  note
  contracts @include(if: $withContracts) {
    items {
      id
      hoursPerWeek
      costPerHour
      startDate
      endDate
      hourlyRateInputs
      customCostPerHour
      salarySlip
      userId
      tenantId
      projectId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  availabilities @include(if: $withAvailabilities) {
    items {
      id
      month
      availability
      userId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  daysOffs @include(if: $withDaysOffs) {
    items {
      id
      startDate
      endDate
      approved
      note
      userId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  loggedHours @include(if: $withLoggedHours) {
    items {
      id
      description
      startDatetime
      endDatetime
      break
      declarableTime
      addendum
      declarable
      status
      categoryId
      projectId
      userId
      approvedById
      tenantId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  approvedLoggedHours @include(if: $withApprovedLoggedHours) {
    items {
      id
      description
      startDatetime
      endDatetime
      break
      declarableTime
      addendum
      declarable
      status
      categoryId
      projectId
      userId
      approvedById
      tenantId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  plannedHours @include(if: $withPlannedHours) {
    items {
      id
      month
      hours
      projectId
      userId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  productivities @include(if: $withProductivities) {
    items {
      id
      startDate
      factor
      userId
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  responsibleForProjects @include(if: $withResponsibleForProjects) {
    items {
      id
      name
      active
      description
      branch
      subsidyPercentage
      invoiceVatSubsidyEligible
      reference
      status
      hourSubsidyType
      maxHourlyRate
      isSimple
      addendum
      startDate
      endDate
      filingDate
      decisionDate
      customerId
      regulationId
      responsibleUserId
      controlUserId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  controllerForProjects @include(if: $withControllerForProjects) {
    items {
      id
      name
      active
      description
      branch
      subsidyPercentage
      invoiceVatSubsidyEligible
      reference
      status
      hourSubsidyType
      maxHourlyRate
      isSimple
      addendum
      startDate
      endDate
      filingDate
      decisionDate
      customerId
      regulationId
      responsibleUserId
      controlUserId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  categories @include(if: $withCategories) {
    items {
      id
      name
      subsidyPercentage
      hasHours
      hasInvoices
      order
      parentCategoryId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
}
    `;
export const UserTenantRoleFieldsFragmentDoc = gql`
    fragment userTenantRoleFields on UserTenantRole {
  id
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    lastName
    function
    phoneNumber
    note
    displayField: fullName
  }
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    description
    kvk
    iban
    invoiceDetails
    contactPerson
    invoiceVatSubsidyEligible
    mfaRequired
    displayField: name
  }
  role @include(if: $withRole) {
    id
    machineName
    displayName
    description
    order
    displayField: displayName
  }
  project @include(if: $withProject) {
    id
    name
    active
    description
    branch
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    isSimple
    addendum
    startDate
    endDate
    filingDate
    decisionDate
    customerId
    regulationId
    responsibleUserId
    controlUserId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
}
    `;
export const RowFieldsFragmentDoc = gql`
    fragment rowFields on DashboardRowDTO {
  id
  name
  order
  status
  totalBudget
  subsidyBudget
  totalRealization
  subsidyRealization
  fictiveTotalRealization
  fictiveSubsidyRealization
  regulation {
    id
    name
  }
}
    `;
export const GetAvailabilitiesDocument = gql`
    query GetAvailabilities($filter: AvailabilityFilterArgs, $paging: PageArgs, $sorting: [AvailabilitySortArgs!], $withUser: Boolean = false) {
  availabilities(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...availabilityFields
    }
    totalCount
  }
}
    ${AvailabilityFieldsFragmentDoc}`;

/**
 * __useGetAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useGetAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailabilitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useGetAvailabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailabilitiesQuery, GetAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailabilitiesQuery, GetAvailabilitiesQueryVariables>(GetAvailabilitiesDocument, options);
      }
export function useGetAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailabilitiesQuery, GetAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailabilitiesQuery, GetAvailabilitiesQueryVariables>(GetAvailabilitiesDocument, options);
        }
export function useGetAvailabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailabilitiesQuery, GetAvailabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailabilitiesQuery, GetAvailabilitiesQueryVariables>(GetAvailabilitiesDocument, options);
        }
export type GetAvailabilitiesQueryHookResult = ReturnType<typeof useGetAvailabilitiesQuery>;
export type GetAvailabilitiesLazyQueryHookResult = ReturnType<typeof useGetAvailabilitiesLazyQuery>;
export type GetAvailabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetAvailabilitiesSuspenseQuery>;
export type GetAvailabilitiesQueryResult = Apollo.QueryResult<GetAvailabilitiesQuery, GetAvailabilitiesQueryVariables>;
export const GetAvailabilityDocument = gql`
    query GetAvailability($id: ID!, $withUser: Boolean = false) {
  availability(id: $id) {
    ...availabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;

/**
 * __useGetAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useGetAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetAvailabilityQuery, GetAvailabilityQueryVariables> & ({ variables: GetAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailabilityQuery, GetAvailabilityQueryVariables>(GetAvailabilityDocument, options);
      }
export function useGetAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailabilityQuery, GetAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailabilityQuery, GetAvailabilityQueryVariables>(GetAvailabilityDocument, options);
        }
export function useGetAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailabilityQuery, GetAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailabilityQuery, GetAvailabilityQueryVariables>(GetAvailabilityDocument, options);
        }
export type GetAvailabilityQueryHookResult = ReturnType<typeof useGetAvailabilityQuery>;
export type GetAvailabilityLazyQueryHookResult = ReturnType<typeof useGetAvailabilityLazyQuery>;
export type GetAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetAvailabilitySuspenseQuery>;
export type GetAvailabilityQueryResult = Apollo.QueryResult<GetAvailabilityQuery, GetAvailabilityQueryVariables>;
export const GetAllRelatedDataForAvailabilityDocument = gql`
    query GetAllRelatedDataForAvailability($withUsers: Boolean = false) {
  users @include(if: $withUsers) {
    items {
      id
      displayField: fullName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForAvailabilityQuery({
 *   variables: {
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useGetAllRelatedDataForAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForAvailabilityQuery, GetAllRelatedDataForAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForAvailabilityQuery, GetAllRelatedDataForAvailabilityQueryVariables>(GetAllRelatedDataForAvailabilityDocument, options);
      }
export function useGetAllRelatedDataForAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForAvailabilityQuery, GetAllRelatedDataForAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForAvailabilityQuery, GetAllRelatedDataForAvailabilityQueryVariables>(GetAllRelatedDataForAvailabilityDocument, options);
        }
export function useGetAllRelatedDataForAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForAvailabilityQuery, GetAllRelatedDataForAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForAvailabilityQuery, GetAllRelatedDataForAvailabilityQueryVariables>(GetAllRelatedDataForAvailabilityDocument, options);
        }
export type GetAllRelatedDataForAvailabilityQueryHookResult = ReturnType<typeof useGetAllRelatedDataForAvailabilityQuery>;
export type GetAllRelatedDataForAvailabilityLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForAvailabilityLazyQuery>;
export type GetAllRelatedDataForAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForAvailabilitySuspenseQuery>;
export type GetAllRelatedDataForAvailabilityQueryResult = Apollo.QueryResult<GetAllRelatedDataForAvailabilityQuery, GetAllRelatedDataForAvailabilityQueryVariables>;
export const CreateAvailabilityDocument = gql`
    mutation CreateAvailability($month: DateTime!, $availability: Int!, $userId: ID!, $withUser: Boolean = false) {
  createAvailability(month: $month, availability: $availability, userId: $userId) {
    ...availabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;
export type CreateAvailabilityMutationFn = Apollo.MutationFunction<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>;

/**
 * __useCreateAvailabilityMutation__
 *
 * To run a mutation, you first call `useCreateAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAvailabilityMutation, { data, loading, error }] = useCreateAvailabilityMutation({
 *   variables: {
 *      month: // value for 'month'
 *      availability: // value for 'availability'
 *      userId: // value for 'userId'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useCreateAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>(CreateAvailabilityDocument, options);
      }
export type CreateAvailabilityMutationHookResult = ReturnType<typeof useCreateAvailabilityMutation>;
export type CreateAvailabilityMutationResult = Apollo.MutationResult<CreateAvailabilityMutation>;
export type CreateAvailabilityMutationOptions = Apollo.BaseMutationOptions<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>;
export const UpdateAvailabilityDocument = gql`
    mutation UpdateAvailability($id: ID!, $month: DateTime, $availability: Int, $userId: ID, $withUser: Boolean = false) {
  updateAvailability(
    id: $id
    month: $month
    availability: $availability
    userId: $userId
  ) {
    ...availabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;
export type UpdateAvailabilityMutationFn = Apollo.MutationFunction<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;

/**
 * __useUpdateAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvailabilityMutation, { data, loading, error }] = useUpdateAvailabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      month: // value for 'month'
 *      availability: // value for 'availability'
 *      userId: // value for 'userId'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useUpdateAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>(UpdateAvailabilityDocument, options);
      }
export type UpdateAvailabilityMutationHookResult = ReturnType<typeof useUpdateAvailabilityMutation>;
export type UpdateAvailabilityMutationResult = Apollo.MutationResult<UpdateAvailabilityMutation>;
export type UpdateAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;
export const DeleteAvailabilityDocument = gql`
    mutation DeleteAvailability($id: ID!, $withUser: Boolean = false) {
  deleteAvailability(id: $id) {
    ...availabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;
export type DeleteAvailabilityMutationFn = Apollo.MutationFunction<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>;

/**
 * __useDeleteAvailabilityMutation__
 *
 * To run a mutation, you first call `useDeleteAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAvailabilityMutation, { data, loading, error }] = useDeleteAvailabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useDeleteAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>(DeleteAvailabilityDocument, options);
      }
export type DeleteAvailabilityMutationHookResult = ReturnType<typeof useDeleteAvailabilityMutation>;
export type DeleteAvailabilityMutationResult = Apollo.MutationResult<DeleteAvailabilityMutation>;
export type DeleteAvailabilityMutationOptions = Apollo.BaseMutationOptions<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>;
export const CreatedAvailabilityDocument = gql`
    subscription CreatedAvailability($filter: AvailabilityFilterArgs, $withUser: Boolean = false) {
  createdAvailability(filter: $filter) {
    ...availabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;

/**
 * __useCreatedAvailabilitySubscription__
 *
 * To run a query within a React component, call `useCreatedAvailabilitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedAvailabilitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedAvailabilitySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useCreatedAvailabilitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedAvailabilitySubscription, CreatedAvailabilitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedAvailabilitySubscription, CreatedAvailabilitySubscriptionVariables>(CreatedAvailabilityDocument, options);
      }
export type CreatedAvailabilitySubscriptionHookResult = ReturnType<typeof useCreatedAvailabilitySubscription>;
export type CreatedAvailabilitySubscriptionResult = Apollo.SubscriptionResult<CreatedAvailabilitySubscription>;
export const UpdatedAvailabilityDocument = gql`
    subscription UpdatedAvailability($filter: AvailabilityFilterArgs, $withUser: Boolean = false) {
  updatedAvailability(filter: $filter) {
    ...availabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;

/**
 * __useUpdatedAvailabilitySubscription__
 *
 * To run a query within a React component, call `useUpdatedAvailabilitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedAvailabilitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedAvailabilitySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useUpdatedAvailabilitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedAvailabilitySubscription, UpdatedAvailabilitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedAvailabilitySubscription, UpdatedAvailabilitySubscriptionVariables>(UpdatedAvailabilityDocument, options);
      }
export type UpdatedAvailabilitySubscriptionHookResult = ReturnType<typeof useUpdatedAvailabilitySubscription>;
export type UpdatedAvailabilitySubscriptionResult = Apollo.SubscriptionResult<UpdatedAvailabilitySubscription>;
export const DeletedAvailabilityDocument = gql`
    subscription DeletedAvailability($filter: AvailabilityFilterArgs) {
  deletedAvailability(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedAvailabilitySubscription__
 *
 * To run a query within a React component, call `useDeletedAvailabilitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedAvailabilitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedAvailabilitySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedAvailabilitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedAvailabilitySubscription, DeletedAvailabilitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedAvailabilitySubscription, DeletedAvailabilitySubscriptionVariables>(DeletedAvailabilityDocument, options);
      }
export type DeletedAvailabilitySubscriptionHookResult = ReturnType<typeof useDeletedAvailabilitySubscription>;
export type DeletedAvailabilitySubscriptionResult = Apollo.SubscriptionResult<DeletedAvailabilitySubscription>;
export const RestoredAvailabilityDocument = gql`
    subscription RestoredAvailability($filter: AvailabilityFilterArgs, $withUser: Boolean = false) {
  restoredAvailability(filter: $filter) {
    ...availabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;

/**
 * __useRestoredAvailabilitySubscription__
 *
 * To run a query within a React component, call `useRestoredAvailabilitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredAvailabilitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredAvailabilitySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useRestoredAvailabilitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredAvailabilitySubscription, RestoredAvailabilitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredAvailabilitySubscription, RestoredAvailabilitySubscriptionVariables>(RestoredAvailabilityDocument, options);
      }
export type RestoredAvailabilitySubscriptionHookResult = ReturnType<typeof useRestoredAvailabilitySubscription>;
export type RestoredAvailabilitySubscriptionResult = Apollo.SubscriptionResult<RestoredAvailabilitySubscription>;
export const GetBudgetsDocument = gql`
    query GetBudgets($filter: BudgetFilterArgs, $paging: PageArgs, $sorting: [BudgetSortArgs!], $withProject: Boolean = false, $withBudgetLines: Boolean = false) {
  budgets(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...budgetFields
    }
    totalCount
  }
}
    ${BudgetFieldsFragmentDoc}`;

/**
 * __useGetBudgetsQuery__
 *
 * To run a query within a React component, call `useGetBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withProject: // value for 'withProject'
 *      withBudgetLines: // value for 'withBudgetLines'
 *   },
 * });
 */
export function useGetBudgetsQuery(baseOptions?: Apollo.QueryHookOptions<GetBudgetsQuery, GetBudgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(GetBudgetsDocument, options);
      }
export function useGetBudgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBudgetsQuery, GetBudgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(GetBudgetsDocument, options);
        }
export function useGetBudgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBudgetsQuery, GetBudgetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(GetBudgetsDocument, options);
        }
export type GetBudgetsQueryHookResult = ReturnType<typeof useGetBudgetsQuery>;
export type GetBudgetsLazyQueryHookResult = ReturnType<typeof useGetBudgetsLazyQuery>;
export type GetBudgetsSuspenseQueryHookResult = ReturnType<typeof useGetBudgetsSuspenseQuery>;
export type GetBudgetsQueryResult = Apollo.QueryResult<GetBudgetsQuery, GetBudgetsQueryVariables>;
export const GetBudgetDocument = gql`
    query GetBudget($id: ID!, $withProject: Boolean = false, $withBudgetLines: Boolean = false) {
  budget(id: $id) {
    ...budgetFields
  }
}
    ${BudgetFieldsFragmentDoc}`;

/**
 * __useGetBudgetQuery__
 *
 * To run a query within a React component, call `useGetBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withProject: // value for 'withProject'
 *      withBudgetLines: // value for 'withBudgetLines'
 *   },
 * });
 */
export function useGetBudgetQuery(baseOptions: Apollo.QueryHookOptions<GetBudgetQuery, GetBudgetQueryVariables> & ({ variables: GetBudgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBudgetQuery, GetBudgetQueryVariables>(GetBudgetDocument, options);
      }
export function useGetBudgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBudgetQuery, GetBudgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBudgetQuery, GetBudgetQueryVariables>(GetBudgetDocument, options);
        }
export function useGetBudgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBudgetQuery, GetBudgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBudgetQuery, GetBudgetQueryVariables>(GetBudgetDocument, options);
        }
export type GetBudgetQueryHookResult = ReturnType<typeof useGetBudgetQuery>;
export type GetBudgetLazyQueryHookResult = ReturnType<typeof useGetBudgetLazyQuery>;
export type GetBudgetSuspenseQueryHookResult = ReturnType<typeof useGetBudgetSuspenseQuery>;
export type GetBudgetQueryResult = Apollo.QueryResult<GetBudgetQuery, GetBudgetQueryVariables>;
export const GetAllRelatedDataForBudgetDocument = gql`
    query GetAllRelatedDataForBudget($withProjects: Boolean = false, $withBudgetLines: Boolean = false) {
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
  budgetLines @include(if: $withBudgetLines) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForBudgetQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForBudgetQuery({
 *   variables: {
 *      withProjects: // value for 'withProjects'
 *      withBudgetLines: // value for 'withBudgetLines'
 *   },
 * });
 */
export function useGetAllRelatedDataForBudgetQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForBudgetQuery, GetAllRelatedDataForBudgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForBudgetQuery, GetAllRelatedDataForBudgetQueryVariables>(GetAllRelatedDataForBudgetDocument, options);
      }
export function useGetAllRelatedDataForBudgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForBudgetQuery, GetAllRelatedDataForBudgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForBudgetQuery, GetAllRelatedDataForBudgetQueryVariables>(GetAllRelatedDataForBudgetDocument, options);
        }
export function useGetAllRelatedDataForBudgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForBudgetQuery, GetAllRelatedDataForBudgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForBudgetQuery, GetAllRelatedDataForBudgetQueryVariables>(GetAllRelatedDataForBudgetDocument, options);
        }
export type GetAllRelatedDataForBudgetQueryHookResult = ReturnType<typeof useGetAllRelatedDataForBudgetQuery>;
export type GetAllRelatedDataForBudgetLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForBudgetLazyQuery>;
export type GetAllRelatedDataForBudgetSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForBudgetSuspenseQuery>;
export type GetAllRelatedDataForBudgetQueryResult = Apollo.QueryResult<GetAllRelatedDataForBudgetQuery, GetAllRelatedDataForBudgetQueryVariables>;
export const CreateBudgetDocument = gql`
    mutation CreateBudget($total: Float, $startDate: DateTime, $endDate: DateTime, $completionDate: DateTime, $note: String!, $projectId: ID!, $budgetLines: [ID], $withProject: Boolean = false, $withBudgetLines: Boolean = false) {
  createBudget(
    total: $total
    startDate: $startDate
    endDate: $endDate
    completionDate: $completionDate
    note: $note
    projectId: $projectId
    budgetLineIds: $budgetLines
  ) {
    ...budgetFields
  }
}
    ${BudgetFieldsFragmentDoc}`;
export type CreateBudgetMutationFn = Apollo.MutationFunction<CreateBudgetMutation, CreateBudgetMutationVariables>;

/**
 * __useCreateBudgetMutation__
 *
 * To run a mutation, you first call `useCreateBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBudgetMutation, { data, loading, error }] = useCreateBudgetMutation({
 *   variables: {
 *      total: // value for 'total'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      completionDate: // value for 'completionDate'
 *      note: // value for 'note'
 *      projectId: // value for 'projectId'
 *      budgetLines: // value for 'budgetLines'
 *      withProject: // value for 'withProject'
 *      withBudgetLines: // value for 'withBudgetLines'
 *   },
 * });
 */
export function useCreateBudgetMutation(baseOptions?: Apollo.MutationHookOptions<CreateBudgetMutation, CreateBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBudgetMutation, CreateBudgetMutationVariables>(CreateBudgetDocument, options);
      }
export type CreateBudgetMutationHookResult = ReturnType<typeof useCreateBudgetMutation>;
export type CreateBudgetMutationResult = Apollo.MutationResult<CreateBudgetMutation>;
export type CreateBudgetMutationOptions = Apollo.BaseMutationOptions<CreateBudgetMutation, CreateBudgetMutationVariables>;
export const UpdateBudgetDocument = gql`
    mutation UpdateBudget($id: ID!, $total: Float, $startDate: DateTime, $endDate: DateTime, $completionDate: DateTime, $note: String, $projectId: ID, $budgetLines: [ID], $withProject: Boolean = false, $withBudgetLines: Boolean = false) {
  updateBudget(
    id: $id
    total: $total
    startDate: $startDate
    endDate: $endDate
    completionDate: $completionDate
    note: $note
    projectId: $projectId
    budgetLineIds: $budgetLines
  ) {
    ...budgetFields
  }
}
    ${BudgetFieldsFragmentDoc}`;
export type UpdateBudgetMutationFn = Apollo.MutationFunction<UpdateBudgetMutation, UpdateBudgetMutationVariables>;

/**
 * __useUpdateBudgetMutation__
 *
 * To run a mutation, you first call `useUpdateBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBudgetMutation, { data, loading, error }] = useUpdateBudgetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      total: // value for 'total'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      completionDate: // value for 'completionDate'
 *      note: // value for 'note'
 *      projectId: // value for 'projectId'
 *      budgetLines: // value for 'budgetLines'
 *      withProject: // value for 'withProject'
 *      withBudgetLines: // value for 'withBudgetLines'
 *   },
 * });
 */
export function useUpdateBudgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBudgetMutation, UpdateBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBudgetMutation, UpdateBudgetMutationVariables>(UpdateBudgetDocument, options);
      }
export type UpdateBudgetMutationHookResult = ReturnType<typeof useUpdateBudgetMutation>;
export type UpdateBudgetMutationResult = Apollo.MutationResult<UpdateBudgetMutation>;
export type UpdateBudgetMutationOptions = Apollo.BaseMutationOptions<UpdateBudgetMutation, UpdateBudgetMutationVariables>;
export const DeleteBudgetDocument = gql`
    mutation DeleteBudget($id: ID!, $withProject: Boolean = false, $withBudgetLines: Boolean = false) {
  deleteBudget(id: $id) {
    ...budgetFields
  }
}
    ${BudgetFieldsFragmentDoc}`;
export type DeleteBudgetMutationFn = Apollo.MutationFunction<DeleteBudgetMutation, DeleteBudgetMutationVariables>;

/**
 * __useDeleteBudgetMutation__
 *
 * To run a mutation, you first call `useDeleteBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBudgetMutation, { data, loading, error }] = useDeleteBudgetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withProject: // value for 'withProject'
 *      withBudgetLines: // value for 'withBudgetLines'
 *   },
 * });
 */
export function useDeleteBudgetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBudgetMutation, DeleteBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBudgetMutation, DeleteBudgetMutationVariables>(DeleteBudgetDocument, options);
      }
export type DeleteBudgetMutationHookResult = ReturnType<typeof useDeleteBudgetMutation>;
export type DeleteBudgetMutationResult = Apollo.MutationResult<DeleteBudgetMutation>;
export type DeleteBudgetMutationOptions = Apollo.BaseMutationOptions<DeleteBudgetMutation, DeleteBudgetMutationVariables>;
export const CreatedBudgetDocument = gql`
    subscription CreatedBudget($filter: BudgetFilterArgs, $withProject: Boolean = false, $withBudgetLines: Boolean = false) {
  createdBudget(filter: $filter) {
    ...budgetFields
  }
}
    ${BudgetFieldsFragmentDoc}`;

/**
 * __useCreatedBudgetSubscription__
 *
 * To run a query within a React component, call `useCreatedBudgetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedBudgetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedBudgetSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *      withBudgetLines: // value for 'withBudgetLines'
 *   },
 * });
 */
export function useCreatedBudgetSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedBudgetSubscription, CreatedBudgetSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedBudgetSubscription, CreatedBudgetSubscriptionVariables>(CreatedBudgetDocument, options);
      }
export type CreatedBudgetSubscriptionHookResult = ReturnType<typeof useCreatedBudgetSubscription>;
export type CreatedBudgetSubscriptionResult = Apollo.SubscriptionResult<CreatedBudgetSubscription>;
export const UpdatedBudgetDocument = gql`
    subscription UpdatedBudget($filter: BudgetFilterArgs, $withProject: Boolean = false, $withBudgetLines: Boolean = false) {
  updatedBudget(filter: $filter) {
    ...budgetFields
  }
}
    ${BudgetFieldsFragmentDoc}`;

/**
 * __useUpdatedBudgetSubscription__
 *
 * To run a query within a React component, call `useUpdatedBudgetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedBudgetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedBudgetSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *      withBudgetLines: // value for 'withBudgetLines'
 *   },
 * });
 */
export function useUpdatedBudgetSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedBudgetSubscription, UpdatedBudgetSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedBudgetSubscription, UpdatedBudgetSubscriptionVariables>(UpdatedBudgetDocument, options);
      }
export type UpdatedBudgetSubscriptionHookResult = ReturnType<typeof useUpdatedBudgetSubscription>;
export type UpdatedBudgetSubscriptionResult = Apollo.SubscriptionResult<UpdatedBudgetSubscription>;
export const DeletedBudgetDocument = gql`
    subscription DeletedBudget($filter: BudgetFilterArgs) {
  deletedBudget(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedBudgetSubscription__
 *
 * To run a query within a React component, call `useDeletedBudgetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedBudgetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedBudgetSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedBudgetSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedBudgetSubscription, DeletedBudgetSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedBudgetSubscription, DeletedBudgetSubscriptionVariables>(DeletedBudgetDocument, options);
      }
export type DeletedBudgetSubscriptionHookResult = ReturnType<typeof useDeletedBudgetSubscription>;
export type DeletedBudgetSubscriptionResult = Apollo.SubscriptionResult<DeletedBudgetSubscription>;
export const RestoredBudgetDocument = gql`
    subscription RestoredBudget($filter: BudgetFilterArgs, $withProject: Boolean = false, $withBudgetLines: Boolean = false) {
  restoredBudget(filter: $filter) {
    ...budgetFields
  }
}
    ${BudgetFieldsFragmentDoc}`;

/**
 * __useRestoredBudgetSubscription__
 *
 * To run a query within a React component, call `useRestoredBudgetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredBudgetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredBudgetSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *      withBudgetLines: // value for 'withBudgetLines'
 *   },
 * });
 */
export function useRestoredBudgetSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredBudgetSubscription, RestoredBudgetSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredBudgetSubscription, RestoredBudgetSubscriptionVariables>(RestoredBudgetDocument, options);
      }
export type RestoredBudgetSubscriptionHookResult = ReturnType<typeof useRestoredBudgetSubscription>;
export type RestoredBudgetSubscriptionResult = Apollo.SubscriptionResult<RestoredBudgetSubscription>;
export const GetBudgetLinesDocument = gql`
    query GetBudgetLines($filter: BudgetLineFilterArgs, $paging: PageArgs, $sorting: [BudgetLineSortArgs!], $withBudget: Boolean = false, $withTenant: Boolean = false, $withCategory: Boolean = false) {
  budgetLines(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...budgetLineFields
    }
    totalCount
  }
}
    ${BudgetLineFieldsFragmentDoc}`;

/**
 * __useGetBudgetLinesQuery__
 *
 * To run a query within a React component, call `useGetBudgetLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetLinesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withBudget: // value for 'withBudget'
 *      withTenant: // value for 'withTenant'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useGetBudgetLinesQuery(baseOptions?: Apollo.QueryHookOptions<GetBudgetLinesQuery, GetBudgetLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBudgetLinesQuery, GetBudgetLinesQueryVariables>(GetBudgetLinesDocument, options);
      }
export function useGetBudgetLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBudgetLinesQuery, GetBudgetLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBudgetLinesQuery, GetBudgetLinesQueryVariables>(GetBudgetLinesDocument, options);
        }
export function useGetBudgetLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBudgetLinesQuery, GetBudgetLinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBudgetLinesQuery, GetBudgetLinesQueryVariables>(GetBudgetLinesDocument, options);
        }
export type GetBudgetLinesQueryHookResult = ReturnType<typeof useGetBudgetLinesQuery>;
export type GetBudgetLinesLazyQueryHookResult = ReturnType<typeof useGetBudgetLinesLazyQuery>;
export type GetBudgetLinesSuspenseQueryHookResult = ReturnType<typeof useGetBudgetLinesSuspenseQuery>;
export type GetBudgetLinesQueryResult = Apollo.QueryResult<GetBudgetLinesQuery, GetBudgetLinesQueryVariables>;
export const GetBudgetLineDocument = gql`
    query GetBudgetLine($id: ID!, $withBudget: Boolean = false, $withTenant: Boolean = false, $withCategory: Boolean = false) {
  budgetLine(id: $id) {
    ...budgetLineFields
  }
}
    ${BudgetLineFieldsFragmentDoc}`;

/**
 * __useGetBudgetLineQuery__
 *
 * To run a query within a React component, call `useGetBudgetLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetLineQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withBudget: // value for 'withBudget'
 *      withTenant: // value for 'withTenant'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useGetBudgetLineQuery(baseOptions: Apollo.QueryHookOptions<GetBudgetLineQuery, GetBudgetLineQueryVariables> & ({ variables: GetBudgetLineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBudgetLineQuery, GetBudgetLineQueryVariables>(GetBudgetLineDocument, options);
      }
export function useGetBudgetLineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBudgetLineQuery, GetBudgetLineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBudgetLineQuery, GetBudgetLineQueryVariables>(GetBudgetLineDocument, options);
        }
export function useGetBudgetLineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBudgetLineQuery, GetBudgetLineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBudgetLineQuery, GetBudgetLineQueryVariables>(GetBudgetLineDocument, options);
        }
export type GetBudgetLineQueryHookResult = ReturnType<typeof useGetBudgetLineQuery>;
export type GetBudgetLineLazyQueryHookResult = ReturnType<typeof useGetBudgetLineLazyQuery>;
export type GetBudgetLineSuspenseQueryHookResult = ReturnType<typeof useGetBudgetLineSuspenseQuery>;
export type GetBudgetLineQueryResult = Apollo.QueryResult<GetBudgetLineQuery, GetBudgetLineQueryVariables>;
export const GetAllRelatedDataForBudgetLineDocument = gql`
    query GetAllRelatedDataForBudgetLine($withBudgets: Boolean = false, $withTenants: Boolean = false, $withCategories: Boolean = false) {
  budgets @include(if: $withBudgets) {
    items {
      id
      displayField: id
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
  categories @include(if: $withCategories) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForBudgetLineQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForBudgetLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForBudgetLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForBudgetLineQuery({
 *   variables: {
 *      withBudgets: // value for 'withBudgets'
 *      withTenants: // value for 'withTenants'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useGetAllRelatedDataForBudgetLineQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForBudgetLineQuery, GetAllRelatedDataForBudgetLineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForBudgetLineQuery, GetAllRelatedDataForBudgetLineQueryVariables>(GetAllRelatedDataForBudgetLineDocument, options);
      }
export function useGetAllRelatedDataForBudgetLineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForBudgetLineQuery, GetAllRelatedDataForBudgetLineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForBudgetLineQuery, GetAllRelatedDataForBudgetLineQueryVariables>(GetAllRelatedDataForBudgetLineDocument, options);
        }
export function useGetAllRelatedDataForBudgetLineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForBudgetLineQuery, GetAllRelatedDataForBudgetLineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForBudgetLineQuery, GetAllRelatedDataForBudgetLineQueryVariables>(GetAllRelatedDataForBudgetLineDocument, options);
        }
export type GetAllRelatedDataForBudgetLineQueryHookResult = ReturnType<typeof useGetAllRelatedDataForBudgetLineQuery>;
export type GetAllRelatedDataForBudgetLineLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForBudgetLineLazyQuery>;
export type GetAllRelatedDataForBudgetLineSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForBudgetLineSuspenseQuery>;
export type GetAllRelatedDataForBudgetLineQueryResult = Apollo.QueryResult<GetAllRelatedDataForBudgetLineQuery, GetAllRelatedDataForBudgetLineQueryVariables>;
export const CreateBudgetLineDocument = gql`
    mutation CreateBudgetLine($hours: Float, $hourlyRate: Float, $hourCosts: Float, $invoiceCosts: Float, $budgetId: ID!, $tenantId: ID, $categoryId: ID, $withBudget: Boolean = false, $withTenant: Boolean = false, $withCategory: Boolean = false) {
  createBudgetLine(
    hours: $hours
    hourlyRate: $hourlyRate
    hourCosts: $hourCosts
    invoiceCosts: $invoiceCosts
    budgetId: $budgetId
    tenantId: $tenantId
    categoryId: $categoryId
  ) {
    ...budgetLineFields
  }
}
    ${BudgetLineFieldsFragmentDoc}`;
export type CreateBudgetLineMutationFn = Apollo.MutationFunction<CreateBudgetLineMutation, CreateBudgetLineMutationVariables>;

/**
 * __useCreateBudgetLineMutation__
 *
 * To run a mutation, you first call `useCreateBudgetLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBudgetLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBudgetLineMutation, { data, loading, error }] = useCreateBudgetLineMutation({
 *   variables: {
 *      hours: // value for 'hours'
 *      hourlyRate: // value for 'hourlyRate'
 *      hourCosts: // value for 'hourCosts'
 *      invoiceCosts: // value for 'invoiceCosts'
 *      budgetId: // value for 'budgetId'
 *      tenantId: // value for 'tenantId'
 *      categoryId: // value for 'categoryId'
 *      withBudget: // value for 'withBudget'
 *      withTenant: // value for 'withTenant'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useCreateBudgetLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateBudgetLineMutation, CreateBudgetLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBudgetLineMutation, CreateBudgetLineMutationVariables>(CreateBudgetLineDocument, options);
      }
export type CreateBudgetLineMutationHookResult = ReturnType<typeof useCreateBudgetLineMutation>;
export type CreateBudgetLineMutationResult = Apollo.MutationResult<CreateBudgetLineMutation>;
export type CreateBudgetLineMutationOptions = Apollo.BaseMutationOptions<CreateBudgetLineMutation, CreateBudgetLineMutationVariables>;
export const UpdateBudgetLineDocument = gql`
    mutation UpdateBudgetLine($id: ID!, $hours: Float, $hourlyRate: Float, $hourCosts: Float, $invoiceCosts: Float, $budgetId: ID, $tenantId: ID, $categoryId: ID, $withBudget: Boolean = false, $withTenant: Boolean = false, $withCategory: Boolean = false) {
  updateBudgetLine(
    id: $id
    hours: $hours
    hourlyRate: $hourlyRate
    hourCosts: $hourCosts
    invoiceCosts: $invoiceCosts
    budgetId: $budgetId
    tenantId: $tenantId
    categoryId: $categoryId
  ) {
    ...budgetLineFields
  }
}
    ${BudgetLineFieldsFragmentDoc}`;
export type UpdateBudgetLineMutationFn = Apollo.MutationFunction<UpdateBudgetLineMutation, UpdateBudgetLineMutationVariables>;

/**
 * __useUpdateBudgetLineMutation__
 *
 * To run a mutation, you first call `useUpdateBudgetLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBudgetLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBudgetLineMutation, { data, loading, error }] = useUpdateBudgetLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hours: // value for 'hours'
 *      hourlyRate: // value for 'hourlyRate'
 *      hourCosts: // value for 'hourCosts'
 *      invoiceCosts: // value for 'invoiceCosts'
 *      budgetId: // value for 'budgetId'
 *      tenantId: // value for 'tenantId'
 *      categoryId: // value for 'categoryId'
 *      withBudget: // value for 'withBudget'
 *      withTenant: // value for 'withTenant'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useUpdateBudgetLineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBudgetLineMutation, UpdateBudgetLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBudgetLineMutation, UpdateBudgetLineMutationVariables>(UpdateBudgetLineDocument, options);
      }
export type UpdateBudgetLineMutationHookResult = ReturnType<typeof useUpdateBudgetLineMutation>;
export type UpdateBudgetLineMutationResult = Apollo.MutationResult<UpdateBudgetLineMutation>;
export type UpdateBudgetLineMutationOptions = Apollo.BaseMutationOptions<UpdateBudgetLineMutation, UpdateBudgetLineMutationVariables>;
export const DeleteBudgetLineDocument = gql`
    mutation DeleteBudgetLine($id: ID!, $withBudget: Boolean = false, $withTenant: Boolean = false, $withCategory: Boolean = false) {
  deleteBudgetLine(id: $id) {
    ...budgetLineFields
  }
}
    ${BudgetLineFieldsFragmentDoc}`;
export type DeleteBudgetLineMutationFn = Apollo.MutationFunction<DeleteBudgetLineMutation, DeleteBudgetLineMutationVariables>;

/**
 * __useDeleteBudgetLineMutation__
 *
 * To run a mutation, you first call `useDeleteBudgetLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBudgetLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBudgetLineMutation, { data, loading, error }] = useDeleteBudgetLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withBudget: // value for 'withBudget'
 *      withTenant: // value for 'withTenant'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useDeleteBudgetLineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBudgetLineMutation, DeleteBudgetLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBudgetLineMutation, DeleteBudgetLineMutationVariables>(DeleteBudgetLineDocument, options);
      }
export type DeleteBudgetLineMutationHookResult = ReturnType<typeof useDeleteBudgetLineMutation>;
export type DeleteBudgetLineMutationResult = Apollo.MutationResult<DeleteBudgetLineMutation>;
export type DeleteBudgetLineMutationOptions = Apollo.BaseMutationOptions<DeleteBudgetLineMutation, DeleteBudgetLineMutationVariables>;
export const CreatedBudgetLineDocument = gql`
    subscription CreatedBudgetLine($filter: BudgetLineFilterArgs, $withBudget: Boolean = false, $withTenant: Boolean = false, $withCategory: Boolean = false) {
  createdBudgetLine(filter: $filter) {
    ...budgetLineFields
  }
}
    ${BudgetLineFieldsFragmentDoc}`;

/**
 * __useCreatedBudgetLineSubscription__
 *
 * To run a query within a React component, call `useCreatedBudgetLineSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedBudgetLineSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedBudgetLineSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withBudget: // value for 'withBudget'
 *      withTenant: // value for 'withTenant'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useCreatedBudgetLineSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedBudgetLineSubscription, CreatedBudgetLineSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedBudgetLineSubscription, CreatedBudgetLineSubscriptionVariables>(CreatedBudgetLineDocument, options);
      }
export type CreatedBudgetLineSubscriptionHookResult = ReturnType<typeof useCreatedBudgetLineSubscription>;
export type CreatedBudgetLineSubscriptionResult = Apollo.SubscriptionResult<CreatedBudgetLineSubscription>;
export const UpdatedBudgetLineDocument = gql`
    subscription UpdatedBudgetLine($filter: BudgetLineFilterArgs, $withBudget: Boolean = false, $withTenant: Boolean = false, $withCategory: Boolean = false) {
  updatedBudgetLine(filter: $filter) {
    ...budgetLineFields
  }
}
    ${BudgetLineFieldsFragmentDoc}`;

/**
 * __useUpdatedBudgetLineSubscription__
 *
 * To run a query within a React component, call `useUpdatedBudgetLineSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedBudgetLineSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedBudgetLineSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withBudget: // value for 'withBudget'
 *      withTenant: // value for 'withTenant'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useUpdatedBudgetLineSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedBudgetLineSubscription, UpdatedBudgetLineSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedBudgetLineSubscription, UpdatedBudgetLineSubscriptionVariables>(UpdatedBudgetLineDocument, options);
      }
export type UpdatedBudgetLineSubscriptionHookResult = ReturnType<typeof useUpdatedBudgetLineSubscription>;
export type UpdatedBudgetLineSubscriptionResult = Apollo.SubscriptionResult<UpdatedBudgetLineSubscription>;
export const DeletedBudgetLineDocument = gql`
    subscription DeletedBudgetLine($filter: BudgetLineFilterArgs) {
  deletedBudgetLine(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedBudgetLineSubscription__
 *
 * To run a query within a React component, call `useDeletedBudgetLineSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedBudgetLineSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedBudgetLineSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedBudgetLineSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedBudgetLineSubscription, DeletedBudgetLineSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedBudgetLineSubscription, DeletedBudgetLineSubscriptionVariables>(DeletedBudgetLineDocument, options);
      }
export type DeletedBudgetLineSubscriptionHookResult = ReturnType<typeof useDeletedBudgetLineSubscription>;
export type DeletedBudgetLineSubscriptionResult = Apollo.SubscriptionResult<DeletedBudgetLineSubscription>;
export const RestoredBudgetLineDocument = gql`
    subscription RestoredBudgetLine($filter: BudgetLineFilterArgs, $withBudget: Boolean = false, $withTenant: Boolean = false, $withCategory: Boolean = false) {
  restoredBudgetLine(filter: $filter) {
    ...budgetLineFields
  }
}
    ${BudgetLineFieldsFragmentDoc}`;

/**
 * __useRestoredBudgetLineSubscription__
 *
 * To run a query within a React component, call `useRestoredBudgetLineSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredBudgetLineSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredBudgetLineSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withBudget: // value for 'withBudget'
 *      withTenant: // value for 'withTenant'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useRestoredBudgetLineSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredBudgetLineSubscription, RestoredBudgetLineSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredBudgetLineSubscription, RestoredBudgetLineSubscriptionVariables>(RestoredBudgetLineDocument, options);
      }
export type RestoredBudgetLineSubscriptionHookResult = ReturnType<typeof useRestoredBudgetLineSubscription>;
export type RestoredBudgetLineSubscriptionResult = Apollo.SubscriptionResult<RestoredBudgetLineSubscription>;
export const GetCategoriesDocument = gql`
    query GetCategories($filter: CategoryFilterArgs, $paging: PageArgs, $sorting: [CategorySortArgs!], $withLoggedHours: Boolean = false, $withBudgetLines: Boolean = false, $withInvoices: Boolean = false, $withProjects: Boolean = false, $withParentCategory: Boolean = false, $withSubCategories: Boolean = false, $withUsers: Boolean = false) {
  categories(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...categoryFields
    }
    totalCount
  }
}
    ${CategoryFieldsFragmentDoc}`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withInvoices: // value for 'withInvoices'
 *      withProjects: // value for 'withProjects'
 *      withParentCategory: // value for 'withParentCategory'
 *      withSubCategories: // value for 'withSubCategories'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoryDocument = gql`
    query GetCategory($id: ID!, $withLoggedHours: Boolean = false, $withBudgetLines: Boolean = false, $withInvoices: Boolean = false, $withProjects: Boolean = false, $withParentCategory: Boolean = false, $withSubCategories: Boolean = false, $withUsers: Boolean = false) {
  category(id: $id) {
    ...categoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withInvoices: // value for 'withInvoices'
 *      withProjects: // value for 'withProjects'
 *      withParentCategory: // value for 'withParentCategory'
 *      withSubCategories: // value for 'withSubCategories'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables> & ({ variables: GetCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
      }
export function useGetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export function useGetCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategorySuspenseQueryHookResult = ReturnType<typeof useGetCategorySuspenseQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export const GetAllRelatedDataForCategoryDocument = gql`
    query GetAllRelatedDataForCategory($withLoggedHours: Boolean = false, $withBudgetLines: Boolean = false, $withInvoices: Boolean = false, $withProjects: Boolean = false, $withParentCategories: Boolean = false, $withSubCategories: Boolean = false, $withUsers: Boolean = false) {
  loggedHours @include(if: $withLoggedHours) {
    items {
      id
      displayField: id
    }
  }
  budgetLines @include(if: $withBudgetLines) {
    items {
      id
      displayField: id
    }
  }
  invoices @include(if: $withInvoices) {
    items {
      id
      displayField: name
    }
  }
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
  categories @include(if: $withParentCategories) {
    items {
      id
      displayField: name
    }
  }
  categories @include(if: $withSubCategories) {
    items {
      id
      displayField: name
    }
  }
  users @include(if: $withUsers) {
    items {
      id
      displayField: fullName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForCategoryQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForCategoryQuery({
 *   variables: {
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withInvoices: // value for 'withInvoices'
 *      withProjects: // value for 'withProjects'
 *      withParentCategories: // value for 'withParentCategories'
 *      withSubCategories: // value for 'withSubCategories'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useGetAllRelatedDataForCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForCategoryQuery, GetAllRelatedDataForCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForCategoryQuery, GetAllRelatedDataForCategoryQueryVariables>(GetAllRelatedDataForCategoryDocument, options);
      }
export function useGetAllRelatedDataForCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForCategoryQuery, GetAllRelatedDataForCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForCategoryQuery, GetAllRelatedDataForCategoryQueryVariables>(GetAllRelatedDataForCategoryDocument, options);
        }
export function useGetAllRelatedDataForCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForCategoryQuery, GetAllRelatedDataForCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForCategoryQuery, GetAllRelatedDataForCategoryQueryVariables>(GetAllRelatedDataForCategoryDocument, options);
        }
export type GetAllRelatedDataForCategoryQueryHookResult = ReturnType<typeof useGetAllRelatedDataForCategoryQuery>;
export type GetAllRelatedDataForCategoryLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForCategoryLazyQuery>;
export type GetAllRelatedDataForCategorySuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForCategorySuspenseQuery>;
export type GetAllRelatedDataForCategoryQueryResult = Apollo.QueryResult<GetAllRelatedDataForCategoryQuery, GetAllRelatedDataForCategoryQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($name: String!, $subsidyPercentage: Float, $hasHours: Boolean!, $hasInvoices: Boolean!, $order: Int, $loggedHours: [ID], $budgetLines: [ID], $invoices: [ID], $projects: [ID], $parentCategoryId: ID, $subCategories: [ID], $users: [ID], $withLoggedHours: Boolean = false, $withBudgetLines: Boolean = false, $withInvoices: Boolean = false, $withProjects: Boolean = false, $withParentCategory: Boolean = false, $withSubCategories: Boolean = false, $withUsers: Boolean = false) {
  createCategory(
    name: $name
    subsidyPercentage: $subsidyPercentage
    hasHours: $hasHours
    hasInvoices: $hasInvoices
    order: $order
    loggedHourIds: $loggedHours
    budgetLineIds: $budgetLines
    invoiceIds: $invoices
    projectIds: $projects
    parentCategoryId: $parentCategoryId
    subCategoriesIds: $subCategories
    userIds: $users
  ) {
    ...categoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      subsidyPercentage: // value for 'subsidyPercentage'
 *      hasHours: // value for 'hasHours'
 *      hasInvoices: // value for 'hasInvoices'
 *      order: // value for 'order'
 *      loggedHours: // value for 'loggedHours'
 *      budgetLines: // value for 'budgetLines'
 *      invoices: // value for 'invoices'
 *      projects: // value for 'projects'
 *      parentCategoryId: // value for 'parentCategoryId'
 *      subCategories: // value for 'subCategories'
 *      users: // value for 'users'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withInvoices: // value for 'withInvoices'
 *      withProjects: // value for 'withProjects'
 *      withParentCategory: // value for 'withParentCategory'
 *      withSubCategories: // value for 'withSubCategories'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($id: ID!, $name: String, $subsidyPercentage: Float, $hasHours: Boolean, $hasInvoices: Boolean, $order: Int, $loggedHours: [ID], $budgetLines: [ID], $invoices: [ID], $projects: [ID], $parentCategoryId: ID, $subCategories: [ID], $users: [ID], $withLoggedHours: Boolean = false, $withBudgetLines: Boolean = false, $withInvoices: Boolean = false, $withProjects: Boolean = false, $withParentCategory: Boolean = false, $withSubCategories: Boolean = false, $withUsers: Boolean = false) {
  updateCategory(
    id: $id
    name: $name
    subsidyPercentage: $subsidyPercentage
    hasHours: $hasHours
    hasInvoices: $hasInvoices
    order: $order
    loggedHourIds: $loggedHours
    budgetLineIds: $budgetLines
    invoiceIds: $invoices
    projectIds: $projects
    parentCategoryId: $parentCategoryId
    subCategoriesIds: $subCategories
    userIds: $users
  ) {
    ...categoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      subsidyPercentage: // value for 'subsidyPercentage'
 *      hasHours: // value for 'hasHours'
 *      hasInvoices: // value for 'hasInvoices'
 *      order: // value for 'order'
 *      loggedHours: // value for 'loggedHours'
 *      budgetLines: // value for 'budgetLines'
 *      invoices: // value for 'invoices'
 *      projects: // value for 'projects'
 *      parentCategoryId: // value for 'parentCategoryId'
 *      subCategories: // value for 'subCategories'
 *      users: // value for 'users'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withInvoices: // value for 'withInvoices'
 *      withProjects: // value for 'withProjects'
 *      withParentCategory: // value for 'withParentCategory'
 *      withSubCategories: // value for 'withSubCategories'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation DeleteCategory($id: ID!, $withLoggedHours: Boolean = false, $withBudgetLines: Boolean = false, $withInvoices: Boolean = false, $withProjects: Boolean = false, $withParentCategory: Boolean = false, $withSubCategories: Boolean = false, $withUsers: Boolean = false) {
  deleteCategory(id: $id) {
    ...categoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withInvoices: // value for 'withInvoices'
 *      withProjects: // value for 'withProjects'
 *      withParentCategory: // value for 'withParentCategory'
 *      withSubCategories: // value for 'withSubCategories'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const CreatedCategoryDocument = gql`
    subscription CreatedCategory($filter: CategoryFilterArgs, $withLoggedHours: Boolean = false, $withBudgetLines: Boolean = false, $withInvoices: Boolean = false, $withProjects: Boolean = false, $withParentCategory: Boolean = false, $withSubCategories: Boolean = false, $withUsers: Boolean = false) {
  createdCategory(filter: $filter) {
    ...categoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;

/**
 * __useCreatedCategorySubscription__
 *
 * To run a query within a React component, call `useCreatedCategorySubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedCategorySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedCategorySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withInvoices: // value for 'withInvoices'
 *      withProjects: // value for 'withProjects'
 *      withParentCategory: // value for 'withParentCategory'
 *      withSubCategories: // value for 'withSubCategories'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useCreatedCategorySubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedCategorySubscription, CreatedCategorySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedCategorySubscription, CreatedCategorySubscriptionVariables>(CreatedCategoryDocument, options);
      }
export type CreatedCategorySubscriptionHookResult = ReturnType<typeof useCreatedCategorySubscription>;
export type CreatedCategorySubscriptionResult = Apollo.SubscriptionResult<CreatedCategorySubscription>;
export const UpdatedCategoryDocument = gql`
    subscription UpdatedCategory($filter: CategoryFilterArgs, $withLoggedHours: Boolean = false, $withBudgetLines: Boolean = false, $withInvoices: Boolean = false, $withProjects: Boolean = false, $withParentCategory: Boolean = false, $withSubCategories: Boolean = false, $withUsers: Boolean = false) {
  updatedCategory(filter: $filter) {
    ...categoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;

/**
 * __useUpdatedCategorySubscription__
 *
 * To run a query within a React component, call `useUpdatedCategorySubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedCategorySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedCategorySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withInvoices: // value for 'withInvoices'
 *      withProjects: // value for 'withProjects'
 *      withParentCategory: // value for 'withParentCategory'
 *      withSubCategories: // value for 'withSubCategories'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useUpdatedCategorySubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedCategorySubscription, UpdatedCategorySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedCategorySubscription, UpdatedCategorySubscriptionVariables>(UpdatedCategoryDocument, options);
      }
export type UpdatedCategorySubscriptionHookResult = ReturnType<typeof useUpdatedCategorySubscription>;
export type UpdatedCategorySubscriptionResult = Apollo.SubscriptionResult<UpdatedCategorySubscription>;
export const DeletedCategoryDocument = gql`
    subscription DeletedCategory($filter: CategoryFilterArgs) {
  deletedCategory(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedCategorySubscription__
 *
 * To run a query within a React component, call `useDeletedCategorySubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedCategorySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedCategorySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedCategorySubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedCategorySubscription, DeletedCategorySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedCategorySubscription, DeletedCategorySubscriptionVariables>(DeletedCategoryDocument, options);
      }
export type DeletedCategorySubscriptionHookResult = ReturnType<typeof useDeletedCategorySubscription>;
export type DeletedCategorySubscriptionResult = Apollo.SubscriptionResult<DeletedCategorySubscription>;
export const RestoredCategoryDocument = gql`
    subscription RestoredCategory($filter: CategoryFilterArgs, $withLoggedHours: Boolean = false, $withBudgetLines: Boolean = false, $withInvoices: Boolean = false, $withProjects: Boolean = false, $withParentCategory: Boolean = false, $withSubCategories: Boolean = false, $withUsers: Boolean = false) {
  restoredCategory(filter: $filter) {
    ...categoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;

/**
 * __useRestoredCategorySubscription__
 *
 * To run a query within a React component, call `useRestoredCategorySubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredCategorySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredCategorySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withInvoices: // value for 'withInvoices'
 *      withProjects: // value for 'withProjects'
 *      withParentCategory: // value for 'withParentCategory'
 *      withSubCategories: // value for 'withSubCategories'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useRestoredCategorySubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredCategorySubscription, RestoredCategorySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredCategorySubscription, RestoredCategorySubscriptionVariables>(RestoredCategoryDocument, options);
      }
export type RestoredCategorySubscriptionHookResult = ReturnType<typeof useRestoredCategorySubscription>;
export type RestoredCategorySubscriptionResult = Apollo.SubscriptionResult<RestoredCategorySubscription>;
export const GetContentsDocument = gql`
    query GetContents($filter: ContentFilterArgs, $paging: PageArgs, $sorting: [ContentSortArgs!], $withContentFills: Boolean = false) {
  contents(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...contentFields
    }
    totalCount
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useGetContentsQuery__
 *
 * To run a query within a React component, call `useGetContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useGetContentsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
      }
export function useGetContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
        }
export function useGetContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
        }
export type GetContentsQueryHookResult = ReturnType<typeof useGetContentsQuery>;
export type GetContentsLazyQueryHookResult = ReturnType<typeof useGetContentsLazyQuery>;
export type GetContentsSuspenseQueryHookResult = ReturnType<typeof useGetContentsSuspenseQuery>;
export type GetContentsQueryResult = Apollo.QueryResult<GetContentsQuery, GetContentsQueryVariables>;
export const GetContentDocument = gql`
    query GetContent($id: ID!, $withContentFills: Boolean = false) {
  content(id: $id) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useGetContentQuery__
 *
 * To run a query within a React component, call `useGetContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useGetContentQuery(baseOptions: Apollo.QueryHookOptions<GetContentQuery, GetContentQueryVariables> & ({ variables: GetContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
      }
export function useGetContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
export function useGetContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
export type GetContentQueryHookResult = ReturnType<typeof useGetContentQuery>;
export type GetContentLazyQueryHookResult = ReturnType<typeof useGetContentLazyQuery>;
export type GetContentSuspenseQueryHookResult = ReturnType<typeof useGetContentSuspenseQuery>;
export type GetContentQueryResult = Apollo.QueryResult<GetContentQuery, GetContentQueryVariables>;
export const GetAllRelatedDataForContentDocument = gql`
    query GetAllRelatedDataForContent($withContentFills: Boolean = false) {
  contentFills @include(if: $withContentFills) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForContentQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForContentQuery({
 *   variables: {
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useGetAllRelatedDataForContentQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>(GetAllRelatedDataForContentDocument, options);
      }
export function useGetAllRelatedDataForContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>(GetAllRelatedDataForContentDocument, options);
        }
export function useGetAllRelatedDataForContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>(GetAllRelatedDataForContentDocument, options);
        }
export type GetAllRelatedDataForContentQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentQuery>;
export type GetAllRelatedDataForContentLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentLazyQuery>;
export type GetAllRelatedDataForContentSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentSuspenseQuery>;
export type GetAllRelatedDataForContentQueryResult = Apollo.QueryResult<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>;
export const CreateContentDocument = gql`
    mutation CreateContent($name: String!, $contentFills: [ID], $withContentFills: Boolean = false) {
  createContent(name: $name, contentFillIds: $contentFills) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;
export type CreateContentMutationFn = Apollo.MutationFunction<CreateContentMutation, CreateContentMutationVariables>;

/**
 * __useCreateContentMutation__
 *
 * To run a mutation, you first call `useCreateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentMutation, { data, loading, error }] = useCreateContentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      contentFills: // value for 'contentFills'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useCreateContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentMutation, CreateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentMutation, CreateContentMutationVariables>(CreateContentDocument, options);
      }
export type CreateContentMutationHookResult = ReturnType<typeof useCreateContentMutation>;
export type CreateContentMutationResult = Apollo.MutationResult<CreateContentMutation>;
export type CreateContentMutationOptions = Apollo.BaseMutationOptions<CreateContentMutation, CreateContentMutationVariables>;
export const UpdateContentDocument = gql`
    mutation UpdateContent($id: ID!, $name: String, $contentFills: [ID], $withContentFills: Boolean = false) {
  updateContent(id: $id, name: $name, contentFillIds: $contentFills) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;
export type UpdateContentMutationFn = Apollo.MutationFunction<UpdateContentMutation, UpdateContentMutationVariables>;

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      contentFills: // value for 'contentFills'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentMutation, UpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentMutation, UpdateContentMutationVariables>(UpdateContentDocument, options);
      }
export type UpdateContentMutationHookResult = ReturnType<typeof useUpdateContentMutation>;
export type UpdateContentMutationResult = Apollo.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = Apollo.BaseMutationOptions<UpdateContentMutation, UpdateContentMutationVariables>;
export const DeleteContentDocument = gql`
    mutation DeleteContent($id: ID!, $withContentFills: Boolean = false) {
  deleteContent(id: $id) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;
export type DeleteContentMutationFn = Apollo.MutationFunction<DeleteContentMutation, DeleteContentMutationVariables>;

/**
 * __useDeleteContentMutation__
 *
 * To run a mutation, you first call `useDeleteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentMutation, { data, loading, error }] = useDeleteContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useDeleteContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentMutation, DeleteContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentMutation, DeleteContentMutationVariables>(DeleteContentDocument, options);
      }
export type DeleteContentMutationHookResult = ReturnType<typeof useDeleteContentMutation>;
export type DeleteContentMutationResult = Apollo.MutationResult<DeleteContentMutation>;
export type DeleteContentMutationOptions = Apollo.BaseMutationOptions<DeleteContentMutation, DeleteContentMutationVariables>;
export const CreatedContentDocument = gql`
    subscription CreatedContent($filter: ContentFilterArgs, $withContentFills: Boolean = false) {
  createdContent(filter: $filter) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useCreatedContentSubscription__
 *
 * To run a query within a React component, call `useCreatedContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useCreatedContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedContentSubscription, CreatedContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedContentSubscription, CreatedContentSubscriptionVariables>(CreatedContentDocument, options);
      }
export type CreatedContentSubscriptionHookResult = ReturnType<typeof useCreatedContentSubscription>;
export type CreatedContentSubscriptionResult = Apollo.SubscriptionResult<CreatedContentSubscription>;
export const UpdatedContentDocument = gql`
    subscription UpdatedContent($filter: ContentFilterArgs, $withContentFills: Boolean = false) {
  updatedContent(filter: $filter) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useUpdatedContentSubscription__
 *
 * To run a query within a React component, call `useUpdatedContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useUpdatedContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedContentSubscription, UpdatedContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedContentSubscription, UpdatedContentSubscriptionVariables>(UpdatedContentDocument, options);
      }
export type UpdatedContentSubscriptionHookResult = ReturnType<typeof useUpdatedContentSubscription>;
export type UpdatedContentSubscriptionResult = Apollo.SubscriptionResult<UpdatedContentSubscription>;
export const DeletedContentDocument = gql`
    subscription DeletedContent($filter: ContentFilterArgs) {
  deletedContent(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedContentSubscription__
 *
 * To run a query within a React component, call `useDeletedContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedContentSubscription, DeletedContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedContentSubscription, DeletedContentSubscriptionVariables>(DeletedContentDocument, options);
      }
export type DeletedContentSubscriptionHookResult = ReturnType<typeof useDeletedContentSubscription>;
export type DeletedContentSubscriptionResult = Apollo.SubscriptionResult<DeletedContentSubscription>;
export const GetContentFillsDocument = gql`
    query GetContentFills($filter: ContentFillFilterArgs, $paging: PageArgs, $sorting: [ContentFillSortArgs!], $withContent: Boolean = false) {
  contentFills(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...contentFillFields
    }
    totalCount
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useGetContentFillsQuery__
 *
 * To run a query within a React component, call `useGetContentFillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useGetContentFillsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentFillsQuery, GetContentFillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentFillsQuery, GetContentFillsQueryVariables>(GetContentFillsDocument, options);
      }
export function useGetContentFillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentFillsQuery, GetContentFillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentFillsQuery, GetContentFillsQueryVariables>(GetContentFillsDocument, options);
        }
export function useGetContentFillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentFillsQuery, GetContentFillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentFillsQuery, GetContentFillsQueryVariables>(GetContentFillsDocument, options);
        }
export type GetContentFillsQueryHookResult = ReturnType<typeof useGetContentFillsQuery>;
export type GetContentFillsLazyQueryHookResult = ReturnType<typeof useGetContentFillsLazyQuery>;
export type GetContentFillsSuspenseQueryHookResult = ReturnType<typeof useGetContentFillsSuspenseQuery>;
export type GetContentFillsQueryResult = Apollo.QueryResult<GetContentFillsQuery, GetContentFillsQueryVariables>;
export const GetContentFillDocument = gql`
    query GetContentFill($id: ID!, $withContent: Boolean = false) {
  contentFill(id: $id) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useGetContentFillQuery__
 *
 * To run a query within a React component, call `useGetContentFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFillQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useGetContentFillQuery(baseOptions: Apollo.QueryHookOptions<GetContentFillQuery, GetContentFillQueryVariables> & ({ variables: GetContentFillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentFillQuery, GetContentFillQueryVariables>(GetContentFillDocument, options);
      }
export function useGetContentFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentFillQuery, GetContentFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentFillQuery, GetContentFillQueryVariables>(GetContentFillDocument, options);
        }
export function useGetContentFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentFillQuery, GetContentFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentFillQuery, GetContentFillQueryVariables>(GetContentFillDocument, options);
        }
export type GetContentFillQueryHookResult = ReturnType<typeof useGetContentFillQuery>;
export type GetContentFillLazyQueryHookResult = ReturnType<typeof useGetContentFillLazyQuery>;
export type GetContentFillSuspenseQueryHookResult = ReturnType<typeof useGetContentFillSuspenseQuery>;
export type GetContentFillQueryResult = Apollo.QueryResult<GetContentFillQuery, GetContentFillQueryVariables>;
export const GetAllRelatedDataForContentFillDocument = gql`
    query GetAllRelatedDataForContentFill($withContents: Boolean = false) {
  contents @include(if: $withContents) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForContentFillQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForContentFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForContentFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForContentFillQuery({
 *   variables: {
 *      withContents: // value for 'withContents'
 *   },
 * });
 */
export function useGetAllRelatedDataForContentFillQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>(GetAllRelatedDataForContentFillDocument, options);
      }
export function useGetAllRelatedDataForContentFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>(GetAllRelatedDataForContentFillDocument, options);
        }
export function useGetAllRelatedDataForContentFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>(GetAllRelatedDataForContentFillDocument, options);
        }
export type GetAllRelatedDataForContentFillQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentFillQuery>;
export type GetAllRelatedDataForContentFillLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentFillLazyQuery>;
export type GetAllRelatedDataForContentFillSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentFillSuspenseQuery>;
export type GetAllRelatedDataForContentFillQueryResult = Apollo.QueryResult<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>;
export const CreateContentFillDocument = gql`
    mutation CreateContentFill($fill: String!, $language: String!, $contentId: ID!, $withContent: Boolean = false) {
  createContentFill(fill: $fill, language: $language, contentId: $contentId) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;
export type CreateContentFillMutationFn = Apollo.MutationFunction<CreateContentFillMutation, CreateContentFillMutationVariables>;

/**
 * __useCreateContentFillMutation__
 *
 * To run a mutation, you first call `useCreateContentFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentFillMutation, { data, loading, error }] = useCreateContentFillMutation({
 *   variables: {
 *      fill: // value for 'fill'
 *      language: // value for 'language'
 *      contentId: // value for 'contentId'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useCreateContentFillMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentFillMutation, CreateContentFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentFillMutation, CreateContentFillMutationVariables>(CreateContentFillDocument, options);
      }
export type CreateContentFillMutationHookResult = ReturnType<typeof useCreateContentFillMutation>;
export type CreateContentFillMutationResult = Apollo.MutationResult<CreateContentFillMutation>;
export type CreateContentFillMutationOptions = Apollo.BaseMutationOptions<CreateContentFillMutation, CreateContentFillMutationVariables>;
export const UpdateContentFillDocument = gql`
    mutation UpdateContentFill($id: ID!, $fill: String, $language: String, $contentId: ID, $withContent: Boolean = false) {
  updateContentFill(
    id: $id
    fill: $fill
    language: $language
    contentId: $contentId
  ) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;
export type UpdateContentFillMutationFn = Apollo.MutationFunction<UpdateContentFillMutation, UpdateContentFillMutationVariables>;

/**
 * __useUpdateContentFillMutation__
 *
 * To run a mutation, you first call `useUpdateContentFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentFillMutation, { data, loading, error }] = useUpdateContentFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fill: // value for 'fill'
 *      language: // value for 'language'
 *      contentId: // value for 'contentId'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useUpdateContentFillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentFillMutation, UpdateContentFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentFillMutation, UpdateContentFillMutationVariables>(UpdateContentFillDocument, options);
      }
export type UpdateContentFillMutationHookResult = ReturnType<typeof useUpdateContentFillMutation>;
export type UpdateContentFillMutationResult = Apollo.MutationResult<UpdateContentFillMutation>;
export type UpdateContentFillMutationOptions = Apollo.BaseMutationOptions<UpdateContentFillMutation, UpdateContentFillMutationVariables>;
export const DeleteContentFillDocument = gql`
    mutation DeleteContentFill($id: ID!, $withContent: Boolean = false) {
  deleteContentFill(id: $id) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;
export type DeleteContentFillMutationFn = Apollo.MutationFunction<DeleteContentFillMutation, DeleteContentFillMutationVariables>;

/**
 * __useDeleteContentFillMutation__
 *
 * To run a mutation, you first call `useDeleteContentFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentFillMutation, { data, loading, error }] = useDeleteContentFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useDeleteContentFillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentFillMutation, DeleteContentFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentFillMutation, DeleteContentFillMutationVariables>(DeleteContentFillDocument, options);
      }
export type DeleteContentFillMutationHookResult = ReturnType<typeof useDeleteContentFillMutation>;
export type DeleteContentFillMutationResult = Apollo.MutationResult<DeleteContentFillMutation>;
export type DeleteContentFillMutationOptions = Apollo.BaseMutationOptions<DeleteContentFillMutation, DeleteContentFillMutationVariables>;
export const CreatedContentFillDocument = gql`
    subscription CreatedContentFill($filter: ContentFillFilterArgs, $withContent: Boolean = false) {
  createdContentFill(filter: $filter) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useCreatedContentFillSubscription__
 *
 * To run a query within a React component, call `useCreatedContentFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedContentFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedContentFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useCreatedContentFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedContentFillSubscription, CreatedContentFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedContentFillSubscription, CreatedContentFillSubscriptionVariables>(CreatedContentFillDocument, options);
      }
export type CreatedContentFillSubscriptionHookResult = ReturnType<typeof useCreatedContentFillSubscription>;
export type CreatedContentFillSubscriptionResult = Apollo.SubscriptionResult<CreatedContentFillSubscription>;
export const UpdatedContentFillDocument = gql`
    subscription UpdatedContentFill($filter: ContentFillFilterArgs, $withContent: Boolean = false) {
  updatedContentFill(filter: $filter) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useUpdatedContentFillSubscription__
 *
 * To run a query within a React component, call `useUpdatedContentFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedContentFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedContentFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useUpdatedContentFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedContentFillSubscription, UpdatedContentFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedContentFillSubscription, UpdatedContentFillSubscriptionVariables>(UpdatedContentFillDocument, options);
      }
export type UpdatedContentFillSubscriptionHookResult = ReturnType<typeof useUpdatedContentFillSubscription>;
export type UpdatedContentFillSubscriptionResult = Apollo.SubscriptionResult<UpdatedContentFillSubscription>;
export const DeletedContentFillDocument = gql`
    subscription DeletedContentFill($filter: ContentFillFilterArgs) {
  deletedContentFill(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedContentFillSubscription__
 *
 * To run a query within a React component, call `useDeletedContentFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedContentFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedContentFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedContentFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedContentFillSubscription, DeletedContentFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedContentFillSubscription, DeletedContentFillSubscriptionVariables>(DeletedContentFillDocument, options);
      }
export type DeletedContentFillSubscriptionHookResult = ReturnType<typeof useDeletedContentFillSubscription>;
export type DeletedContentFillSubscriptionResult = Apollo.SubscriptionResult<DeletedContentFillSubscription>;
export const GetContractsDocument = gql`
    query GetContracts($filter: ContractFilterArgs, $paging: PageArgs, $sorting: [ContractSortArgs!], $withUser: Boolean = false, $withTenant: Boolean = false, $withProject: Boolean = false) {
  contracts(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...contractFields
    }
    totalCount
  }
}
    ${ContractFieldsFragmentDoc}`;

/**
 * __useGetContractsQuery__
 *
 * To run a query within a React component, call `useGetContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetContractsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractsQuery, GetContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, options);
      }
export function useGetContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractsQuery, GetContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, options);
        }
export function useGetContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractsQuery, GetContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, options);
        }
export type GetContractsQueryHookResult = ReturnType<typeof useGetContractsQuery>;
export type GetContractsLazyQueryHookResult = ReturnType<typeof useGetContractsLazyQuery>;
export type GetContractsSuspenseQueryHookResult = ReturnType<typeof useGetContractsSuspenseQuery>;
export type GetContractsQueryResult = Apollo.QueryResult<GetContractsQuery, GetContractsQueryVariables>;
export const GetContractDocument = gql`
    query GetContract($id: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withProject: Boolean = false) {
  contract(id: $id) {
    ...contractFields
  }
}
    ${ContractFieldsFragmentDoc}`;

/**
 * __useGetContractQuery__
 *
 * To run a query within a React component, call `useGetContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetContractQuery(baseOptions: Apollo.QueryHookOptions<GetContractQuery, GetContractQueryVariables> & ({ variables: GetContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
      }
export function useGetContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
        }
export function useGetContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
        }
export type GetContractQueryHookResult = ReturnType<typeof useGetContractQuery>;
export type GetContractLazyQueryHookResult = ReturnType<typeof useGetContractLazyQuery>;
export type GetContractSuspenseQueryHookResult = ReturnType<typeof useGetContractSuspenseQuery>;
export type GetContractQueryResult = Apollo.QueryResult<GetContractQuery, GetContractQueryVariables>;
export const GetAllRelatedDataForContractDocument = gql`
    query GetAllRelatedDataForContract($withUsers: Boolean = false, $withTenants: Boolean = false, $withProjects: Boolean = false) {
  users @include(if: $withUsers) {
    items {
      id
      displayField: fullName
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForContractQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForContractQuery({
 *   variables: {
 *      withUsers: // value for 'withUsers'
 *      withTenants: // value for 'withTenants'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetAllRelatedDataForContractQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForContractQuery, GetAllRelatedDataForContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForContractQuery, GetAllRelatedDataForContractQueryVariables>(GetAllRelatedDataForContractDocument, options);
      }
export function useGetAllRelatedDataForContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForContractQuery, GetAllRelatedDataForContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForContractQuery, GetAllRelatedDataForContractQueryVariables>(GetAllRelatedDataForContractDocument, options);
        }
export function useGetAllRelatedDataForContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForContractQuery, GetAllRelatedDataForContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForContractQuery, GetAllRelatedDataForContractQueryVariables>(GetAllRelatedDataForContractDocument, options);
        }
export type GetAllRelatedDataForContractQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContractQuery>;
export type GetAllRelatedDataForContractLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContractLazyQuery>;
export type GetAllRelatedDataForContractSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContractSuspenseQuery>;
export type GetAllRelatedDataForContractQueryResult = Apollo.QueryResult<GetAllRelatedDataForContractQuery, GetAllRelatedDataForContractQueryVariables>;
export const CreateContractDocument = gql`
    mutation CreateContract($hoursPerWeek: Float, $costPerHour: Float!, $startDate: DateTime!, $endDate: DateTime, $customCostPerHour: Float, $salarySlip: String, $userId: ID!, $tenantId: ID!, $projectId: ID, $withUser: Boolean = false, $withTenant: Boolean = false, $withProject: Boolean = false) {
  createContract(
    hoursPerWeek: $hoursPerWeek
    costPerHour: $costPerHour
    startDate: $startDate
    endDate: $endDate
    customCostPerHour: $customCostPerHour
    salarySlip: $salarySlip
    userId: $userId
    tenantId: $tenantId
    projectId: $projectId
  ) {
    ...contractFields
  }
}
    ${ContractFieldsFragmentDoc}`;
export type CreateContractMutationFn = Apollo.MutationFunction<CreateContractMutation, CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      hoursPerWeek: // value for 'hoursPerWeek'
 *      costPerHour: // value for 'costPerHour'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      customCostPerHour: // value for 'customCostPerHour'
 *      salarySlip: // value for 'salarySlip'
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *      projectId: // value for 'projectId'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const UpdateContractDocument = gql`
    mutation UpdateContract($id: ID!, $hoursPerWeek: Float, $costPerHour: Float, $startDate: DateTime, $endDate: DateTime, $customCostPerHour: Float, $salarySlip: String, $userId: ID, $tenantId: ID, $projectId: ID, $withUser: Boolean = false, $withTenant: Boolean = false, $withProject: Boolean = false) {
  updateContract(
    id: $id
    hoursPerWeek: $hoursPerWeek
    costPerHour: $costPerHour
    startDate: $startDate
    endDate: $endDate
    customCostPerHour: $customCostPerHour
    salarySlip: $salarySlip
    userId: $userId
    tenantId: $tenantId
    projectId: $projectId
  ) {
    ...contractFields
  }
}
    ${ContractFieldsFragmentDoc}`;
export type UpdateContractMutationFn = Apollo.MutationFunction<UpdateContractMutation, UpdateContractMutationVariables>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hoursPerWeek: // value for 'hoursPerWeek'
 *      costPerHour: // value for 'costPerHour'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      customCostPerHour: // value for 'customCostPerHour'
 *      salarySlip: // value for 'salarySlip'
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *      projectId: // value for 'projectId'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdateContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractMutation, UpdateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument, options);
      }
export type UpdateContractMutationHookResult = ReturnType<typeof useUpdateContractMutation>;
export type UpdateContractMutationResult = Apollo.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables>;
export const DeleteContractDocument = gql`
    mutation DeleteContract($id: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withProject: Boolean = false) {
  deleteContract(id: $id) {
    ...contractFields
  }
}
    ${ContractFieldsFragmentDoc}`;
export type DeleteContractMutationFn = Apollo.MutationFunction<DeleteContractMutation, DeleteContractMutationVariables>;

/**
 * __useDeleteContractMutation__
 *
 * To run a mutation, you first call `useDeleteContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractMutation, { data, loading, error }] = useDeleteContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useDeleteContractMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractMutation, DeleteContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractMutation, DeleteContractMutationVariables>(DeleteContractDocument, options);
      }
export type DeleteContractMutationHookResult = ReturnType<typeof useDeleteContractMutation>;
export type DeleteContractMutationResult = Apollo.MutationResult<DeleteContractMutation>;
export type DeleteContractMutationOptions = Apollo.BaseMutationOptions<DeleteContractMutation, DeleteContractMutationVariables>;
export const CreatedContractDocument = gql`
    subscription CreatedContract($filter: ContractFilterArgs, $withUser: Boolean = false, $withTenant: Boolean = false, $withProject: Boolean = false) {
  createdContract(filter: $filter) {
    ...contractFields
  }
}
    ${ContractFieldsFragmentDoc}`;

/**
 * __useCreatedContractSubscription__
 *
 * To run a query within a React component, call `useCreatedContractSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedContractSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedContractSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreatedContractSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedContractSubscription, CreatedContractSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedContractSubscription, CreatedContractSubscriptionVariables>(CreatedContractDocument, options);
      }
export type CreatedContractSubscriptionHookResult = ReturnType<typeof useCreatedContractSubscription>;
export type CreatedContractSubscriptionResult = Apollo.SubscriptionResult<CreatedContractSubscription>;
export const UpdatedContractDocument = gql`
    subscription UpdatedContract($filter: ContractFilterArgs, $withUser: Boolean = false, $withTenant: Boolean = false, $withProject: Boolean = false) {
  updatedContract(filter: $filter) {
    ...contractFields
  }
}
    ${ContractFieldsFragmentDoc}`;

/**
 * __useUpdatedContractSubscription__
 *
 * To run a query within a React component, call `useUpdatedContractSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedContractSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedContractSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdatedContractSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedContractSubscription, UpdatedContractSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedContractSubscription, UpdatedContractSubscriptionVariables>(UpdatedContractDocument, options);
      }
export type UpdatedContractSubscriptionHookResult = ReturnType<typeof useUpdatedContractSubscription>;
export type UpdatedContractSubscriptionResult = Apollo.SubscriptionResult<UpdatedContractSubscription>;
export const DeletedContractDocument = gql`
    subscription DeletedContract($filter: ContractFilterArgs) {
  deletedContract(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedContractSubscription__
 *
 * To run a query within a React component, call `useDeletedContractSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedContractSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedContractSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedContractSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedContractSubscription, DeletedContractSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedContractSubscription, DeletedContractSubscriptionVariables>(DeletedContractDocument, options);
      }
export type DeletedContractSubscriptionHookResult = ReturnType<typeof useDeletedContractSubscription>;
export type DeletedContractSubscriptionResult = Apollo.SubscriptionResult<DeletedContractSubscription>;
export const RestoredContractDocument = gql`
    subscription RestoredContract($filter: ContractFilterArgs, $withUser: Boolean = false, $withTenant: Boolean = false, $withProject: Boolean = false) {
  restoredContract(filter: $filter) {
    ...contractFields
  }
}
    ${ContractFieldsFragmentDoc}`;

/**
 * __useRestoredContractSubscription__
 *
 * To run a query within a React component, call `useRestoredContractSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredContractSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredContractSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useRestoredContractSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredContractSubscription, RestoredContractSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredContractSubscription, RestoredContractSubscriptionVariables>(RestoredContractDocument, options);
      }
export type RestoredContractSubscriptionHookResult = ReturnType<typeof useRestoredContractSubscription>;
export type RestoredContractSubscriptionResult = Apollo.SubscriptionResult<RestoredContractSubscription>;
export const GetCustomersDocument = gql`
    query GetCustomers($filter: CustomerFilterArgs, $paging: PageArgs, $sorting: [CustomerSortArgs!], $withProjects: Boolean = false) {
  customers(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...customerFields
    }
    totalCount
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($id: ID!, $withProjects: Boolean = false) {
  customer(id: $id) {
    ...customerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables> & ({ variables: GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetAllRelatedDataForCustomerDocument = gql`
    query GetAllRelatedDataForCustomer($withProjects: Boolean = false) {
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForCustomerQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForCustomerQuery({
 *   variables: {
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetAllRelatedDataForCustomerQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForCustomerQuery, GetAllRelatedDataForCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForCustomerQuery, GetAllRelatedDataForCustomerQueryVariables>(GetAllRelatedDataForCustomerDocument, options);
      }
export function useGetAllRelatedDataForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForCustomerQuery, GetAllRelatedDataForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForCustomerQuery, GetAllRelatedDataForCustomerQueryVariables>(GetAllRelatedDataForCustomerDocument, options);
        }
export function useGetAllRelatedDataForCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForCustomerQuery, GetAllRelatedDataForCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForCustomerQuery, GetAllRelatedDataForCustomerQueryVariables>(GetAllRelatedDataForCustomerDocument, options);
        }
export type GetAllRelatedDataForCustomerQueryHookResult = ReturnType<typeof useGetAllRelatedDataForCustomerQuery>;
export type GetAllRelatedDataForCustomerLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForCustomerLazyQuery>;
export type GetAllRelatedDataForCustomerSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForCustomerSuspenseQuery>;
export type GetAllRelatedDataForCustomerQueryResult = Apollo.QueryResult<GetAllRelatedDataForCustomerQuery, GetAllRelatedDataForCustomerQueryVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($name: String!, $active: Boolean!, $projects: [ID], $withProjects: Boolean = false) {
  createCustomer(name: $name, active: $active, projectIds: $projects) {
    ...customerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      name: // value for 'name'
 *      active: // value for 'active'
 *      projects: // value for 'projects'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($id: ID!, $name: String, $active: Boolean, $projects: [ID], $withProjects: Boolean = false) {
  updateCustomer(id: $id, name: $name, active: $active, projectIds: $projects) {
    ...customerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      active: // value for 'active'
 *      projects: // value for 'projects'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($id: ID!, $withProjects: Boolean = false) {
  deleteCustomer(id: $id) {
    ...customerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const CreatedCustomerDocument = gql`
    subscription CreatedCustomer($filter: CustomerFilterArgs, $withProjects: Boolean = false) {
  createdCustomer(filter: $filter) {
    ...customerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useCreatedCustomerSubscription__
 *
 * To run a query within a React component, call `useCreatedCustomerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedCustomerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedCustomerSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useCreatedCustomerSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedCustomerSubscription, CreatedCustomerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedCustomerSubscription, CreatedCustomerSubscriptionVariables>(CreatedCustomerDocument, options);
      }
export type CreatedCustomerSubscriptionHookResult = ReturnType<typeof useCreatedCustomerSubscription>;
export type CreatedCustomerSubscriptionResult = Apollo.SubscriptionResult<CreatedCustomerSubscription>;
export const UpdatedCustomerDocument = gql`
    subscription UpdatedCustomer($filter: CustomerFilterArgs, $withProjects: Boolean = false) {
  updatedCustomer(filter: $filter) {
    ...customerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useUpdatedCustomerSubscription__
 *
 * To run a query within a React component, call `useUpdatedCustomerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedCustomerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedCustomerSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useUpdatedCustomerSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedCustomerSubscription, UpdatedCustomerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedCustomerSubscription, UpdatedCustomerSubscriptionVariables>(UpdatedCustomerDocument, options);
      }
export type UpdatedCustomerSubscriptionHookResult = ReturnType<typeof useUpdatedCustomerSubscription>;
export type UpdatedCustomerSubscriptionResult = Apollo.SubscriptionResult<UpdatedCustomerSubscription>;
export const DeletedCustomerDocument = gql`
    subscription DeletedCustomer($filter: CustomerFilterArgs) {
  deletedCustomer(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedCustomerSubscription__
 *
 * To run a query within a React component, call `useDeletedCustomerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedCustomerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedCustomerSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedCustomerSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedCustomerSubscription, DeletedCustomerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedCustomerSubscription, DeletedCustomerSubscriptionVariables>(DeletedCustomerDocument, options);
      }
export type DeletedCustomerSubscriptionHookResult = ReturnType<typeof useDeletedCustomerSubscription>;
export type DeletedCustomerSubscriptionResult = Apollo.SubscriptionResult<DeletedCustomerSubscription>;
export const RestoredCustomerDocument = gql`
    subscription RestoredCustomer($filter: CustomerFilterArgs, $withProjects: Boolean = false) {
  restoredCustomer(filter: $filter) {
    ...customerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useRestoredCustomerSubscription__
 *
 * To run a query within a React component, call `useRestoredCustomerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredCustomerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredCustomerSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useRestoredCustomerSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredCustomerSubscription, RestoredCustomerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredCustomerSubscription, RestoredCustomerSubscriptionVariables>(RestoredCustomerDocument, options);
      }
export type RestoredCustomerSubscriptionHookResult = ReturnType<typeof useRestoredCustomerSubscription>;
export type RestoredCustomerSubscriptionResult = Apollo.SubscriptionResult<RestoredCustomerSubscription>;
export const GetDaysOffsDocument = gql`
    query GetDaysOffs($filter: DaysOffFilterArgs, $paging: PageArgs, $sorting: [DaysOffSortArgs!], $withUser: Boolean = false) {
  daysOffs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...daysOffFields
    }
    totalCount
  }
}
    ${DaysOffFieldsFragmentDoc}`;

/**
 * __useGetDaysOffsQuery__
 *
 * To run a query within a React component, call `useGetDaysOffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDaysOffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDaysOffsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useGetDaysOffsQuery(baseOptions?: Apollo.QueryHookOptions<GetDaysOffsQuery, GetDaysOffsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDaysOffsQuery, GetDaysOffsQueryVariables>(GetDaysOffsDocument, options);
      }
export function useGetDaysOffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDaysOffsQuery, GetDaysOffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDaysOffsQuery, GetDaysOffsQueryVariables>(GetDaysOffsDocument, options);
        }
export function useGetDaysOffsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDaysOffsQuery, GetDaysOffsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDaysOffsQuery, GetDaysOffsQueryVariables>(GetDaysOffsDocument, options);
        }
export type GetDaysOffsQueryHookResult = ReturnType<typeof useGetDaysOffsQuery>;
export type GetDaysOffsLazyQueryHookResult = ReturnType<typeof useGetDaysOffsLazyQuery>;
export type GetDaysOffsSuspenseQueryHookResult = ReturnType<typeof useGetDaysOffsSuspenseQuery>;
export type GetDaysOffsQueryResult = Apollo.QueryResult<GetDaysOffsQuery, GetDaysOffsQueryVariables>;
export const GetDaysOffDocument = gql`
    query GetDaysOff($id: ID!, $withUser: Boolean = false) {
  daysOff(id: $id) {
    ...daysOffFields
  }
}
    ${DaysOffFieldsFragmentDoc}`;

/**
 * __useGetDaysOffQuery__
 *
 * To run a query within a React component, call `useGetDaysOffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDaysOffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDaysOffQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useGetDaysOffQuery(baseOptions: Apollo.QueryHookOptions<GetDaysOffQuery, GetDaysOffQueryVariables> & ({ variables: GetDaysOffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDaysOffQuery, GetDaysOffQueryVariables>(GetDaysOffDocument, options);
      }
export function useGetDaysOffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDaysOffQuery, GetDaysOffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDaysOffQuery, GetDaysOffQueryVariables>(GetDaysOffDocument, options);
        }
export function useGetDaysOffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDaysOffQuery, GetDaysOffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDaysOffQuery, GetDaysOffQueryVariables>(GetDaysOffDocument, options);
        }
export type GetDaysOffQueryHookResult = ReturnType<typeof useGetDaysOffQuery>;
export type GetDaysOffLazyQueryHookResult = ReturnType<typeof useGetDaysOffLazyQuery>;
export type GetDaysOffSuspenseQueryHookResult = ReturnType<typeof useGetDaysOffSuspenseQuery>;
export type GetDaysOffQueryResult = Apollo.QueryResult<GetDaysOffQuery, GetDaysOffQueryVariables>;
export const GetAllRelatedDataForDaysOffDocument = gql`
    query GetAllRelatedDataForDaysOff($withUsers: Boolean = false) {
  users @include(if: $withUsers) {
    items {
      id
      displayField: fullName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForDaysOffQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForDaysOffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForDaysOffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForDaysOffQuery({
 *   variables: {
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useGetAllRelatedDataForDaysOffQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForDaysOffQuery, GetAllRelatedDataForDaysOffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForDaysOffQuery, GetAllRelatedDataForDaysOffQueryVariables>(GetAllRelatedDataForDaysOffDocument, options);
      }
export function useGetAllRelatedDataForDaysOffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForDaysOffQuery, GetAllRelatedDataForDaysOffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForDaysOffQuery, GetAllRelatedDataForDaysOffQueryVariables>(GetAllRelatedDataForDaysOffDocument, options);
        }
export function useGetAllRelatedDataForDaysOffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForDaysOffQuery, GetAllRelatedDataForDaysOffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForDaysOffQuery, GetAllRelatedDataForDaysOffQueryVariables>(GetAllRelatedDataForDaysOffDocument, options);
        }
export type GetAllRelatedDataForDaysOffQueryHookResult = ReturnType<typeof useGetAllRelatedDataForDaysOffQuery>;
export type GetAllRelatedDataForDaysOffLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForDaysOffLazyQuery>;
export type GetAllRelatedDataForDaysOffSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForDaysOffSuspenseQuery>;
export type GetAllRelatedDataForDaysOffQueryResult = Apollo.QueryResult<GetAllRelatedDataForDaysOffQuery, GetAllRelatedDataForDaysOffQueryVariables>;
export const CreateDaysOffDocument = gql`
    mutation CreateDaysOff($startDate: DateTime!, $endDate: DateTime!, $approved: Boolean, $note: String, $userId: ID!, $withUser: Boolean = false) {
  createDaysOff(
    startDate: $startDate
    endDate: $endDate
    approved: $approved
    note: $note
    userId: $userId
  ) {
    ...daysOffFields
  }
}
    ${DaysOffFieldsFragmentDoc}`;
export type CreateDaysOffMutationFn = Apollo.MutationFunction<CreateDaysOffMutation, CreateDaysOffMutationVariables>;

/**
 * __useCreateDaysOffMutation__
 *
 * To run a mutation, you first call `useCreateDaysOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDaysOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDaysOffMutation, { data, loading, error }] = useCreateDaysOffMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      approved: // value for 'approved'
 *      note: // value for 'note'
 *      userId: // value for 'userId'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useCreateDaysOffMutation(baseOptions?: Apollo.MutationHookOptions<CreateDaysOffMutation, CreateDaysOffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDaysOffMutation, CreateDaysOffMutationVariables>(CreateDaysOffDocument, options);
      }
export type CreateDaysOffMutationHookResult = ReturnType<typeof useCreateDaysOffMutation>;
export type CreateDaysOffMutationResult = Apollo.MutationResult<CreateDaysOffMutation>;
export type CreateDaysOffMutationOptions = Apollo.BaseMutationOptions<CreateDaysOffMutation, CreateDaysOffMutationVariables>;
export const UpdateDaysOffDocument = gql`
    mutation UpdateDaysOff($id: ID!, $startDate: DateTime, $endDate: DateTime, $approved: Boolean, $note: String, $userId: ID, $withUser: Boolean = false) {
  updateDaysOff(
    id: $id
    startDate: $startDate
    endDate: $endDate
    approved: $approved
    note: $note
    userId: $userId
  ) {
    ...daysOffFields
  }
}
    ${DaysOffFieldsFragmentDoc}`;
export type UpdateDaysOffMutationFn = Apollo.MutationFunction<UpdateDaysOffMutation, UpdateDaysOffMutationVariables>;

/**
 * __useUpdateDaysOffMutation__
 *
 * To run a mutation, you first call `useUpdateDaysOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDaysOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDaysOffMutation, { data, loading, error }] = useUpdateDaysOffMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      approved: // value for 'approved'
 *      note: // value for 'note'
 *      userId: // value for 'userId'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useUpdateDaysOffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDaysOffMutation, UpdateDaysOffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDaysOffMutation, UpdateDaysOffMutationVariables>(UpdateDaysOffDocument, options);
      }
export type UpdateDaysOffMutationHookResult = ReturnType<typeof useUpdateDaysOffMutation>;
export type UpdateDaysOffMutationResult = Apollo.MutationResult<UpdateDaysOffMutation>;
export type UpdateDaysOffMutationOptions = Apollo.BaseMutationOptions<UpdateDaysOffMutation, UpdateDaysOffMutationVariables>;
export const DeleteDaysOffDocument = gql`
    mutation DeleteDaysOff($id: ID!, $withUser: Boolean = false) {
  deleteDaysOff(id: $id) {
    ...daysOffFields
  }
}
    ${DaysOffFieldsFragmentDoc}`;
export type DeleteDaysOffMutationFn = Apollo.MutationFunction<DeleteDaysOffMutation, DeleteDaysOffMutationVariables>;

/**
 * __useDeleteDaysOffMutation__
 *
 * To run a mutation, you first call `useDeleteDaysOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDaysOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDaysOffMutation, { data, loading, error }] = useDeleteDaysOffMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useDeleteDaysOffMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDaysOffMutation, DeleteDaysOffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDaysOffMutation, DeleteDaysOffMutationVariables>(DeleteDaysOffDocument, options);
      }
export type DeleteDaysOffMutationHookResult = ReturnType<typeof useDeleteDaysOffMutation>;
export type DeleteDaysOffMutationResult = Apollo.MutationResult<DeleteDaysOffMutation>;
export type DeleteDaysOffMutationOptions = Apollo.BaseMutationOptions<DeleteDaysOffMutation, DeleteDaysOffMutationVariables>;
export const CreatedDaysOffDocument = gql`
    subscription CreatedDaysOff($filter: DaysOffFilterArgs, $withUser: Boolean = false) {
  createdDaysOff(filter: $filter) {
    ...daysOffFields
  }
}
    ${DaysOffFieldsFragmentDoc}`;

/**
 * __useCreatedDaysOffSubscription__
 *
 * To run a query within a React component, call `useCreatedDaysOffSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedDaysOffSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedDaysOffSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useCreatedDaysOffSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedDaysOffSubscription, CreatedDaysOffSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedDaysOffSubscription, CreatedDaysOffSubscriptionVariables>(CreatedDaysOffDocument, options);
      }
export type CreatedDaysOffSubscriptionHookResult = ReturnType<typeof useCreatedDaysOffSubscription>;
export type CreatedDaysOffSubscriptionResult = Apollo.SubscriptionResult<CreatedDaysOffSubscription>;
export const UpdatedDaysOffDocument = gql`
    subscription UpdatedDaysOff($filter: DaysOffFilterArgs, $withUser: Boolean = false) {
  updatedDaysOff(filter: $filter) {
    ...daysOffFields
  }
}
    ${DaysOffFieldsFragmentDoc}`;

/**
 * __useUpdatedDaysOffSubscription__
 *
 * To run a query within a React component, call `useUpdatedDaysOffSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedDaysOffSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedDaysOffSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useUpdatedDaysOffSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedDaysOffSubscription, UpdatedDaysOffSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedDaysOffSubscription, UpdatedDaysOffSubscriptionVariables>(UpdatedDaysOffDocument, options);
      }
export type UpdatedDaysOffSubscriptionHookResult = ReturnType<typeof useUpdatedDaysOffSubscription>;
export type UpdatedDaysOffSubscriptionResult = Apollo.SubscriptionResult<UpdatedDaysOffSubscription>;
export const DeletedDaysOffDocument = gql`
    subscription DeletedDaysOff($filter: DaysOffFilterArgs) {
  deletedDaysOff(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedDaysOffSubscription__
 *
 * To run a query within a React component, call `useDeletedDaysOffSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedDaysOffSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedDaysOffSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedDaysOffSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedDaysOffSubscription, DeletedDaysOffSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedDaysOffSubscription, DeletedDaysOffSubscriptionVariables>(DeletedDaysOffDocument, options);
      }
export type DeletedDaysOffSubscriptionHookResult = ReturnType<typeof useDeletedDaysOffSubscription>;
export type DeletedDaysOffSubscriptionResult = Apollo.SubscriptionResult<DeletedDaysOffSubscription>;
export const RestoredDaysOffDocument = gql`
    subscription RestoredDaysOff($filter: DaysOffFilterArgs, $withUser: Boolean = false) {
  restoredDaysOff(filter: $filter) {
    ...daysOffFields
  }
}
    ${DaysOffFieldsFragmentDoc}`;

/**
 * __useRestoredDaysOffSubscription__
 *
 * To run a query within a React component, call `useRestoredDaysOffSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredDaysOffSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredDaysOffSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useRestoredDaysOffSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredDaysOffSubscription, RestoredDaysOffSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredDaysOffSubscription, RestoredDaysOffSubscriptionVariables>(RestoredDaysOffDocument, options);
      }
export type RestoredDaysOffSubscriptionHookResult = ReturnType<typeof useRestoredDaysOffSubscription>;
export type RestoredDaysOffSubscriptionResult = Apollo.SubscriptionResult<RestoredDaysOffSubscription>;
export const GetErrorLogsDocument = gql`
    query GetErrorLogs($filter: ErrorLogFilterArgs, $paging: PageArgs, $sorting: [ErrorLogSortArgs!]) {
  errorLogs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...errorLogFields
    }
    totalCount
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useGetErrorLogsQuery__
 *
 * To run a query within a React component, call `useGetErrorLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetErrorLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
      }
export function useGetErrorLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
        }
export function useGetErrorLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
        }
export type GetErrorLogsQueryHookResult = ReturnType<typeof useGetErrorLogsQuery>;
export type GetErrorLogsLazyQueryHookResult = ReturnType<typeof useGetErrorLogsLazyQuery>;
export type GetErrorLogsSuspenseQueryHookResult = ReturnType<typeof useGetErrorLogsSuspenseQuery>;
export type GetErrorLogsQueryResult = Apollo.QueryResult<GetErrorLogsQuery, GetErrorLogsQueryVariables>;
export const GetErrorLogDocument = gql`
    query GetErrorLog($id: ID!) {
  errorLog(id: $id) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useGetErrorLogQuery__
 *
 * To run a query within a React component, call `useGetErrorLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetErrorLogQuery(baseOptions: Apollo.QueryHookOptions<GetErrorLogQuery, GetErrorLogQueryVariables> & ({ variables: GetErrorLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErrorLogQuery, GetErrorLogQueryVariables>(GetErrorLogDocument, options);
      }
export function useGetErrorLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErrorLogQuery, GetErrorLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErrorLogQuery, GetErrorLogQueryVariables>(GetErrorLogDocument, options);
        }
export function useGetErrorLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetErrorLogQuery, GetErrorLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetErrorLogQuery, GetErrorLogQueryVariables>(GetErrorLogDocument, options);
        }
export type GetErrorLogQueryHookResult = ReturnType<typeof useGetErrorLogQuery>;
export type GetErrorLogLazyQueryHookResult = ReturnType<typeof useGetErrorLogLazyQuery>;
export type GetErrorLogSuspenseQueryHookResult = ReturnType<typeof useGetErrorLogSuspenseQuery>;
export type GetErrorLogQueryResult = Apollo.QueryResult<GetErrorLogQuery, GetErrorLogQueryVariables>;
export const CreateErrorLogDocument = gql`
    mutation CreateErrorLog($error: String!, $stack: String, $domain: String!) {
  createErrorLog(error: $error, stack: $stack, domain: $domain) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;
export type CreateErrorLogMutationFn = Apollo.MutationFunction<CreateErrorLogMutation, CreateErrorLogMutationVariables>;

/**
 * __useCreateErrorLogMutation__
 *
 * To run a mutation, you first call `useCreateErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrorLogMutation, { data, loading, error }] = useCreateErrorLogMutation({
 *   variables: {
 *      error: // value for 'error'
 *      stack: // value for 'stack'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useCreateErrorLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrorLogMutation, CreateErrorLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrorLogMutation, CreateErrorLogMutationVariables>(CreateErrorLogDocument, options);
      }
export type CreateErrorLogMutationHookResult = ReturnType<typeof useCreateErrorLogMutation>;
export type CreateErrorLogMutationResult = Apollo.MutationResult<CreateErrorLogMutation>;
export type CreateErrorLogMutationOptions = Apollo.BaseMutationOptions<CreateErrorLogMutation, CreateErrorLogMutationVariables>;
export const UpdateErrorLogDocument = gql`
    mutation UpdateErrorLog($id: ID!, $error: String, $stack: String, $domain: String) {
  updateErrorLog(id: $id, error: $error, stack: $stack, domain: $domain) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;
export type UpdateErrorLogMutationFn = Apollo.MutationFunction<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>;

/**
 * __useUpdateErrorLogMutation__
 *
 * To run a mutation, you first call `useUpdateErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrorLogMutation, { data, loading, error }] = useUpdateErrorLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      error: // value for 'error'
 *      stack: // value for 'stack'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useUpdateErrorLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>(UpdateErrorLogDocument, options);
      }
export type UpdateErrorLogMutationHookResult = ReturnType<typeof useUpdateErrorLogMutation>;
export type UpdateErrorLogMutationResult = Apollo.MutationResult<UpdateErrorLogMutation>;
export type UpdateErrorLogMutationOptions = Apollo.BaseMutationOptions<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>;
export const DeleteErrorLogDocument = gql`
    mutation DeleteErrorLog($id: ID!) {
  deleteErrorLog(id: $id) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;
export type DeleteErrorLogMutationFn = Apollo.MutationFunction<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>;

/**
 * __useDeleteErrorLogMutation__
 *
 * To run a mutation, you first call `useDeleteErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErrorLogMutation, { data, loading, error }] = useDeleteErrorLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteErrorLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>(DeleteErrorLogDocument, options);
      }
export type DeleteErrorLogMutationHookResult = ReturnType<typeof useDeleteErrorLogMutation>;
export type DeleteErrorLogMutationResult = Apollo.MutationResult<DeleteErrorLogMutation>;
export type DeleteErrorLogMutationOptions = Apollo.BaseMutationOptions<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>;
export const CreatedErrorLogDocument = gql`
    subscription CreatedErrorLog($filter: ErrorLogFilterArgs) {
  createdErrorLog(filter: $filter) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useCreatedErrorLogSubscription__
 *
 * To run a query within a React component, call `useCreatedErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedErrorLogSubscription, CreatedErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedErrorLogSubscription, CreatedErrorLogSubscriptionVariables>(CreatedErrorLogDocument, options);
      }
export type CreatedErrorLogSubscriptionHookResult = ReturnType<typeof useCreatedErrorLogSubscription>;
export type CreatedErrorLogSubscriptionResult = Apollo.SubscriptionResult<CreatedErrorLogSubscription>;
export const UpdatedErrorLogDocument = gql`
    subscription UpdatedErrorLog($filter: ErrorLogFilterArgs) {
  updatedErrorLog(filter: $filter) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useUpdatedErrorLogSubscription__
 *
 * To run a query within a React component, call `useUpdatedErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedErrorLogSubscription, UpdatedErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedErrorLogSubscription, UpdatedErrorLogSubscriptionVariables>(UpdatedErrorLogDocument, options);
      }
export type UpdatedErrorLogSubscriptionHookResult = ReturnType<typeof useUpdatedErrorLogSubscription>;
export type UpdatedErrorLogSubscriptionResult = Apollo.SubscriptionResult<UpdatedErrorLogSubscription>;
export const DeletedErrorLogDocument = gql`
    subscription DeletedErrorLog($filter: ErrorLogFilterArgs) {
  deletedErrorLog(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedErrorLogSubscription__
 *
 * To run a query within a React component, call `useDeletedErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedErrorLogSubscription, DeletedErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedErrorLogSubscription, DeletedErrorLogSubscriptionVariables>(DeletedErrorLogDocument, options);
      }
export type DeletedErrorLogSubscriptionHookResult = ReturnType<typeof useDeletedErrorLogSubscription>;
export type DeletedErrorLogSubscriptionResult = Apollo.SubscriptionResult<DeletedErrorLogSubscription>;
export const RestoredErrorLogDocument = gql`
    subscription RestoredErrorLog($filter: ErrorLogFilterArgs) {
  restoredErrorLog(filter: $filter) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useRestoredErrorLogSubscription__
 *
 * To run a query within a React component, call `useRestoredErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredErrorLogSubscription, RestoredErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredErrorLogSubscription, RestoredErrorLogSubscriptionVariables>(RestoredErrorLogDocument, options);
      }
export type RestoredErrorLogSubscriptionHookResult = ReturnType<typeof useRestoredErrorLogSubscription>;
export type RestoredErrorLogSubscriptionResult = Apollo.SubscriptionResult<RestoredErrorLogSubscription>;
export const GetEventLogsDocument = gql`
    query GetEventLogs($filter: EventLogFilterArgs, $paging: PageArgs, $sorting: [EventLogSortArgs!]) {
  eventLogs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...eventLogFields
    }
    totalCount
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useGetEventLogsQuery__
 *
 * To run a query within a React component, call `useGetEventLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetEventLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventLogsQuery, GetEventLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLogsQuery, GetEventLogsQueryVariables>(GetEventLogsDocument, options);
      }
export function useGetEventLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLogsQuery, GetEventLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLogsQuery, GetEventLogsQueryVariables>(GetEventLogsDocument, options);
        }
export function useGetEventLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventLogsQuery, GetEventLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventLogsQuery, GetEventLogsQueryVariables>(GetEventLogsDocument, options);
        }
export type GetEventLogsQueryHookResult = ReturnType<typeof useGetEventLogsQuery>;
export type GetEventLogsLazyQueryHookResult = ReturnType<typeof useGetEventLogsLazyQuery>;
export type GetEventLogsSuspenseQueryHookResult = ReturnType<typeof useGetEventLogsSuspenseQuery>;
export type GetEventLogsQueryResult = Apollo.QueryResult<GetEventLogsQuery, GetEventLogsQueryVariables>;
export const GetEventLogDocument = gql`
    query GetEventLog($id: ID!) {
  eventLog(id: $id) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useGetEventLogQuery__
 *
 * To run a query within a React component, call `useGetEventLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventLogQuery(baseOptions: Apollo.QueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables> & ({ variables: GetEventLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
      }
export function useGetEventLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
        }
export function useGetEventLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
        }
export type GetEventLogQueryHookResult = ReturnType<typeof useGetEventLogQuery>;
export type GetEventLogLazyQueryHookResult = ReturnType<typeof useGetEventLogLazyQuery>;
export type GetEventLogSuspenseQueryHookResult = ReturnType<typeof useGetEventLogSuspenseQuery>;
export type GetEventLogQueryResult = Apollo.QueryResult<GetEventLogQuery, GetEventLogQueryVariables>;
export const CreateEventLogDocument = gql`
    mutation CreateEventLog($log: String!, $type: String!) {
  createEventLog(log: $log, type: $type) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;
export type CreateEventLogMutationFn = Apollo.MutationFunction<CreateEventLogMutation, CreateEventLogMutationVariables>;

/**
 * __useCreateEventLogMutation__
 *
 * To run a mutation, you first call `useCreateEventLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventLogMutation, { data, loading, error }] = useCreateEventLogMutation({
 *   variables: {
 *      log: // value for 'log'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateEventLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventLogMutation, CreateEventLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventLogMutation, CreateEventLogMutationVariables>(CreateEventLogDocument, options);
      }
export type CreateEventLogMutationHookResult = ReturnType<typeof useCreateEventLogMutation>;
export type CreateEventLogMutationResult = Apollo.MutationResult<CreateEventLogMutation>;
export type CreateEventLogMutationOptions = Apollo.BaseMutationOptions<CreateEventLogMutation, CreateEventLogMutationVariables>;
export const UpdateEventLogDocument = gql`
    mutation UpdateEventLog($id: ID!, $log: String, $type: String) {
  updateEventLog(id: $id, log: $log, type: $type) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;
export type UpdateEventLogMutationFn = Apollo.MutationFunction<UpdateEventLogMutation, UpdateEventLogMutationVariables>;

/**
 * __useUpdateEventLogMutation__
 *
 * To run a mutation, you first call `useUpdateEventLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventLogMutation, { data, loading, error }] = useUpdateEventLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      log: // value for 'log'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateEventLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventLogMutation, UpdateEventLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventLogMutation, UpdateEventLogMutationVariables>(UpdateEventLogDocument, options);
      }
export type UpdateEventLogMutationHookResult = ReturnType<typeof useUpdateEventLogMutation>;
export type UpdateEventLogMutationResult = Apollo.MutationResult<UpdateEventLogMutation>;
export type UpdateEventLogMutationOptions = Apollo.BaseMutationOptions<UpdateEventLogMutation, UpdateEventLogMutationVariables>;
export const DeleteEventLogDocument = gql`
    mutation DeleteEventLog($id: ID!) {
  deleteEventLog(id: $id) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;
export type DeleteEventLogMutationFn = Apollo.MutationFunction<DeleteEventLogMutation, DeleteEventLogMutationVariables>;

/**
 * __useDeleteEventLogMutation__
 *
 * To run a mutation, you first call `useDeleteEventLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventLogMutation, { data, loading, error }] = useDeleteEventLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventLogMutation, DeleteEventLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventLogMutation, DeleteEventLogMutationVariables>(DeleteEventLogDocument, options);
      }
export type DeleteEventLogMutationHookResult = ReturnType<typeof useDeleteEventLogMutation>;
export type DeleteEventLogMutationResult = Apollo.MutationResult<DeleteEventLogMutation>;
export type DeleteEventLogMutationOptions = Apollo.BaseMutationOptions<DeleteEventLogMutation, DeleteEventLogMutationVariables>;
export const CreatedEventLogDocument = gql`
    subscription CreatedEventLog($filter: EventLogFilterArgs) {
  createdEventLog(filter: $filter) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useCreatedEventLogSubscription__
 *
 * To run a query within a React component, call `useCreatedEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedEventLogSubscription, CreatedEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedEventLogSubscription, CreatedEventLogSubscriptionVariables>(CreatedEventLogDocument, options);
      }
export type CreatedEventLogSubscriptionHookResult = ReturnType<typeof useCreatedEventLogSubscription>;
export type CreatedEventLogSubscriptionResult = Apollo.SubscriptionResult<CreatedEventLogSubscription>;
export const UpdatedEventLogDocument = gql`
    subscription UpdatedEventLog($filter: EventLogFilterArgs) {
  updatedEventLog(filter: $filter) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useUpdatedEventLogSubscription__
 *
 * To run a query within a React component, call `useUpdatedEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedEventLogSubscription, UpdatedEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedEventLogSubscription, UpdatedEventLogSubscriptionVariables>(UpdatedEventLogDocument, options);
      }
export type UpdatedEventLogSubscriptionHookResult = ReturnType<typeof useUpdatedEventLogSubscription>;
export type UpdatedEventLogSubscriptionResult = Apollo.SubscriptionResult<UpdatedEventLogSubscription>;
export const DeletedEventLogDocument = gql`
    subscription DeletedEventLog($filter: EventLogFilterArgs) {
  deletedEventLog(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedEventLogSubscription__
 *
 * To run a query within a React component, call `useDeletedEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedEventLogSubscription, DeletedEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedEventLogSubscription, DeletedEventLogSubscriptionVariables>(DeletedEventLogDocument, options);
      }
export type DeletedEventLogSubscriptionHookResult = ReturnType<typeof useDeletedEventLogSubscription>;
export type DeletedEventLogSubscriptionResult = Apollo.SubscriptionResult<DeletedEventLogSubscription>;
export const RestoredEventLogDocument = gql`
    subscription RestoredEventLog($filter: EventLogFilterArgs) {
  restoredEventLog(filter: $filter) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useRestoredEventLogSubscription__
 *
 * To run a query within a React component, call `useRestoredEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredEventLogSubscription, RestoredEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredEventLogSubscription, RestoredEventLogSubscriptionVariables>(RestoredEventLogDocument, options);
      }
export type RestoredEventLogSubscriptionHookResult = ReturnType<typeof useRestoredEventLogSubscription>;
export type RestoredEventLogSubscriptionResult = Apollo.SubscriptionResult<RestoredEventLogSubscription>;
export const GetHoursRequiredsDocument = gql`
    query GetHoursRequireds($filter: HoursRequiredFilterArgs, $paging: PageArgs, $sorting: [HoursRequiredSortArgs!], $withProject: Boolean = false) {
  hoursRequireds(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...hoursRequiredFields
    }
    totalCount
  }
}
    ${HoursRequiredFieldsFragmentDoc}`;

/**
 * __useGetHoursRequiredsQuery__
 *
 * To run a query within a React component, call `useGetHoursRequiredsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoursRequiredsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoursRequiredsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetHoursRequiredsQuery(baseOptions?: Apollo.QueryHookOptions<GetHoursRequiredsQuery, GetHoursRequiredsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHoursRequiredsQuery, GetHoursRequiredsQueryVariables>(GetHoursRequiredsDocument, options);
      }
export function useGetHoursRequiredsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHoursRequiredsQuery, GetHoursRequiredsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHoursRequiredsQuery, GetHoursRequiredsQueryVariables>(GetHoursRequiredsDocument, options);
        }
export function useGetHoursRequiredsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHoursRequiredsQuery, GetHoursRequiredsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHoursRequiredsQuery, GetHoursRequiredsQueryVariables>(GetHoursRequiredsDocument, options);
        }
export type GetHoursRequiredsQueryHookResult = ReturnType<typeof useGetHoursRequiredsQuery>;
export type GetHoursRequiredsLazyQueryHookResult = ReturnType<typeof useGetHoursRequiredsLazyQuery>;
export type GetHoursRequiredsSuspenseQueryHookResult = ReturnType<typeof useGetHoursRequiredsSuspenseQuery>;
export type GetHoursRequiredsQueryResult = Apollo.QueryResult<GetHoursRequiredsQuery, GetHoursRequiredsQueryVariables>;
export const GetHoursRequiredDocument = gql`
    query GetHoursRequired($id: ID!, $withProject: Boolean = false) {
  hoursRequired(id: $id) {
    ...hoursRequiredFields
  }
}
    ${HoursRequiredFieldsFragmentDoc}`;

/**
 * __useGetHoursRequiredQuery__
 *
 * To run a query within a React component, call `useGetHoursRequiredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoursRequiredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoursRequiredQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetHoursRequiredQuery(baseOptions: Apollo.QueryHookOptions<GetHoursRequiredQuery, GetHoursRequiredQueryVariables> & ({ variables: GetHoursRequiredQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHoursRequiredQuery, GetHoursRequiredQueryVariables>(GetHoursRequiredDocument, options);
      }
export function useGetHoursRequiredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHoursRequiredQuery, GetHoursRequiredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHoursRequiredQuery, GetHoursRequiredQueryVariables>(GetHoursRequiredDocument, options);
        }
export function useGetHoursRequiredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHoursRequiredQuery, GetHoursRequiredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHoursRequiredQuery, GetHoursRequiredQueryVariables>(GetHoursRequiredDocument, options);
        }
export type GetHoursRequiredQueryHookResult = ReturnType<typeof useGetHoursRequiredQuery>;
export type GetHoursRequiredLazyQueryHookResult = ReturnType<typeof useGetHoursRequiredLazyQuery>;
export type GetHoursRequiredSuspenseQueryHookResult = ReturnType<typeof useGetHoursRequiredSuspenseQuery>;
export type GetHoursRequiredQueryResult = Apollo.QueryResult<GetHoursRequiredQuery, GetHoursRequiredQueryVariables>;
export const GetAllRelatedDataForHoursRequiredDocument = gql`
    query GetAllRelatedDataForHoursRequired($withProjects: Boolean = false) {
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForHoursRequiredQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForHoursRequiredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForHoursRequiredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForHoursRequiredQuery({
 *   variables: {
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetAllRelatedDataForHoursRequiredQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForHoursRequiredQuery, GetAllRelatedDataForHoursRequiredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForHoursRequiredQuery, GetAllRelatedDataForHoursRequiredQueryVariables>(GetAllRelatedDataForHoursRequiredDocument, options);
      }
export function useGetAllRelatedDataForHoursRequiredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForHoursRequiredQuery, GetAllRelatedDataForHoursRequiredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForHoursRequiredQuery, GetAllRelatedDataForHoursRequiredQueryVariables>(GetAllRelatedDataForHoursRequiredDocument, options);
        }
export function useGetAllRelatedDataForHoursRequiredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForHoursRequiredQuery, GetAllRelatedDataForHoursRequiredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForHoursRequiredQuery, GetAllRelatedDataForHoursRequiredQueryVariables>(GetAllRelatedDataForHoursRequiredDocument, options);
        }
export type GetAllRelatedDataForHoursRequiredQueryHookResult = ReturnType<typeof useGetAllRelatedDataForHoursRequiredQuery>;
export type GetAllRelatedDataForHoursRequiredLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForHoursRequiredLazyQuery>;
export type GetAllRelatedDataForHoursRequiredSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForHoursRequiredSuspenseQuery>;
export type GetAllRelatedDataForHoursRequiredQueryResult = Apollo.QueryResult<GetAllRelatedDataForHoursRequiredQuery, GetAllRelatedDataForHoursRequiredQueryVariables>;
export const CreateHoursRequiredDocument = gql`
    mutation CreateHoursRequired($month: DateTime!, $perMonth: Int!, $projectId: ID!, $withProject: Boolean = false) {
  createHoursRequired(month: $month, perMonth: $perMonth, projectId: $projectId) {
    ...hoursRequiredFields
  }
}
    ${HoursRequiredFieldsFragmentDoc}`;
export type CreateHoursRequiredMutationFn = Apollo.MutationFunction<CreateHoursRequiredMutation, CreateHoursRequiredMutationVariables>;

/**
 * __useCreateHoursRequiredMutation__
 *
 * To run a mutation, you first call `useCreateHoursRequiredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHoursRequiredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHoursRequiredMutation, { data, loading, error }] = useCreateHoursRequiredMutation({
 *   variables: {
 *      month: // value for 'month'
 *      perMonth: // value for 'perMonth'
 *      projectId: // value for 'projectId'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreateHoursRequiredMutation(baseOptions?: Apollo.MutationHookOptions<CreateHoursRequiredMutation, CreateHoursRequiredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHoursRequiredMutation, CreateHoursRequiredMutationVariables>(CreateHoursRequiredDocument, options);
      }
export type CreateHoursRequiredMutationHookResult = ReturnType<typeof useCreateHoursRequiredMutation>;
export type CreateHoursRequiredMutationResult = Apollo.MutationResult<CreateHoursRequiredMutation>;
export type CreateHoursRequiredMutationOptions = Apollo.BaseMutationOptions<CreateHoursRequiredMutation, CreateHoursRequiredMutationVariables>;
export const UpdateHoursRequiredDocument = gql`
    mutation UpdateHoursRequired($id: ID!, $month: DateTime, $perMonth: Int, $projectId: ID, $withProject: Boolean = false) {
  updateHoursRequired(
    id: $id
    month: $month
    perMonth: $perMonth
    projectId: $projectId
  ) {
    ...hoursRequiredFields
  }
}
    ${HoursRequiredFieldsFragmentDoc}`;
export type UpdateHoursRequiredMutationFn = Apollo.MutationFunction<UpdateHoursRequiredMutation, UpdateHoursRequiredMutationVariables>;

/**
 * __useUpdateHoursRequiredMutation__
 *
 * To run a mutation, you first call `useUpdateHoursRequiredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHoursRequiredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHoursRequiredMutation, { data, loading, error }] = useUpdateHoursRequiredMutation({
 *   variables: {
 *      id: // value for 'id'
 *      month: // value for 'month'
 *      perMonth: // value for 'perMonth'
 *      projectId: // value for 'projectId'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdateHoursRequiredMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHoursRequiredMutation, UpdateHoursRequiredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHoursRequiredMutation, UpdateHoursRequiredMutationVariables>(UpdateHoursRequiredDocument, options);
      }
export type UpdateHoursRequiredMutationHookResult = ReturnType<typeof useUpdateHoursRequiredMutation>;
export type UpdateHoursRequiredMutationResult = Apollo.MutationResult<UpdateHoursRequiredMutation>;
export type UpdateHoursRequiredMutationOptions = Apollo.BaseMutationOptions<UpdateHoursRequiredMutation, UpdateHoursRequiredMutationVariables>;
export const DeleteHoursRequiredDocument = gql`
    mutation DeleteHoursRequired($id: ID!, $withProject: Boolean = false) {
  deleteHoursRequired(id: $id) {
    ...hoursRequiredFields
  }
}
    ${HoursRequiredFieldsFragmentDoc}`;
export type DeleteHoursRequiredMutationFn = Apollo.MutationFunction<DeleteHoursRequiredMutation, DeleteHoursRequiredMutationVariables>;

/**
 * __useDeleteHoursRequiredMutation__
 *
 * To run a mutation, you first call `useDeleteHoursRequiredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHoursRequiredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHoursRequiredMutation, { data, loading, error }] = useDeleteHoursRequiredMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useDeleteHoursRequiredMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHoursRequiredMutation, DeleteHoursRequiredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHoursRequiredMutation, DeleteHoursRequiredMutationVariables>(DeleteHoursRequiredDocument, options);
      }
export type DeleteHoursRequiredMutationHookResult = ReturnType<typeof useDeleteHoursRequiredMutation>;
export type DeleteHoursRequiredMutationResult = Apollo.MutationResult<DeleteHoursRequiredMutation>;
export type DeleteHoursRequiredMutationOptions = Apollo.BaseMutationOptions<DeleteHoursRequiredMutation, DeleteHoursRequiredMutationVariables>;
export const CreatedHoursRequiredDocument = gql`
    subscription CreatedHoursRequired($filter: HoursRequiredFilterArgs, $withProject: Boolean = false) {
  createdHoursRequired(filter: $filter) {
    ...hoursRequiredFields
  }
}
    ${HoursRequiredFieldsFragmentDoc}`;

/**
 * __useCreatedHoursRequiredSubscription__
 *
 * To run a query within a React component, call `useCreatedHoursRequiredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedHoursRequiredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedHoursRequiredSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreatedHoursRequiredSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedHoursRequiredSubscription, CreatedHoursRequiredSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedHoursRequiredSubscription, CreatedHoursRequiredSubscriptionVariables>(CreatedHoursRequiredDocument, options);
      }
export type CreatedHoursRequiredSubscriptionHookResult = ReturnType<typeof useCreatedHoursRequiredSubscription>;
export type CreatedHoursRequiredSubscriptionResult = Apollo.SubscriptionResult<CreatedHoursRequiredSubscription>;
export const UpdatedHoursRequiredDocument = gql`
    subscription UpdatedHoursRequired($filter: HoursRequiredFilterArgs, $withProject: Boolean = false) {
  updatedHoursRequired(filter: $filter) {
    ...hoursRequiredFields
  }
}
    ${HoursRequiredFieldsFragmentDoc}`;

/**
 * __useUpdatedHoursRequiredSubscription__
 *
 * To run a query within a React component, call `useUpdatedHoursRequiredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedHoursRequiredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedHoursRequiredSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdatedHoursRequiredSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedHoursRequiredSubscription, UpdatedHoursRequiredSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedHoursRequiredSubscription, UpdatedHoursRequiredSubscriptionVariables>(UpdatedHoursRequiredDocument, options);
      }
export type UpdatedHoursRequiredSubscriptionHookResult = ReturnType<typeof useUpdatedHoursRequiredSubscription>;
export type UpdatedHoursRequiredSubscriptionResult = Apollo.SubscriptionResult<UpdatedHoursRequiredSubscription>;
export const DeletedHoursRequiredDocument = gql`
    subscription DeletedHoursRequired($filter: HoursRequiredFilterArgs) {
  deletedHoursRequired(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedHoursRequiredSubscription__
 *
 * To run a query within a React component, call `useDeletedHoursRequiredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedHoursRequiredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedHoursRequiredSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedHoursRequiredSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedHoursRequiredSubscription, DeletedHoursRequiredSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedHoursRequiredSubscription, DeletedHoursRequiredSubscriptionVariables>(DeletedHoursRequiredDocument, options);
      }
export type DeletedHoursRequiredSubscriptionHookResult = ReturnType<typeof useDeletedHoursRequiredSubscription>;
export type DeletedHoursRequiredSubscriptionResult = Apollo.SubscriptionResult<DeletedHoursRequiredSubscription>;
export const RestoredHoursRequiredDocument = gql`
    subscription RestoredHoursRequired($filter: HoursRequiredFilterArgs, $withProject: Boolean = false) {
  restoredHoursRequired(filter: $filter) {
    ...hoursRequiredFields
  }
}
    ${HoursRequiredFieldsFragmentDoc}`;

/**
 * __useRestoredHoursRequiredSubscription__
 *
 * To run a query within a React component, call `useRestoredHoursRequiredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredHoursRequiredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredHoursRequiredSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useRestoredHoursRequiredSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredHoursRequiredSubscription, RestoredHoursRequiredSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredHoursRequiredSubscription, RestoredHoursRequiredSubscriptionVariables>(RestoredHoursRequiredDocument, options);
      }
export type RestoredHoursRequiredSubscriptionHookResult = ReturnType<typeof useRestoredHoursRequiredSubscription>;
export type RestoredHoursRequiredSubscriptionResult = Apollo.SubscriptionResult<RestoredHoursRequiredSubscription>;
export const GetInvoicesDocument = gql`
    query GetInvoices($filter: InvoiceFilterArgs, $paging: PageArgs, $sorting: [InvoiceSortArgs!], $withTenant: Boolean = false, $withProject: Boolean = false, $withCategory: Boolean = false) {
  invoices(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...invoiceFields
    }
    totalCount
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export function useGetInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesSuspenseQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetInvoiceDocument = gql`
    query GetInvoice($id: ID!, $withTenant: Boolean = false, $withProject: Boolean = false, $withCategory: Boolean = false) {
  invoice(id: $id) {
    ...invoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables> & ({ variables: GetInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
      }
export function useGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export function useGetInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export type GetInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceSuspenseQuery>;
export type GetInvoiceQueryResult = Apollo.QueryResult<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const GetAllRelatedDataForInvoiceDocument = gql`
    query GetAllRelatedDataForInvoice($withTenants: Boolean = false, $withProjects: Boolean = false, $withCategories: Boolean = false) {
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
  categories @include(if: $withCategories) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForInvoiceQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForInvoiceQuery({
 *   variables: {
 *      withTenants: // value for 'withTenants'
 *      withProjects: // value for 'withProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useGetAllRelatedDataForInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForInvoiceQuery, GetAllRelatedDataForInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForInvoiceQuery, GetAllRelatedDataForInvoiceQueryVariables>(GetAllRelatedDataForInvoiceDocument, options);
      }
export function useGetAllRelatedDataForInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForInvoiceQuery, GetAllRelatedDataForInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForInvoiceQuery, GetAllRelatedDataForInvoiceQueryVariables>(GetAllRelatedDataForInvoiceDocument, options);
        }
export function useGetAllRelatedDataForInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForInvoiceQuery, GetAllRelatedDataForInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForInvoiceQuery, GetAllRelatedDataForInvoiceQueryVariables>(GetAllRelatedDataForInvoiceDocument, options);
        }
export type GetAllRelatedDataForInvoiceQueryHookResult = ReturnType<typeof useGetAllRelatedDataForInvoiceQuery>;
export type GetAllRelatedDataForInvoiceLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForInvoiceLazyQuery>;
export type GetAllRelatedDataForInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForInvoiceSuspenseQuery>;
export type GetAllRelatedDataForInvoiceQueryResult = Apollo.QueryResult<GetAllRelatedDataForInvoiceQuery, GetAllRelatedDataForInvoiceQueryVariables>;
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($name: String!, $description: String!, $status: String!, $total: Float!, $vat: Float, $attachment: String, $attachmentProof: String, $subsidyPercentage: Int, $vatSubsidyEligible: Boolean!, $invoiceNumber: String, $paidOn: DateTime, $tenantId: ID!, $projectId: ID!, $categoryId: ID!, $withTenant: Boolean = false, $withProject: Boolean = false, $withCategory: Boolean = false) {
  createInvoice(
    name: $name
    description: $description
    status: $status
    total: $total
    vat: $vat
    attachment: $attachment
    attachmentProof: $attachmentProof
    subsidyPercentage: $subsidyPercentage
    vatSubsidyEligible: $vatSubsidyEligible
    invoiceNumber: $invoiceNumber
    paidOn: $paidOn
    tenantId: $tenantId
    projectId: $projectId
    categoryId: $categoryId
  ) {
    ...invoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *      total: // value for 'total'
 *      vat: // value for 'vat'
 *      attachment: // value for 'attachment'
 *      attachmentProof: // value for 'attachmentProof'
 *      subsidyPercentage: // value for 'subsidyPercentage'
 *      vatSubsidyEligible: // value for 'vatSubsidyEligible'
 *      invoiceNumber: // value for 'invoiceNumber'
 *      paidOn: // value for 'paidOn'
 *      tenantId: // value for 'tenantId'
 *      projectId: // value for 'projectId'
 *      categoryId: // value for 'categoryId'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($id: ID!, $name: String, $description: String, $status: String, $total: Float, $vat: Float, $attachment: String, $attachmentProof: String, $subsidyPercentage: Int, $vatSubsidyEligible: Boolean, $invoiceNumber: String, $paidOn: DateTime, $tenantId: ID, $projectId: ID, $categoryId: ID, $withTenant: Boolean = false, $withProject: Boolean = false, $withCategory: Boolean = false) {
  updateInvoice(
    id: $id
    name: $name
    description: $description
    status: $status
    total: $total
    vat: $vat
    attachment: $attachment
    attachmentProof: $attachmentProof
    subsidyPercentage: $subsidyPercentage
    vatSubsidyEligible: $vatSubsidyEligible
    invoiceNumber: $invoiceNumber
    paidOn: $paidOn
    tenantId: $tenantId
    projectId: $projectId
    categoryId: $categoryId
  ) {
    ...invoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *      total: // value for 'total'
 *      vat: // value for 'vat'
 *      attachment: // value for 'attachment'
 *      attachmentProof: // value for 'attachmentProof'
 *      subsidyPercentage: // value for 'subsidyPercentage'
 *      vatSubsidyEligible: // value for 'vatSubsidyEligible'
 *      invoiceNumber: // value for 'invoiceNumber'
 *      paidOn: // value for 'paidOn'
 *      tenantId: // value for 'tenantId'
 *      projectId: // value for 'projectId'
 *      categoryId: // value for 'categoryId'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($id: ID!, $withTenant: Boolean = false, $withProject: Boolean = false, $withCategory: Boolean = false) {
  deleteInvoice(id: $id) {
    ...invoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;
export type DeleteInvoiceMutationFn = Apollo.MutationFunction<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceMutation, { data, loading, error }] = useDeleteInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, options);
      }
export type DeleteInvoiceMutationHookResult = ReturnType<typeof useDeleteInvoiceMutation>;
export type DeleteInvoiceMutationResult = Apollo.MutationResult<DeleteInvoiceMutation>;
export type DeleteInvoiceMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;
export const CreatedInvoiceDocument = gql`
    subscription CreatedInvoice($filter: InvoiceFilterArgs, $withTenant: Boolean = false, $withProject: Boolean = false, $withCategory: Boolean = false) {
  createdInvoice(filter: $filter) {
    ...invoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useCreatedInvoiceSubscription__
 *
 * To run a query within a React component, call `useCreatedInvoiceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedInvoiceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedInvoiceSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useCreatedInvoiceSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedInvoiceSubscription, CreatedInvoiceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedInvoiceSubscription, CreatedInvoiceSubscriptionVariables>(CreatedInvoiceDocument, options);
      }
export type CreatedInvoiceSubscriptionHookResult = ReturnType<typeof useCreatedInvoiceSubscription>;
export type CreatedInvoiceSubscriptionResult = Apollo.SubscriptionResult<CreatedInvoiceSubscription>;
export const UpdatedInvoiceDocument = gql`
    subscription UpdatedInvoice($filter: InvoiceFilterArgs, $withTenant: Boolean = false, $withProject: Boolean = false, $withCategory: Boolean = false) {
  updatedInvoice(filter: $filter) {
    ...invoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useUpdatedInvoiceSubscription__
 *
 * To run a query within a React component, call `useUpdatedInvoiceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedInvoiceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedInvoiceSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useUpdatedInvoiceSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedInvoiceSubscription, UpdatedInvoiceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedInvoiceSubscription, UpdatedInvoiceSubscriptionVariables>(UpdatedInvoiceDocument, options);
      }
export type UpdatedInvoiceSubscriptionHookResult = ReturnType<typeof useUpdatedInvoiceSubscription>;
export type UpdatedInvoiceSubscriptionResult = Apollo.SubscriptionResult<UpdatedInvoiceSubscription>;
export const DeletedInvoiceDocument = gql`
    subscription DeletedInvoice($filter: InvoiceFilterArgs) {
  deletedInvoice(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedInvoiceSubscription__
 *
 * To run a query within a React component, call `useDeletedInvoiceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedInvoiceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedInvoiceSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedInvoiceSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedInvoiceSubscription, DeletedInvoiceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedInvoiceSubscription, DeletedInvoiceSubscriptionVariables>(DeletedInvoiceDocument, options);
      }
export type DeletedInvoiceSubscriptionHookResult = ReturnType<typeof useDeletedInvoiceSubscription>;
export type DeletedInvoiceSubscriptionResult = Apollo.SubscriptionResult<DeletedInvoiceSubscription>;
export const RestoredInvoiceDocument = gql`
    subscription RestoredInvoice($filter: InvoiceFilterArgs, $withTenant: Boolean = false, $withProject: Boolean = false, $withCategory: Boolean = false) {
  restoredInvoice(filter: $filter) {
    ...invoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useRestoredInvoiceSubscription__
 *
 * To run a query within a React component, call `useRestoredInvoiceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredInvoiceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredInvoiceSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *      withProject: // value for 'withProject'
 *      withCategory: // value for 'withCategory'
 *   },
 * });
 */
export function useRestoredInvoiceSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredInvoiceSubscription, RestoredInvoiceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredInvoiceSubscription, RestoredInvoiceSubscriptionVariables>(RestoredInvoiceDocument, options);
      }
export type RestoredInvoiceSubscriptionHookResult = ReturnType<typeof useRestoredInvoiceSubscription>;
export type RestoredInvoiceSubscriptionResult = Apollo.SubscriptionResult<RestoredInvoiceSubscription>;
export const GetJobsDocument = gql`
    query GetJobs($filter: JobFilterArgs, $paging: PageArgs, $sorting: [JobSortArgs!]) {
  jobs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...jobFields
    }
    totalCount
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsSuspenseQueryHookResult = ReturnType<typeof useGetJobsSuspenseQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetJobDocument = gql`
    query GetJob($id: ID!) {
  job(id: $id) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables> & ({ variables: GetJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export function useGetJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobSuspenseQueryHookResult = ReturnType<typeof useGetJobSuspenseQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const CreateJobDocument = gql`
    mutation CreateJob($queue: String!, $status: String!, $log: String) {
  createJob(queue: $queue, status: $status, log: $log) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      queue: // value for 'queue'
 *      status: // value for 'status'
 *      log: // value for 'log'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const UpdateJobDocument = gql`
    mutation UpdateJob($id: ID!, $queue: String, $status: String, $log: String) {
  updateJob(id: $id, queue: $queue, status: $status, log: $log) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      queue: // value for 'queue'
 *      status: // value for 'status'
 *      log: // value for 'log'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const DeleteJobDocument = gql`
    mutation DeleteJob($id: ID!) {
  deleteJob(id: $id) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, options);
      }
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const CreatedJobDocument = gql`
    subscription CreatedJob($filter: JobFilterArgs) {
  createdJob(filter: $filter) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useCreatedJobSubscription__
 *
 * To run a query within a React component, call `useCreatedJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedJobSubscription, CreatedJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedJobSubscription, CreatedJobSubscriptionVariables>(CreatedJobDocument, options);
      }
export type CreatedJobSubscriptionHookResult = ReturnType<typeof useCreatedJobSubscription>;
export type CreatedJobSubscriptionResult = Apollo.SubscriptionResult<CreatedJobSubscription>;
export const UpdatedJobDocument = gql`
    subscription UpdatedJob($filter: JobFilterArgs) {
  updatedJob(filter: $filter) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useUpdatedJobSubscription__
 *
 * To run a query within a React component, call `useUpdatedJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedJobSubscription, UpdatedJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedJobSubscription, UpdatedJobSubscriptionVariables>(UpdatedJobDocument, options);
      }
export type UpdatedJobSubscriptionHookResult = ReturnType<typeof useUpdatedJobSubscription>;
export type UpdatedJobSubscriptionResult = Apollo.SubscriptionResult<UpdatedJobSubscription>;
export const DeletedJobDocument = gql`
    subscription DeletedJob($filter: JobFilterArgs) {
  deletedJob(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedJobSubscription__
 *
 * To run a query within a React component, call `useDeletedJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedJobSubscription, DeletedJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedJobSubscription, DeletedJobSubscriptionVariables>(DeletedJobDocument, options);
      }
export type DeletedJobSubscriptionHookResult = ReturnType<typeof useDeletedJobSubscription>;
export type DeletedJobSubscriptionResult = Apollo.SubscriptionResult<DeletedJobSubscription>;
export const RestoredJobDocument = gql`
    subscription RestoredJob($filter: JobFilterArgs) {
  restoredJob(filter: $filter) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useRestoredJobSubscription__
 *
 * To run a query within a React component, call `useRestoredJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredJobSubscription, RestoredJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredJobSubscription, RestoredJobSubscriptionVariables>(RestoredJobDocument, options);
      }
export type RestoredJobSubscriptionHookResult = ReturnType<typeof useRestoredJobSubscription>;
export type RestoredJobSubscriptionResult = Apollo.SubscriptionResult<RestoredJobSubscription>;
export const GetLoggedHoursDocument = gql`
    query GetLoggedHours($filter: LoggedHourFilterArgs, $paging: PageArgs, $sorting: [LoggedHourSortArgs!], $withCategory: Boolean = false, $withProject: Boolean = false, $withUser: Boolean = false, $withApprovedBy: Boolean = false, $withTenant: Boolean = false) {
  loggedHours(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...loggedHourFields
    }
    totalCount
  }
}
    ${LoggedHourFieldsFragmentDoc}`;

/**
 * __useGetLoggedHoursQuery__
 *
 * To run a query within a React component, call `useGetLoggedHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoggedHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoggedHoursQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withCategory: // value for 'withCategory'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *      withApprovedBy: // value for 'withApprovedBy'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetLoggedHoursQuery(baseOptions?: Apollo.QueryHookOptions<GetLoggedHoursQuery, GetLoggedHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoggedHoursQuery, GetLoggedHoursQueryVariables>(GetLoggedHoursDocument, options);
      }
export function useGetLoggedHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoggedHoursQuery, GetLoggedHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoggedHoursQuery, GetLoggedHoursQueryVariables>(GetLoggedHoursDocument, options);
        }
export function useGetLoggedHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoggedHoursQuery, GetLoggedHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoggedHoursQuery, GetLoggedHoursQueryVariables>(GetLoggedHoursDocument, options);
        }
export type GetLoggedHoursQueryHookResult = ReturnType<typeof useGetLoggedHoursQuery>;
export type GetLoggedHoursLazyQueryHookResult = ReturnType<typeof useGetLoggedHoursLazyQuery>;
export type GetLoggedHoursSuspenseQueryHookResult = ReturnType<typeof useGetLoggedHoursSuspenseQuery>;
export type GetLoggedHoursQueryResult = Apollo.QueryResult<GetLoggedHoursQuery, GetLoggedHoursQueryVariables>;
export const GetLoggedHourDocument = gql`
    query GetLoggedHour($id: ID!, $withCategory: Boolean = false, $withProject: Boolean = false, $withUser: Boolean = false, $withApprovedBy: Boolean = false, $withTenant: Boolean = false) {
  loggedHour(id: $id) {
    ...loggedHourFields
  }
}
    ${LoggedHourFieldsFragmentDoc}`;

/**
 * __useGetLoggedHourQuery__
 *
 * To run a query within a React component, call `useGetLoggedHourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoggedHourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoggedHourQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withCategory: // value for 'withCategory'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *      withApprovedBy: // value for 'withApprovedBy'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetLoggedHourQuery(baseOptions: Apollo.QueryHookOptions<GetLoggedHourQuery, GetLoggedHourQueryVariables> & ({ variables: GetLoggedHourQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoggedHourQuery, GetLoggedHourQueryVariables>(GetLoggedHourDocument, options);
      }
export function useGetLoggedHourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoggedHourQuery, GetLoggedHourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoggedHourQuery, GetLoggedHourQueryVariables>(GetLoggedHourDocument, options);
        }
export function useGetLoggedHourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoggedHourQuery, GetLoggedHourQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoggedHourQuery, GetLoggedHourQueryVariables>(GetLoggedHourDocument, options);
        }
export type GetLoggedHourQueryHookResult = ReturnType<typeof useGetLoggedHourQuery>;
export type GetLoggedHourLazyQueryHookResult = ReturnType<typeof useGetLoggedHourLazyQuery>;
export type GetLoggedHourSuspenseQueryHookResult = ReturnType<typeof useGetLoggedHourSuspenseQuery>;
export type GetLoggedHourQueryResult = Apollo.QueryResult<GetLoggedHourQuery, GetLoggedHourQueryVariables>;
export const GetAllRelatedDataForLoggedHourDocument = gql`
    query GetAllRelatedDataForLoggedHour($withCategories: Boolean = false, $withProjects: Boolean = false, $withUsers: Boolean = false, $withApprovedBies: Boolean = false, $withTenants: Boolean = false) {
  categories @include(if: $withCategories) {
    items {
      id
      displayField: name
    }
  }
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
  users @include(if: $withUsers) {
    items {
      id
      displayField: fullName
    }
  }
  users @include(if: $withApprovedBies) {
    items {
      id
      displayField: fullName
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForLoggedHourQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForLoggedHourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForLoggedHourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForLoggedHourQuery({
 *   variables: {
 *      withCategories: // value for 'withCategories'
 *      withProjects: // value for 'withProjects'
 *      withUsers: // value for 'withUsers'
 *      withApprovedBies: // value for 'withApprovedBies'
 *      withTenants: // value for 'withTenants'
 *   },
 * });
 */
export function useGetAllRelatedDataForLoggedHourQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForLoggedHourQuery, GetAllRelatedDataForLoggedHourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForLoggedHourQuery, GetAllRelatedDataForLoggedHourQueryVariables>(GetAllRelatedDataForLoggedHourDocument, options);
      }
export function useGetAllRelatedDataForLoggedHourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForLoggedHourQuery, GetAllRelatedDataForLoggedHourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForLoggedHourQuery, GetAllRelatedDataForLoggedHourQueryVariables>(GetAllRelatedDataForLoggedHourDocument, options);
        }
export function useGetAllRelatedDataForLoggedHourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForLoggedHourQuery, GetAllRelatedDataForLoggedHourQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForLoggedHourQuery, GetAllRelatedDataForLoggedHourQueryVariables>(GetAllRelatedDataForLoggedHourDocument, options);
        }
export type GetAllRelatedDataForLoggedHourQueryHookResult = ReturnType<typeof useGetAllRelatedDataForLoggedHourQuery>;
export type GetAllRelatedDataForLoggedHourLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForLoggedHourLazyQuery>;
export type GetAllRelatedDataForLoggedHourSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForLoggedHourSuspenseQuery>;
export type GetAllRelatedDataForLoggedHourQueryResult = Apollo.QueryResult<GetAllRelatedDataForLoggedHourQuery, GetAllRelatedDataForLoggedHourQueryVariables>;
export const CreateLoggedHourDocument = gql`
    mutation CreateLoggedHour($description: String!, $startDatetime: DateTime!, $endDatetime: DateTime!, $break: Int!, $declarableTime: Int, $addendum: Boolean, $declarable: Boolean, $status: Boolean, $createdAt: DateTime, $updatedAt: DateTime, $categoryId: ID!, $projectId: ID!, $userId: ID!, $approvedById: ID, $tenantId: ID, $withCategory: Boolean = false, $withProject: Boolean = false, $withUser: Boolean = false, $withApprovedBy: Boolean = false, $withTenant: Boolean = false) {
  createLoggedHour(
    description: $description
    startDatetime: $startDatetime
    endDatetime: $endDatetime
    break: $break
    declarableTime: $declarableTime
    addendum: $addendum
    declarable: $declarable
    status: $status
    createdAt: $createdAt
    updatedAt: $updatedAt
    categoryId: $categoryId
    projectId: $projectId
    userId: $userId
    approvedById: $approvedById
    tenantId: $tenantId
  ) {
    ...loggedHourFields
  }
}
    ${LoggedHourFieldsFragmentDoc}`;
export type CreateLoggedHourMutationFn = Apollo.MutationFunction<CreateLoggedHourMutation, CreateLoggedHourMutationVariables>;

/**
 * __useCreateLoggedHourMutation__
 *
 * To run a mutation, you first call `useCreateLoggedHourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoggedHourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoggedHourMutation, { data, loading, error }] = useCreateLoggedHourMutation({
 *   variables: {
 *      description: // value for 'description'
 *      startDatetime: // value for 'startDatetime'
 *      endDatetime: // value for 'endDatetime'
 *      break: // value for 'break'
 *      declarableTime: // value for 'declarableTime'
 *      addendum: // value for 'addendum'
 *      declarable: // value for 'declarable'
 *      status: // value for 'status'
 *      createdAt: // value for 'createdAt'
 *      updatedAt: // value for 'updatedAt'
 *      categoryId: // value for 'categoryId'
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      approvedById: // value for 'approvedById'
 *      tenantId: // value for 'tenantId'
 *      withCategory: // value for 'withCategory'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *      withApprovedBy: // value for 'withApprovedBy'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreateLoggedHourMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoggedHourMutation, CreateLoggedHourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoggedHourMutation, CreateLoggedHourMutationVariables>(CreateLoggedHourDocument, options);
      }
export type CreateLoggedHourMutationHookResult = ReturnType<typeof useCreateLoggedHourMutation>;
export type CreateLoggedHourMutationResult = Apollo.MutationResult<CreateLoggedHourMutation>;
export type CreateLoggedHourMutationOptions = Apollo.BaseMutationOptions<CreateLoggedHourMutation, CreateLoggedHourMutationVariables>;
export const UpdateLoggedHourDocument = gql`
    mutation UpdateLoggedHour($id: ID!, $description: String, $startDatetime: DateTime, $endDatetime: DateTime, $break: Int, $declarableTime: Int, $addendum: Boolean, $declarable: Boolean, $status: Boolean, $createdAt: DateTime, $updatedAt: DateTime, $categoryId: ID, $projectId: ID, $userId: ID, $approvedById: ID, $tenantId: ID, $withCategory: Boolean = false, $withProject: Boolean = false, $withUser: Boolean = false, $withApprovedBy: Boolean = false, $withTenant: Boolean = false) {
  updateLoggedHour(
    id: $id
    description: $description
    startDatetime: $startDatetime
    endDatetime: $endDatetime
    break: $break
    declarableTime: $declarableTime
    addendum: $addendum
    declarable: $declarable
    status: $status
    createdAt: $createdAt
    updatedAt: $updatedAt
    categoryId: $categoryId
    projectId: $projectId
    userId: $userId
    approvedById: $approvedById
    tenantId: $tenantId
  ) {
    ...loggedHourFields
  }
}
    ${LoggedHourFieldsFragmentDoc}`;
export type UpdateLoggedHourMutationFn = Apollo.MutationFunction<UpdateLoggedHourMutation, UpdateLoggedHourMutationVariables>;

/**
 * __useUpdateLoggedHourMutation__
 *
 * To run a mutation, you first call `useUpdateLoggedHourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoggedHourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoggedHourMutation, { data, loading, error }] = useUpdateLoggedHourMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      startDatetime: // value for 'startDatetime'
 *      endDatetime: // value for 'endDatetime'
 *      break: // value for 'break'
 *      declarableTime: // value for 'declarableTime'
 *      addendum: // value for 'addendum'
 *      declarable: // value for 'declarable'
 *      status: // value for 'status'
 *      createdAt: // value for 'createdAt'
 *      updatedAt: // value for 'updatedAt'
 *      categoryId: // value for 'categoryId'
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      approvedById: // value for 'approvedById'
 *      tenantId: // value for 'tenantId'
 *      withCategory: // value for 'withCategory'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *      withApprovedBy: // value for 'withApprovedBy'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdateLoggedHourMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoggedHourMutation, UpdateLoggedHourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoggedHourMutation, UpdateLoggedHourMutationVariables>(UpdateLoggedHourDocument, options);
      }
export type UpdateLoggedHourMutationHookResult = ReturnType<typeof useUpdateLoggedHourMutation>;
export type UpdateLoggedHourMutationResult = Apollo.MutationResult<UpdateLoggedHourMutation>;
export type UpdateLoggedHourMutationOptions = Apollo.BaseMutationOptions<UpdateLoggedHourMutation, UpdateLoggedHourMutationVariables>;
export const DeleteLoggedHourDocument = gql`
    mutation DeleteLoggedHour($id: ID!, $withCategory: Boolean = false, $withProject: Boolean = false, $withUser: Boolean = false, $withApprovedBy: Boolean = false, $withTenant: Boolean = false) {
  deleteLoggedHour(id: $id) {
    ...loggedHourFields
  }
}
    ${LoggedHourFieldsFragmentDoc}`;
export type DeleteLoggedHourMutationFn = Apollo.MutationFunction<DeleteLoggedHourMutation, DeleteLoggedHourMutationVariables>;

/**
 * __useDeleteLoggedHourMutation__
 *
 * To run a mutation, you first call `useDeleteLoggedHourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoggedHourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoggedHourMutation, { data, loading, error }] = useDeleteLoggedHourMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withCategory: // value for 'withCategory'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *      withApprovedBy: // value for 'withApprovedBy'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useDeleteLoggedHourMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLoggedHourMutation, DeleteLoggedHourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLoggedHourMutation, DeleteLoggedHourMutationVariables>(DeleteLoggedHourDocument, options);
      }
export type DeleteLoggedHourMutationHookResult = ReturnType<typeof useDeleteLoggedHourMutation>;
export type DeleteLoggedHourMutationResult = Apollo.MutationResult<DeleteLoggedHourMutation>;
export type DeleteLoggedHourMutationOptions = Apollo.BaseMutationOptions<DeleteLoggedHourMutation, DeleteLoggedHourMutationVariables>;
export const CreatedLoggedHourDocument = gql`
    subscription CreatedLoggedHour($filter: LoggedHourFilterArgs, $withCategory: Boolean = false, $withProject: Boolean = false, $withUser: Boolean = false, $withApprovedBy: Boolean = false, $withTenant: Boolean = false) {
  createdLoggedHour(filter: $filter) {
    ...loggedHourFields
  }
}
    ${LoggedHourFieldsFragmentDoc}`;

/**
 * __useCreatedLoggedHourSubscription__
 *
 * To run a query within a React component, call `useCreatedLoggedHourSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedLoggedHourSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedLoggedHourSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withCategory: // value for 'withCategory'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *      withApprovedBy: // value for 'withApprovedBy'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreatedLoggedHourSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedLoggedHourSubscription, CreatedLoggedHourSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedLoggedHourSubscription, CreatedLoggedHourSubscriptionVariables>(CreatedLoggedHourDocument, options);
      }
export type CreatedLoggedHourSubscriptionHookResult = ReturnType<typeof useCreatedLoggedHourSubscription>;
export type CreatedLoggedHourSubscriptionResult = Apollo.SubscriptionResult<CreatedLoggedHourSubscription>;
export const UpdatedLoggedHourDocument = gql`
    subscription UpdatedLoggedHour($filter: LoggedHourFilterArgs, $withCategory: Boolean = false, $withProject: Boolean = false, $withUser: Boolean = false, $withApprovedBy: Boolean = false, $withTenant: Boolean = false) {
  updatedLoggedHour(filter: $filter) {
    ...loggedHourFields
  }
}
    ${LoggedHourFieldsFragmentDoc}`;

/**
 * __useUpdatedLoggedHourSubscription__
 *
 * To run a query within a React component, call `useUpdatedLoggedHourSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedLoggedHourSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedLoggedHourSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withCategory: // value for 'withCategory'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *      withApprovedBy: // value for 'withApprovedBy'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdatedLoggedHourSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedLoggedHourSubscription, UpdatedLoggedHourSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedLoggedHourSubscription, UpdatedLoggedHourSubscriptionVariables>(UpdatedLoggedHourDocument, options);
      }
export type UpdatedLoggedHourSubscriptionHookResult = ReturnType<typeof useUpdatedLoggedHourSubscription>;
export type UpdatedLoggedHourSubscriptionResult = Apollo.SubscriptionResult<UpdatedLoggedHourSubscription>;
export const DeletedLoggedHourDocument = gql`
    subscription DeletedLoggedHour($filter: LoggedHourFilterArgs) {
  deletedLoggedHour(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedLoggedHourSubscription__
 *
 * To run a query within a React component, call `useDeletedLoggedHourSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedLoggedHourSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedLoggedHourSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedLoggedHourSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedLoggedHourSubscription, DeletedLoggedHourSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedLoggedHourSubscription, DeletedLoggedHourSubscriptionVariables>(DeletedLoggedHourDocument, options);
      }
export type DeletedLoggedHourSubscriptionHookResult = ReturnType<typeof useDeletedLoggedHourSubscription>;
export type DeletedLoggedHourSubscriptionResult = Apollo.SubscriptionResult<DeletedLoggedHourSubscription>;
export const RestoredLoggedHourDocument = gql`
    subscription RestoredLoggedHour($filter: LoggedHourFilterArgs, $withCategory: Boolean = false, $withProject: Boolean = false, $withUser: Boolean = false, $withApprovedBy: Boolean = false, $withTenant: Boolean = false) {
  restoredLoggedHour(filter: $filter) {
    ...loggedHourFields
  }
}
    ${LoggedHourFieldsFragmentDoc}`;

/**
 * __useRestoredLoggedHourSubscription__
 *
 * To run a query within a React component, call `useRestoredLoggedHourSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredLoggedHourSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredLoggedHourSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withCategory: // value for 'withCategory'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *      withApprovedBy: // value for 'withApprovedBy'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useRestoredLoggedHourSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredLoggedHourSubscription, RestoredLoggedHourSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredLoggedHourSubscription, RestoredLoggedHourSubscriptionVariables>(RestoredLoggedHourDocument, options);
      }
export type RestoredLoggedHourSubscriptionHookResult = ReturnType<typeof useRestoredLoggedHourSubscription>;
export type RestoredLoggedHourSubscriptionResult = Apollo.SubscriptionResult<RestoredLoggedHourSubscription>;
export const GetMailLogsDocument = gql`
    query GetMailLogs($filter: MailLogFilterArgs, $paging: PageArgs, $sorting: [MailLogSortArgs!]) {
  mailLogs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailLogFields
    }
    totalCount
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useGetMailLogsQuery__
 *
 * To run a query within a React component, call `useGetMailLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetMailLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetMailLogsQuery, GetMailLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLogsQuery, GetMailLogsQueryVariables>(GetMailLogsDocument, options);
      }
export function useGetMailLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLogsQuery, GetMailLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLogsQuery, GetMailLogsQueryVariables>(GetMailLogsDocument, options);
        }
export function useGetMailLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLogsQuery, GetMailLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLogsQuery, GetMailLogsQueryVariables>(GetMailLogsDocument, options);
        }
export type GetMailLogsQueryHookResult = ReturnType<typeof useGetMailLogsQuery>;
export type GetMailLogsLazyQueryHookResult = ReturnType<typeof useGetMailLogsLazyQuery>;
export type GetMailLogsSuspenseQueryHookResult = ReturnType<typeof useGetMailLogsSuspenseQuery>;
export type GetMailLogsQueryResult = Apollo.QueryResult<GetMailLogsQuery, GetMailLogsQueryVariables>;
export const GetMailLogDocument = gql`
    query GetMailLog($id: ID!) {
  mailLog(id: $id) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useGetMailLogQuery__
 *
 * To run a query within a React component, call `useGetMailLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMailLogQuery(baseOptions: Apollo.QueryHookOptions<GetMailLogQuery, GetMailLogQueryVariables> & ({ variables: GetMailLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLogQuery, GetMailLogQueryVariables>(GetMailLogDocument, options);
      }
export function useGetMailLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLogQuery, GetMailLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLogQuery, GetMailLogQueryVariables>(GetMailLogDocument, options);
        }
export function useGetMailLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLogQuery, GetMailLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLogQuery, GetMailLogQueryVariables>(GetMailLogDocument, options);
        }
export type GetMailLogQueryHookResult = ReturnType<typeof useGetMailLogQuery>;
export type GetMailLogLazyQueryHookResult = ReturnType<typeof useGetMailLogLazyQuery>;
export type GetMailLogSuspenseQueryHookResult = ReturnType<typeof useGetMailLogSuspenseQuery>;
export type GetMailLogQueryResult = Apollo.QueryResult<GetMailLogQuery, GetMailLogQueryVariables>;
export const CreateMailLogDocument = gql`
    mutation CreateMailLog($sentTo: String!, $sentBy: String!, $emailTemplate: String, $status: String, $message: String, $reason: String) {
  createMailLog(
    sentTo: $sentTo
    sentBy: $sentBy
    emailTemplate: $emailTemplate
    status: $status
    message: $message
    reason: $reason
  ) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;
export type CreateMailLogMutationFn = Apollo.MutationFunction<CreateMailLogMutation, CreateMailLogMutationVariables>;

/**
 * __useCreateMailLogMutation__
 *
 * To run a mutation, you first call `useCreateMailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailLogMutation, { data, loading, error }] = useCreateMailLogMutation({
 *   variables: {
 *      sentTo: // value for 'sentTo'
 *      sentBy: // value for 'sentBy'
 *      emailTemplate: // value for 'emailTemplate'
 *      status: // value for 'status'
 *      message: // value for 'message'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateMailLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailLogMutation, CreateMailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailLogMutation, CreateMailLogMutationVariables>(CreateMailLogDocument, options);
      }
export type CreateMailLogMutationHookResult = ReturnType<typeof useCreateMailLogMutation>;
export type CreateMailLogMutationResult = Apollo.MutationResult<CreateMailLogMutation>;
export type CreateMailLogMutationOptions = Apollo.BaseMutationOptions<CreateMailLogMutation, CreateMailLogMutationVariables>;
export const UpdateMailLogDocument = gql`
    mutation UpdateMailLog($id: ID!, $sentTo: String, $sentBy: String, $emailTemplate: String, $status: String, $message: String, $reason: String) {
  updateMailLog(
    id: $id
    sentTo: $sentTo
    sentBy: $sentBy
    emailTemplate: $emailTemplate
    status: $status
    message: $message
    reason: $reason
  ) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;
export type UpdateMailLogMutationFn = Apollo.MutationFunction<UpdateMailLogMutation, UpdateMailLogMutationVariables>;

/**
 * __useUpdateMailLogMutation__
 *
 * To run a mutation, you first call `useUpdateMailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailLogMutation, { data, loading, error }] = useUpdateMailLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sentTo: // value for 'sentTo'
 *      sentBy: // value for 'sentBy'
 *      emailTemplate: // value for 'emailTemplate'
 *      status: // value for 'status'
 *      message: // value for 'message'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateMailLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailLogMutation, UpdateMailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailLogMutation, UpdateMailLogMutationVariables>(UpdateMailLogDocument, options);
      }
export type UpdateMailLogMutationHookResult = ReturnType<typeof useUpdateMailLogMutation>;
export type UpdateMailLogMutationResult = Apollo.MutationResult<UpdateMailLogMutation>;
export type UpdateMailLogMutationOptions = Apollo.BaseMutationOptions<UpdateMailLogMutation, UpdateMailLogMutationVariables>;
export const DeleteMailLogDocument = gql`
    mutation DeleteMailLog($id: ID!) {
  deleteMailLog(id: $id) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;
export type DeleteMailLogMutationFn = Apollo.MutationFunction<DeleteMailLogMutation, DeleteMailLogMutationVariables>;

/**
 * __useDeleteMailLogMutation__
 *
 * To run a mutation, you first call `useDeleteMailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailLogMutation, { data, loading, error }] = useDeleteMailLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMailLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailLogMutation, DeleteMailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailLogMutation, DeleteMailLogMutationVariables>(DeleteMailLogDocument, options);
      }
export type DeleteMailLogMutationHookResult = ReturnType<typeof useDeleteMailLogMutation>;
export type DeleteMailLogMutationResult = Apollo.MutationResult<DeleteMailLogMutation>;
export type DeleteMailLogMutationOptions = Apollo.BaseMutationOptions<DeleteMailLogMutation, DeleteMailLogMutationVariables>;
export const CreatedMailLogDocument = gql`
    subscription CreatedMailLog($filter: MailLogFilterArgs) {
  createdMailLog(filter: $filter) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useCreatedMailLogSubscription__
 *
 * To run a query within a React component, call `useCreatedMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailLogSubscription, CreatedMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailLogSubscription, CreatedMailLogSubscriptionVariables>(CreatedMailLogDocument, options);
      }
export type CreatedMailLogSubscriptionHookResult = ReturnType<typeof useCreatedMailLogSubscription>;
export type CreatedMailLogSubscriptionResult = Apollo.SubscriptionResult<CreatedMailLogSubscription>;
export const UpdatedMailLogDocument = gql`
    subscription UpdatedMailLog($filter: MailLogFilterArgs) {
  updatedMailLog(filter: $filter) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useUpdatedMailLogSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailLogSubscription, UpdatedMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailLogSubscription, UpdatedMailLogSubscriptionVariables>(UpdatedMailLogDocument, options);
      }
export type UpdatedMailLogSubscriptionHookResult = ReturnType<typeof useUpdatedMailLogSubscription>;
export type UpdatedMailLogSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailLogSubscription>;
export const DeletedMailLogDocument = gql`
    subscription DeletedMailLog($filter: MailLogFilterArgs) {
  deletedMailLog(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailLogSubscription__
 *
 * To run a query within a React component, call `useDeletedMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailLogSubscription, DeletedMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailLogSubscription, DeletedMailLogSubscriptionVariables>(DeletedMailLogDocument, options);
      }
export type DeletedMailLogSubscriptionHookResult = ReturnType<typeof useDeletedMailLogSubscription>;
export type DeletedMailLogSubscriptionResult = Apollo.SubscriptionResult<DeletedMailLogSubscription>;
export const RestoredMailLogDocument = gql`
    subscription RestoredMailLog($filter: MailLogFilterArgs) {
  restoredMailLog(filter: $filter) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useRestoredMailLogSubscription__
 *
 * To run a query within a React component, call `useRestoredMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredMailLogSubscription, RestoredMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredMailLogSubscription, RestoredMailLogSubscriptionVariables>(RestoredMailLogDocument, options);
      }
export type RestoredMailLogSubscriptionHookResult = ReturnType<typeof useRestoredMailLogSubscription>;
export type RestoredMailLogSubscriptionResult = Apollo.SubscriptionResult<RestoredMailLogSubscription>;
export const GetMailTemplatesDocument = gql`
    query GetMailTemplates($filter: MailTemplateFilterArgs, $paging: PageArgs, $sorting: [MailTemplateSortArgs!], $withMailTemplateFills: Boolean = false) {
  mailTemplates(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailTemplateFields
    }
    totalCount
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useGetMailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *   },
 * });
 */
export function useGetMailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, options);
      }
export function useGetMailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, options);
        }
export function useGetMailTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, options);
        }
export type GetMailTemplatesQueryHookResult = ReturnType<typeof useGetMailTemplatesQuery>;
export type GetMailTemplatesLazyQueryHookResult = ReturnType<typeof useGetMailTemplatesLazyQuery>;
export type GetMailTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplatesSuspenseQuery>;
export type GetMailTemplatesQueryResult = Apollo.QueryResult<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>;
export const GetMailTemplateDocument = gql`
    query GetMailTemplate($id: ID!, $withMailTemplateFills: Boolean = false) {
  mailTemplate(id: $id) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *   },
 * });
 */
export function useGetMailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetMailTemplateQuery, GetMailTemplateQueryVariables> & ({ variables: GetMailTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateQuery, GetMailTemplateQueryVariables>(GetMailTemplateDocument, options);
      }
export function useGetMailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateQuery, GetMailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateQuery, GetMailTemplateQueryVariables>(GetMailTemplateDocument, options);
        }
export function useGetMailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateQuery, GetMailTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateQuery, GetMailTemplateQueryVariables>(GetMailTemplateDocument, options);
        }
export type GetMailTemplateQueryHookResult = ReturnType<typeof useGetMailTemplateQuery>;
export type GetMailTemplateLazyQueryHookResult = ReturnType<typeof useGetMailTemplateLazyQuery>;
export type GetMailTemplateSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateSuspenseQuery>;
export type GetMailTemplateQueryResult = Apollo.QueryResult<GetMailTemplateQuery, GetMailTemplateQueryVariables>;
export const GetAllRelatedDataForMailTemplateDocument = gql`
    query GetAllRelatedDataForMailTemplate($withMailTemplateFills: Boolean = false) {
  mailTemplateFills @include(if: $withMailTemplateFills) {
    items {
      id
      displayField: title
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMailTemplateQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMailTemplateQuery({
 *   variables: {
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *   },
 * });
 */
export function useGetAllRelatedDataForMailTemplateQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>(GetAllRelatedDataForMailTemplateDocument, options);
      }
export function useGetAllRelatedDataForMailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>(GetAllRelatedDataForMailTemplateDocument, options);
        }
export function useGetAllRelatedDataForMailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>(GetAllRelatedDataForMailTemplateDocument, options);
        }
export type GetAllRelatedDataForMailTemplateQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateQuery>;
export type GetAllRelatedDataForMailTemplateLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateLazyQuery>;
export type GetAllRelatedDataForMailTemplateSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateSuspenseQuery>;
export type GetAllRelatedDataForMailTemplateQueryResult = Apollo.QueryResult<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>;
export const CreateMailTemplateDocument = gql`
    mutation CreateMailTemplate($active: Boolean!, $mailTemplateFills: [ID], $withMailTemplateFills: Boolean = false) {
  createMailTemplate(active: $active, mailTemplateFillIds: $mailTemplateFills) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;
export type CreateMailTemplateMutationFn = Apollo.MutationFunction<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>;

/**
 * __useCreateMailTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailTemplateMutation, { data, loading, error }] = useCreateMailTemplateMutation({
 *   variables: {
 *      active: // value for 'active'
 *      mailTemplateFills: // value for 'mailTemplateFills'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *   },
 * });
 */
export function useCreateMailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>(CreateMailTemplateDocument, options);
      }
export type CreateMailTemplateMutationHookResult = ReturnType<typeof useCreateMailTemplateMutation>;
export type CreateMailTemplateMutationResult = Apollo.MutationResult<CreateMailTemplateMutation>;
export type CreateMailTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>;
export const UpdateMailTemplateDocument = gql`
    mutation UpdateMailTemplate($id: ID!, $active: Boolean, $mailTemplateFills: [ID], $withMailTemplateFills: Boolean = false) {
  updateMailTemplate(
    id: $id
    active: $active
    mailTemplateFillIds: $mailTemplateFills
  ) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;
export type UpdateMailTemplateMutationFn = Apollo.MutationFunction<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>;

/**
 * __useUpdateMailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailTemplateMutation, { data, loading, error }] = useUpdateMailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *      mailTemplateFills: // value for 'mailTemplateFills'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *   },
 * });
 */
export function useUpdateMailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>(UpdateMailTemplateDocument, options);
      }
export type UpdateMailTemplateMutationHookResult = ReturnType<typeof useUpdateMailTemplateMutation>;
export type UpdateMailTemplateMutationResult = Apollo.MutationResult<UpdateMailTemplateMutation>;
export type UpdateMailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>;
export const DeleteMailTemplateDocument = gql`
    mutation DeleteMailTemplate($id: ID!, $withMailTemplateFills: Boolean = false) {
  deleteMailTemplate(id: $id) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;
export type DeleteMailTemplateMutationFn = Apollo.MutationFunction<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>;

/**
 * __useDeleteMailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteMailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailTemplateMutation, { data, loading, error }] = useDeleteMailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *   },
 * });
 */
export function useDeleteMailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>(DeleteMailTemplateDocument, options);
      }
export type DeleteMailTemplateMutationHookResult = ReturnType<typeof useDeleteMailTemplateMutation>;
export type DeleteMailTemplateMutationResult = Apollo.MutationResult<DeleteMailTemplateMutation>;
export type DeleteMailTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>;
export const CreatedMailTemplateDocument = gql`
    subscription CreatedMailTemplate($filter: MailTemplateFilterArgs, $withMailTemplateFills: Boolean = false) {
  createdMailTemplate(filter: $filter) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useCreatedMailTemplateSubscription__
 *
 * To run a query within a React component, call `useCreatedMailTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailTemplateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailTemplateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *   },
 * });
 */
export function useCreatedMailTemplateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailTemplateSubscription, CreatedMailTemplateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailTemplateSubscription, CreatedMailTemplateSubscriptionVariables>(CreatedMailTemplateDocument, options);
      }
export type CreatedMailTemplateSubscriptionHookResult = ReturnType<typeof useCreatedMailTemplateSubscription>;
export type CreatedMailTemplateSubscriptionResult = Apollo.SubscriptionResult<CreatedMailTemplateSubscription>;
export const UpdatedMailTemplateDocument = gql`
    subscription UpdatedMailTemplate($filter: MailTemplateFilterArgs, $withMailTemplateFills: Boolean = false) {
  updatedMailTemplate(filter: $filter) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useUpdatedMailTemplateSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailTemplateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailTemplateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *   },
 * });
 */
export function useUpdatedMailTemplateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailTemplateSubscription, UpdatedMailTemplateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailTemplateSubscription, UpdatedMailTemplateSubscriptionVariables>(UpdatedMailTemplateDocument, options);
      }
export type UpdatedMailTemplateSubscriptionHookResult = ReturnType<typeof useUpdatedMailTemplateSubscription>;
export type UpdatedMailTemplateSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailTemplateSubscription>;
export const DeletedMailTemplateDocument = gql`
    subscription DeletedMailTemplate($filter: MailTemplateFilterArgs) {
  deletedMailTemplate(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailTemplateSubscription__
 *
 * To run a query within a React component, call `useDeletedMailTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailTemplateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailTemplateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailTemplateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailTemplateSubscription, DeletedMailTemplateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailTemplateSubscription, DeletedMailTemplateSubscriptionVariables>(DeletedMailTemplateDocument, options);
      }
export type DeletedMailTemplateSubscriptionHookResult = ReturnType<typeof useDeletedMailTemplateSubscription>;
export type DeletedMailTemplateSubscriptionResult = Apollo.SubscriptionResult<DeletedMailTemplateSubscription>;
export const GetMailTemplateFillsDocument = gql`
    query GetMailTemplateFills($filter: MailTemplateFillFilterArgs, $paging: PageArgs, $sorting: [MailTemplateFillSortArgs!], $withMailTemplate: Boolean = false) {
  mailTemplateFills(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailTemplateFillFields
    }
    totalCount
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateFillsQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateFillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateFillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateFillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetMailTemplateFillsQuery(baseOptions?: Apollo.QueryHookOptions<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>(GetMailTemplateFillsDocument, options);
      }
export function useGetMailTemplateFillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>(GetMailTemplateFillsDocument, options);
        }
export function useGetMailTemplateFillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>(GetMailTemplateFillsDocument, options);
        }
export type GetMailTemplateFillsQueryHookResult = ReturnType<typeof useGetMailTemplateFillsQuery>;
export type GetMailTemplateFillsLazyQueryHookResult = ReturnType<typeof useGetMailTemplateFillsLazyQuery>;
export type GetMailTemplateFillsSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateFillsSuspenseQuery>;
export type GetMailTemplateFillsQueryResult = Apollo.QueryResult<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>;
export const GetMailTemplateFillDocument = gql`
    query GetMailTemplateFill($id: ID!, $withMailTemplate: Boolean = false) {
  mailTemplateFill(id: $id) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateFillQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateFillQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetMailTemplateFillQuery(baseOptions: Apollo.QueryHookOptions<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables> & ({ variables: GetMailTemplateFillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>(GetMailTemplateFillDocument, options);
      }
export function useGetMailTemplateFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>(GetMailTemplateFillDocument, options);
        }
export function useGetMailTemplateFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>(GetMailTemplateFillDocument, options);
        }
export type GetMailTemplateFillQueryHookResult = ReturnType<typeof useGetMailTemplateFillQuery>;
export type GetMailTemplateFillLazyQueryHookResult = ReturnType<typeof useGetMailTemplateFillLazyQuery>;
export type GetMailTemplateFillSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateFillSuspenseQuery>;
export type GetMailTemplateFillQueryResult = Apollo.QueryResult<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>;
export const GetAllRelatedDataForMailTemplateFillDocument = gql`
    query GetAllRelatedDataForMailTemplateFill($withMailTemplates: Boolean = false) {
  mailTemplates @include(if: $withMailTemplates) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMailTemplateFillQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMailTemplateFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMailTemplateFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMailTemplateFillQuery({
 *   variables: {
 *      withMailTemplates: // value for 'withMailTemplates'
 *   },
 * });
 */
export function useGetAllRelatedDataForMailTemplateFillQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>(GetAllRelatedDataForMailTemplateFillDocument, options);
      }
export function useGetAllRelatedDataForMailTemplateFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>(GetAllRelatedDataForMailTemplateFillDocument, options);
        }
export function useGetAllRelatedDataForMailTemplateFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>(GetAllRelatedDataForMailTemplateFillDocument, options);
        }
export type GetAllRelatedDataForMailTemplateFillQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFillQuery>;
export type GetAllRelatedDataForMailTemplateFillLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFillLazyQuery>;
export type GetAllRelatedDataForMailTemplateFillSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFillSuspenseQuery>;
export type GetAllRelatedDataForMailTemplateFillQueryResult = Apollo.QueryResult<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>;
export const CreateMailTemplateFillDocument = gql`
    mutation CreateMailTemplateFill($subject: String!, $urlText: String, $title: String, $heading: String, $preHeader: String, $disclaimer: String, $text: String!, $plainText: String!, $language: String!, $mailTemplateId: ID!, $withMailTemplate: Boolean = false) {
  createMailTemplateFill(
    subject: $subject
    urlText: $urlText
    title: $title
    heading: $heading
    preHeader: $preHeader
    disclaimer: $disclaimer
    text: $text
    plainText: $plainText
    language: $language
    mailTemplateId: $mailTemplateId
  ) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;
export type CreateMailTemplateFillMutationFn = Apollo.MutationFunction<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>;

/**
 * __useCreateMailTemplateFillMutation__
 *
 * To run a mutation, you first call `useCreateMailTemplateFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailTemplateFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailTemplateFillMutation, { data, loading, error }] = useCreateMailTemplateFillMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      urlText: // value for 'urlText'
 *      title: // value for 'title'
 *      heading: // value for 'heading'
 *      preHeader: // value for 'preHeader'
 *      disclaimer: // value for 'disclaimer'
 *      text: // value for 'text'
 *      plainText: // value for 'plainText'
 *      language: // value for 'language'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreateMailTemplateFillMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>(CreateMailTemplateFillDocument, options);
      }
export type CreateMailTemplateFillMutationHookResult = ReturnType<typeof useCreateMailTemplateFillMutation>;
export type CreateMailTemplateFillMutationResult = Apollo.MutationResult<CreateMailTemplateFillMutation>;
export type CreateMailTemplateFillMutationOptions = Apollo.BaseMutationOptions<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>;
export const UpdateMailTemplateFillDocument = gql`
    mutation UpdateMailTemplateFill($id: ID!, $subject: String, $urlText: String, $title: String, $heading: String, $preHeader: String, $disclaimer: String, $text: String, $plainText: String, $language: String, $mailTemplateId: ID, $withMailTemplate: Boolean = false) {
  updateMailTemplateFill(
    id: $id
    subject: $subject
    urlText: $urlText
    title: $title
    heading: $heading
    preHeader: $preHeader
    disclaimer: $disclaimer
    text: $text
    plainText: $plainText
    language: $language
    mailTemplateId: $mailTemplateId
  ) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;
export type UpdateMailTemplateFillMutationFn = Apollo.MutationFunction<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>;

/**
 * __useUpdateMailTemplateFillMutation__
 *
 * To run a mutation, you first call `useUpdateMailTemplateFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailTemplateFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailTemplateFillMutation, { data, loading, error }] = useUpdateMailTemplateFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      subject: // value for 'subject'
 *      urlText: // value for 'urlText'
 *      title: // value for 'title'
 *      heading: // value for 'heading'
 *      preHeader: // value for 'preHeader'
 *      disclaimer: // value for 'disclaimer'
 *      text: // value for 'text'
 *      plainText: // value for 'plainText'
 *      language: // value for 'language'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdateMailTemplateFillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>(UpdateMailTemplateFillDocument, options);
      }
export type UpdateMailTemplateFillMutationHookResult = ReturnType<typeof useUpdateMailTemplateFillMutation>;
export type UpdateMailTemplateFillMutationResult = Apollo.MutationResult<UpdateMailTemplateFillMutation>;
export type UpdateMailTemplateFillMutationOptions = Apollo.BaseMutationOptions<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>;
export const DeleteMailTemplateFillDocument = gql`
    mutation DeleteMailTemplateFill($id: ID!, $withMailTemplate: Boolean = false) {
  deleteMailTemplateFill(id: $id) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;
export type DeleteMailTemplateFillMutationFn = Apollo.MutationFunction<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>;

/**
 * __useDeleteMailTemplateFillMutation__
 *
 * To run a mutation, you first call `useDeleteMailTemplateFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailTemplateFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailTemplateFillMutation, { data, loading, error }] = useDeleteMailTemplateFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useDeleteMailTemplateFillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>(DeleteMailTemplateFillDocument, options);
      }
export type DeleteMailTemplateFillMutationHookResult = ReturnType<typeof useDeleteMailTemplateFillMutation>;
export type DeleteMailTemplateFillMutationResult = Apollo.MutationResult<DeleteMailTemplateFillMutation>;
export type DeleteMailTemplateFillMutationOptions = Apollo.BaseMutationOptions<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>;
export const CreatedMailTemplateFillDocument = gql`
    subscription CreatedMailTemplateFill($filter: MailTemplateFillFilterArgs, $withMailTemplate: Boolean = false) {
  createdMailTemplateFill(filter: $filter) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useCreatedMailTemplateFillSubscription__
 *
 * To run a query within a React component, call `useCreatedMailTemplateFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailTemplateFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailTemplateFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreatedMailTemplateFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailTemplateFillSubscription, CreatedMailTemplateFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailTemplateFillSubscription, CreatedMailTemplateFillSubscriptionVariables>(CreatedMailTemplateFillDocument, options);
      }
export type CreatedMailTemplateFillSubscriptionHookResult = ReturnType<typeof useCreatedMailTemplateFillSubscription>;
export type CreatedMailTemplateFillSubscriptionResult = Apollo.SubscriptionResult<CreatedMailTemplateFillSubscription>;
export const UpdatedMailTemplateFillDocument = gql`
    subscription UpdatedMailTemplateFill($filter: MailTemplateFillFilterArgs, $withMailTemplate: Boolean = false) {
  updatedMailTemplateFill(filter: $filter) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useUpdatedMailTemplateFillSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailTemplateFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailTemplateFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailTemplateFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdatedMailTemplateFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailTemplateFillSubscription, UpdatedMailTemplateFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailTemplateFillSubscription, UpdatedMailTemplateFillSubscriptionVariables>(UpdatedMailTemplateFillDocument, options);
      }
export type UpdatedMailTemplateFillSubscriptionHookResult = ReturnType<typeof useUpdatedMailTemplateFillSubscription>;
export type UpdatedMailTemplateFillSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailTemplateFillSubscription>;
export const DeletedMailTemplateFillDocument = gql`
    subscription DeletedMailTemplateFill($filter: MailTemplateFillFilterArgs) {
  deletedMailTemplateFill(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailTemplateFillSubscription__
 *
 * To run a query within a React component, call `useDeletedMailTemplateFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailTemplateFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailTemplateFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailTemplateFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailTemplateFillSubscription, DeletedMailTemplateFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailTemplateFillSubscription, DeletedMailTemplateFillSubscriptionVariables>(DeletedMailTemplateFillDocument, options);
      }
export type DeletedMailTemplateFillSubscriptionHookResult = ReturnType<typeof useDeletedMailTemplateFillSubscription>;
export type DeletedMailTemplateFillSubscriptionResult = Apollo.SubscriptionResult<DeletedMailTemplateFillSubscription>;
export const GetPermissionsDocument = gql`
    query GetPermissions($filter: PermissionFilterArgs, $paging: PageArgs, $sorting: [PermissionSortArgs!], $withRoles: Boolean = false) {
  permissions(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...permissionFields
    }
    totalCount
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
      }
export function useGetPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetPermissionsSuspenseQuery>;
export type GetPermissionsQueryResult = Apollo.QueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export const GetPermissionDocument = gql`
    query GetPermission($id: ID!, $withRoles: Boolean = false) {
  permission(id: $id) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useGetPermissionQuery__
 *
 * To run a query within a React component, call `useGetPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetPermissionQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables> & ({ variables: GetPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
      }
export function useGetPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
        }
export function useGetPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
        }
export type GetPermissionQueryHookResult = ReturnType<typeof useGetPermissionQuery>;
export type GetPermissionLazyQueryHookResult = ReturnType<typeof useGetPermissionLazyQuery>;
export type GetPermissionSuspenseQueryHookResult = ReturnType<typeof useGetPermissionSuspenseQuery>;
export type GetPermissionQueryResult = Apollo.QueryResult<GetPermissionQuery, GetPermissionQueryVariables>;
export const GetAllRelatedDataForPermissionDocument = gql`
    query GetAllRelatedDataForPermission($withRoles: Boolean = false) {
  roles @include(if: $withRoles) {
    items {
      id
      displayField: displayName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForPermissionQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForPermissionQuery({
 *   variables: {
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetAllRelatedDataForPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>(GetAllRelatedDataForPermissionDocument, options);
      }
export function useGetAllRelatedDataForPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>(GetAllRelatedDataForPermissionDocument, options);
        }
export function useGetAllRelatedDataForPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>(GetAllRelatedDataForPermissionDocument, options);
        }
export type GetAllRelatedDataForPermissionQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPermissionQuery>;
export type GetAllRelatedDataForPermissionLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPermissionLazyQuery>;
export type GetAllRelatedDataForPermissionSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPermissionSuspenseQuery>;
export type GetAllRelatedDataForPermissionQueryResult = Apollo.QueryResult<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>;
export const CreatePermissionDocument = gql`
    mutation CreatePermission($name: String!, $description: String!, $roles: [ID], $withRoles: Boolean = false) {
  createPermission(name: $name, description: $description, roleIds: $roles) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type CreatePermissionMutationFn = Apollo.MutationFunction<CreatePermissionMutation, CreatePermissionMutationVariables>;

/**
 * __useCreatePermissionMutation__
 *
 * To run a mutation, you first call `useCreatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionMutation, { data, loading, error }] = useCreatePermissionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      roles: // value for 'roles'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useCreatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionMutation, CreatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionMutation, CreatePermissionMutationVariables>(CreatePermissionDocument, options);
      }
export type CreatePermissionMutationHookResult = ReturnType<typeof useCreatePermissionMutation>;
export type CreatePermissionMutationResult = Apollo.MutationResult<CreatePermissionMutation>;
export type CreatePermissionMutationOptions = Apollo.BaseMutationOptions<CreatePermissionMutation, CreatePermissionMutationVariables>;
export const UpdatePermissionDocument = gql`
    mutation UpdatePermission($id: ID!, $name: String, $description: String, $roles: [ID], $withRoles: Boolean = false) {
  updatePermission(
    id: $id
    name: $name
    description: $description
    roleIds: $roles
  ) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type UpdatePermissionMutationFn = Apollo.MutationFunction<UpdatePermissionMutation, UpdatePermissionMutationVariables>;

/**
 * __useUpdatePermissionMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionMutation, { data, loading, error }] = useUpdatePermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      roles: // value for 'roles'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useUpdatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionMutation, UpdatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionMutation, UpdatePermissionMutationVariables>(UpdatePermissionDocument, options);
      }
export type UpdatePermissionMutationHookResult = ReturnType<typeof useUpdatePermissionMutation>;
export type UpdatePermissionMutationResult = Apollo.MutationResult<UpdatePermissionMutation>;
export type UpdatePermissionMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionMutation, UpdatePermissionMutationVariables>;
export const DeletePermissionDocument = gql`
    mutation DeletePermission($id: ID!, $withRoles: Boolean = false) {
  deletePermission(id: $id) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type DeletePermissionMutationFn = Apollo.MutationFunction<DeletePermissionMutation, DeletePermissionMutationVariables>;

/**
 * __useDeletePermissionMutation__
 *
 * To run a mutation, you first call `useDeletePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermissionMutation, { data, loading, error }] = useDeletePermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useDeletePermissionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePermissionMutation, DeletePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePermissionMutation, DeletePermissionMutationVariables>(DeletePermissionDocument, options);
      }
export type DeletePermissionMutationHookResult = ReturnType<typeof useDeletePermissionMutation>;
export type DeletePermissionMutationResult = Apollo.MutationResult<DeletePermissionMutation>;
export type DeletePermissionMutationOptions = Apollo.BaseMutationOptions<DeletePermissionMutation, DeletePermissionMutationVariables>;
export const CreatedPermissionDocument = gql`
    subscription CreatedPermission($filter: PermissionFilterArgs, $withRoles: Boolean = false) {
  createdPermission(filter: $filter) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useCreatedPermissionSubscription__
 *
 * To run a query within a React component, call `useCreatedPermissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedPermissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedPermissionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useCreatedPermissionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedPermissionSubscription, CreatedPermissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedPermissionSubscription, CreatedPermissionSubscriptionVariables>(CreatedPermissionDocument, options);
      }
export type CreatedPermissionSubscriptionHookResult = ReturnType<typeof useCreatedPermissionSubscription>;
export type CreatedPermissionSubscriptionResult = Apollo.SubscriptionResult<CreatedPermissionSubscription>;
export const UpdatedPermissionDocument = gql`
    subscription UpdatedPermission($filter: PermissionFilterArgs, $withRoles: Boolean = false) {
  updatedPermission(filter: $filter) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useUpdatedPermissionSubscription__
 *
 * To run a query within a React component, call `useUpdatedPermissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedPermissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedPermissionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useUpdatedPermissionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedPermissionSubscription, UpdatedPermissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedPermissionSubscription, UpdatedPermissionSubscriptionVariables>(UpdatedPermissionDocument, options);
      }
export type UpdatedPermissionSubscriptionHookResult = ReturnType<typeof useUpdatedPermissionSubscription>;
export type UpdatedPermissionSubscriptionResult = Apollo.SubscriptionResult<UpdatedPermissionSubscription>;
export const DeletedPermissionDocument = gql`
    subscription DeletedPermission($filter: PermissionFilterArgs) {
  deletedPermission(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedPermissionSubscription__
 *
 * To run a query within a React component, call `useDeletedPermissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedPermissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedPermissionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedPermissionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedPermissionSubscription, DeletedPermissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedPermissionSubscription, DeletedPermissionSubscriptionVariables>(DeletedPermissionDocument, options);
      }
export type DeletedPermissionSubscriptionHookResult = ReturnType<typeof useDeletedPermissionSubscription>;
export type DeletedPermissionSubscriptionResult = Apollo.SubscriptionResult<DeletedPermissionSubscription>;
export const GetPlannedHoursDocument = gql`
    query GetPlannedHours($filter: PlannedHourFilterArgs, $paging: PageArgs, $sorting: [PlannedHourSortArgs!], $withProject: Boolean = false, $withUser: Boolean = false) {
  plannedHours(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...plannedHourFields
    }
    totalCount
  }
}
    ${PlannedHourFieldsFragmentDoc}`;

/**
 * __useGetPlannedHoursQuery__
 *
 * To run a query within a React component, call `useGetPlannedHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannedHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannedHoursQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useGetPlannedHoursQuery(baseOptions?: Apollo.QueryHookOptions<GetPlannedHoursQuery, GetPlannedHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannedHoursQuery, GetPlannedHoursQueryVariables>(GetPlannedHoursDocument, options);
      }
export function useGetPlannedHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannedHoursQuery, GetPlannedHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannedHoursQuery, GetPlannedHoursQueryVariables>(GetPlannedHoursDocument, options);
        }
export function useGetPlannedHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlannedHoursQuery, GetPlannedHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlannedHoursQuery, GetPlannedHoursQueryVariables>(GetPlannedHoursDocument, options);
        }
export type GetPlannedHoursQueryHookResult = ReturnType<typeof useGetPlannedHoursQuery>;
export type GetPlannedHoursLazyQueryHookResult = ReturnType<typeof useGetPlannedHoursLazyQuery>;
export type GetPlannedHoursSuspenseQueryHookResult = ReturnType<typeof useGetPlannedHoursSuspenseQuery>;
export type GetPlannedHoursQueryResult = Apollo.QueryResult<GetPlannedHoursQuery, GetPlannedHoursQueryVariables>;
export const GetPlannedHourDocument = gql`
    query GetPlannedHour($id: ID!, $withProject: Boolean = false, $withUser: Boolean = false) {
  plannedHour(id: $id) {
    ...plannedHourFields
  }
}
    ${PlannedHourFieldsFragmentDoc}`;

/**
 * __useGetPlannedHourQuery__
 *
 * To run a query within a React component, call `useGetPlannedHourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannedHourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannedHourQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useGetPlannedHourQuery(baseOptions: Apollo.QueryHookOptions<GetPlannedHourQuery, GetPlannedHourQueryVariables> & ({ variables: GetPlannedHourQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannedHourQuery, GetPlannedHourQueryVariables>(GetPlannedHourDocument, options);
      }
export function useGetPlannedHourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannedHourQuery, GetPlannedHourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannedHourQuery, GetPlannedHourQueryVariables>(GetPlannedHourDocument, options);
        }
export function useGetPlannedHourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlannedHourQuery, GetPlannedHourQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlannedHourQuery, GetPlannedHourQueryVariables>(GetPlannedHourDocument, options);
        }
export type GetPlannedHourQueryHookResult = ReturnType<typeof useGetPlannedHourQuery>;
export type GetPlannedHourLazyQueryHookResult = ReturnType<typeof useGetPlannedHourLazyQuery>;
export type GetPlannedHourSuspenseQueryHookResult = ReturnType<typeof useGetPlannedHourSuspenseQuery>;
export type GetPlannedHourQueryResult = Apollo.QueryResult<GetPlannedHourQuery, GetPlannedHourQueryVariables>;
export const GetAllRelatedDataForPlannedHourDocument = gql`
    query GetAllRelatedDataForPlannedHour($withProjects: Boolean = false, $withUsers: Boolean = false) {
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
  users @include(if: $withUsers) {
    items {
      id
      displayField: fullName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForPlannedHourQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForPlannedHourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForPlannedHourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForPlannedHourQuery({
 *   variables: {
 *      withProjects: // value for 'withProjects'
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useGetAllRelatedDataForPlannedHourQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForPlannedHourQuery, GetAllRelatedDataForPlannedHourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForPlannedHourQuery, GetAllRelatedDataForPlannedHourQueryVariables>(GetAllRelatedDataForPlannedHourDocument, options);
      }
export function useGetAllRelatedDataForPlannedHourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForPlannedHourQuery, GetAllRelatedDataForPlannedHourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForPlannedHourQuery, GetAllRelatedDataForPlannedHourQueryVariables>(GetAllRelatedDataForPlannedHourDocument, options);
        }
export function useGetAllRelatedDataForPlannedHourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForPlannedHourQuery, GetAllRelatedDataForPlannedHourQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForPlannedHourQuery, GetAllRelatedDataForPlannedHourQueryVariables>(GetAllRelatedDataForPlannedHourDocument, options);
        }
export type GetAllRelatedDataForPlannedHourQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPlannedHourQuery>;
export type GetAllRelatedDataForPlannedHourLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPlannedHourLazyQuery>;
export type GetAllRelatedDataForPlannedHourSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPlannedHourSuspenseQuery>;
export type GetAllRelatedDataForPlannedHourQueryResult = Apollo.QueryResult<GetAllRelatedDataForPlannedHourQuery, GetAllRelatedDataForPlannedHourQueryVariables>;
export const CreatePlannedHourDocument = gql`
    mutation CreatePlannedHour($month: DateTime!, $hours: Float!, $projectId: ID!, $userId: ID!, $withProject: Boolean = false, $withUser: Boolean = false) {
  createPlannedHour(
    month: $month
    hours: $hours
    projectId: $projectId
    userId: $userId
  ) {
    ...plannedHourFields
  }
}
    ${PlannedHourFieldsFragmentDoc}`;
export type CreatePlannedHourMutationFn = Apollo.MutationFunction<CreatePlannedHourMutation, CreatePlannedHourMutationVariables>;

/**
 * __useCreatePlannedHourMutation__
 *
 * To run a mutation, you first call `useCreatePlannedHourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlannedHourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlannedHourMutation, { data, loading, error }] = useCreatePlannedHourMutation({
 *   variables: {
 *      month: // value for 'month'
 *      hours: // value for 'hours'
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useCreatePlannedHourMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlannedHourMutation, CreatePlannedHourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlannedHourMutation, CreatePlannedHourMutationVariables>(CreatePlannedHourDocument, options);
      }
export type CreatePlannedHourMutationHookResult = ReturnType<typeof useCreatePlannedHourMutation>;
export type CreatePlannedHourMutationResult = Apollo.MutationResult<CreatePlannedHourMutation>;
export type CreatePlannedHourMutationOptions = Apollo.BaseMutationOptions<CreatePlannedHourMutation, CreatePlannedHourMutationVariables>;
export const UpdatePlannedHourDocument = gql`
    mutation UpdatePlannedHour($id: ID!, $month: DateTime, $hours: Float, $projectId: ID, $userId: ID, $withProject: Boolean = false, $withUser: Boolean = false) {
  updatePlannedHour(
    id: $id
    month: $month
    hours: $hours
    projectId: $projectId
    userId: $userId
  ) {
    ...plannedHourFields
  }
}
    ${PlannedHourFieldsFragmentDoc}`;
export type UpdatePlannedHourMutationFn = Apollo.MutationFunction<UpdatePlannedHourMutation, UpdatePlannedHourMutationVariables>;

/**
 * __useUpdatePlannedHourMutation__
 *
 * To run a mutation, you first call `useUpdatePlannedHourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannedHourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlannedHourMutation, { data, loading, error }] = useUpdatePlannedHourMutation({
 *   variables: {
 *      id: // value for 'id'
 *      month: // value for 'month'
 *      hours: // value for 'hours'
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useUpdatePlannedHourMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlannedHourMutation, UpdatePlannedHourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlannedHourMutation, UpdatePlannedHourMutationVariables>(UpdatePlannedHourDocument, options);
      }
export type UpdatePlannedHourMutationHookResult = ReturnType<typeof useUpdatePlannedHourMutation>;
export type UpdatePlannedHourMutationResult = Apollo.MutationResult<UpdatePlannedHourMutation>;
export type UpdatePlannedHourMutationOptions = Apollo.BaseMutationOptions<UpdatePlannedHourMutation, UpdatePlannedHourMutationVariables>;
export const DeletePlannedHourDocument = gql`
    mutation DeletePlannedHour($id: ID!, $withProject: Boolean = false, $withUser: Boolean = false) {
  deletePlannedHour(id: $id) {
    ...plannedHourFields
  }
}
    ${PlannedHourFieldsFragmentDoc}`;
export type DeletePlannedHourMutationFn = Apollo.MutationFunction<DeletePlannedHourMutation, DeletePlannedHourMutationVariables>;

/**
 * __useDeletePlannedHourMutation__
 *
 * To run a mutation, you first call `useDeletePlannedHourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlannedHourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlannedHourMutation, { data, loading, error }] = useDeletePlannedHourMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useDeletePlannedHourMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlannedHourMutation, DeletePlannedHourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlannedHourMutation, DeletePlannedHourMutationVariables>(DeletePlannedHourDocument, options);
      }
export type DeletePlannedHourMutationHookResult = ReturnType<typeof useDeletePlannedHourMutation>;
export type DeletePlannedHourMutationResult = Apollo.MutationResult<DeletePlannedHourMutation>;
export type DeletePlannedHourMutationOptions = Apollo.BaseMutationOptions<DeletePlannedHourMutation, DeletePlannedHourMutationVariables>;
export const CreatedPlannedHourDocument = gql`
    subscription CreatedPlannedHour($filter: PlannedHourFilterArgs, $withProject: Boolean = false, $withUser: Boolean = false) {
  createdPlannedHour(filter: $filter) {
    ...plannedHourFields
  }
}
    ${PlannedHourFieldsFragmentDoc}`;

/**
 * __useCreatedPlannedHourSubscription__
 *
 * To run a query within a React component, call `useCreatedPlannedHourSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedPlannedHourSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedPlannedHourSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useCreatedPlannedHourSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedPlannedHourSubscription, CreatedPlannedHourSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedPlannedHourSubscription, CreatedPlannedHourSubscriptionVariables>(CreatedPlannedHourDocument, options);
      }
export type CreatedPlannedHourSubscriptionHookResult = ReturnType<typeof useCreatedPlannedHourSubscription>;
export type CreatedPlannedHourSubscriptionResult = Apollo.SubscriptionResult<CreatedPlannedHourSubscription>;
export const UpdatedPlannedHourDocument = gql`
    subscription UpdatedPlannedHour($filter: PlannedHourFilterArgs, $withProject: Boolean = false, $withUser: Boolean = false) {
  updatedPlannedHour(filter: $filter) {
    ...plannedHourFields
  }
}
    ${PlannedHourFieldsFragmentDoc}`;

/**
 * __useUpdatedPlannedHourSubscription__
 *
 * To run a query within a React component, call `useUpdatedPlannedHourSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedPlannedHourSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedPlannedHourSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useUpdatedPlannedHourSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedPlannedHourSubscription, UpdatedPlannedHourSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedPlannedHourSubscription, UpdatedPlannedHourSubscriptionVariables>(UpdatedPlannedHourDocument, options);
      }
export type UpdatedPlannedHourSubscriptionHookResult = ReturnType<typeof useUpdatedPlannedHourSubscription>;
export type UpdatedPlannedHourSubscriptionResult = Apollo.SubscriptionResult<UpdatedPlannedHourSubscription>;
export const DeletedPlannedHourDocument = gql`
    subscription DeletedPlannedHour($filter: PlannedHourFilterArgs) {
  deletedPlannedHour(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedPlannedHourSubscription__
 *
 * To run a query within a React component, call `useDeletedPlannedHourSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedPlannedHourSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedPlannedHourSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedPlannedHourSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedPlannedHourSubscription, DeletedPlannedHourSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedPlannedHourSubscription, DeletedPlannedHourSubscriptionVariables>(DeletedPlannedHourDocument, options);
      }
export type DeletedPlannedHourSubscriptionHookResult = ReturnType<typeof useDeletedPlannedHourSubscription>;
export type DeletedPlannedHourSubscriptionResult = Apollo.SubscriptionResult<DeletedPlannedHourSubscription>;
export const RestoredPlannedHourDocument = gql`
    subscription RestoredPlannedHour($filter: PlannedHourFilterArgs, $withProject: Boolean = false, $withUser: Boolean = false) {
  restoredPlannedHour(filter: $filter) {
    ...plannedHourFields
  }
}
    ${PlannedHourFieldsFragmentDoc}`;

/**
 * __useRestoredPlannedHourSubscription__
 *
 * To run a query within a React component, call `useRestoredPlannedHourSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredPlannedHourSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredPlannedHourSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useRestoredPlannedHourSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredPlannedHourSubscription, RestoredPlannedHourSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredPlannedHourSubscription, RestoredPlannedHourSubscriptionVariables>(RestoredPlannedHourDocument, options);
      }
export type RestoredPlannedHourSubscriptionHookResult = ReturnType<typeof useRestoredPlannedHourSubscription>;
export type RestoredPlannedHourSubscriptionResult = Apollo.SubscriptionResult<RestoredPlannedHourSubscription>;
export const GetProductivitiesDocument = gql`
    query GetProductivities($filter: ProductivityFilterArgs, $paging: PageArgs, $sorting: [ProductivitySortArgs!], $withUser: Boolean = false) {
  productivities(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...productivityFields
    }
    totalCount
  }
}
    ${ProductivityFieldsFragmentDoc}`;

/**
 * __useGetProductivitiesQuery__
 *
 * To run a query within a React component, call `useGetProductivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductivitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useGetProductivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductivitiesQuery, GetProductivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductivitiesQuery, GetProductivitiesQueryVariables>(GetProductivitiesDocument, options);
      }
export function useGetProductivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductivitiesQuery, GetProductivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductivitiesQuery, GetProductivitiesQueryVariables>(GetProductivitiesDocument, options);
        }
export function useGetProductivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductivitiesQuery, GetProductivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductivitiesQuery, GetProductivitiesQueryVariables>(GetProductivitiesDocument, options);
        }
export type GetProductivitiesQueryHookResult = ReturnType<typeof useGetProductivitiesQuery>;
export type GetProductivitiesLazyQueryHookResult = ReturnType<typeof useGetProductivitiesLazyQuery>;
export type GetProductivitiesSuspenseQueryHookResult = ReturnType<typeof useGetProductivitiesSuspenseQuery>;
export type GetProductivitiesQueryResult = Apollo.QueryResult<GetProductivitiesQuery, GetProductivitiesQueryVariables>;
export const GetProductivityDocument = gql`
    query GetProductivity($id: ID!, $withUser: Boolean = false) {
  productivity(id: $id) {
    ...productivityFields
  }
}
    ${ProductivityFieldsFragmentDoc}`;

/**
 * __useGetProductivityQuery__
 *
 * To run a query within a React component, call `useGetProductivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useGetProductivityQuery(baseOptions: Apollo.QueryHookOptions<GetProductivityQuery, GetProductivityQueryVariables> & ({ variables: GetProductivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductivityQuery, GetProductivityQueryVariables>(GetProductivityDocument, options);
      }
export function useGetProductivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductivityQuery, GetProductivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductivityQuery, GetProductivityQueryVariables>(GetProductivityDocument, options);
        }
export function useGetProductivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductivityQuery, GetProductivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductivityQuery, GetProductivityQueryVariables>(GetProductivityDocument, options);
        }
export type GetProductivityQueryHookResult = ReturnType<typeof useGetProductivityQuery>;
export type GetProductivityLazyQueryHookResult = ReturnType<typeof useGetProductivityLazyQuery>;
export type GetProductivitySuspenseQueryHookResult = ReturnType<typeof useGetProductivitySuspenseQuery>;
export type GetProductivityQueryResult = Apollo.QueryResult<GetProductivityQuery, GetProductivityQueryVariables>;
export const GetAllRelatedDataForProductivityDocument = gql`
    query GetAllRelatedDataForProductivity($withUsers: Boolean = false) {
  users @include(if: $withUsers) {
    items {
      id
      displayField: fullName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForProductivityQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForProductivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForProductivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForProductivityQuery({
 *   variables: {
 *      withUsers: // value for 'withUsers'
 *   },
 * });
 */
export function useGetAllRelatedDataForProductivityQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForProductivityQuery, GetAllRelatedDataForProductivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForProductivityQuery, GetAllRelatedDataForProductivityQueryVariables>(GetAllRelatedDataForProductivityDocument, options);
      }
export function useGetAllRelatedDataForProductivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForProductivityQuery, GetAllRelatedDataForProductivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForProductivityQuery, GetAllRelatedDataForProductivityQueryVariables>(GetAllRelatedDataForProductivityDocument, options);
        }
export function useGetAllRelatedDataForProductivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForProductivityQuery, GetAllRelatedDataForProductivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForProductivityQuery, GetAllRelatedDataForProductivityQueryVariables>(GetAllRelatedDataForProductivityDocument, options);
        }
export type GetAllRelatedDataForProductivityQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProductivityQuery>;
export type GetAllRelatedDataForProductivityLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProductivityLazyQuery>;
export type GetAllRelatedDataForProductivitySuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProductivitySuspenseQuery>;
export type GetAllRelatedDataForProductivityQueryResult = Apollo.QueryResult<GetAllRelatedDataForProductivityQuery, GetAllRelatedDataForProductivityQueryVariables>;
export const CreateProductivityDocument = gql`
    mutation CreateProductivity($startDate: DateTime!, $factor: Float!, $userId: ID!, $withUser: Boolean = false) {
  createProductivity(startDate: $startDate, factor: $factor, userId: $userId) {
    ...productivityFields
  }
}
    ${ProductivityFieldsFragmentDoc}`;
export type CreateProductivityMutationFn = Apollo.MutationFunction<CreateProductivityMutation, CreateProductivityMutationVariables>;

/**
 * __useCreateProductivityMutation__
 *
 * To run a mutation, you first call `useCreateProductivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductivityMutation, { data, loading, error }] = useCreateProductivityMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      factor: // value for 'factor'
 *      userId: // value for 'userId'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useCreateProductivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductivityMutation, CreateProductivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductivityMutation, CreateProductivityMutationVariables>(CreateProductivityDocument, options);
      }
export type CreateProductivityMutationHookResult = ReturnType<typeof useCreateProductivityMutation>;
export type CreateProductivityMutationResult = Apollo.MutationResult<CreateProductivityMutation>;
export type CreateProductivityMutationOptions = Apollo.BaseMutationOptions<CreateProductivityMutation, CreateProductivityMutationVariables>;
export const UpdateProductivityDocument = gql`
    mutation UpdateProductivity($id: ID!, $startDate: DateTime, $factor: Float, $userId: ID, $withUser: Boolean = false) {
  updateProductivity(
    id: $id
    startDate: $startDate
    factor: $factor
    userId: $userId
  ) {
    ...productivityFields
  }
}
    ${ProductivityFieldsFragmentDoc}`;
export type UpdateProductivityMutationFn = Apollo.MutationFunction<UpdateProductivityMutation, UpdateProductivityMutationVariables>;

/**
 * __useUpdateProductivityMutation__
 *
 * To run a mutation, you first call `useUpdateProductivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductivityMutation, { data, loading, error }] = useUpdateProductivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      factor: // value for 'factor'
 *      userId: // value for 'userId'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useUpdateProductivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductivityMutation, UpdateProductivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductivityMutation, UpdateProductivityMutationVariables>(UpdateProductivityDocument, options);
      }
export type UpdateProductivityMutationHookResult = ReturnType<typeof useUpdateProductivityMutation>;
export type UpdateProductivityMutationResult = Apollo.MutationResult<UpdateProductivityMutation>;
export type UpdateProductivityMutationOptions = Apollo.BaseMutationOptions<UpdateProductivityMutation, UpdateProductivityMutationVariables>;
export const DeleteProductivityDocument = gql`
    mutation DeleteProductivity($id: ID!, $withUser: Boolean = false) {
  deleteProductivity(id: $id) {
    ...productivityFields
  }
}
    ${ProductivityFieldsFragmentDoc}`;
export type DeleteProductivityMutationFn = Apollo.MutationFunction<DeleteProductivityMutation, DeleteProductivityMutationVariables>;

/**
 * __useDeleteProductivityMutation__
 *
 * To run a mutation, you first call `useDeleteProductivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductivityMutation, { data, loading, error }] = useDeleteProductivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useDeleteProductivityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductivityMutation, DeleteProductivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductivityMutation, DeleteProductivityMutationVariables>(DeleteProductivityDocument, options);
      }
export type DeleteProductivityMutationHookResult = ReturnType<typeof useDeleteProductivityMutation>;
export type DeleteProductivityMutationResult = Apollo.MutationResult<DeleteProductivityMutation>;
export type DeleteProductivityMutationOptions = Apollo.BaseMutationOptions<DeleteProductivityMutation, DeleteProductivityMutationVariables>;
export const CreatedProductivityDocument = gql`
    subscription CreatedProductivity($filter: ProductivityFilterArgs, $withUser: Boolean = false) {
  createdProductivity(filter: $filter) {
    ...productivityFields
  }
}
    ${ProductivityFieldsFragmentDoc}`;

/**
 * __useCreatedProductivitySubscription__
 *
 * To run a query within a React component, call `useCreatedProductivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedProductivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedProductivitySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useCreatedProductivitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedProductivitySubscription, CreatedProductivitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedProductivitySubscription, CreatedProductivitySubscriptionVariables>(CreatedProductivityDocument, options);
      }
export type CreatedProductivitySubscriptionHookResult = ReturnType<typeof useCreatedProductivitySubscription>;
export type CreatedProductivitySubscriptionResult = Apollo.SubscriptionResult<CreatedProductivitySubscription>;
export const UpdatedProductivityDocument = gql`
    subscription UpdatedProductivity($filter: ProductivityFilterArgs, $withUser: Boolean = false) {
  updatedProductivity(filter: $filter) {
    ...productivityFields
  }
}
    ${ProductivityFieldsFragmentDoc}`;

/**
 * __useUpdatedProductivitySubscription__
 *
 * To run a query within a React component, call `useUpdatedProductivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedProductivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedProductivitySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useUpdatedProductivitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedProductivitySubscription, UpdatedProductivitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedProductivitySubscription, UpdatedProductivitySubscriptionVariables>(UpdatedProductivityDocument, options);
      }
export type UpdatedProductivitySubscriptionHookResult = ReturnType<typeof useUpdatedProductivitySubscription>;
export type UpdatedProductivitySubscriptionResult = Apollo.SubscriptionResult<UpdatedProductivitySubscription>;
export const DeletedProductivityDocument = gql`
    subscription DeletedProductivity($filter: ProductivityFilterArgs) {
  deletedProductivity(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedProductivitySubscription__
 *
 * To run a query within a React component, call `useDeletedProductivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedProductivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedProductivitySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedProductivitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedProductivitySubscription, DeletedProductivitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedProductivitySubscription, DeletedProductivitySubscriptionVariables>(DeletedProductivityDocument, options);
      }
export type DeletedProductivitySubscriptionHookResult = ReturnType<typeof useDeletedProductivitySubscription>;
export type DeletedProductivitySubscriptionResult = Apollo.SubscriptionResult<DeletedProductivitySubscription>;
export const RestoredProductivityDocument = gql`
    subscription RestoredProductivity($filter: ProductivityFilterArgs, $withUser: Boolean = false) {
  restoredProductivity(filter: $filter) {
    ...productivityFields
  }
}
    ${ProductivityFieldsFragmentDoc}`;

/**
 * __useRestoredProductivitySubscription__
 *
 * To run a query within a React component, call `useRestoredProductivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredProductivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredProductivitySubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *   },
 * });
 */
export function useRestoredProductivitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredProductivitySubscription, RestoredProductivitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredProductivitySubscription, RestoredProductivitySubscriptionVariables>(RestoredProductivityDocument, options);
      }
export type RestoredProductivitySubscriptionHookResult = ReturnType<typeof useRestoredProductivitySubscription>;
export type RestoredProductivitySubscriptionResult = Apollo.SubscriptionResult<RestoredProductivitySubscription>;
export const GetProjectsDocument = gql`
    query GetProjects($filter: ProjectFilterArgs, $paging: PageArgs, $sorting: [ProjectSortArgs!], $withCustomer: Boolean = false, $withCategories: Boolean = false, $withTenants: Boolean = false, $withLoggedHours: Boolean = false, $withBudgets: Boolean = false, $withPlannedHours: Boolean = false, $withHoursRequireds: Boolean = false, $withInvoices: Boolean = false, $withProjectDates: Boolean = false, $withContracts: Boolean = false, $withProjectDocuments: Boolean = false, $withUserTenantRoles: Boolean = false, $withRegulation: Boolean = false, $withResponsibleUser: Boolean = false, $withControlUser: Boolean = false) {
  projects(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...projectFields
    }
    totalCount
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withCustomer: // value for 'withCustomer'
 *      withCategories: // value for 'withCategories'
 *      withTenants: // value for 'withTenants'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgets: // value for 'withBudgets'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withHoursRequireds: // value for 'withHoursRequireds'
 *      withInvoices: // value for 'withInvoices'
 *      withProjectDates: // value for 'withProjectDates'
 *      withContracts: // value for 'withContracts'
 *      withProjectDocuments: // value for 'withProjectDocuments'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withRegulation: // value for 'withRegulation'
 *      withResponsibleUser: // value for 'withResponsibleUser'
 *      withControlUser: // value for 'withControlUser'
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export function useGetProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsSuspenseQueryHookResult = ReturnType<typeof useGetProjectsSuspenseQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($id: ID!, $withCustomer: Boolean = false, $withCategories: Boolean = false, $withTenants: Boolean = false, $withLoggedHours: Boolean = false, $withBudgets: Boolean = false, $withPlannedHours: Boolean = false, $withHoursRequireds: Boolean = false, $withInvoices: Boolean = false, $withProjectDates: Boolean = false, $withContracts: Boolean = false, $withProjectDocuments: Boolean = false, $withUserTenantRoles: Boolean = false, $withRegulation: Boolean = false, $withResponsibleUser: Boolean = false, $withControlUser: Boolean = false) {
  project(id: $id) {
    ...projectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withCustomer: // value for 'withCustomer'
 *      withCategories: // value for 'withCategories'
 *      withTenants: // value for 'withTenants'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgets: // value for 'withBudgets'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withHoursRequireds: // value for 'withHoursRequireds'
 *      withInvoices: // value for 'withInvoices'
 *      withProjectDates: // value for 'withProjectDates'
 *      withContracts: // value for 'withContracts'
 *      withProjectDocuments: // value for 'withProjectDocuments'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withRegulation: // value for 'withRegulation'
 *      withResponsibleUser: // value for 'withResponsibleUser'
 *      withControlUser: // value for 'withControlUser'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables> & ({ variables: GetProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetAllRelatedDataForProjectDocument = gql`
    query GetAllRelatedDataForProject($withCustomers: Boolean = false, $withCategories: Boolean = false, $withTenants: Boolean = false, $withLoggedHours: Boolean = false, $withBudgets: Boolean = false, $withPlannedHours: Boolean = false, $withHoursRequireds: Boolean = false, $withInvoices: Boolean = false, $withProjectDates: Boolean = false, $withContracts: Boolean = false, $withProjectDocuments: Boolean = false, $withUserTenantRoles: Boolean = false, $withRegulations: Boolean = false, $withResponsibleUsers: Boolean = false, $withControlUsers: Boolean = false) {
  customers @include(if: $withCustomers) {
    items {
      id
      displayField: name
    }
  }
  categories @include(if: $withCategories) {
    items {
      id
      displayField: name
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
  loggedHours @include(if: $withLoggedHours) {
    items {
      id
      displayField: id
    }
  }
  budgets @include(if: $withBudgets) {
    items {
      id
      displayField: id
    }
  }
  plannedHours @include(if: $withPlannedHours) {
    items {
      id
      displayField: id
    }
  }
  hoursRequireds @include(if: $withHoursRequireds) {
    items {
      id
      displayField: id
    }
  }
  invoices @include(if: $withInvoices) {
    items {
      id
      displayField: name
    }
  }
  projectDates @include(if: $withProjectDates) {
    items {
      id
      displayField: name
    }
  }
  contracts @include(if: $withContracts) {
    items {
      id
      displayField: id
    }
  }
  projectDocuments @include(if: $withProjectDocuments) {
    items {
      id
      displayField: name
    }
  }
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
  regulations @include(if: $withRegulations) {
    items {
      id
      displayField: name
    }
  }
  users @include(if: $withResponsibleUsers) {
    items {
      id
      displayField: fullName
    }
  }
  users @include(if: $withControlUsers) {
    items {
      id
      displayField: fullName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForProjectQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForProjectQuery({
 *   variables: {
 *      withCustomers: // value for 'withCustomers'
 *      withCategories: // value for 'withCategories'
 *      withTenants: // value for 'withTenants'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgets: // value for 'withBudgets'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withHoursRequireds: // value for 'withHoursRequireds'
 *      withInvoices: // value for 'withInvoices'
 *      withProjectDates: // value for 'withProjectDates'
 *      withContracts: // value for 'withContracts'
 *      withProjectDocuments: // value for 'withProjectDocuments'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withRegulations: // value for 'withRegulations'
 *      withResponsibleUsers: // value for 'withResponsibleUsers'
 *      withControlUsers: // value for 'withControlUsers'
 *   },
 * });
 */
export function useGetAllRelatedDataForProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForProjectQuery, GetAllRelatedDataForProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForProjectQuery, GetAllRelatedDataForProjectQueryVariables>(GetAllRelatedDataForProjectDocument, options);
      }
export function useGetAllRelatedDataForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForProjectQuery, GetAllRelatedDataForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForProjectQuery, GetAllRelatedDataForProjectQueryVariables>(GetAllRelatedDataForProjectDocument, options);
        }
export function useGetAllRelatedDataForProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForProjectQuery, GetAllRelatedDataForProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForProjectQuery, GetAllRelatedDataForProjectQueryVariables>(GetAllRelatedDataForProjectDocument, options);
        }
export type GetAllRelatedDataForProjectQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectQuery>;
export type GetAllRelatedDataForProjectLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectLazyQuery>;
export type GetAllRelatedDataForProjectSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectSuspenseQuery>;
export type GetAllRelatedDataForProjectQueryResult = Apollo.QueryResult<GetAllRelatedDataForProjectQuery, GetAllRelatedDataForProjectQueryVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($name: String!, $active: Boolean!, $description: String, $branch: String, $subsidyPercentage: Float, $invoiceVatSubsidyEligible: Boolean!, $reference: String, $status: String!, $hourSubsidyType: String!, $maxHourlyRate: Float, $addendum: Boolean!, $startDate: DateTime, $endDate: DateTime, $filingDate: DateTime, $decisionDate: DateTime, $customerId: ID, $categories: [ID], $tenants: [ID], $loggedHours: [ID], $budgets: [ID], $plannedHours: [ID], $hoursRequireds: [ID], $invoices: [ID], $projectDates: [ID], $contracts: [ID], $projectDocuments: [ID], $userTenantRoles: [ID], $regulationId: ID, $responsibleUserId: ID, $controlUserId: ID, $withCustomer: Boolean = false, $withCategories: Boolean = false, $withTenants: Boolean = false, $withLoggedHours: Boolean = false, $withBudgets: Boolean = false, $withPlannedHours: Boolean = false, $withHoursRequireds: Boolean = false, $withInvoices: Boolean = false, $withProjectDates: Boolean = false, $withContracts: Boolean = false, $withProjectDocuments: Boolean = false, $withUserTenantRoles: Boolean = false, $withRegulation: Boolean = false, $withResponsibleUser: Boolean = false, $withControlUser: Boolean = false) {
  createProject(
    name: $name
    active: $active
    description: $description
    branch: $branch
    subsidyPercentage: $subsidyPercentage
    invoiceVatSubsidyEligible: $invoiceVatSubsidyEligible
    reference: $reference
    status: $status
    hourSubsidyType: $hourSubsidyType
    maxHourlyRate: $maxHourlyRate
    addendum: $addendum
    startDate: $startDate
    endDate: $endDate
    filingDate: $filingDate
    decisionDate: $decisionDate
    customerId: $customerId
    categoryIds: $categories
    tenantIds: $tenants
    loggedHourIds: $loggedHours
    budgetIds: $budgets
    plannedHourIds: $plannedHours
    hoursRequiredIds: $hoursRequireds
    invoiceIds: $invoices
    projectDateIds: $projectDates
    contractIds: $contracts
    projectDocumentIds: $projectDocuments
    userTenantRoleIds: $userTenantRoles
    regulationId: $regulationId
    responsibleUserId: $responsibleUserId
    controlUserId: $controlUserId
  ) {
    ...projectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      active: // value for 'active'
 *      description: // value for 'description'
 *      branch: // value for 'branch'
 *      subsidyPercentage: // value for 'subsidyPercentage'
 *      invoiceVatSubsidyEligible: // value for 'invoiceVatSubsidyEligible'
 *      reference: // value for 'reference'
 *      status: // value for 'status'
 *      hourSubsidyType: // value for 'hourSubsidyType'
 *      maxHourlyRate: // value for 'maxHourlyRate'
 *      addendum: // value for 'addendum'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filingDate: // value for 'filingDate'
 *      decisionDate: // value for 'decisionDate'
 *      customerId: // value for 'customerId'
 *      categories: // value for 'categories'
 *      tenants: // value for 'tenants'
 *      loggedHours: // value for 'loggedHours'
 *      budgets: // value for 'budgets'
 *      plannedHours: // value for 'plannedHours'
 *      hoursRequireds: // value for 'hoursRequireds'
 *      invoices: // value for 'invoices'
 *      projectDates: // value for 'projectDates'
 *      contracts: // value for 'contracts'
 *      projectDocuments: // value for 'projectDocuments'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      regulationId: // value for 'regulationId'
 *      responsibleUserId: // value for 'responsibleUserId'
 *      controlUserId: // value for 'controlUserId'
 *      withCustomer: // value for 'withCustomer'
 *      withCategories: // value for 'withCategories'
 *      withTenants: // value for 'withTenants'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgets: // value for 'withBudgets'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withHoursRequireds: // value for 'withHoursRequireds'
 *      withInvoices: // value for 'withInvoices'
 *      withProjectDates: // value for 'withProjectDates'
 *      withContracts: // value for 'withContracts'
 *      withProjectDocuments: // value for 'withProjectDocuments'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withRegulation: // value for 'withRegulation'
 *      withResponsibleUser: // value for 'withResponsibleUser'
 *      withControlUser: // value for 'withControlUser'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: ID!, $name: String, $active: Boolean, $description: String, $branch: String, $subsidyPercentage: Float, $invoiceVatSubsidyEligible: Boolean, $reference: String, $status: String, $hourSubsidyType: String, $maxHourlyRate: Float, $addendum: Boolean, $startDate: DateTime, $endDate: DateTime, $filingDate: DateTime, $decisionDate: DateTime, $customerId: ID, $categories: [ID], $tenants: [ID], $loggedHours: [ID], $budgets: [ID], $plannedHours: [ID], $hoursRequireds: [ID], $invoices: [ID], $projectDates: [ID], $contracts: [ID], $projectDocuments: [ID], $userTenantRoles: [ID], $regulationId: ID, $responsibleUserId: ID, $controlUserId: ID, $withCustomer: Boolean = false, $withCategories: Boolean = false, $withTenants: Boolean = false, $withLoggedHours: Boolean = false, $withBudgets: Boolean = false, $withPlannedHours: Boolean = false, $withHoursRequireds: Boolean = false, $withInvoices: Boolean = false, $withProjectDates: Boolean = false, $withContracts: Boolean = false, $withProjectDocuments: Boolean = false, $withUserTenantRoles: Boolean = false, $withRegulation: Boolean = false, $withResponsibleUser: Boolean = false, $withControlUser: Boolean = false) {
  updateProject(
    id: $id
    name: $name
    active: $active
    description: $description
    branch: $branch
    subsidyPercentage: $subsidyPercentage
    invoiceVatSubsidyEligible: $invoiceVatSubsidyEligible
    reference: $reference
    status: $status
    hourSubsidyType: $hourSubsidyType
    maxHourlyRate: $maxHourlyRate
    addendum: $addendum
    startDate: $startDate
    endDate: $endDate
    filingDate: $filingDate
    decisionDate: $decisionDate
    customerId: $customerId
    categoryIds: $categories
    tenantIds: $tenants
    loggedHourIds: $loggedHours
    budgetIds: $budgets
    plannedHourIds: $plannedHours
    hoursRequiredIds: $hoursRequireds
    invoiceIds: $invoices
    projectDateIds: $projectDates
    contractIds: $contracts
    projectDocumentIds: $projectDocuments
    userTenantRoleIds: $userTenantRoles
    regulationId: $regulationId
    responsibleUserId: $responsibleUserId
    controlUserId: $controlUserId
  ) {
    ...projectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      active: // value for 'active'
 *      description: // value for 'description'
 *      branch: // value for 'branch'
 *      subsidyPercentage: // value for 'subsidyPercentage'
 *      invoiceVatSubsidyEligible: // value for 'invoiceVatSubsidyEligible'
 *      reference: // value for 'reference'
 *      status: // value for 'status'
 *      hourSubsidyType: // value for 'hourSubsidyType'
 *      maxHourlyRate: // value for 'maxHourlyRate'
 *      addendum: // value for 'addendum'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filingDate: // value for 'filingDate'
 *      decisionDate: // value for 'decisionDate'
 *      customerId: // value for 'customerId'
 *      categories: // value for 'categories'
 *      tenants: // value for 'tenants'
 *      loggedHours: // value for 'loggedHours'
 *      budgets: // value for 'budgets'
 *      plannedHours: // value for 'plannedHours'
 *      hoursRequireds: // value for 'hoursRequireds'
 *      invoices: // value for 'invoices'
 *      projectDates: // value for 'projectDates'
 *      contracts: // value for 'contracts'
 *      projectDocuments: // value for 'projectDocuments'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      regulationId: // value for 'regulationId'
 *      responsibleUserId: // value for 'responsibleUserId'
 *      controlUserId: // value for 'controlUserId'
 *      withCustomer: // value for 'withCustomer'
 *      withCategories: // value for 'withCategories'
 *      withTenants: // value for 'withTenants'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgets: // value for 'withBudgets'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withHoursRequireds: // value for 'withHoursRequireds'
 *      withInvoices: // value for 'withInvoices'
 *      withProjectDates: // value for 'withProjectDates'
 *      withContracts: // value for 'withContracts'
 *      withProjectDocuments: // value for 'withProjectDocuments'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withRegulation: // value for 'withRegulation'
 *      withResponsibleUser: // value for 'withResponsibleUser'
 *      withControlUser: // value for 'withControlUser'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!, $withCustomer: Boolean = false, $withCategories: Boolean = false, $withTenants: Boolean = false, $withLoggedHours: Boolean = false, $withBudgets: Boolean = false, $withPlannedHours: Boolean = false, $withHoursRequireds: Boolean = false, $withInvoices: Boolean = false, $withProjectDates: Boolean = false, $withContracts: Boolean = false, $withProjectDocuments: Boolean = false, $withUserTenantRoles: Boolean = false, $withRegulation: Boolean = false, $withResponsibleUser: Boolean = false, $withControlUser: Boolean = false) {
  deleteProject(id: $id) {
    ...projectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withCustomer: // value for 'withCustomer'
 *      withCategories: // value for 'withCategories'
 *      withTenants: // value for 'withTenants'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgets: // value for 'withBudgets'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withHoursRequireds: // value for 'withHoursRequireds'
 *      withInvoices: // value for 'withInvoices'
 *      withProjectDates: // value for 'withProjectDates'
 *      withContracts: // value for 'withContracts'
 *      withProjectDocuments: // value for 'withProjectDocuments'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withRegulation: // value for 'withRegulation'
 *      withResponsibleUser: // value for 'withResponsibleUser'
 *      withControlUser: // value for 'withControlUser'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const CreatedProjectDocument = gql`
    subscription CreatedProject($filter: ProjectFilterArgs, $withCustomer: Boolean = false, $withCategories: Boolean = false, $withTenants: Boolean = false, $withLoggedHours: Boolean = false, $withBudgets: Boolean = false, $withPlannedHours: Boolean = false, $withHoursRequireds: Boolean = false, $withInvoices: Boolean = false, $withProjectDates: Boolean = false, $withContracts: Boolean = false, $withProjectDocuments: Boolean = false, $withUserTenantRoles: Boolean = false, $withRegulation: Boolean = false, $withResponsibleUser: Boolean = false, $withControlUser: Boolean = false) {
  createdProject(filter: $filter) {
    ...projectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useCreatedProjectSubscription__
 *
 * To run a query within a React component, call `useCreatedProjectSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedProjectSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedProjectSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withCustomer: // value for 'withCustomer'
 *      withCategories: // value for 'withCategories'
 *      withTenants: // value for 'withTenants'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgets: // value for 'withBudgets'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withHoursRequireds: // value for 'withHoursRequireds'
 *      withInvoices: // value for 'withInvoices'
 *      withProjectDates: // value for 'withProjectDates'
 *      withContracts: // value for 'withContracts'
 *      withProjectDocuments: // value for 'withProjectDocuments'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withRegulation: // value for 'withRegulation'
 *      withResponsibleUser: // value for 'withResponsibleUser'
 *      withControlUser: // value for 'withControlUser'
 *   },
 * });
 */
export function useCreatedProjectSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedProjectSubscription, CreatedProjectSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedProjectSubscription, CreatedProjectSubscriptionVariables>(CreatedProjectDocument, options);
      }
export type CreatedProjectSubscriptionHookResult = ReturnType<typeof useCreatedProjectSubscription>;
export type CreatedProjectSubscriptionResult = Apollo.SubscriptionResult<CreatedProjectSubscription>;
export const UpdatedProjectDocument = gql`
    subscription UpdatedProject($filter: ProjectFilterArgs, $withCustomer: Boolean = false, $withCategories: Boolean = false, $withTenants: Boolean = false, $withLoggedHours: Boolean = false, $withBudgets: Boolean = false, $withPlannedHours: Boolean = false, $withHoursRequireds: Boolean = false, $withInvoices: Boolean = false, $withProjectDates: Boolean = false, $withContracts: Boolean = false, $withProjectDocuments: Boolean = false, $withUserTenantRoles: Boolean = false, $withRegulation: Boolean = false, $withResponsibleUser: Boolean = false, $withControlUser: Boolean = false) {
  updatedProject(filter: $filter) {
    ...projectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useUpdatedProjectSubscription__
 *
 * To run a query within a React component, call `useUpdatedProjectSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedProjectSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedProjectSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withCustomer: // value for 'withCustomer'
 *      withCategories: // value for 'withCategories'
 *      withTenants: // value for 'withTenants'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgets: // value for 'withBudgets'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withHoursRequireds: // value for 'withHoursRequireds'
 *      withInvoices: // value for 'withInvoices'
 *      withProjectDates: // value for 'withProjectDates'
 *      withContracts: // value for 'withContracts'
 *      withProjectDocuments: // value for 'withProjectDocuments'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withRegulation: // value for 'withRegulation'
 *      withResponsibleUser: // value for 'withResponsibleUser'
 *      withControlUser: // value for 'withControlUser'
 *   },
 * });
 */
export function useUpdatedProjectSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedProjectSubscription, UpdatedProjectSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedProjectSubscription, UpdatedProjectSubscriptionVariables>(UpdatedProjectDocument, options);
      }
export type UpdatedProjectSubscriptionHookResult = ReturnType<typeof useUpdatedProjectSubscription>;
export type UpdatedProjectSubscriptionResult = Apollo.SubscriptionResult<UpdatedProjectSubscription>;
export const DeletedProjectDocument = gql`
    subscription DeletedProject($filter: ProjectFilterArgs) {
  deletedProject(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedProjectSubscription__
 *
 * To run a query within a React component, call `useDeletedProjectSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedProjectSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedProjectSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedProjectSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedProjectSubscription, DeletedProjectSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedProjectSubscription, DeletedProjectSubscriptionVariables>(DeletedProjectDocument, options);
      }
export type DeletedProjectSubscriptionHookResult = ReturnType<typeof useDeletedProjectSubscription>;
export type DeletedProjectSubscriptionResult = Apollo.SubscriptionResult<DeletedProjectSubscription>;
export const RestoredProjectDocument = gql`
    subscription RestoredProject($filter: ProjectFilterArgs, $withCustomer: Boolean = false, $withCategories: Boolean = false, $withTenants: Boolean = false, $withLoggedHours: Boolean = false, $withBudgets: Boolean = false, $withPlannedHours: Boolean = false, $withHoursRequireds: Boolean = false, $withInvoices: Boolean = false, $withProjectDates: Boolean = false, $withContracts: Boolean = false, $withProjectDocuments: Boolean = false, $withUserTenantRoles: Boolean = false, $withRegulation: Boolean = false, $withResponsibleUser: Boolean = false, $withControlUser: Boolean = false) {
  restoredProject(filter: $filter) {
    ...projectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useRestoredProjectSubscription__
 *
 * To run a query within a React component, call `useRestoredProjectSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredProjectSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredProjectSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withCustomer: // value for 'withCustomer'
 *      withCategories: // value for 'withCategories'
 *      withTenants: // value for 'withTenants'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withBudgets: // value for 'withBudgets'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withHoursRequireds: // value for 'withHoursRequireds'
 *      withInvoices: // value for 'withInvoices'
 *      withProjectDates: // value for 'withProjectDates'
 *      withContracts: // value for 'withContracts'
 *      withProjectDocuments: // value for 'withProjectDocuments'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withRegulation: // value for 'withRegulation'
 *      withResponsibleUser: // value for 'withResponsibleUser'
 *      withControlUser: // value for 'withControlUser'
 *   },
 * });
 */
export function useRestoredProjectSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredProjectSubscription, RestoredProjectSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredProjectSubscription, RestoredProjectSubscriptionVariables>(RestoredProjectDocument, options);
      }
export type RestoredProjectSubscriptionHookResult = ReturnType<typeof useRestoredProjectSubscription>;
export type RestoredProjectSubscriptionResult = Apollo.SubscriptionResult<RestoredProjectSubscription>;
export const GetProjectDatesDocument = gql`
    query GetProjectDates($filter: ProjectDateFilterArgs, $paging: PageArgs, $sorting: [ProjectDateSortArgs!], $withProjectDateReminders: Boolean = false, $withProject: Boolean = false) {
  projectDates(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...projectDateFields
    }
    totalCount
  }
}
    ${ProjectDateFieldsFragmentDoc}`;

/**
 * __useGetProjectDatesQuery__
 *
 * To run a query within a React component, call `useGetProjectDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetProjectDatesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectDatesQuery, GetProjectDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDatesQuery, GetProjectDatesQueryVariables>(GetProjectDatesDocument, options);
      }
export function useGetProjectDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDatesQuery, GetProjectDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDatesQuery, GetProjectDatesQueryVariables>(GetProjectDatesDocument, options);
        }
export function useGetProjectDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDatesQuery, GetProjectDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDatesQuery, GetProjectDatesQueryVariables>(GetProjectDatesDocument, options);
        }
export type GetProjectDatesQueryHookResult = ReturnType<typeof useGetProjectDatesQuery>;
export type GetProjectDatesLazyQueryHookResult = ReturnType<typeof useGetProjectDatesLazyQuery>;
export type GetProjectDatesSuspenseQueryHookResult = ReturnType<typeof useGetProjectDatesSuspenseQuery>;
export type GetProjectDatesQueryResult = Apollo.QueryResult<GetProjectDatesQuery, GetProjectDatesQueryVariables>;
export const GetProjectDateDocument = gql`
    query GetProjectDate($id: ID!, $withProjectDateReminders: Boolean = false, $withProject: Boolean = false) {
  projectDate(id: $id) {
    ...projectDateFields
  }
}
    ${ProjectDateFieldsFragmentDoc}`;

/**
 * __useGetProjectDateQuery__
 *
 * To run a query within a React component, call `useGetProjectDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetProjectDateQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDateQuery, GetProjectDateQueryVariables> & ({ variables: GetProjectDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDateQuery, GetProjectDateQueryVariables>(GetProjectDateDocument, options);
      }
export function useGetProjectDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDateQuery, GetProjectDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDateQuery, GetProjectDateQueryVariables>(GetProjectDateDocument, options);
        }
export function useGetProjectDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDateQuery, GetProjectDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDateQuery, GetProjectDateQueryVariables>(GetProjectDateDocument, options);
        }
export type GetProjectDateQueryHookResult = ReturnType<typeof useGetProjectDateQuery>;
export type GetProjectDateLazyQueryHookResult = ReturnType<typeof useGetProjectDateLazyQuery>;
export type GetProjectDateSuspenseQueryHookResult = ReturnType<typeof useGetProjectDateSuspenseQuery>;
export type GetProjectDateQueryResult = Apollo.QueryResult<GetProjectDateQuery, GetProjectDateQueryVariables>;
export const GetAllRelatedDataForProjectDateDocument = gql`
    query GetAllRelatedDataForProjectDate($withProjectDateReminders: Boolean = false, $withProjects: Boolean = false) {
  projectDateReminders @include(if: $withProjectDateReminders) {
    items {
      id
      displayField: id
    }
  }
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForProjectDateQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForProjectDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForProjectDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForProjectDateQuery({
 *   variables: {
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetAllRelatedDataForProjectDateQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForProjectDateQuery, GetAllRelatedDataForProjectDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForProjectDateQuery, GetAllRelatedDataForProjectDateQueryVariables>(GetAllRelatedDataForProjectDateDocument, options);
      }
export function useGetAllRelatedDataForProjectDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForProjectDateQuery, GetAllRelatedDataForProjectDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForProjectDateQuery, GetAllRelatedDataForProjectDateQueryVariables>(GetAllRelatedDataForProjectDateDocument, options);
        }
export function useGetAllRelatedDataForProjectDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForProjectDateQuery, GetAllRelatedDataForProjectDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForProjectDateQuery, GetAllRelatedDataForProjectDateQueryVariables>(GetAllRelatedDataForProjectDateDocument, options);
        }
export type GetAllRelatedDataForProjectDateQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectDateQuery>;
export type GetAllRelatedDataForProjectDateLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectDateLazyQuery>;
export type GetAllRelatedDataForProjectDateSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectDateSuspenseQuery>;
export type GetAllRelatedDataForProjectDateQueryResult = Apollo.QueryResult<GetAllRelatedDataForProjectDateQuery, GetAllRelatedDataForProjectDateQueryVariables>;
export const CreateProjectDateDocument = gql`
    mutation CreateProjectDate($name: String!, $dateTime: DateTime!, $type: String!, $doneAt: DateTime, $projectDateReminders: [ID], $projectId: ID!, $withProjectDateReminders: Boolean = false, $withProject: Boolean = false) {
  createProjectDate(
    name: $name
    dateTime: $dateTime
    type: $type
    doneAt: $doneAt
    projectDateReminderIds: $projectDateReminders
    projectId: $projectId
  ) {
    ...projectDateFields
  }
}
    ${ProjectDateFieldsFragmentDoc}`;
export type CreateProjectDateMutationFn = Apollo.MutationFunction<CreateProjectDateMutation, CreateProjectDateMutationVariables>;

/**
 * __useCreateProjectDateMutation__
 *
 * To run a mutation, you first call `useCreateProjectDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectDateMutation, { data, loading, error }] = useCreateProjectDateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      dateTime: // value for 'dateTime'
 *      type: // value for 'type'
 *      doneAt: // value for 'doneAt'
 *      projectDateReminders: // value for 'projectDateReminders'
 *      projectId: // value for 'projectId'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreateProjectDateMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectDateMutation, CreateProjectDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectDateMutation, CreateProjectDateMutationVariables>(CreateProjectDateDocument, options);
      }
export type CreateProjectDateMutationHookResult = ReturnType<typeof useCreateProjectDateMutation>;
export type CreateProjectDateMutationResult = Apollo.MutationResult<CreateProjectDateMutation>;
export type CreateProjectDateMutationOptions = Apollo.BaseMutationOptions<CreateProjectDateMutation, CreateProjectDateMutationVariables>;
export const UpdateProjectDateDocument = gql`
    mutation UpdateProjectDate($id: ID!, $name: String, $dateTime: DateTime, $type: String, $doneAt: DateTime, $projectDateReminders: [ID], $projectId: ID, $withProjectDateReminders: Boolean = false, $withProject: Boolean = false) {
  updateProjectDate(
    id: $id
    name: $name
    dateTime: $dateTime
    type: $type
    doneAt: $doneAt
    projectDateReminderIds: $projectDateReminders
    projectId: $projectId
  ) {
    ...projectDateFields
  }
}
    ${ProjectDateFieldsFragmentDoc}`;
export type UpdateProjectDateMutationFn = Apollo.MutationFunction<UpdateProjectDateMutation, UpdateProjectDateMutationVariables>;

/**
 * __useUpdateProjectDateMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDateMutation, { data, loading, error }] = useUpdateProjectDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      dateTime: // value for 'dateTime'
 *      type: // value for 'type'
 *      doneAt: // value for 'doneAt'
 *      projectDateReminders: // value for 'projectDateReminders'
 *      projectId: // value for 'projectId'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdateProjectDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectDateMutation, UpdateProjectDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectDateMutation, UpdateProjectDateMutationVariables>(UpdateProjectDateDocument, options);
      }
export type UpdateProjectDateMutationHookResult = ReturnType<typeof useUpdateProjectDateMutation>;
export type UpdateProjectDateMutationResult = Apollo.MutationResult<UpdateProjectDateMutation>;
export type UpdateProjectDateMutationOptions = Apollo.BaseMutationOptions<UpdateProjectDateMutation, UpdateProjectDateMutationVariables>;
export const DeleteProjectDateDocument = gql`
    mutation DeleteProjectDate($id: ID!, $withProjectDateReminders: Boolean = false, $withProject: Boolean = false) {
  deleteProjectDate(id: $id) {
    ...projectDateFields
  }
}
    ${ProjectDateFieldsFragmentDoc}`;
export type DeleteProjectDateMutationFn = Apollo.MutationFunction<DeleteProjectDateMutation, DeleteProjectDateMutationVariables>;

/**
 * __useDeleteProjectDateMutation__
 *
 * To run a mutation, you first call `useDeleteProjectDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectDateMutation, { data, loading, error }] = useDeleteProjectDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useDeleteProjectDateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectDateMutation, DeleteProjectDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectDateMutation, DeleteProjectDateMutationVariables>(DeleteProjectDateDocument, options);
      }
export type DeleteProjectDateMutationHookResult = ReturnType<typeof useDeleteProjectDateMutation>;
export type DeleteProjectDateMutationResult = Apollo.MutationResult<DeleteProjectDateMutation>;
export type DeleteProjectDateMutationOptions = Apollo.BaseMutationOptions<DeleteProjectDateMutation, DeleteProjectDateMutationVariables>;
export const CreatedProjectDateDocument = gql`
    subscription CreatedProjectDate($filter: ProjectDateFilterArgs, $withProjectDateReminders: Boolean = false, $withProject: Boolean = false) {
  createdProjectDate(filter: $filter) {
    ...projectDateFields
  }
}
    ${ProjectDateFieldsFragmentDoc}`;

/**
 * __useCreatedProjectDateSubscription__
 *
 * To run a query within a React component, call `useCreatedProjectDateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedProjectDateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedProjectDateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreatedProjectDateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedProjectDateSubscription, CreatedProjectDateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedProjectDateSubscription, CreatedProjectDateSubscriptionVariables>(CreatedProjectDateDocument, options);
      }
export type CreatedProjectDateSubscriptionHookResult = ReturnType<typeof useCreatedProjectDateSubscription>;
export type CreatedProjectDateSubscriptionResult = Apollo.SubscriptionResult<CreatedProjectDateSubscription>;
export const UpdatedProjectDateDocument = gql`
    subscription UpdatedProjectDate($filter: ProjectDateFilterArgs, $withProjectDateReminders: Boolean = false, $withProject: Boolean = false) {
  updatedProjectDate(filter: $filter) {
    ...projectDateFields
  }
}
    ${ProjectDateFieldsFragmentDoc}`;

/**
 * __useUpdatedProjectDateSubscription__
 *
 * To run a query within a React component, call `useUpdatedProjectDateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedProjectDateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedProjectDateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdatedProjectDateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedProjectDateSubscription, UpdatedProjectDateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedProjectDateSubscription, UpdatedProjectDateSubscriptionVariables>(UpdatedProjectDateDocument, options);
      }
export type UpdatedProjectDateSubscriptionHookResult = ReturnType<typeof useUpdatedProjectDateSubscription>;
export type UpdatedProjectDateSubscriptionResult = Apollo.SubscriptionResult<UpdatedProjectDateSubscription>;
export const DeletedProjectDateDocument = gql`
    subscription DeletedProjectDate($filter: ProjectDateFilterArgs) {
  deletedProjectDate(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedProjectDateSubscription__
 *
 * To run a query within a React component, call `useDeletedProjectDateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedProjectDateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedProjectDateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedProjectDateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedProjectDateSubscription, DeletedProjectDateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedProjectDateSubscription, DeletedProjectDateSubscriptionVariables>(DeletedProjectDateDocument, options);
      }
export type DeletedProjectDateSubscriptionHookResult = ReturnType<typeof useDeletedProjectDateSubscription>;
export type DeletedProjectDateSubscriptionResult = Apollo.SubscriptionResult<DeletedProjectDateSubscription>;
export const GetProjectDateRemindersDocument = gql`
    query GetProjectDateReminders($filter: ProjectDateReminderFilterArgs, $paging: PageArgs, $sorting: [ProjectDateReminderSortArgs!], $withProjectDate: Boolean = false, $withRoles: Boolean = false) {
  projectDateReminders(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...projectDateReminderFields
    }
    totalCount
  }
}
    ${ProjectDateReminderFieldsFragmentDoc}`;

/**
 * __useGetProjectDateRemindersQuery__
 *
 * To run a query within a React component, call `useGetProjectDateRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDateRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDateRemindersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withProjectDate: // value for 'withProjectDate'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetProjectDateRemindersQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectDateRemindersQuery, GetProjectDateRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDateRemindersQuery, GetProjectDateRemindersQueryVariables>(GetProjectDateRemindersDocument, options);
      }
export function useGetProjectDateRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDateRemindersQuery, GetProjectDateRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDateRemindersQuery, GetProjectDateRemindersQueryVariables>(GetProjectDateRemindersDocument, options);
        }
export function useGetProjectDateRemindersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDateRemindersQuery, GetProjectDateRemindersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDateRemindersQuery, GetProjectDateRemindersQueryVariables>(GetProjectDateRemindersDocument, options);
        }
export type GetProjectDateRemindersQueryHookResult = ReturnType<typeof useGetProjectDateRemindersQuery>;
export type GetProjectDateRemindersLazyQueryHookResult = ReturnType<typeof useGetProjectDateRemindersLazyQuery>;
export type GetProjectDateRemindersSuspenseQueryHookResult = ReturnType<typeof useGetProjectDateRemindersSuspenseQuery>;
export type GetProjectDateRemindersQueryResult = Apollo.QueryResult<GetProjectDateRemindersQuery, GetProjectDateRemindersQueryVariables>;
export const GetProjectDateReminderDocument = gql`
    query GetProjectDateReminder($id: ID!, $withProjectDate: Boolean = false, $withRoles: Boolean = false) {
  projectDateReminder(id: $id) {
    ...projectDateReminderFields
  }
}
    ${ProjectDateReminderFieldsFragmentDoc}`;

/**
 * __useGetProjectDateReminderQuery__
 *
 * To run a query within a React component, call `useGetProjectDateReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDateReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDateReminderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withProjectDate: // value for 'withProjectDate'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetProjectDateReminderQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDateReminderQuery, GetProjectDateReminderQueryVariables> & ({ variables: GetProjectDateReminderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDateReminderQuery, GetProjectDateReminderQueryVariables>(GetProjectDateReminderDocument, options);
      }
export function useGetProjectDateReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDateReminderQuery, GetProjectDateReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDateReminderQuery, GetProjectDateReminderQueryVariables>(GetProjectDateReminderDocument, options);
        }
export function useGetProjectDateReminderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDateReminderQuery, GetProjectDateReminderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDateReminderQuery, GetProjectDateReminderQueryVariables>(GetProjectDateReminderDocument, options);
        }
export type GetProjectDateReminderQueryHookResult = ReturnType<typeof useGetProjectDateReminderQuery>;
export type GetProjectDateReminderLazyQueryHookResult = ReturnType<typeof useGetProjectDateReminderLazyQuery>;
export type GetProjectDateReminderSuspenseQueryHookResult = ReturnType<typeof useGetProjectDateReminderSuspenseQuery>;
export type GetProjectDateReminderQueryResult = Apollo.QueryResult<GetProjectDateReminderQuery, GetProjectDateReminderQueryVariables>;
export const GetAllRelatedDataForProjectDateReminderDocument = gql`
    query GetAllRelatedDataForProjectDateReminder($withProjectDates: Boolean = false, $withRoles: Boolean = false) {
  projectDates @include(if: $withProjectDates) {
    items {
      id
      displayField: name
    }
  }
  roles @include(if: $withRoles) {
    items {
      id
      displayField: displayName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForProjectDateReminderQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForProjectDateReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForProjectDateReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForProjectDateReminderQuery({
 *   variables: {
 *      withProjectDates: // value for 'withProjectDates'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetAllRelatedDataForProjectDateReminderQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForProjectDateReminderQuery, GetAllRelatedDataForProjectDateReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForProjectDateReminderQuery, GetAllRelatedDataForProjectDateReminderQueryVariables>(GetAllRelatedDataForProjectDateReminderDocument, options);
      }
export function useGetAllRelatedDataForProjectDateReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForProjectDateReminderQuery, GetAllRelatedDataForProjectDateReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForProjectDateReminderQuery, GetAllRelatedDataForProjectDateReminderQueryVariables>(GetAllRelatedDataForProjectDateReminderDocument, options);
        }
export function useGetAllRelatedDataForProjectDateReminderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForProjectDateReminderQuery, GetAllRelatedDataForProjectDateReminderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForProjectDateReminderQuery, GetAllRelatedDataForProjectDateReminderQueryVariables>(GetAllRelatedDataForProjectDateReminderDocument, options);
        }
export type GetAllRelatedDataForProjectDateReminderQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectDateReminderQuery>;
export type GetAllRelatedDataForProjectDateReminderLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectDateReminderLazyQuery>;
export type GetAllRelatedDataForProjectDateReminderSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectDateReminderSuspenseQuery>;
export type GetAllRelatedDataForProjectDateReminderQueryResult = Apollo.QueryResult<GetAllRelatedDataForProjectDateReminderQuery, GetAllRelatedDataForProjectDateReminderQueryVariables>;
export const CreateProjectDateReminderDocument = gql`
    mutation CreateProjectDateReminder($advanceHours: Int!, $mailText: String!, $sentAt: DateTime, $projectDateId: ID!, $roles: [ID], $withProjectDate: Boolean = false, $withRoles: Boolean = false) {
  createProjectDateReminder(
    advanceHours: $advanceHours
    mailText: $mailText
    sentAt: $sentAt
    projectDateId: $projectDateId
    roleIds: $roles
  ) {
    ...projectDateReminderFields
  }
}
    ${ProjectDateReminderFieldsFragmentDoc}`;
export type CreateProjectDateReminderMutationFn = Apollo.MutationFunction<CreateProjectDateReminderMutation, CreateProjectDateReminderMutationVariables>;

/**
 * __useCreateProjectDateReminderMutation__
 *
 * To run a mutation, you first call `useCreateProjectDateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectDateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectDateReminderMutation, { data, loading, error }] = useCreateProjectDateReminderMutation({
 *   variables: {
 *      advanceHours: // value for 'advanceHours'
 *      mailText: // value for 'mailText'
 *      sentAt: // value for 'sentAt'
 *      projectDateId: // value for 'projectDateId'
 *      roles: // value for 'roles'
 *      withProjectDate: // value for 'withProjectDate'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useCreateProjectDateReminderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectDateReminderMutation, CreateProjectDateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectDateReminderMutation, CreateProjectDateReminderMutationVariables>(CreateProjectDateReminderDocument, options);
      }
export type CreateProjectDateReminderMutationHookResult = ReturnType<typeof useCreateProjectDateReminderMutation>;
export type CreateProjectDateReminderMutationResult = Apollo.MutationResult<CreateProjectDateReminderMutation>;
export type CreateProjectDateReminderMutationOptions = Apollo.BaseMutationOptions<CreateProjectDateReminderMutation, CreateProjectDateReminderMutationVariables>;
export const UpdateProjectDateReminderDocument = gql`
    mutation UpdateProjectDateReminder($id: ID!, $advanceHours: Int, $mailText: String, $sentAt: DateTime, $projectDateId: ID, $roles: [ID], $withProjectDate: Boolean = false, $withRoles: Boolean = false) {
  updateProjectDateReminder(
    id: $id
    advanceHours: $advanceHours
    mailText: $mailText
    sentAt: $sentAt
    projectDateId: $projectDateId
    roleIds: $roles
  ) {
    ...projectDateReminderFields
  }
}
    ${ProjectDateReminderFieldsFragmentDoc}`;
export type UpdateProjectDateReminderMutationFn = Apollo.MutationFunction<UpdateProjectDateReminderMutation, UpdateProjectDateReminderMutationVariables>;

/**
 * __useUpdateProjectDateReminderMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDateReminderMutation, { data, loading, error }] = useUpdateProjectDateReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      advanceHours: // value for 'advanceHours'
 *      mailText: // value for 'mailText'
 *      sentAt: // value for 'sentAt'
 *      projectDateId: // value for 'projectDateId'
 *      roles: // value for 'roles'
 *      withProjectDate: // value for 'withProjectDate'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useUpdateProjectDateReminderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectDateReminderMutation, UpdateProjectDateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectDateReminderMutation, UpdateProjectDateReminderMutationVariables>(UpdateProjectDateReminderDocument, options);
      }
export type UpdateProjectDateReminderMutationHookResult = ReturnType<typeof useUpdateProjectDateReminderMutation>;
export type UpdateProjectDateReminderMutationResult = Apollo.MutationResult<UpdateProjectDateReminderMutation>;
export type UpdateProjectDateReminderMutationOptions = Apollo.BaseMutationOptions<UpdateProjectDateReminderMutation, UpdateProjectDateReminderMutationVariables>;
export const DeleteProjectDateReminderDocument = gql`
    mutation DeleteProjectDateReminder($id: ID!, $withProjectDate: Boolean = false, $withRoles: Boolean = false) {
  deleteProjectDateReminder(id: $id) {
    ...projectDateReminderFields
  }
}
    ${ProjectDateReminderFieldsFragmentDoc}`;
export type DeleteProjectDateReminderMutationFn = Apollo.MutationFunction<DeleteProjectDateReminderMutation, DeleteProjectDateReminderMutationVariables>;

/**
 * __useDeleteProjectDateReminderMutation__
 *
 * To run a mutation, you first call `useDeleteProjectDateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectDateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectDateReminderMutation, { data, loading, error }] = useDeleteProjectDateReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withProjectDate: // value for 'withProjectDate'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useDeleteProjectDateReminderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectDateReminderMutation, DeleteProjectDateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectDateReminderMutation, DeleteProjectDateReminderMutationVariables>(DeleteProjectDateReminderDocument, options);
      }
export type DeleteProjectDateReminderMutationHookResult = ReturnType<typeof useDeleteProjectDateReminderMutation>;
export type DeleteProjectDateReminderMutationResult = Apollo.MutationResult<DeleteProjectDateReminderMutation>;
export type DeleteProjectDateReminderMutationOptions = Apollo.BaseMutationOptions<DeleteProjectDateReminderMutation, DeleteProjectDateReminderMutationVariables>;
export const CreatedProjectDateReminderDocument = gql`
    subscription CreatedProjectDateReminder($filter: ProjectDateReminderFilterArgs, $withProjectDate: Boolean = false, $withRoles: Boolean = false) {
  createdProjectDateReminder(filter: $filter) {
    ...projectDateReminderFields
  }
}
    ${ProjectDateReminderFieldsFragmentDoc}`;

/**
 * __useCreatedProjectDateReminderSubscription__
 *
 * To run a query within a React component, call `useCreatedProjectDateReminderSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedProjectDateReminderSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedProjectDateReminderSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjectDate: // value for 'withProjectDate'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useCreatedProjectDateReminderSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedProjectDateReminderSubscription, CreatedProjectDateReminderSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedProjectDateReminderSubscription, CreatedProjectDateReminderSubscriptionVariables>(CreatedProjectDateReminderDocument, options);
      }
export type CreatedProjectDateReminderSubscriptionHookResult = ReturnType<typeof useCreatedProjectDateReminderSubscription>;
export type CreatedProjectDateReminderSubscriptionResult = Apollo.SubscriptionResult<CreatedProjectDateReminderSubscription>;
export const UpdatedProjectDateReminderDocument = gql`
    subscription UpdatedProjectDateReminder($filter: ProjectDateReminderFilterArgs, $withProjectDate: Boolean = false, $withRoles: Boolean = false) {
  updatedProjectDateReminder(filter: $filter) {
    ...projectDateReminderFields
  }
}
    ${ProjectDateReminderFieldsFragmentDoc}`;

/**
 * __useUpdatedProjectDateReminderSubscription__
 *
 * To run a query within a React component, call `useUpdatedProjectDateReminderSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedProjectDateReminderSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedProjectDateReminderSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjectDate: // value for 'withProjectDate'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useUpdatedProjectDateReminderSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedProjectDateReminderSubscription, UpdatedProjectDateReminderSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedProjectDateReminderSubscription, UpdatedProjectDateReminderSubscriptionVariables>(UpdatedProjectDateReminderDocument, options);
      }
export type UpdatedProjectDateReminderSubscriptionHookResult = ReturnType<typeof useUpdatedProjectDateReminderSubscription>;
export type UpdatedProjectDateReminderSubscriptionResult = Apollo.SubscriptionResult<UpdatedProjectDateReminderSubscription>;
export const DeletedProjectDateReminderDocument = gql`
    subscription DeletedProjectDateReminder($filter: ProjectDateReminderFilterArgs) {
  deletedProjectDateReminder(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedProjectDateReminderSubscription__
 *
 * To run a query within a React component, call `useDeletedProjectDateReminderSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedProjectDateReminderSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedProjectDateReminderSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedProjectDateReminderSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedProjectDateReminderSubscription, DeletedProjectDateReminderSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedProjectDateReminderSubscription, DeletedProjectDateReminderSubscriptionVariables>(DeletedProjectDateReminderDocument, options);
      }
export type DeletedProjectDateReminderSubscriptionHookResult = ReturnType<typeof useDeletedProjectDateReminderSubscription>;
export type DeletedProjectDateReminderSubscriptionResult = Apollo.SubscriptionResult<DeletedProjectDateReminderSubscription>;
export const RestoredProjectDateReminderDocument = gql`
    subscription RestoredProjectDateReminder($filter: ProjectDateReminderFilterArgs, $withProjectDate: Boolean = false, $withRoles: Boolean = false) {
  restoredProjectDateReminder(filter: $filter) {
    ...projectDateReminderFields
  }
}
    ${ProjectDateReminderFieldsFragmentDoc}`;

/**
 * __useRestoredProjectDateReminderSubscription__
 *
 * To run a query within a React component, call `useRestoredProjectDateReminderSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredProjectDateReminderSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredProjectDateReminderSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjectDate: // value for 'withProjectDate'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useRestoredProjectDateReminderSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredProjectDateReminderSubscription, RestoredProjectDateReminderSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredProjectDateReminderSubscription, RestoredProjectDateReminderSubscriptionVariables>(RestoredProjectDateReminderDocument, options);
      }
export type RestoredProjectDateReminderSubscriptionHookResult = ReturnType<typeof useRestoredProjectDateReminderSubscription>;
export type RestoredProjectDateReminderSubscriptionResult = Apollo.SubscriptionResult<RestoredProjectDateReminderSubscription>;
export const GetProjectDocumentsDocument = gql`
    query GetProjectDocuments($filter: ProjectDocumentFilterArgs, $paging: PageArgs, $sorting: [ProjectDocumentSortArgs!], $withProject: Boolean = false) {
  projectDocuments(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...projectDocumentFields
    }
    totalCount
  }
}
    ${ProjectDocumentFieldsFragmentDoc}`;

/**
 * __useGetProjectDocumentsQuery__
 *
 * To run a query within a React component, call `useGetProjectDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetProjectDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>(GetProjectDocumentsDocument, options);
      }
export function useGetProjectDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>(GetProjectDocumentsDocument, options);
        }
export function useGetProjectDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>(GetProjectDocumentsDocument, options);
        }
export type GetProjectDocumentsQueryHookResult = ReturnType<typeof useGetProjectDocumentsQuery>;
export type GetProjectDocumentsLazyQueryHookResult = ReturnType<typeof useGetProjectDocumentsLazyQuery>;
export type GetProjectDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetProjectDocumentsSuspenseQuery>;
export type GetProjectDocumentsQueryResult = Apollo.QueryResult<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>;
export const GetProjectDocumentDocument = gql`
    query GetProjectDocument($id: ID!, $withProject: Boolean = false) {
  projectDocument(id: $id) {
    ...projectDocumentFields
  }
}
    ${ProjectDocumentFieldsFragmentDoc}`;

/**
 * __useGetProjectDocumentQuery__
 *
 * To run a query within a React component, call `useGetProjectDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetProjectDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDocumentQuery, GetProjectDocumentQueryVariables> & ({ variables: GetProjectDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDocumentQuery, GetProjectDocumentQueryVariables>(GetProjectDocumentDocument, options);
      }
export function useGetProjectDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDocumentQuery, GetProjectDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDocumentQuery, GetProjectDocumentQueryVariables>(GetProjectDocumentDocument, options);
        }
export function useGetProjectDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDocumentQuery, GetProjectDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDocumentQuery, GetProjectDocumentQueryVariables>(GetProjectDocumentDocument, options);
        }
export type GetProjectDocumentQueryHookResult = ReturnType<typeof useGetProjectDocumentQuery>;
export type GetProjectDocumentLazyQueryHookResult = ReturnType<typeof useGetProjectDocumentLazyQuery>;
export type GetProjectDocumentSuspenseQueryHookResult = ReturnType<typeof useGetProjectDocumentSuspenseQuery>;
export type GetProjectDocumentQueryResult = Apollo.QueryResult<GetProjectDocumentQuery, GetProjectDocumentQueryVariables>;
export const GetAllRelatedDataForProjectDocumentDocument = gql`
    query GetAllRelatedDataForProjectDocument($withProjects: Boolean = false) {
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForProjectDocumentQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForProjectDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForProjectDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForProjectDocumentQuery({
 *   variables: {
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetAllRelatedDataForProjectDocumentQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForProjectDocumentQuery, GetAllRelatedDataForProjectDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForProjectDocumentQuery, GetAllRelatedDataForProjectDocumentQueryVariables>(GetAllRelatedDataForProjectDocumentDocument, options);
      }
export function useGetAllRelatedDataForProjectDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForProjectDocumentQuery, GetAllRelatedDataForProjectDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForProjectDocumentQuery, GetAllRelatedDataForProjectDocumentQueryVariables>(GetAllRelatedDataForProjectDocumentDocument, options);
        }
export function useGetAllRelatedDataForProjectDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForProjectDocumentQuery, GetAllRelatedDataForProjectDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForProjectDocumentQuery, GetAllRelatedDataForProjectDocumentQueryVariables>(GetAllRelatedDataForProjectDocumentDocument, options);
        }
export type GetAllRelatedDataForProjectDocumentQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectDocumentQuery>;
export type GetAllRelatedDataForProjectDocumentLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectDocumentLazyQuery>;
export type GetAllRelatedDataForProjectDocumentSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForProjectDocumentSuspenseQuery>;
export type GetAllRelatedDataForProjectDocumentQueryResult = Apollo.QueryResult<GetAllRelatedDataForProjectDocumentQuery, GetAllRelatedDataForProjectDocumentQueryVariables>;
export const CreateProjectDocumentDocument = gql`
    mutation CreateProjectDocument($name: String!, $description: String, $attachment: String!, $projectId: ID!, $withProject: Boolean = false) {
  createProjectDocument(
    name: $name
    description: $description
    attachment: $attachment
    projectId: $projectId
  ) {
    ...projectDocumentFields
  }
}
    ${ProjectDocumentFieldsFragmentDoc}`;
export type CreateProjectDocumentMutationFn = Apollo.MutationFunction<CreateProjectDocumentMutation, CreateProjectDocumentMutationVariables>;

/**
 * __useCreateProjectDocumentMutation__
 *
 * To run a mutation, you first call `useCreateProjectDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectDocumentMutation, { data, loading, error }] = useCreateProjectDocumentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      attachment: // value for 'attachment'
 *      projectId: // value for 'projectId'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreateProjectDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectDocumentMutation, CreateProjectDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectDocumentMutation, CreateProjectDocumentMutationVariables>(CreateProjectDocumentDocument, options);
      }
export type CreateProjectDocumentMutationHookResult = ReturnType<typeof useCreateProjectDocumentMutation>;
export type CreateProjectDocumentMutationResult = Apollo.MutationResult<CreateProjectDocumentMutation>;
export type CreateProjectDocumentMutationOptions = Apollo.BaseMutationOptions<CreateProjectDocumentMutation, CreateProjectDocumentMutationVariables>;
export const UpdateProjectDocumentDocument = gql`
    mutation UpdateProjectDocument($id: ID!, $name: String, $description: String, $attachment: String, $projectId: ID, $withProject: Boolean = false) {
  updateProjectDocument(
    id: $id
    name: $name
    description: $description
    attachment: $attachment
    projectId: $projectId
  ) {
    ...projectDocumentFields
  }
}
    ${ProjectDocumentFieldsFragmentDoc}`;
export type UpdateProjectDocumentMutationFn = Apollo.MutationFunction<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>;

/**
 * __useUpdateProjectDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDocumentMutation, { data, loading, error }] = useUpdateProjectDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      attachment: // value for 'attachment'
 *      projectId: // value for 'projectId'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdateProjectDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>(UpdateProjectDocumentDocument, options);
      }
export type UpdateProjectDocumentMutationHookResult = ReturnType<typeof useUpdateProjectDocumentMutation>;
export type UpdateProjectDocumentMutationResult = Apollo.MutationResult<UpdateProjectDocumentMutation>;
export type UpdateProjectDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>;
export const DeleteProjectDocumentDocument = gql`
    mutation DeleteProjectDocument($id: ID!, $withProject: Boolean = false) {
  deleteProjectDocument(id: $id) {
    ...projectDocumentFields
  }
}
    ${ProjectDocumentFieldsFragmentDoc}`;
export type DeleteProjectDocumentMutationFn = Apollo.MutationFunction<DeleteProjectDocumentMutation, DeleteProjectDocumentMutationVariables>;

/**
 * __useDeleteProjectDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteProjectDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectDocumentMutation, { data, loading, error }] = useDeleteProjectDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useDeleteProjectDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectDocumentMutation, DeleteProjectDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectDocumentMutation, DeleteProjectDocumentMutationVariables>(DeleteProjectDocumentDocument, options);
      }
export type DeleteProjectDocumentMutationHookResult = ReturnType<typeof useDeleteProjectDocumentMutation>;
export type DeleteProjectDocumentMutationResult = Apollo.MutationResult<DeleteProjectDocumentMutation>;
export type DeleteProjectDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteProjectDocumentMutation, DeleteProjectDocumentMutationVariables>;
export const CreatedProjectDocumentDocument = gql`
    subscription CreatedProjectDocument($filter: ProjectDocumentFilterArgs, $withProject: Boolean = false) {
  createdProjectDocument(filter: $filter) {
    ...projectDocumentFields
  }
}
    ${ProjectDocumentFieldsFragmentDoc}`;

/**
 * __useCreatedProjectDocumentSubscription__
 *
 * To run a query within a React component, call `useCreatedProjectDocumentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedProjectDocumentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedProjectDocumentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreatedProjectDocumentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedProjectDocumentSubscription, CreatedProjectDocumentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedProjectDocumentSubscription, CreatedProjectDocumentSubscriptionVariables>(CreatedProjectDocumentDocument, options);
      }
export type CreatedProjectDocumentSubscriptionHookResult = ReturnType<typeof useCreatedProjectDocumentSubscription>;
export type CreatedProjectDocumentSubscriptionResult = Apollo.SubscriptionResult<CreatedProjectDocumentSubscription>;
export const UpdatedProjectDocumentDocument = gql`
    subscription UpdatedProjectDocument($filter: ProjectDocumentFilterArgs, $withProject: Boolean = false) {
  updatedProjectDocument(filter: $filter) {
    ...projectDocumentFields
  }
}
    ${ProjectDocumentFieldsFragmentDoc}`;

/**
 * __useUpdatedProjectDocumentSubscription__
 *
 * To run a query within a React component, call `useUpdatedProjectDocumentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedProjectDocumentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedProjectDocumentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdatedProjectDocumentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedProjectDocumentSubscription, UpdatedProjectDocumentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedProjectDocumentSubscription, UpdatedProjectDocumentSubscriptionVariables>(UpdatedProjectDocumentDocument, options);
      }
export type UpdatedProjectDocumentSubscriptionHookResult = ReturnType<typeof useUpdatedProjectDocumentSubscription>;
export type UpdatedProjectDocumentSubscriptionResult = Apollo.SubscriptionResult<UpdatedProjectDocumentSubscription>;
export const DeletedProjectDocumentDocument = gql`
    subscription DeletedProjectDocument($filter: ProjectDocumentFilterArgs) {
  deletedProjectDocument(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedProjectDocumentSubscription__
 *
 * To run a query within a React component, call `useDeletedProjectDocumentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedProjectDocumentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedProjectDocumentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedProjectDocumentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedProjectDocumentSubscription, DeletedProjectDocumentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedProjectDocumentSubscription, DeletedProjectDocumentSubscriptionVariables>(DeletedProjectDocumentDocument, options);
      }
export type DeletedProjectDocumentSubscriptionHookResult = ReturnType<typeof useDeletedProjectDocumentSubscription>;
export type DeletedProjectDocumentSubscriptionResult = Apollo.SubscriptionResult<DeletedProjectDocumentSubscription>;
export const GetRegulationsDocument = gql`
    query GetRegulations($filter: RegulationFilterArgs, $paging: PageArgs, $sorting: [RegulationSortArgs!], $withProjects: Boolean = false) {
  regulations(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...regulationFields
    }
    totalCount
  }
}
    ${RegulationFieldsFragmentDoc}`;

/**
 * __useGetRegulationsQuery__
 *
 * To run a query within a React component, call `useGetRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetRegulationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegulationsQuery, GetRegulationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationsQuery, GetRegulationsQueryVariables>(GetRegulationsDocument, options);
      }
export function useGetRegulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationsQuery, GetRegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationsQuery, GetRegulationsQueryVariables>(GetRegulationsDocument, options);
        }
export function useGetRegulationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegulationsQuery, GetRegulationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegulationsQuery, GetRegulationsQueryVariables>(GetRegulationsDocument, options);
        }
export type GetRegulationsQueryHookResult = ReturnType<typeof useGetRegulationsQuery>;
export type GetRegulationsLazyQueryHookResult = ReturnType<typeof useGetRegulationsLazyQuery>;
export type GetRegulationsSuspenseQueryHookResult = ReturnType<typeof useGetRegulationsSuspenseQuery>;
export type GetRegulationsQueryResult = Apollo.QueryResult<GetRegulationsQuery, GetRegulationsQueryVariables>;
export const GetRegulationDocument = gql`
    query GetRegulation($id: ID!, $withProjects: Boolean = false) {
  regulation(id: $id) {
    ...regulationFields
  }
}
    ${RegulationFieldsFragmentDoc}`;

/**
 * __useGetRegulationQuery__
 *
 * To run a query within a React component, call `useGetRegulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetRegulationQuery(baseOptions: Apollo.QueryHookOptions<GetRegulationQuery, GetRegulationQueryVariables> & ({ variables: GetRegulationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationQuery, GetRegulationQueryVariables>(GetRegulationDocument, options);
      }
export function useGetRegulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationQuery, GetRegulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationQuery, GetRegulationQueryVariables>(GetRegulationDocument, options);
        }
export function useGetRegulationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegulationQuery, GetRegulationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegulationQuery, GetRegulationQueryVariables>(GetRegulationDocument, options);
        }
export type GetRegulationQueryHookResult = ReturnType<typeof useGetRegulationQuery>;
export type GetRegulationLazyQueryHookResult = ReturnType<typeof useGetRegulationLazyQuery>;
export type GetRegulationSuspenseQueryHookResult = ReturnType<typeof useGetRegulationSuspenseQuery>;
export type GetRegulationQueryResult = Apollo.QueryResult<GetRegulationQuery, GetRegulationQueryVariables>;
export const GetAllRelatedDataForRegulationDocument = gql`
    query GetAllRelatedDataForRegulation($withProjects: Boolean = false) {
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForRegulationQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForRegulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForRegulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForRegulationQuery({
 *   variables: {
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetAllRelatedDataForRegulationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForRegulationQuery, GetAllRelatedDataForRegulationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForRegulationQuery, GetAllRelatedDataForRegulationQueryVariables>(GetAllRelatedDataForRegulationDocument, options);
      }
export function useGetAllRelatedDataForRegulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForRegulationQuery, GetAllRelatedDataForRegulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForRegulationQuery, GetAllRelatedDataForRegulationQueryVariables>(GetAllRelatedDataForRegulationDocument, options);
        }
export function useGetAllRelatedDataForRegulationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForRegulationQuery, GetAllRelatedDataForRegulationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForRegulationQuery, GetAllRelatedDataForRegulationQueryVariables>(GetAllRelatedDataForRegulationDocument, options);
        }
export type GetAllRelatedDataForRegulationQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRegulationQuery>;
export type GetAllRelatedDataForRegulationLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRegulationLazyQuery>;
export type GetAllRelatedDataForRegulationSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRegulationSuspenseQuery>;
export type GetAllRelatedDataForRegulationQueryResult = Apollo.QueryResult<GetAllRelatedDataForRegulationQuery, GetAllRelatedDataForRegulationQueryVariables>;
export const CreateRegulationDocument = gql`
    mutation CreateRegulation($name: String!, $description: String, $projects: [ID], $withProjects: Boolean = false) {
  createRegulation(name: $name, description: $description, projectIds: $projects) {
    ...regulationFields
  }
}
    ${RegulationFieldsFragmentDoc}`;
export type CreateRegulationMutationFn = Apollo.MutationFunction<CreateRegulationMutation, CreateRegulationMutationVariables>;

/**
 * __useCreateRegulationMutation__
 *
 * To run a mutation, you first call `useCreateRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegulationMutation, { data, loading, error }] = useCreateRegulationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      projects: // value for 'projects'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useCreateRegulationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegulationMutation, CreateRegulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegulationMutation, CreateRegulationMutationVariables>(CreateRegulationDocument, options);
      }
export type CreateRegulationMutationHookResult = ReturnType<typeof useCreateRegulationMutation>;
export type CreateRegulationMutationResult = Apollo.MutationResult<CreateRegulationMutation>;
export type CreateRegulationMutationOptions = Apollo.BaseMutationOptions<CreateRegulationMutation, CreateRegulationMutationVariables>;
export const UpdateRegulationDocument = gql`
    mutation UpdateRegulation($id: ID!, $name: String, $description: String, $projects: [ID], $withProjects: Boolean = false) {
  updateRegulation(
    id: $id
    name: $name
    description: $description
    projectIds: $projects
  ) {
    ...regulationFields
  }
}
    ${RegulationFieldsFragmentDoc}`;
export type UpdateRegulationMutationFn = Apollo.MutationFunction<UpdateRegulationMutation, UpdateRegulationMutationVariables>;

/**
 * __useUpdateRegulationMutation__
 *
 * To run a mutation, you first call `useUpdateRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulationMutation, { data, loading, error }] = useUpdateRegulationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      projects: // value for 'projects'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useUpdateRegulationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulationMutation, UpdateRegulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegulationMutation, UpdateRegulationMutationVariables>(UpdateRegulationDocument, options);
      }
export type UpdateRegulationMutationHookResult = ReturnType<typeof useUpdateRegulationMutation>;
export type UpdateRegulationMutationResult = Apollo.MutationResult<UpdateRegulationMutation>;
export type UpdateRegulationMutationOptions = Apollo.BaseMutationOptions<UpdateRegulationMutation, UpdateRegulationMutationVariables>;
export const DeleteRegulationDocument = gql`
    mutation DeleteRegulation($id: ID!, $withProjects: Boolean = false) {
  deleteRegulation(id: $id) {
    ...regulationFields
  }
}
    ${RegulationFieldsFragmentDoc}`;
export type DeleteRegulationMutationFn = Apollo.MutationFunction<DeleteRegulationMutation, DeleteRegulationMutationVariables>;

/**
 * __useDeleteRegulationMutation__
 *
 * To run a mutation, you first call `useDeleteRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegulationMutation, { data, loading, error }] = useDeleteRegulationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useDeleteRegulationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegulationMutation, DeleteRegulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegulationMutation, DeleteRegulationMutationVariables>(DeleteRegulationDocument, options);
      }
export type DeleteRegulationMutationHookResult = ReturnType<typeof useDeleteRegulationMutation>;
export type DeleteRegulationMutationResult = Apollo.MutationResult<DeleteRegulationMutation>;
export type DeleteRegulationMutationOptions = Apollo.BaseMutationOptions<DeleteRegulationMutation, DeleteRegulationMutationVariables>;
export const CreatedRegulationDocument = gql`
    subscription CreatedRegulation($filter: RegulationFilterArgs, $withProjects: Boolean = false) {
  createdRegulation(filter: $filter) {
    ...regulationFields
  }
}
    ${RegulationFieldsFragmentDoc}`;

/**
 * __useCreatedRegulationSubscription__
 *
 * To run a query within a React component, call `useCreatedRegulationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedRegulationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedRegulationSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useCreatedRegulationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedRegulationSubscription, CreatedRegulationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedRegulationSubscription, CreatedRegulationSubscriptionVariables>(CreatedRegulationDocument, options);
      }
export type CreatedRegulationSubscriptionHookResult = ReturnType<typeof useCreatedRegulationSubscription>;
export type CreatedRegulationSubscriptionResult = Apollo.SubscriptionResult<CreatedRegulationSubscription>;
export const UpdatedRegulationDocument = gql`
    subscription UpdatedRegulation($filter: RegulationFilterArgs, $withProjects: Boolean = false) {
  updatedRegulation(filter: $filter) {
    ...regulationFields
  }
}
    ${RegulationFieldsFragmentDoc}`;

/**
 * __useUpdatedRegulationSubscription__
 *
 * To run a query within a React component, call `useUpdatedRegulationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedRegulationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedRegulationSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useUpdatedRegulationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedRegulationSubscription, UpdatedRegulationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedRegulationSubscription, UpdatedRegulationSubscriptionVariables>(UpdatedRegulationDocument, options);
      }
export type UpdatedRegulationSubscriptionHookResult = ReturnType<typeof useUpdatedRegulationSubscription>;
export type UpdatedRegulationSubscriptionResult = Apollo.SubscriptionResult<UpdatedRegulationSubscription>;
export const DeletedRegulationDocument = gql`
    subscription DeletedRegulation($filter: RegulationFilterArgs) {
  deletedRegulation(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedRegulationSubscription__
 *
 * To run a query within a React component, call `useDeletedRegulationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedRegulationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedRegulationSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedRegulationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedRegulationSubscription, DeletedRegulationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedRegulationSubscription, DeletedRegulationSubscriptionVariables>(DeletedRegulationDocument, options);
      }
export type DeletedRegulationSubscriptionHookResult = ReturnType<typeof useDeletedRegulationSubscription>;
export type DeletedRegulationSubscriptionResult = Apollo.SubscriptionResult<DeletedRegulationSubscription>;
export const GetResetPasswordsDocument = gql`
    query GetResetPasswords($filter: ResetPasswordFilterArgs, $paging: PageArgs, $sorting: [ResetPasswordSortArgs!]) {
  resetPasswords(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...resetPasswordFields
    }
    totalCount
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useGetResetPasswordsQuery__
 *
 * To run a query within a React component, call `useGetResetPasswordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResetPasswordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResetPasswordsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetResetPasswordsQuery(baseOptions?: Apollo.QueryHookOptions<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>(GetResetPasswordsDocument, options);
      }
export function useGetResetPasswordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>(GetResetPasswordsDocument, options);
        }
export function useGetResetPasswordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>(GetResetPasswordsDocument, options);
        }
export type GetResetPasswordsQueryHookResult = ReturnType<typeof useGetResetPasswordsQuery>;
export type GetResetPasswordsLazyQueryHookResult = ReturnType<typeof useGetResetPasswordsLazyQuery>;
export type GetResetPasswordsSuspenseQueryHookResult = ReturnType<typeof useGetResetPasswordsSuspenseQuery>;
export type GetResetPasswordsQueryResult = Apollo.QueryResult<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>;
export const GetResetPasswordDocument = gql`
    query GetResetPassword($id: ID!) {
  resetPassword(id: $id) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useGetResetPasswordQuery__
 *
 * To run a query within a React component, call `useGetResetPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResetPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResetPasswordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResetPasswordQuery(baseOptions: Apollo.QueryHookOptions<GetResetPasswordQuery, GetResetPasswordQueryVariables> & ({ variables: GetResetPasswordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResetPasswordQuery, GetResetPasswordQueryVariables>(GetResetPasswordDocument, options);
      }
export function useGetResetPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResetPasswordQuery, GetResetPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResetPasswordQuery, GetResetPasswordQueryVariables>(GetResetPasswordDocument, options);
        }
export function useGetResetPasswordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResetPasswordQuery, GetResetPasswordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResetPasswordQuery, GetResetPasswordQueryVariables>(GetResetPasswordDocument, options);
        }
export type GetResetPasswordQueryHookResult = ReturnType<typeof useGetResetPasswordQuery>;
export type GetResetPasswordLazyQueryHookResult = ReturnType<typeof useGetResetPasswordLazyQuery>;
export type GetResetPasswordSuspenseQueryHookResult = ReturnType<typeof useGetResetPasswordSuspenseQuery>;
export type GetResetPasswordQueryResult = Apollo.QueryResult<GetResetPasswordQuery, GetResetPasswordQueryVariables>;
export const CreateResetPasswordDocument = gql`
    mutation CreateResetPassword($email: String!, $token: String!, $type: String!) {
  createResetPassword(email: $email, token: $token, type: $type) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;
export type CreateResetPasswordMutationFn = Apollo.MutationFunction<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>;

/**
 * __useCreateResetPasswordMutation__
 *
 * To run a mutation, you first call `useCreateResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResetPasswordMutation, { data, loading, error }] = useCreateResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>(CreateResetPasswordDocument, options);
      }
export type CreateResetPasswordMutationHookResult = ReturnType<typeof useCreateResetPasswordMutation>;
export type CreateResetPasswordMutationResult = Apollo.MutationResult<CreateResetPasswordMutation>;
export type CreateResetPasswordMutationOptions = Apollo.BaseMutationOptions<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>;
export const UpdateResetPasswordDocument = gql`
    mutation UpdateResetPassword($id: ID!, $email: String, $token: String, $type: String) {
  updateResetPassword(id: $id, email: $email, token: $token, type: $type) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;
export type UpdateResetPasswordMutationFn = Apollo.MutationFunction<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>;

/**
 * __useUpdateResetPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResetPasswordMutation, { data, loading, error }] = useUpdateResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>(UpdateResetPasswordDocument, options);
      }
export type UpdateResetPasswordMutationHookResult = ReturnType<typeof useUpdateResetPasswordMutation>;
export type UpdateResetPasswordMutationResult = Apollo.MutationResult<UpdateResetPasswordMutation>;
export type UpdateResetPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>;
export const DeleteResetPasswordDocument = gql`
    mutation DeleteResetPassword($id: ID!) {
  deleteResetPassword(id: $id) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;
export type DeleteResetPasswordMutationFn = Apollo.MutationFunction<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>;

/**
 * __useDeleteResetPasswordMutation__
 *
 * To run a mutation, you first call `useDeleteResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResetPasswordMutation, { data, loading, error }] = useDeleteResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>(DeleteResetPasswordDocument, options);
      }
export type DeleteResetPasswordMutationHookResult = ReturnType<typeof useDeleteResetPasswordMutation>;
export type DeleteResetPasswordMutationResult = Apollo.MutationResult<DeleteResetPasswordMutation>;
export type DeleteResetPasswordMutationOptions = Apollo.BaseMutationOptions<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>;
export const CreatedResetPasswordDocument = gql`
    subscription CreatedResetPassword($filter: ResetPasswordFilterArgs) {
  createdResetPassword(filter: $filter) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useCreatedResetPasswordSubscription__
 *
 * To run a query within a React component, call `useCreatedResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedResetPasswordSubscription, CreatedResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedResetPasswordSubscription, CreatedResetPasswordSubscriptionVariables>(CreatedResetPasswordDocument, options);
      }
export type CreatedResetPasswordSubscriptionHookResult = ReturnType<typeof useCreatedResetPasswordSubscription>;
export type CreatedResetPasswordSubscriptionResult = Apollo.SubscriptionResult<CreatedResetPasswordSubscription>;
export const UpdatedResetPasswordDocument = gql`
    subscription UpdatedResetPassword($filter: ResetPasswordFilterArgs) {
  updatedResetPassword(filter: $filter) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useUpdatedResetPasswordSubscription__
 *
 * To run a query within a React component, call `useUpdatedResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedResetPasswordSubscription, UpdatedResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedResetPasswordSubscription, UpdatedResetPasswordSubscriptionVariables>(UpdatedResetPasswordDocument, options);
      }
export type UpdatedResetPasswordSubscriptionHookResult = ReturnType<typeof useUpdatedResetPasswordSubscription>;
export type UpdatedResetPasswordSubscriptionResult = Apollo.SubscriptionResult<UpdatedResetPasswordSubscription>;
export const DeletedResetPasswordDocument = gql`
    subscription DeletedResetPassword($filter: ResetPasswordFilterArgs) {
  deletedResetPassword(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedResetPasswordSubscription__
 *
 * To run a query within a React component, call `useDeletedResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedResetPasswordSubscription, DeletedResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedResetPasswordSubscription, DeletedResetPasswordSubscriptionVariables>(DeletedResetPasswordDocument, options);
      }
export type DeletedResetPasswordSubscriptionHookResult = ReturnType<typeof useDeletedResetPasswordSubscription>;
export type DeletedResetPasswordSubscriptionResult = Apollo.SubscriptionResult<DeletedResetPasswordSubscription>;
export const GetRolesDocument = gql`
    query GetRoles($filter: RoleFilterArgs, $paging: PageArgs, $sorting: [RoleSortArgs!], $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false, $withProjectDateReminders: Boolean = false) {
  roles(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...roleFields
    }
    totalCount
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetRoleDocument = gql`
    query GetRole($id: ID!, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false, $withProjectDateReminders: Boolean = false) {
  role(id: $id) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables> & ({ variables: GetRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleSuspenseQueryHookResult = ReturnType<typeof useGetRoleSuspenseQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const GetAllRelatedDataForRoleDocument = gql`
    query GetAllRelatedDataForRole($withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false, $withProjectDateReminders: Boolean = false) {
  permissions @include(if: $withPermissions) {
    items {
      id
      displayField: name
    }
  }
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
  projectDateReminders @include(if: $withProjectDateReminders) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForRoleQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForRoleQuery({
 *   variables: {
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *   },
 * });
 */
export function useGetAllRelatedDataForRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>(GetAllRelatedDataForRoleDocument, options);
      }
export function useGetAllRelatedDataForRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>(GetAllRelatedDataForRoleDocument, options);
        }
export function useGetAllRelatedDataForRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>(GetAllRelatedDataForRoleDocument, options);
        }
export type GetAllRelatedDataForRoleQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRoleQuery>;
export type GetAllRelatedDataForRoleLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRoleLazyQuery>;
export type GetAllRelatedDataForRoleSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRoleSuspenseQuery>;
export type GetAllRelatedDataForRoleQueryResult = Apollo.QueryResult<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($displayName: String!, $description: String!, $order: Int, $permissions: [ID], $userTenantRoles: [ID], $projectDateReminders: [ID], $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false, $withProjectDateReminders: Boolean = false) {
  createRole(
    displayName: $displayName
    description: $description
    order: $order
    permissionIds: $permissions
    userTenantRoleIds: $userTenantRoles
    projectDateReminderIds: $projectDateReminders
  ) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      order: // value for 'order'
 *      permissions: // value for 'permissions'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      projectDateReminders: // value for 'projectDateReminders'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($id: ID!, $displayName: String, $description: String, $order: Int, $permissions: [ID], $userTenantRoles: [ID], $projectDateReminders: [ID], $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false, $withProjectDateReminders: Boolean = false) {
  updateRole(
    id: $id
    displayName: $displayName
    description: $description
    order: $order
    permissionIds: $permissions
    userTenantRoleIds: $userTenantRoles
    projectDateReminderIds: $projectDateReminders
  ) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      order: // value for 'order'
 *      permissions: // value for 'permissions'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      projectDateReminders: // value for 'projectDateReminders'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($id: ID!, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false, $withProjectDateReminders: Boolean = false) {
  deleteRole(id: $id) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const CreatedRoleDocument = gql`
    subscription CreatedRole($filter: RoleFilterArgs, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false, $withProjectDateReminders: Boolean = false) {
  createdRole(filter: $filter) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useCreatedRoleSubscription__
 *
 * To run a query within a React component, call `useCreatedRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *   },
 * });
 */
export function useCreatedRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedRoleSubscription, CreatedRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedRoleSubscription, CreatedRoleSubscriptionVariables>(CreatedRoleDocument, options);
      }
export type CreatedRoleSubscriptionHookResult = ReturnType<typeof useCreatedRoleSubscription>;
export type CreatedRoleSubscriptionResult = Apollo.SubscriptionResult<CreatedRoleSubscription>;
export const UpdatedRoleDocument = gql`
    subscription UpdatedRole($filter: RoleFilterArgs, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false, $withProjectDateReminders: Boolean = false) {
  updatedRole(filter: $filter) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useUpdatedRoleSubscription__
 *
 * To run a query within a React component, call `useUpdatedRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjectDateReminders: // value for 'withProjectDateReminders'
 *   },
 * });
 */
export function useUpdatedRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedRoleSubscription, UpdatedRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedRoleSubscription, UpdatedRoleSubscriptionVariables>(UpdatedRoleDocument, options);
      }
export type UpdatedRoleSubscriptionHookResult = ReturnType<typeof useUpdatedRoleSubscription>;
export type UpdatedRoleSubscriptionResult = Apollo.SubscriptionResult<UpdatedRoleSubscription>;
export const DeletedRoleDocument = gql`
    subscription DeletedRole($filter: RoleFilterArgs) {
  deletedRole(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedRoleSubscription__
 *
 * To run a query within a React component, call `useDeletedRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedRoleSubscription, DeletedRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedRoleSubscription, DeletedRoleSubscriptionVariables>(DeletedRoleDocument, options);
      }
export type DeletedRoleSubscriptionHookResult = ReturnType<typeof useDeletedRoleSubscription>;
export type DeletedRoleSubscriptionResult = Apollo.SubscriptionResult<DeletedRoleSubscription>;
export const GetTenantsDocument = gql`
    query GetTenants($filter: TenantFilterArgs, $paging: PageArgs, $sorting: [TenantSortArgs!], $withUserTenantRoles: Boolean = false, $withProjects: Boolean = false, $withBudgetLines: Boolean = false, $withLoggedHours: Boolean = false, $withContracts: Boolean = false, $withInvoices: Boolean = false) {
  tenants(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...tenantFields
    }
    totalCount
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useGetTenantsQuery__
 *
 * To run a query within a React component, call `useGetTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjects: // value for 'withProjects'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withContracts: // value for 'withContracts'
 *      withInvoices: // value for 'withInvoices'
 *   },
 * });
 */
export function useGetTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
      }
export function useGetTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export function useGetTenantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export type GetTenantsQueryHookResult = ReturnType<typeof useGetTenantsQuery>;
export type GetTenantsLazyQueryHookResult = ReturnType<typeof useGetTenantsLazyQuery>;
export type GetTenantsSuspenseQueryHookResult = ReturnType<typeof useGetTenantsSuspenseQuery>;
export type GetTenantsQueryResult = Apollo.QueryResult<GetTenantsQuery, GetTenantsQueryVariables>;
export const GetTenantDocument = gql`
    query GetTenant($id: ID!, $withUserTenantRoles: Boolean = false, $withProjects: Boolean = false, $withBudgetLines: Boolean = false, $withLoggedHours: Boolean = false, $withContracts: Boolean = false, $withInvoices: Boolean = false) {
  tenant(id: $id) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useGetTenantQuery__
 *
 * To run a query within a React component, call `useGetTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjects: // value for 'withProjects'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withContracts: // value for 'withContracts'
 *      withInvoices: // value for 'withInvoices'
 *   },
 * });
 */
export function useGetTenantQuery(baseOptions: Apollo.QueryHookOptions<GetTenantQuery, GetTenantQueryVariables> & ({ variables: GetTenantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
      }
export function useGetTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
        }
export function useGetTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
        }
export type GetTenantQueryHookResult = ReturnType<typeof useGetTenantQuery>;
export type GetTenantLazyQueryHookResult = ReturnType<typeof useGetTenantLazyQuery>;
export type GetTenantSuspenseQueryHookResult = ReturnType<typeof useGetTenantSuspenseQuery>;
export type GetTenantQueryResult = Apollo.QueryResult<GetTenantQuery, GetTenantQueryVariables>;
export const GetAllRelatedDataForTenantDocument = gql`
    query GetAllRelatedDataForTenant($withUserTenantRoles: Boolean = false, $withProjects: Boolean = false, $withBudgetLines: Boolean = false, $withLoggedHours: Boolean = false, $withContracts: Boolean = false, $withInvoices: Boolean = false) {
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
  budgetLines @include(if: $withBudgetLines) {
    items {
      id
      displayField: id
    }
  }
  loggedHours @include(if: $withLoggedHours) {
    items {
      id
      displayField: id
    }
  }
  contracts @include(if: $withContracts) {
    items {
      id
      displayField: id
    }
  }
  invoices @include(if: $withInvoices) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForTenantQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForTenantQuery({
 *   variables: {
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjects: // value for 'withProjects'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withContracts: // value for 'withContracts'
 *      withInvoices: // value for 'withInvoices'
 *   },
 * });
 */
export function useGetAllRelatedDataForTenantQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>(GetAllRelatedDataForTenantDocument, options);
      }
export function useGetAllRelatedDataForTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>(GetAllRelatedDataForTenantDocument, options);
        }
export function useGetAllRelatedDataForTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>(GetAllRelatedDataForTenantDocument, options);
        }
export type GetAllRelatedDataForTenantQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantQuery>;
export type GetAllRelatedDataForTenantLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantLazyQuery>;
export type GetAllRelatedDataForTenantSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantSuspenseQuery>;
export type GetAllRelatedDataForTenantQueryResult = Apollo.QueryResult<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>;
export const CreateTenantDocument = gql`
    mutation CreateTenant($name: String!, $timeZone: String!, $description: String, $kvk: String, $iban: String, $invoiceDetails: String, $contactPerson: String, $invoiceVatSubsidyEligible: Boolean!, $mfaRequired: Boolean!, $userTenantRoles: [ID], $projects: [ID], $budgetLines: [ID], $loggedHours: [ID], $contracts: [ID], $invoices: [ID], $withUserTenantRoles: Boolean = false, $withProjects: Boolean = false, $withBudgetLines: Boolean = false, $withLoggedHours: Boolean = false, $withContracts: Boolean = false, $withInvoices: Boolean = false) {
  createTenant(
    name: $name
    timeZone: $timeZone
    description: $description
    kvk: $kvk
    iban: $iban
    invoiceDetails: $invoiceDetails
    contactPerson: $contactPerson
    invoiceVatSubsidyEligible: $invoiceVatSubsidyEligible
    mfaRequired: $mfaRequired
    userTenantRoleIds: $userTenantRoles
    projectIds: $projects
    budgetLineIds: $budgetLines
    loggedHourIds: $loggedHours
    contractIds: $contracts
    invoiceIds: $invoices
  ) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;
export type CreateTenantMutationFn = Apollo.MutationFunction<CreateTenantMutation, CreateTenantMutationVariables>;

/**
 * __useCreateTenantMutation__
 *
 * To run a mutation, you first call `useCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantMutation, { data, loading, error }] = useCreateTenantMutation({
 *   variables: {
 *      name: // value for 'name'
 *      timeZone: // value for 'timeZone'
 *      description: // value for 'description'
 *      kvk: // value for 'kvk'
 *      iban: // value for 'iban'
 *      invoiceDetails: // value for 'invoiceDetails'
 *      contactPerson: // value for 'contactPerson'
 *      invoiceVatSubsidyEligible: // value for 'invoiceVatSubsidyEligible'
 *      mfaRequired: // value for 'mfaRequired'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      projects: // value for 'projects'
 *      budgetLines: // value for 'budgetLines'
 *      loggedHours: // value for 'loggedHours'
 *      contracts: // value for 'contracts'
 *      invoices: // value for 'invoices'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjects: // value for 'withProjects'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withContracts: // value for 'withContracts'
 *      withInvoices: // value for 'withInvoices'
 *   },
 * });
 */
export function useCreateTenantMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantMutation, CreateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument, options);
      }
export type CreateTenantMutationHookResult = ReturnType<typeof useCreateTenantMutation>;
export type CreateTenantMutationResult = Apollo.MutationResult<CreateTenantMutation>;
export type CreateTenantMutationOptions = Apollo.BaseMutationOptions<CreateTenantMutation, CreateTenantMutationVariables>;
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($id: ID!, $name: String, $timeZone: String, $description: String, $kvk: String, $iban: String, $invoiceDetails: String, $contactPerson: String, $invoiceVatSubsidyEligible: Boolean, $mfaRequired: Boolean, $userTenantRoles: [ID], $projects: [ID], $budgetLines: [ID], $loggedHours: [ID], $contracts: [ID], $invoices: [ID], $withUserTenantRoles: Boolean = false, $withProjects: Boolean = false, $withBudgetLines: Boolean = false, $withLoggedHours: Boolean = false, $withContracts: Boolean = false, $withInvoices: Boolean = false) {
  updateTenant(
    id: $id
    name: $name
    timeZone: $timeZone
    description: $description
    kvk: $kvk
    iban: $iban
    invoiceDetails: $invoiceDetails
    contactPerson: $contactPerson
    invoiceVatSubsidyEligible: $invoiceVatSubsidyEligible
    mfaRequired: $mfaRequired
    userTenantRoleIds: $userTenantRoles
    projectIds: $projects
    budgetLineIds: $budgetLines
    loggedHourIds: $loggedHours
    contractIds: $contracts
    invoiceIds: $invoices
  ) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      timeZone: // value for 'timeZone'
 *      description: // value for 'description'
 *      kvk: // value for 'kvk'
 *      iban: // value for 'iban'
 *      invoiceDetails: // value for 'invoiceDetails'
 *      contactPerson: // value for 'contactPerson'
 *      invoiceVatSubsidyEligible: // value for 'invoiceVatSubsidyEligible'
 *      mfaRequired: // value for 'mfaRequired'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      projects: // value for 'projects'
 *      budgetLines: // value for 'budgetLines'
 *      loggedHours: // value for 'loggedHours'
 *      contracts: // value for 'contracts'
 *      invoices: // value for 'invoices'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjects: // value for 'withProjects'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withContracts: // value for 'withContracts'
 *      withInvoices: // value for 'withInvoices'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const DeleteTenantDocument = gql`
    mutation DeleteTenant($id: ID!, $withUserTenantRoles: Boolean = false, $withProjects: Boolean = false, $withBudgetLines: Boolean = false, $withLoggedHours: Boolean = false, $withContracts: Boolean = false, $withInvoices: Boolean = false) {
  deleteTenant(id: $id) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;
export type DeleteTenantMutationFn = Apollo.MutationFunction<DeleteTenantMutation, DeleteTenantMutationVariables>;

/**
 * __useDeleteTenantMutation__
 *
 * To run a mutation, you first call `useDeleteTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantMutation, { data, loading, error }] = useDeleteTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjects: // value for 'withProjects'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withContracts: // value for 'withContracts'
 *      withInvoices: // value for 'withInvoices'
 *   },
 * });
 */
export function useDeleteTenantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenantMutation, DeleteTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenantMutation, DeleteTenantMutationVariables>(DeleteTenantDocument, options);
      }
export type DeleteTenantMutationHookResult = ReturnType<typeof useDeleteTenantMutation>;
export type DeleteTenantMutationResult = Apollo.MutationResult<DeleteTenantMutation>;
export type DeleteTenantMutationOptions = Apollo.BaseMutationOptions<DeleteTenantMutation, DeleteTenantMutationVariables>;
export const CreatedTenantDocument = gql`
    subscription CreatedTenant($filter: TenantFilterArgs, $withUserTenantRoles: Boolean = false, $withProjects: Boolean = false, $withBudgetLines: Boolean = false, $withLoggedHours: Boolean = false, $withContracts: Boolean = false, $withInvoices: Boolean = false) {
  createdTenant(filter: $filter) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useCreatedTenantSubscription__
 *
 * To run a query within a React component, call `useCreatedTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedTenantSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjects: // value for 'withProjects'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withContracts: // value for 'withContracts'
 *      withInvoices: // value for 'withInvoices'
 *   },
 * });
 */
export function useCreatedTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedTenantSubscription, CreatedTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedTenantSubscription, CreatedTenantSubscriptionVariables>(CreatedTenantDocument, options);
      }
export type CreatedTenantSubscriptionHookResult = ReturnType<typeof useCreatedTenantSubscription>;
export type CreatedTenantSubscriptionResult = Apollo.SubscriptionResult<CreatedTenantSubscription>;
export const UpdatedTenantDocument = gql`
    subscription UpdatedTenant($filter: TenantFilterArgs, $withUserTenantRoles: Boolean = false, $withProjects: Boolean = false, $withBudgetLines: Boolean = false, $withLoggedHours: Boolean = false, $withContracts: Boolean = false, $withInvoices: Boolean = false) {
  updatedTenant(filter: $filter) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useUpdatedTenantSubscription__
 *
 * To run a query within a React component, call `useUpdatedTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedTenantSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withProjects: // value for 'withProjects'
 *      withBudgetLines: // value for 'withBudgetLines'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withContracts: // value for 'withContracts'
 *      withInvoices: // value for 'withInvoices'
 *   },
 * });
 */
export function useUpdatedTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedTenantSubscription, UpdatedTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedTenantSubscription, UpdatedTenantSubscriptionVariables>(UpdatedTenantDocument, options);
      }
export type UpdatedTenantSubscriptionHookResult = ReturnType<typeof useUpdatedTenantSubscription>;
export type UpdatedTenantSubscriptionResult = Apollo.SubscriptionResult<UpdatedTenantSubscription>;
export const DeletedTenantDocument = gql`
    subscription DeletedTenant($filter: TenantFilterArgs) {
  deletedTenant(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedTenantSubscription__
 *
 * To run a query within a React component, call `useDeletedTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedTenantSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedTenantSubscription, DeletedTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedTenantSubscription, DeletedTenantSubscriptionVariables>(DeletedTenantDocument, options);
      }
export type DeletedTenantSubscriptionHookResult = ReturnType<typeof useDeletedTenantSubscription>;
export type DeletedTenantSubscriptionResult = Apollo.SubscriptionResult<DeletedTenantSubscription>;
export const GetUsersDocument = gql`
    query GetUsers($filter: UserFilterArgs, $paging: PageArgs, $sorting: [UserSortArgs!], $withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  users(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...userFields
    }
    totalCount
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: ID!, $withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  user(id: $id) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetAllRelatedDataForUserDocument = gql`
    query GetAllRelatedDataForUser($withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
  contracts @include(if: $withContracts) {
    items {
      id
      displayField: id
    }
  }
  availabilities @include(if: $withAvailabilities) {
    items {
      id
      displayField: id
    }
  }
  daysOffs @include(if: $withDaysOffs) {
    items {
      id
      displayField: id
    }
  }
  loggedHours @include(if: $withLoggedHours) {
    items {
      id
      displayField: id
    }
  }
  loggedHours @include(if: $withApprovedLoggedHours) {
    items {
      id
      displayField: id
    }
  }
  plannedHours @include(if: $withPlannedHours) {
    items {
      id
      displayField: id
    }
  }
  productivities @include(if: $withProductivities) {
    items {
      id
      displayField: id
    }
  }
  projects @include(if: $withResponsibleForProjects) {
    items {
      id
      displayField: name
    }
  }
  projects @include(if: $withControllerForProjects) {
    items {
      id
      displayField: name
    }
  }
  categories @include(if: $withCategories) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForUserQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForUserQuery({
 *   variables: {
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useGetAllRelatedDataForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>(GetAllRelatedDataForUserDocument, options);
      }
export function useGetAllRelatedDataForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>(GetAllRelatedDataForUserDocument, options);
        }
export function useGetAllRelatedDataForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>(GetAllRelatedDataForUserDocument, options);
        }
export type GetAllRelatedDataForUserQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserQuery>;
export type GetAllRelatedDataForUserLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserLazyQuery>;
export type GetAllRelatedDataForUserSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserSuspenseQuery>;
export type GetAllRelatedDataForUserQueryResult = Apollo.QueryResult<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($name: String!, $email: String!, $active: Boolean!, $avatar: String, $termsAndConditions: Boolean, $locale: String!, $timeZone: String!, $lastName: String!, $function: String, $phoneNumber: String, $note: String, $userTenantRoles: [ID], $contracts: [ID], $availabilities: [ID], $daysOffs: [ID], $loggedHours: [ID], $approvedLoggedHours: [ID], $plannedHours: [ID], $productivities: [ID], $responsibleForProjects: [ID], $controllerForProjects: [ID], $categories: [ID], $withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  createUser(
    name: $name
    email: $email
    active: $active
    avatar: $avatar
    termsAndConditions: $termsAndConditions
    locale: $locale
    timeZone: $timeZone
    lastName: $lastName
    function: $function
    phoneNumber: $phoneNumber
    note: $note
    userTenantRoleIds: $userTenantRoles
    contractIds: $contracts
    availabilityIds: $availabilities
    daysOffIds: $daysOffs
    loggedHourIds: $loggedHours
    approvedLoggedHourIds: $approvedLoggedHours
    plannedHourIds: $plannedHours
    productivityIds: $productivities
    responsibleForProjectIds: $responsibleForProjects
    controllerForProjectIds: $controllerForProjects
    categoryIds: $categories
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      avatar: // value for 'avatar'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      locale: // value for 'locale'
 *      timeZone: // value for 'timeZone'
 *      lastName: // value for 'lastName'
 *      function: // value for 'function'
 *      phoneNumber: // value for 'phoneNumber'
 *      note: // value for 'note'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      contracts: // value for 'contracts'
 *      availabilities: // value for 'availabilities'
 *      daysOffs: // value for 'daysOffs'
 *      loggedHours: // value for 'loggedHours'
 *      approvedLoggedHours: // value for 'approvedLoggedHours'
 *      plannedHours: // value for 'plannedHours'
 *      productivities: // value for 'productivities'
 *      responsibleForProjects: // value for 'responsibleForProjects'
 *      controllerForProjects: // value for 'controllerForProjects'
 *      categories: // value for 'categories'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $name: String, $email: String, $active: Boolean, $avatar: String, $termsAndConditions: Boolean, $locale: String, $timeZone: String, $lastName: String, $function: String, $phoneNumber: String, $note: String, $userTenantRoles: [ID], $contracts: [ID], $availabilities: [ID], $daysOffs: [ID], $loggedHours: [ID], $approvedLoggedHours: [ID], $plannedHours: [ID], $productivities: [ID], $responsibleForProjects: [ID], $controllerForProjects: [ID], $categories: [ID], $withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  updateUser(
    id: $id
    name: $name
    email: $email
    active: $active
    avatar: $avatar
    termsAndConditions: $termsAndConditions
    locale: $locale
    timeZone: $timeZone
    lastName: $lastName
    function: $function
    phoneNumber: $phoneNumber
    note: $note
    userTenantRoleIds: $userTenantRoles
    contractIds: $contracts
    availabilityIds: $availabilities
    daysOffIds: $daysOffs
    loggedHourIds: $loggedHours
    approvedLoggedHourIds: $approvedLoggedHours
    plannedHourIds: $plannedHours
    productivityIds: $productivities
    responsibleForProjectIds: $responsibleForProjects
    controllerForProjectIds: $controllerForProjects
    categoryIds: $categories
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      avatar: // value for 'avatar'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      locale: // value for 'locale'
 *      timeZone: // value for 'timeZone'
 *      lastName: // value for 'lastName'
 *      function: // value for 'function'
 *      phoneNumber: // value for 'phoneNumber'
 *      note: // value for 'note'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      contracts: // value for 'contracts'
 *      availabilities: // value for 'availabilities'
 *      daysOffs: // value for 'daysOffs'
 *      loggedHours: // value for 'loggedHours'
 *      approvedLoggedHours: // value for 'approvedLoggedHours'
 *      plannedHours: // value for 'plannedHours'
 *      productivities: // value for 'productivities'
 *      responsibleForProjects: // value for 'responsibleForProjects'
 *      controllerForProjects: // value for 'controllerForProjects'
 *      categories: // value for 'categories'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!, $withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  deleteUser(id: $id) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const CreatedUserDocument = gql`
    subscription CreatedUser($filter: UserFilterArgs, $withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  createdUser(filter: $filter) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useCreatedUserSubscription__
 *
 * To run a query within a React component, call `useCreatedUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useCreatedUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedUserSubscription, CreatedUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedUserSubscription, CreatedUserSubscriptionVariables>(CreatedUserDocument, options);
      }
export type CreatedUserSubscriptionHookResult = ReturnType<typeof useCreatedUserSubscription>;
export type CreatedUserSubscriptionResult = Apollo.SubscriptionResult<CreatedUserSubscription>;
export const UpdatedUserDocument = gql`
    subscription UpdatedUser($filter: UserFilterArgs, $withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  updatedUser(filter: $filter) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUpdatedUserSubscription__
 *
 * To run a query within a React component, call `useUpdatedUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useUpdatedUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedUserSubscription, UpdatedUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedUserSubscription, UpdatedUserSubscriptionVariables>(UpdatedUserDocument, options);
      }
export type UpdatedUserSubscriptionHookResult = ReturnType<typeof useUpdatedUserSubscription>;
export type UpdatedUserSubscriptionResult = Apollo.SubscriptionResult<UpdatedUserSubscription>;
export const DeletedUserDocument = gql`
    subscription DeletedUser($filter: UserFilterArgs) {
  deletedUser(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedUserSubscription__
 *
 * To run a query within a React component, call `useDeletedUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedUserSubscription, DeletedUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedUserSubscription, DeletedUserSubscriptionVariables>(DeletedUserDocument, options);
      }
export type DeletedUserSubscriptionHookResult = ReturnType<typeof useDeletedUserSubscription>;
export type DeletedUserSubscriptionResult = Apollo.SubscriptionResult<DeletedUserSubscription>;
export const RestoredUserDocument = gql`
    subscription RestoredUser($filter: UserFilterArgs, $withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  restoredUser(filter: $filter) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useRestoredUserSubscription__
 *
 * To run a query within a React component, call `useRestoredUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useRestoredUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredUserSubscription, RestoredUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredUserSubscription, RestoredUserSubscriptionVariables>(RestoredUserDocument, options);
      }
export type RestoredUserSubscriptionHookResult = ReturnType<typeof useRestoredUserSubscription>;
export type RestoredUserSubscriptionResult = Apollo.SubscriptionResult<RestoredUserSubscription>;
export const GetUserTenantRolesDocument = gql`
    query GetUserTenantRoles($filter: UserTenantRoleFilterArgs, $paging: PageArgs, $sorting: [UserTenantRoleSortArgs!], $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false, $withProject: Boolean = false) {
  userTenantRoles(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...userTenantRoleFields
    }
    totalCount
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useGetUserTenantRolesQuery__
 *
 * To run a query within a React component, call `useGetUserTenantRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTenantRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTenantRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetUserTenantRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>(GetUserTenantRolesDocument, options);
      }
export function useGetUserTenantRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>(GetUserTenantRolesDocument, options);
        }
export function useGetUserTenantRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>(GetUserTenantRolesDocument, options);
        }
export type GetUserTenantRolesQueryHookResult = ReturnType<typeof useGetUserTenantRolesQuery>;
export type GetUserTenantRolesLazyQueryHookResult = ReturnType<typeof useGetUserTenantRolesLazyQuery>;
export type GetUserTenantRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserTenantRolesSuspenseQuery>;
export type GetUserTenantRolesQueryResult = Apollo.QueryResult<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>;
export const GetUserTenantRoleDocument = gql`
    query GetUserTenantRole($id: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false, $withProject: Boolean = false) {
  userTenantRole(id: $id) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useGetUserTenantRoleQuery__
 *
 * To run a query within a React component, call `useGetUserTenantRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTenantRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTenantRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useGetUserTenantRoleQuery(baseOptions: Apollo.QueryHookOptions<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables> & ({ variables: GetUserTenantRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>(GetUserTenantRoleDocument, options);
      }
export function useGetUserTenantRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>(GetUserTenantRoleDocument, options);
        }
export function useGetUserTenantRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>(GetUserTenantRoleDocument, options);
        }
export type GetUserTenantRoleQueryHookResult = ReturnType<typeof useGetUserTenantRoleQuery>;
export type GetUserTenantRoleLazyQueryHookResult = ReturnType<typeof useGetUserTenantRoleLazyQuery>;
export type GetUserTenantRoleSuspenseQueryHookResult = ReturnType<typeof useGetUserTenantRoleSuspenseQuery>;
export type GetUserTenantRoleQueryResult = Apollo.QueryResult<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>;
export const GetAllRelatedDataForUserTenantRoleDocument = gql`
    query GetAllRelatedDataForUserTenantRole($withUsers: Boolean = false, $withTenants: Boolean = false, $withRoles: Boolean = false, $withProjects: Boolean = false) {
  users @include(if: $withUsers) {
    items {
      id
      displayField: fullName
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
  roles @include(if: $withRoles) {
    items {
      id
      displayField: displayName
    }
  }
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForUserTenantRoleQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForUserTenantRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForUserTenantRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForUserTenantRoleQuery({
 *   variables: {
 *      withUsers: // value for 'withUsers'
 *      withTenants: // value for 'withTenants'
 *      withRoles: // value for 'withRoles'
 *      withProjects: // value for 'withProjects'
 *   },
 * });
 */
export function useGetAllRelatedDataForUserTenantRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>(GetAllRelatedDataForUserTenantRoleDocument, options);
      }
export function useGetAllRelatedDataForUserTenantRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>(GetAllRelatedDataForUserTenantRoleDocument, options);
        }
export function useGetAllRelatedDataForUserTenantRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>(GetAllRelatedDataForUserTenantRoleDocument, options);
        }
export type GetAllRelatedDataForUserTenantRoleQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserTenantRoleQuery>;
export type GetAllRelatedDataForUserTenantRoleLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserTenantRoleLazyQuery>;
export type GetAllRelatedDataForUserTenantRoleSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserTenantRoleSuspenseQuery>;
export type GetAllRelatedDataForUserTenantRoleQueryResult = Apollo.QueryResult<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>;
export const CreateUserTenantRoleDocument = gql`
    mutation CreateUserTenantRole($userId: ID!, $tenantId: ID!, $roleId: ID!, $projectId: ID, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false, $withProject: Boolean = false) {
  createUserTenantRole(
    userId: $userId
    tenantId: $tenantId
    roleId: $roleId
    projectId: $projectId
  ) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;
export type CreateUserTenantRoleMutationFn = Apollo.MutationFunction<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>;

/**
 * __useCreateUserTenantRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserTenantRoleMutation, { data, loading, error }] = useCreateUserTenantRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *      roleId: // value for 'roleId'
 *      projectId: // value for 'projectId'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreateUserTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>(CreateUserTenantRoleDocument, options);
      }
export type CreateUserTenantRoleMutationHookResult = ReturnType<typeof useCreateUserTenantRoleMutation>;
export type CreateUserTenantRoleMutationResult = Apollo.MutationResult<CreateUserTenantRoleMutation>;
export type CreateUserTenantRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>;
export const UpdateUserTenantRoleDocument = gql`
    mutation UpdateUserTenantRole($id: ID!, $userId: ID, $tenantId: ID, $roleId: ID, $projectId: ID, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false, $withProject: Boolean = false) {
  updateUserTenantRole(
    id: $id
    userId: $userId
    tenantId: $tenantId
    roleId: $roleId
    projectId: $projectId
  ) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;
export type UpdateUserTenantRoleMutationFn = Apollo.MutationFunction<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>;

/**
 * __useUpdateUserTenantRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTenantRoleMutation, { data, loading, error }] = useUpdateUserTenantRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *      roleId: // value for 'roleId'
 *      projectId: // value for 'projectId'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdateUserTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>(UpdateUserTenantRoleDocument, options);
      }
export type UpdateUserTenantRoleMutationHookResult = ReturnType<typeof useUpdateUserTenantRoleMutation>;
export type UpdateUserTenantRoleMutationResult = Apollo.MutationResult<UpdateUserTenantRoleMutation>;
export type UpdateUserTenantRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>;
export const DeleteUserTenantRoleDocument = gql`
    mutation DeleteUserTenantRole($id: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false, $withProject: Boolean = false) {
  deleteUserTenantRole(id: $id) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;
export type DeleteUserTenantRoleMutationFn = Apollo.MutationFunction<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>;

/**
 * __useDeleteUserTenantRoleMutation__
 *
 * To run a mutation, you first call `useDeleteUserTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTenantRoleMutation, { data, loading, error }] = useDeleteUserTenantRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useDeleteUserTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>(DeleteUserTenantRoleDocument, options);
      }
export type DeleteUserTenantRoleMutationHookResult = ReturnType<typeof useDeleteUserTenantRoleMutation>;
export type DeleteUserTenantRoleMutationResult = Apollo.MutationResult<DeleteUserTenantRoleMutation>;
export type DeleteUserTenantRoleMutationOptions = Apollo.BaseMutationOptions<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>;
export const CreatedUserTenantRoleDocument = gql`
    subscription CreatedUserTenantRole($filter: UserTenantRoleFilterArgs, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false, $withProject: Boolean = false) {
  createdUserTenantRole(filter: $filter) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useCreatedUserTenantRoleSubscription__
 *
 * To run a query within a React component, call `useCreatedUserTenantRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedUserTenantRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedUserTenantRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useCreatedUserTenantRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedUserTenantRoleSubscription, CreatedUserTenantRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedUserTenantRoleSubscription, CreatedUserTenantRoleSubscriptionVariables>(CreatedUserTenantRoleDocument, options);
      }
export type CreatedUserTenantRoleSubscriptionHookResult = ReturnType<typeof useCreatedUserTenantRoleSubscription>;
export type CreatedUserTenantRoleSubscriptionResult = Apollo.SubscriptionResult<CreatedUserTenantRoleSubscription>;
export const UpdatedUserTenantRoleDocument = gql`
    subscription UpdatedUserTenantRole($filter: UserTenantRoleFilterArgs, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false, $withProject: Boolean = false) {
  updatedUserTenantRole(filter: $filter) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useUpdatedUserTenantRoleSubscription__
 *
 * To run a query within a React component, call `useUpdatedUserTenantRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedUserTenantRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedUserTenantRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *      withProject: // value for 'withProject'
 *   },
 * });
 */
export function useUpdatedUserTenantRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedUserTenantRoleSubscription, UpdatedUserTenantRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedUserTenantRoleSubscription, UpdatedUserTenantRoleSubscriptionVariables>(UpdatedUserTenantRoleDocument, options);
      }
export type UpdatedUserTenantRoleSubscriptionHookResult = ReturnType<typeof useUpdatedUserTenantRoleSubscription>;
export type UpdatedUserTenantRoleSubscriptionResult = Apollo.SubscriptionResult<UpdatedUserTenantRoleSubscription>;
export const DeletedUserTenantRoleDocument = gql`
    subscription DeletedUserTenantRole($filter: UserTenantRoleFilterArgs) {
  deletedUserTenantRole(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedUserTenantRoleSubscription__
 *
 * To run a query within a React component, call `useDeletedUserTenantRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedUserTenantRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedUserTenantRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedUserTenantRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedUserTenantRoleSubscription, DeletedUserTenantRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedUserTenantRoleSubscription, DeletedUserTenantRoleSubscriptionVariables>(DeletedUserTenantRoleDocument, options);
      }
export type DeletedUserTenantRoleSubscriptionHookResult = ReturnType<typeof useDeletedUserTenantRoleSubscription>;
export type DeletedUserTenantRoleSubscriptionResult = Apollo.SubscriptionResult<DeletedUserTenantRoleSubscription>;
export const GetFullUserDocument = gql`
    query GetFullUser($id: ID!) {
  user(id: $id) {
    id
    name
    lastName
    fullName
    email
    emailVerifiedAt
    active
    avatar
    userTenantRoles {
      items {
        id
        userId
        tenantId
        roleId
        role {
          id
          machineName
          displayField: machineName
        }
        tenant {
          id
          name
          displayField: name
        }
        displayField: id
      }
      totalCount
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useGetFullUserQuery__
 *
 * To run a query within a React component, call `useGetFullUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullUserQuery(baseOptions: Apollo.QueryHookOptions<GetFullUserQuery, GetFullUserQueryVariables> & ({ variables: GetFullUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
      }
export function useGetFullUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullUserQuery, GetFullUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
        }
export function useGetFullUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFullUserQuery, GetFullUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
        }
export type GetFullUserQueryHookResult = ReturnType<typeof useGetFullUserQuery>;
export type GetFullUserLazyQueryHookResult = ReturnType<typeof useGetFullUserLazyQuery>;
export type GetFullUserSuspenseQueryHookResult = ReturnType<typeof useGetFullUserSuspenseQuery>;
export type GetFullUserQueryResult = Apollo.QueryResult<GetFullUserQuery, GetFullUserQueryVariables>;
export const CreateUserWithUserTenantDocument = gql`
    mutation CreateUserWithUserTenant($name: String!, $email: String!, $active: Boolean!, $password: String, $avatar: String, $termsAndConditions: Boolean, $lastName: String!, $locale: String!, $timeZone: String!, $function: String, $phoneNumber: String, $note: String, $roleId: String, $projectId: String, $tenantId: String, $invite: Boolean, $withUserTenantRoles: Boolean = false, $withContracts: Boolean = false, $withAvailabilities: Boolean = false, $withDaysOffs: Boolean = false, $withLoggedHours: Boolean = false, $withApprovedLoggedHours: Boolean = false, $withPlannedHours: Boolean = false, $withProductivities: Boolean = false, $withResponsibleForProjects: Boolean = false, $withControllerForProjects: Boolean = false, $withCategories: Boolean = false) {
  createUser(
    name: $name
    email: $email
    active: $active
    password: $password
    avatar: $avatar
    termsAndConditions: $termsAndConditions
    lastName: $lastName
    locale: $locale
    timeZone: $timeZone
    function: $function
    phoneNumber: $phoneNumber
    note: $note
    roleId: $roleId
    projectId: $projectId
    tenantId: $tenantId
    invite: $invite
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserWithUserTenantMutationFn = Apollo.MutationFunction<CreateUserWithUserTenantMutation, CreateUserWithUserTenantMutationVariables>;

/**
 * __useCreateUserWithUserTenantMutation__
 *
 * To run a mutation, you first call `useCreateUserWithUserTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserWithUserTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserWithUserTenantMutation, { data, loading, error }] = useCreateUserWithUserTenantMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      password: // value for 'password'
 *      avatar: // value for 'avatar'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      lastName: // value for 'lastName'
 *      locale: // value for 'locale'
 *      timeZone: // value for 'timeZone'
 *      function: // value for 'function'
 *      phoneNumber: // value for 'phoneNumber'
 *      note: // value for 'note'
 *      roleId: // value for 'roleId'
 *      projectId: // value for 'projectId'
 *      tenantId: // value for 'tenantId'
 *      invite: // value for 'invite'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContracts: // value for 'withContracts'
 *      withAvailabilities: // value for 'withAvailabilities'
 *      withDaysOffs: // value for 'withDaysOffs'
 *      withLoggedHours: // value for 'withLoggedHours'
 *      withApprovedLoggedHours: // value for 'withApprovedLoggedHours'
 *      withPlannedHours: // value for 'withPlannedHours'
 *      withProductivities: // value for 'withProductivities'
 *      withResponsibleForProjects: // value for 'withResponsibleForProjects'
 *      withControllerForProjects: // value for 'withControllerForProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useCreateUserWithUserTenantMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserWithUserTenantMutation, CreateUserWithUserTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserWithUserTenantMutation, CreateUserWithUserTenantMutationVariables>(CreateUserWithUserTenantDocument, options);
      }
export type CreateUserWithUserTenantMutationHookResult = ReturnType<typeof useCreateUserWithUserTenantMutation>;
export type CreateUserWithUserTenantMutationResult = Apollo.MutationResult<CreateUserWithUserTenantMutation>;
export type CreateUserWithUserTenantMutationOptions = Apollo.BaseMutationOptions<CreateUserWithUserTenantMutation, CreateUserWithUserTenantMutationVariables>;
export const GetBudgetsWithCategoriesDocument = gql`
    query GetBudgetsWithCategories($filter: BudgetFilterArgsWithCategory, $paging: PageArgs, $sorting: [BudgetSortArgs!]) {
  budgetsWithCategories(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      id
      total
      startDate
      endDate
      completionDate
      note
      project {
        id
        name
        active
        description
        subsidyPercentage
        invoiceVatSubsidyEligible
        reference
        status
        hourSubsidyType
        maxHourlyRate
        isSimple
        startDate
        endDate
        customerId
        regulationId
        responsibleUserId
        controlUserId
        createdAt
        updatedAt
        deletedAt
        displayField: name
        __typename
      }
      budgetLines {
        items {
          id
          hours
          hourlyRate
          hourCosts
          invoiceCosts
          budgetId
          tenantId
          categoryId
          createdAt
          updatedAt
          deletedAt
          displayField: id
          __typename
          category {
            name
          }
        }
        totalCount
        __typename
      }
      createdAt
      updatedAt
      deletedAt
      __typename
      __typename
    }
    totalCount
    __typename
  }
}
    `;

/**
 * __useGetBudgetsWithCategoriesQuery__
 *
 * To run a query within a React component, call `useGetBudgetsWithCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetsWithCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetsWithCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetBudgetsWithCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetBudgetsWithCategoriesQuery, GetBudgetsWithCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBudgetsWithCategoriesQuery, GetBudgetsWithCategoriesQueryVariables>(GetBudgetsWithCategoriesDocument, options);
      }
export function useGetBudgetsWithCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBudgetsWithCategoriesQuery, GetBudgetsWithCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBudgetsWithCategoriesQuery, GetBudgetsWithCategoriesQueryVariables>(GetBudgetsWithCategoriesDocument, options);
        }
export function useGetBudgetsWithCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBudgetsWithCategoriesQuery, GetBudgetsWithCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBudgetsWithCategoriesQuery, GetBudgetsWithCategoriesQueryVariables>(GetBudgetsWithCategoriesDocument, options);
        }
export type GetBudgetsWithCategoriesQueryHookResult = ReturnType<typeof useGetBudgetsWithCategoriesQuery>;
export type GetBudgetsWithCategoriesLazyQueryHookResult = ReturnType<typeof useGetBudgetsWithCategoriesLazyQuery>;
export type GetBudgetsWithCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetBudgetsWithCategoriesSuspenseQuery>;
export type GetBudgetsWithCategoriesQueryResult = Apollo.QueryResult<GetBudgetsWithCategoriesQuery, GetBudgetsWithCategoriesQueryVariables>;
export const DeleteCategoryAndChildrenDocument = gql`
    mutation DeleteCategoryAndChildren($id: ID!) {
  deleteCategoryAndChildren(id: $id) {
    id
  }
}
    `;
export type DeleteCategoryAndChildrenMutationFn = Apollo.MutationFunction<DeleteCategoryAndChildrenMutation, DeleteCategoryAndChildrenMutationVariables>;

/**
 * __useDeleteCategoryAndChildrenMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryAndChildrenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryAndChildrenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryAndChildrenMutation, { data, loading, error }] = useDeleteCategoryAndChildrenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCategoryAndChildrenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryAndChildrenMutation, DeleteCategoryAndChildrenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryAndChildrenMutation, DeleteCategoryAndChildrenMutationVariables>(DeleteCategoryAndChildrenDocument, options);
      }
export type DeleteCategoryAndChildrenMutationHookResult = ReturnType<typeof useDeleteCategoryAndChildrenMutation>;
export type DeleteCategoryAndChildrenMutationResult = Apollo.MutationResult<DeleteCategoryAndChildrenMutation>;
export type DeleteCategoryAndChildrenMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryAndChildrenMutation, DeleteCategoryAndChildrenMutationVariables>;
export const CreateContentWithFillDocument = gql`
    mutation createContentWithFill($id: ID!, $name: String!, $fill: String!, $language: String!) {
  createContentWithFill(id: $id, name: $name, fill: $fill, language: $language)
}
    `;
export type CreateContentWithFillMutationFn = Apollo.MutationFunction<CreateContentWithFillMutation, CreateContentWithFillMutationVariables>;

/**
 * __useCreateContentWithFillMutation__
 *
 * To run a mutation, you first call `useCreateContentWithFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentWithFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentWithFillMutation, { data, loading, error }] = useCreateContentWithFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      fill: // value for 'fill'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateContentWithFillMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentWithFillMutation, CreateContentWithFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentWithFillMutation, CreateContentWithFillMutationVariables>(CreateContentWithFillDocument, options);
      }
export type CreateContentWithFillMutationHookResult = ReturnType<typeof useCreateContentWithFillMutation>;
export type CreateContentWithFillMutationResult = Apollo.MutationResult<CreateContentWithFillMutation>;
export type CreateContentWithFillMutationOptions = Apollo.BaseMutationOptions<CreateContentWithFillMutation, CreateContentWithFillMutationVariables>;
export const UpdateContentWithFillDocument = gql`
    mutation updateContentWithFill($id: ID!, $name: String!, $fill: String!, $language: String!) {
  updateContentWithFill(id: $id, name: $name, fill: $fill, language: $language)
}
    `;
export type UpdateContentWithFillMutationFn = Apollo.MutationFunction<UpdateContentWithFillMutation, UpdateContentWithFillMutationVariables>;

/**
 * __useUpdateContentWithFillMutation__
 *
 * To run a mutation, you first call `useUpdateContentWithFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentWithFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentWithFillMutation, { data, loading, error }] = useUpdateContentWithFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      fill: // value for 'fill'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateContentWithFillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentWithFillMutation, UpdateContentWithFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentWithFillMutation, UpdateContentWithFillMutationVariables>(UpdateContentWithFillDocument, options);
      }
export type UpdateContentWithFillMutationHookResult = ReturnType<typeof useUpdateContentWithFillMutation>;
export type UpdateContentWithFillMutationResult = Apollo.MutationResult<UpdateContentWithFillMutation>;
export type UpdateContentWithFillMutationOptions = Apollo.BaseMutationOptions<UpdateContentWithFillMutation, UpdateContentWithFillMutationVariables>;
export const GetDashboardRowsDocument = gql`
    query getDashboardRows {
  dashboardRows {
    ...rowFields
    subRows {
      ...rowFields
    }
  }
}
    ${RowFieldsFragmentDoc}`;

/**
 * __useGetDashboardRowsQuery__
 *
 * To run a query within a React component, call `useGetDashboardRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardRowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardRowsQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardRowsQuery, GetDashboardRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardRowsQuery, GetDashboardRowsQueryVariables>(GetDashboardRowsDocument, options);
      }
export function useGetDashboardRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardRowsQuery, GetDashboardRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardRowsQuery, GetDashboardRowsQueryVariables>(GetDashboardRowsDocument, options);
        }
export function useGetDashboardRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardRowsQuery, GetDashboardRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardRowsQuery, GetDashboardRowsQueryVariables>(GetDashboardRowsDocument, options);
        }
export type GetDashboardRowsQueryHookResult = ReturnType<typeof useGetDashboardRowsQuery>;
export type GetDashboardRowsLazyQueryHookResult = ReturnType<typeof useGetDashboardRowsLazyQuery>;
export type GetDashboardRowsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardRowsSuspenseQuery>;
export type GetDashboardRowsQueryResult = Apollo.QueryResult<GetDashboardRowsQuery, GetDashboardRowsQueryVariables>;
export const GetProjectDashboardRowsDocument = gql`
    query getProjectDashboardRows($projectId: String!) {
  projectDashboardRows(projectId: $projectId) {
    hourRows {
      ...rowFields
      subRows {
        ...rowFields
      }
    }
    invoiceRows {
      ...rowFields
      subRows {
        ...rowFields
      }
    }
    totalRows {
      ...rowFields
      subRows {
        ...rowFields
      }
    }
  }
}
    ${RowFieldsFragmentDoc}`;

/**
 * __useGetProjectDashboardRowsQuery__
 *
 * To run a query within a React component, call `useGetProjectDashboardRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDashboardRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDashboardRowsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectDashboardRowsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDashboardRowsQuery, GetProjectDashboardRowsQueryVariables> & ({ variables: GetProjectDashboardRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDashboardRowsQuery, GetProjectDashboardRowsQueryVariables>(GetProjectDashboardRowsDocument, options);
      }
export function useGetProjectDashboardRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDashboardRowsQuery, GetProjectDashboardRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDashboardRowsQuery, GetProjectDashboardRowsQueryVariables>(GetProjectDashboardRowsDocument, options);
        }
export function useGetProjectDashboardRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDashboardRowsQuery, GetProjectDashboardRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDashboardRowsQuery, GetProjectDashboardRowsQueryVariables>(GetProjectDashboardRowsDocument, options);
        }
export type GetProjectDashboardRowsQueryHookResult = ReturnType<typeof useGetProjectDashboardRowsQuery>;
export type GetProjectDashboardRowsLazyQueryHookResult = ReturnType<typeof useGetProjectDashboardRowsLazyQuery>;
export type GetProjectDashboardRowsSuspenseQueryHookResult = ReturnType<typeof useGetProjectDashboardRowsSuspenseQuery>;
export type GetProjectDashboardRowsQueryResult = Apollo.QueryResult<GetProjectDashboardRowsQuery, GetProjectDashboardRowsQueryVariables>;
export const GetAdminDashboardRowsDocument = gql`
    query getAdminDashboardRows {
  adminDashboardRows {
    id
    name
    branch
    regulation {
      id
      name
    }
    tenants {
      id
      name
    }
    status
    startDate
    endDate
    deadline {
      name
      date
    }
    responsibleUser
    controlUser
    subsidyBudget
    subsidyUtilization
    fictiveSubsidyUtilization
  }
}
    `;

/**
 * __useGetAdminDashboardRowsQuery__
 *
 * To run a query within a React component, call `useGetAdminDashboardRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDashboardRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDashboardRowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminDashboardRowsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminDashboardRowsQuery, GetAdminDashboardRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminDashboardRowsQuery, GetAdminDashboardRowsQueryVariables>(GetAdminDashboardRowsDocument, options);
      }
export function useGetAdminDashboardRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDashboardRowsQuery, GetAdminDashboardRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminDashboardRowsQuery, GetAdminDashboardRowsQueryVariables>(GetAdminDashboardRowsDocument, options);
        }
export function useGetAdminDashboardRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminDashboardRowsQuery, GetAdminDashboardRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminDashboardRowsQuery, GetAdminDashboardRowsQueryVariables>(GetAdminDashboardRowsDocument, options);
        }
export type GetAdminDashboardRowsQueryHookResult = ReturnType<typeof useGetAdminDashboardRowsQuery>;
export type GetAdminDashboardRowsLazyQueryHookResult = ReturnType<typeof useGetAdminDashboardRowsLazyQuery>;
export type GetAdminDashboardRowsSuspenseQueryHookResult = ReturnType<typeof useGetAdminDashboardRowsSuspenseQuery>;
export type GetAdminDashboardRowsQueryResult = Apollo.QueryResult<GetAdminDashboardRowsQuery, GetAdminDashboardRowsQueryVariables>;
export const GetHoursOverviewInputDataDocument = gql`
    query GetHoursOverviewInputData($filters: HoursOverviewFilterArgs) {
  getHoursOverviewInputData(filters: $filters) {
    tenants {
      id
      name
    }
    employees {
      id
      name
      lastName
      active
      categories {
        id
      }
      userTenantRoles {
        projectId
      }
    }
    projects {
      id
      name
      active
      tenants {
        id
        name
      }
    }
    categories {
      id
      name
      projects {
        id
        name
      }
      parentCategory {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetHoursOverviewInputDataQuery__
 *
 * To run a query within a React component, call `useGetHoursOverviewInputDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoursOverviewInputDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoursOverviewInputDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetHoursOverviewInputDataQuery(baseOptions?: Apollo.QueryHookOptions<GetHoursOverviewInputDataQuery, GetHoursOverviewInputDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHoursOverviewInputDataQuery, GetHoursOverviewInputDataQueryVariables>(GetHoursOverviewInputDataDocument, options);
      }
export function useGetHoursOverviewInputDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHoursOverviewInputDataQuery, GetHoursOverviewInputDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHoursOverviewInputDataQuery, GetHoursOverviewInputDataQueryVariables>(GetHoursOverviewInputDataDocument, options);
        }
export function useGetHoursOverviewInputDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHoursOverviewInputDataQuery, GetHoursOverviewInputDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHoursOverviewInputDataQuery, GetHoursOverviewInputDataQueryVariables>(GetHoursOverviewInputDataDocument, options);
        }
export type GetHoursOverviewInputDataQueryHookResult = ReturnType<typeof useGetHoursOverviewInputDataQuery>;
export type GetHoursOverviewInputDataLazyQueryHookResult = ReturnType<typeof useGetHoursOverviewInputDataLazyQuery>;
export type GetHoursOverviewInputDataSuspenseQueryHookResult = ReturnType<typeof useGetHoursOverviewInputDataSuspenseQuery>;
export type GetHoursOverviewInputDataQueryResult = Apollo.QueryResult<GetHoursOverviewInputDataQuery, GetHoursOverviewInputDataQueryVariables>;
export const GetHoursOverviewDataDocument = gql`
    query GetHoursOverviewData($filters: HoursOverviewFilterArgs, $sorting: HoursOverviewSortingArgs, $pagination: HoursOverviewPagingArgs) {
  getHoursOverviewData(
    filters: $filters
    sorting: $sorting
    pagination: $pagination
  ) {
    allIds
    advancedReport {
      users {
        id
        name
        lastName
        total
      }
      tenants {
        id
        name
        total
        users {
          id
          name
          total
        }
        projects {
          id
          name
          total
          users {
            id
            name
            total
          }
          categories {
            id
            name
            order
            total
            users {
              id
              name
              total
            }
            parentCategory {
              id
              name
              order
            }
          }
        }
      }
      total
    }
    data {
      id
      description
      startDatetime
      endDatetime
      declarableTime
      addendum
      break
      status
      project {
        id
        name
        tenants {
          id
          name
        }
      }
      category {
        id
        name
        parentCategory {
          id
          name
        }
      }
      user {
        id
        name
        lastName
      }
      tenant {
        id
        name
      }
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetHoursOverviewDataQuery__
 *
 * To run a query within a React component, call `useGetHoursOverviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoursOverviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoursOverviewDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sorting: // value for 'sorting'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetHoursOverviewDataQuery(baseOptions?: Apollo.QueryHookOptions<GetHoursOverviewDataQuery, GetHoursOverviewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHoursOverviewDataQuery, GetHoursOverviewDataQueryVariables>(GetHoursOverviewDataDocument, options);
      }
export function useGetHoursOverviewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHoursOverviewDataQuery, GetHoursOverviewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHoursOverviewDataQuery, GetHoursOverviewDataQueryVariables>(GetHoursOverviewDataDocument, options);
        }
export function useGetHoursOverviewDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHoursOverviewDataQuery, GetHoursOverviewDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHoursOverviewDataQuery, GetHoursOverviewDataQueryVariables>(GetHoursOverviewDataDocument, options);
        }
export type GetHoursOverviewDataQueryHookResult = ReturnType<typeof useGetHoursOverviewDataQuery>;
export type GetHoursOverviewDataLazyQueryHookResult = ReturnType<typeof useGetHoursOverviewDataLazyQuery>;
export type GetHoursOverviewDataSuspenseQueryHookResult = ReturnType<typeof useGetHoursOverviewDataSuspenseQuery>;
export type GetHoursOverviewDataQueryResult = Apollo.QueryResult<GetHoursOverviewDataQuery, GetHoursOverviewDataQueryVariables>;
export const UpdateLoggedHourStatusDocument = gql`
    mutation UpdateLoggedHourStatus($data: [UpdateLoggedHoursStatusType!]!) {
  updateLoggedHourStatus(data: $data)
}
    `;
export type UpdateLoggedHourStatusMutationFn = Apollo.MutationFunction<UpdateLoggedHourStatusMutation, UpdateLoggedHourStatusMutationVariables>;

/**
 * __useUpdateLoggedHourStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLoggedHourStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoggedHourStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoggedHourStatusMutation, { data, loading, error }] = useUpdateLoggedHourStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLoggedHourStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoggedHourStatusMutation, UpdateLoggedHourStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoggedHourStatusMutation, UpdateLoggedHourStatusMutationVariables>(UpdateLoggedHourStatusDocument, options);
      }
export type UpdateLoggedHourStatusMutationHookResult = ReturnType<typeof useUpdateLoggedHourStatusMutation>;
export type UpdateLoggedHourStatusMutationResult = Apollo.MutationResult<UpdateLoggedHourStatusMutation>;
export type UpdateLoggedHourStatusMutationOptions = Apollo.BaseMutationOptions<UpdateLoggedHourStatusMutation, UpdateLoggedHourStatusMutationVariables>;
export const GetAllRelatedDataForInvoiceExtendedDocument = gql`
    query GetAllRelatedDataForInvoiceExtended($withTenants: Boolean = false, $withProjects: Boolean = false, $withCategories: Boolean = false) {
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
      invoiceVatSubsidyEligible
    }
  }
  projects @include(if: $withProjects) {
    items {
      id
      displayField: name
      invoiceVatSubsidyEligible
      tenants {
        items {
          id
        }
      }
      categories {
        items {
          id
          hasInvoices
          displayField: name
          order
          parentCategory {
            id
            name
            hasHours
            hasInvoices
            order
          }
        }
      }
    }
  }
  categories @include(if: $withCategories) {
    items {
      id
      hasInvoices
      displayField: name
      parentCategory {
        id
        name
        hasHours
        hasInvoices
      }
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForInvoiceExtendedQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForInvoiceExtendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForInvoiceExtendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForInvoiceExtendedQuery({
 *   variables: {
 *      withTenants: // value for 'withTenants'
 *      withProjects: // value for 'withProjects'
 *      withCategories: // value for 'withCategories'
 *   },
 * });
 */
export function useGetAllRelatedDataForInvoiceExtendedQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForInvoiceExtendedQuery, GetAllRelatedDataForInvoiceExtendedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForInvoiceExtendedQuery, GetAllRelatedDataForInvoiceExtendedQueryVariables>(GetAllRelatedDataForInvoiceExtendedDocument, options);
      }
export function useGetAllRelatedDataForInvoiceExtendedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForInvoiceExtendedQuery, GetAllRelatedDataForInvoiceExtendedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForInvoiceExtendedQuery, GetAllRelatedDataForInvoiceExtendedQueryVariables>(GetAllRelatedDataForInvoiceExtendedDocument, options);
        }
export function useGetAllRelatedDataForInvoiceExtendedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForInvoiceExtendedQuery, GetAllRelatedDataForInvoiceExtendedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForInvoiceExtendedQuery, GetAllRelatedDataForInvoiceExtendedQueryVariables>(GetAllRelatedDataForInvoiceExtendedDocument, options);
        }
export type GetAllRelatedDataForInvoiceExtendedQueryHookResult = ReturnType<typeof useGetAllRelatedDataForInvoiceExtendedQuery>;
export type GetAllRelatedDataForInvoiceExtendedLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForInvoiceExtendedLazyQuery>;
export type GetAllRelatedDataForInvoiceExtendedSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForInvoiceExtendedSuspenseQuery>;
export type GetAllRelatedDataForInvoiceExtendedQueryResult = Apollo.QueryResult<GetAllRelatedDataForInvoiceExtendedQuery, GetAllRelatedDataForInvoiceExtendedQueryVariables>;
export const GetOrganizedLoggedHoursDocument = gql`
    query getOrganizedLoggedHours($startDate: DateTime, $endDate: DateTime) {
  getOrganizedLoggedHours(startDate: $startDate, endDate: $endDate) {
    id
    description
    startDatetime
    endDatetime
    declarableTime
    break
    userId
    project {
      id
      name
      active
      customer {
        id
        name
      }
    }
    category {
      id
      name
    }
    tenant {
      id
      name
    }
  }
}
    `;

/**
 * __useGetOrganizedLoggedHoursQuery__
 *
 * To run a query within a React component, call `useGetOrganizedLoggedHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizedLoggedHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizedLoggedHoursQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOrganizedLoggedHoursQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizedLoggedHoursQuery, GetOrganizedLoggedHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizedLoggedHoursQuery, GetOrganizedLoggedHoursQueryVariables>(GetOrganizedLoggedHoursDocument, options);
      }
export function useGetOrganizedLoggedHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizedLoggedHoursQuery, GetOrganizedLoggedHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizedLoggedHoursQuery, GetOrganizedLoggedHoursQueryVariables>(GetOrganizedLoggedHoursDocument, options);
        }
export function useGetOrganizedLoggedHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizedLoggedHoursQuery, GetOrganizedLoggedHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizedLoggedHoursQuery, GetOrganizedLoggedHoursQueryVariables>(GetOrganizedLoggedHoursDocument, options);
        }
export type GetOrganizedLoggedHoursQueryHookResult = ReturnType<typeof useGetOrganizedLoggedHoursQuery>;
export type GetOrganizedLoggedHoursLazyQueryHookResult = ReturnType<typeof useGetOrganizedLoggedHoursLazyQuery>;
export type GetOrganizedLoggedHoursSuspenseQueryHookResult = ReturnType<typeof useGetOrganizedLoggedHoursSuspenseQuery>;
export type GetOrganizedLoggedHoursQueryResult = Apollo.QueryResult<GetOrganizedLoggedHoursQuery, GetOrganizedLoggedHoursQueryVariables>;
export const GetProjectsWithCategoriesDocument = gql`
    query GetProjectsWithCategories {
  projectWithCategories(filter: {active: {eq: true}}) {
    items {
      id
      name
      active
      subsidyPercentage
      hourSubsidyType
      categories {
        items {
          id
          name
          order
          hasHours
          hasInvoices
          subsidyPercentage
          parentCategory {
            id
            name
            hasHours
            hasInvoices
            order
          }
          subCategories {
            items {
              id
              order
            }
          }
        }
      }
      customer {
        name
      }
      tenants {
        items {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectsWithCategoriesQuery__
 *
 * To run a query within a React component, call `useGetProjectsWithCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsWithCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsWithCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsWithCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsWithCategoriesQuery, GetProjectsWithCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsWithCategoriesQuery, GetProjectsWithCategoriesQueryVariables>(GetProjectsWithCategoriesDocument, options);
      }
export function useGetProjectsWithCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsWithCategoriesQuery, GetProjectsWithCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsWithCategoriesQuery, GetProjectsWithCategoriesQueryVariables>(GetProjectsWithCategoriesDocument, options);
        }
export function useGetProjectsWithCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsWithCategoriesQuery, GetProjectsWithCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsWithCategoriesQuery, GetProjectsWithCategoriesQueryVariables>(GetProjectsWithCategoriesDocument, options);
        }
export type GetProjectsWithCategoriesQueryHookResult = ReturnType<typeof useGetProjectsWithCategoriesQuery>;
export type GetProjectsWithCategoriesLazyQueryHookResult = ReturnType<typeof useGetProjectsWithCategoriesLazyQuery>;
export type GetProjectsWithCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetProjectsWithCategoriesSuspenseQuery>;
export type GetProjectsWithCategoriesQueryResult = Apollo.QueryResult<GetProjectsWithCategoriesQuery, GetProjectsWithCategoriesQueryVariables>;
export const CreateSimpleProjectDocument = gql`
    mutation CreateSimpleProject($name: String!, $description: String!, $status: String!, $regulationId: String, $tenantId: String!, $budget: Float!, $realization: Float!, $branch: String, $subsidyPercentage: Float!, $invoiceVatSubsidyEligible: Boolean!, $vatSubsidyEligible: Boolean!, $hourSubsidyType: String!, $addendum: Boolean!) {
  createSimpleProject(
    name: $name
    description: $description
    status: $status
    regulationId: $regulationId
    tenantId: $tenantId
    budget: $budget
    realization: $realization
    branch: $branch
    subsidyPercentage: $subsidyPercentage
    invoiceVatSubsidyEligible: $invoiceVatSubsidyEligible
    vatSubsidyEligible: $vatSubsidyEligible
    hourSubsidyType: $hourSubsidyType
    addendum: $addendum
  ) {
    id
    name
  }
}
    `;
export type CreateSimpleProjectMutationFn = Apollo.MutationFunction<CreateSimpleProjectMutation, CreateSimpleProjectMutationVariables>;

/**
 * __useCreateSimpleProjectMutation__
 *
 * To run a mutation, you first call `useCreateSimpleProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSimpleProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSimpleProjectMutation, { data, loading, error }] = useCreateSimpleProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *      regulationId: // value for 'regulationId'
 *      tenantId: // value for 'tenantId'
 *      budget: // value for 'budget'
 *      realization: // value for 'realization'
 *      branch: // value for 'branch'
 *      subsidyPercentage: // value for 'subsidyPercentage'
 *      invoiceVatSubsidyEligible: // value for 'invoiceVatSubsidyEligible'
 *      vatSubsidyEligible: // value for 'vatSubsidyEligible'
 *      hourSubsidyType: // value for 'hourSubsidyType'
 *      addendum: // value for 'addendum'
 *   },
 * });
 */
export function useCreateSimpleProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateSimpleProjectMutation, CreateSimpleProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSimpleProjectMutation, CreateSimpleProjectMutationVariables>(CreateSimpleProjectDocument, options);
      }
export type CreateSimpleProjectMutationHookResult = ReturnType<typeof useCreateSimpleProjectMutation>;
export type CreateSimpleProjectMutationResult = Apollo.MutationResult<CreateSimpleProjectMutation>;
export type CreateSimpleProjectMutationOptions = Apollo.BaseMutationOptions<CreateSimpleProjectMutation, CreateSimpleProjectMutationVariables>;
export const ProjectsWhereAdminDocument = gql`
    query ProjectsWhereAdmin {
  projectsWhereAdmin {
    items {
      id
      name
      hourSubsidyType
      tenants {
        items {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useProjectsWhereAdminQuery__
 *
 * To run a query within a React component, call `useProjectsWhereAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsWhereAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsWhereAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsWhereAdminQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsWhereAdminQuery, ProjectsWhereAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsWhereAdminQuery, ProjectsWhereAdminQueryVariables>(ProjectsWhereAdminDocument, options);
      }
export function useProjectsWhereAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsWhereAdminQuery, ProjectsWhereAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsWhereAdminQuery, ProjectsWhereAdminQueryVariables>(ProjectsWhereAdminDocument, options);
        }
export function useProjectsWhereAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectsWhereAdminQuery, ProjectsWhereAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsWhereAdminQuery, ProjectsWhereAdminQueryVariables>(ProjectsWhereAdminDocument, options);
        }
export type ProjectsWhereAdminQueryHookResult = ReturnType<typeof useProjectsWhereAdminQuery>;
export type ProjectsWhereAdminLazyQueryHookResult = ReturnType<typeof useProjectsWhereAdminLazyQuery>;
export type ProjectsWhereAdminSuspenseQueryHookResult = ReturnType<typeof useProjectsWhereAdminSuspenseQuery>;
export type ProjectsWhereAdminQueryResult = Apollo.QueryResult<ProjectsWhereAdminQuery, ProjectsWhereAdminQueryVariables>;
export const ProjectsWhereAdminWithContractsDocument = gql`
    query ProjectsWhereAdminWithContracts($filter: ProjectFilterArgs) {
  projectsWhereAdmin(filter: $filter) {
    items {
      id
      name
      hourSubsidyType
      contracts {
        items {
          id
          costPerHour
          customCostPerHour
          tenantId
        }
      }
      tenants {
        items {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useProjectsWhereAdminWithContractsQuery__
 *
 * To run a query within a React component, call `useProjectsWhereAdminWithContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsWhereAdminWithContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsWhereAdminWithContractsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProjectsWhereAdminWithContractsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsWhereAdminWithContractsQuery, ProjectsWhereAdminWithContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsWhereAdminWithContractsQuery, ProjectsWhereAdminWithContractsQueryVariables>(ProjectsWhereAdminWithContractsDocument, options);
      }
export function useProjectsWhereAdminWithContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsWhereAdminWithContractsQuery, ProjectsWhereAdminWithContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsWhereAdminWithContractsQuery, ProjectsWhereAdminWithContractsQueryVariables>(ProjectsWhereAdminWithContractsDocument, options);
        }
export function useProjectsWhereAdminWithContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectsWhereAdminWithContractsQuery, ProjectsWhereAdminWithContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsWhereAdminWithContractsQuery, ProjectsWhereAdminWithContractsQueryVariables>(ProjectsWhereAdminWithContractsDocument, options);
        }
export type ProjectsWhereAdminWithContractsQueryHookResult = ReturnType<typeof useProjectsWhereAdminWithContractsQuery>;
export type ProjectsWhereAdminWithContractsLazyQueryHookResult = ReturnType<typeof useProjectsWhereAdminWithContractsLazyQuery>;
export type ProjectsWhereAdminWithContractsSuspenseQueryHookResult = ReturnType<typeof useProjectsWhereAdminWithContractsSuspenseQuery>;
export type ProjectsWhereAdminWithContractsQueryResult = Apollo.QueryResult<ProjectsWhereAdminWithContractsQuery, ProjectsWhereAdminWithContractsQueryVariables>;
export const GetSalaryProjectDocument = gql`
    query GetSalaryProject($id: ID!) {
  projectWithUsers(id: $id) {
    id
    name
    active
    description
    subsidyPercentage
    invoiceVatSubsidyEligible
    reference
    status
    hourSubsidyType
    maxHourlyRate
    users {
      id
      name
      lastName
      avatar
    }
  }
}
    `;

/**
 * __useGetSalaryProjectQuery__
 *
 * To run a query within a React component, call `useGetSalaryProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalaryProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalaryProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSalaryProjectQuery(baseOptions: Apollo.QueryHookOptions<GetSalaryProjectQuery, GetSalaryProjectQueryVariables> & ({ variables: GetSalaryProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalaryProjectQuery, GetSalaryProjectQueryVariables>(GetSalaryProjectDocument, options);
      }
export function useGetSalaryProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalaryProjectQuery, GetSalaryProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalaryProjectQuery, GetSalaryProjectQueryVariables>(GetSalaryProjectDocument, options);
        }
export function useGetSalaryProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalaryProjectQuery, GetSalaryProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalaryProjectQuery, GetSalaryProjectQueryVariables>(GetSalaryProjectDocument, options);
        }
export type GetSalaryProjectQueryHookResult = ReturnType<typeof useGetSalaryProjectQuery>;
export type GetSalaryProjectLazyQueryHookResult = ReturnType<typeof useGetSalaryProjectLazyQuery>;
export type GetSalaryProjectSuspenseQueryHookResult = ReturnType<typeof useGetSalaryProjectSuspenseQuery>;
export type GetSalaryProjectQueryResult = Apollo.QueryResult<GetSalaryProjectQuery, GetSalaryProjectQueryVariables>;